{
  "testit": {
    "catalog": {
      "title": "TestIt",
      "subtitle": "Your reusable test results — take a test once, reuse it in any CheckUp.",
      "notTaken": "Not taken yet",
      "validDays": "Valid · {{days}}d left",
      "expired": "Expired",
      "delete": "Delete",
      "declareHint": "Self-declare your level (unverified). You can replace it with a verified test later.",
      "retake": "Retake",
      "footnote": "Valid results are reused automatically inside CheckUp.",
      "kindPitch": "Video pitch",
      "kindCefr": "Language test",
      "kindMotivational": "Questionnaire",
      "valid": "Valid",
      "takeTest": "Take test",
      "viewRetake": "View & retake",
      "lastTaken": "Last taken {{date}}",
      "recordedOn": "Recorded {{date}}",
      "emptyPrompt": "Take it once — reuse the result in any CheckUp.",
      "heroTitle": "Your reusable test bank",
      "heroSubtitle": "Valid results are picked up automatically the next time you run a CheckUp.",
      "statValid": "Valid",
      "statExpired": "Expired",
      "statUntaken": "Not taken",
      "errorTitle": "We couldn't load your tests",
      "errorBody": "Something went wrong fetching your test bank. Try again in a moment."
    },
    "modal": {
      "history": "History",
      "historyError": "Couldn't load your attempts.",
      "current": "Current",
      "superseded": "Superseded",
      "selfDeclared": "Self-declared",
      "verified": "Verified",
      "recorded": "Recorded",
      "daysLeft": "{{days}} days left",
      "takenOn": "Taken {{date}}",
      "expiresOn": "expires {{date}}",
      "reuseNote": "Reused automatically in your next CheckUp",
      "takeNew": "Take a new test",
      "declareCta": "Declare level"
    },
    "test": {
      "pitch": "Pitch",
      "languageEn": "English",
      "languagePt": "Portuguese",
      "language": "Language",
      "motivational": "Motivational"
    },
    "invite": {
      "bulkKindNote": "Applies to all selected candidates.",
      "kindFull": "Full CheckUp",
      "kindFullHint": "The complete CheckUp assessment — a full iQulture profile.",
      "kindLabel": "What should they complete?",
      "kindTestit": "Specific tests",
      "kindTestitHint": "Only the tests you choose below — quicker, and results are reusable.",
      "previewFull": "The full CheckUp invitation email.",
      "previewLabel": "They'll receive",
      "previewTestit": "A TestIt invitation naming: {{tests}}.",
      "previewTestitEmpty": "A TestIt invitation — choose the tests above.",
      "selectAtLeastOne": "Select at least one test.",
      "selectTestsHint": "Pick one or more. The candidate completes only these.",
      "selectTestsLabel": "Which tests should they take?",
      "testNeverExpires": "No expiry",
      "wizardBannerCta": "Start now",
      "wizardCompleteBody": "Your results have been shared with the company. You can close this and explore your dashboard.",
      "wizardCompleteTitle": "All tests complete!",
      "wizardDoLater": "Do this later",
      "wizardDone": "Done",
      "wizardGoToDashboard": "Go to dashboard",
      "wizardIntro": "You were invited to complete these tests. Do them in any order — your results are saved and reusable.",
      "wizardPending": "Not done yet",
      "wizardProgress": "{{done}} of {{total}} done",
      "wizardRetake": "Retake",
      "wizardStart": "Start",
      "wizardTitle": "Complete your invited tests",
      "testValidityDays_one": "Valid {{count}} day",
      "testValidityDays_other": "Valid {{count}} days",
      "wizardBannerTitle_one": "You've been invited to complete {{count}} test",
      "wizardBannerTitle_other": "You've been invited to complete {{count}} tests",
      "completeBannerTitle": "Your invited tests are complete",
      "completeBannerBody": "The company that asked for them can see your results. There is nothing left to take."
    },
    "vetting": {
      "allComplete": "All invited tests complete",
      "askDescription": "We’ll ask {{name}} for the selected assessment. If it needs more than they share with you now, they decide whether to share it — nothing more is shared until they answer. Results they already have are reused.",
      "askFailed": "Couldn't send the request",
      "askForCheckup": "Ask for full CheckUp",
      "askSend": "Send request",
      "askSending": "Sending…",
      "askEmailFailed": "The request to {{name}} is recorded, but its email could not be sent",
      "askTitle": "Request an assessment from {{name}}",
      "decline": "Decline",
      "declined": "Declined",
      "durationLabel": "Duration",
      "expired": "Expired",
      "invitedProgress": "{{done}} of {{total}} tests complete",
      "latestResult": "Latest result",
      "motivationalComplete": "Questionnaire completed",
      "noPriorAttempts": "No previous attempts",
      "noResults": "No test results yet",
      "noVerdict": "No decision yet",
      "notTaken": "Not taken",
      "otherResults": "Other results",
      "overallLevel": "Overall level",
      "overviewTitle": "TestIt assessment",
      "pass": "Pass",
      "passed": "Passed",
      "pending": "Pending",
      "pitchAria": "Candidate pitch recording",
      "pitchUnavailable": "Recording unavailable",
      "previousAttempts": "Previous attempts",
      "recorded": "Recorded",
      "remind": "Remind",
      "reminderFailed": "Couldn't send the reminder.",
      "reminderSent": "Reminder sent",
      "reminderTooSoon": "You reminded them recently — try again later.",
      "selfDeclared": "Self-declared",
      "skillListening": "Listening",
      "skillReading": "Reading",
      "skillSpeaking": "Speaking",
      "skillWriting": "Writing",
      "sourceCheckup": "From CheckUp",
      "sourceTestit": "TestIt",
      "takenOn": "taken {{date}}",
      "valid": "Valid · {{days}}d left",
      "validShort": "Valid",
      "verdictTitle": "Verdict",
      "failed": "Analysis failed",
      "failedReason": {
        "languageMismatch": "The certificate attests a different language than this test.",
        "unsupportedDocument": "The uploaded file could not be read.",
        "archiveTooLarge": "The Word document is too large to be read safely.",
        "docxEmpty": "The Word document has no readable text or picture.",
        "tooManyPages": "The certificate has more than {{max}} pages; only certificates up to {{max}} pages are read.",
        "noLevelFound": "No CEFR level was found in the certificate.",
        "serviceUnavailable": "Our analysis service could not process the certificate."
      },
      "withheldBody": "This citizen has not shared their test results with your company. The tests you invited them to are still listed; whether they have completed them is withheld — it is not “pending”.",
      "moreActions": "More actions",
      "motivationalAnswered_one": "{{count}} answer",
      "motivationalAnswered_other": "{{count}} answers",
      "repositoryTitle": "Banked test results",
      "repositorySubtitle": "Every test, and what the candidate has completed of each — read-only. This CheckUp invitation asked for no specific tests.",
      "loadFailed": "We couldn't load the test results.",
      "analyserConfidence": "Analyser confidence: {{value}}",
      "askRequested": "Asked {{name}} to share it — nothing more is shared until they answer",
      "askReminded": "Reminded {{name}} of what is still to do",
      "askAlreadyShared": "{{name}} already shares this with you — there is nothing to ask"
    },
    "doOnWeb": "Do my tests on web",
    "doOnWebDesc": "The tests your company asked for run on the Citizen Web Portal — open it in a desktop browser to start."
  },
  "introCarousel": {
    "back": "Back",
    "business": {
      "cta": "Add talents",
      "ctaSecondary": "Maybe later",
      "slides": {
        "welcome": {
          "eyebrow": "Welcome to Tonnie",
          "title": "Sponsor global talent, protected",
          "body": "Vet, sponsor and support international hires in one place — Tonnie protects every sponsorship, with an audit trail at each step."
        },
        "acquire": {
          "eyebrow": "Talent Pool · Vetting",
          "title": "Vet before you sponsor",
          "body": "Screen candidates for relocation-readiness in the Talent Pool, so you sponsor only people who will actually land."
        },
        "sponsor": {
          "eyebrow": "Sponsorship · Protected",
          "title": "Sponsor with protection",
          "body": "Back a talent and Tonnie safeguards the investment end-to-end — readiness checks, milestones and evidence keep every sponsorship on track."
        },
        "mobility": {
          "eyebrow": "Mobility · Adaptation",
          "title": "Track the move and the fit",
          "body": "Follow every relocation across legal, travel and setup — and see how each sponsored hire settles into the role and the country."
        },
        "care": {
          "eyebrow": "Care · Compliance",
          "title": "Retain talent, backed by evidence",
          "body": "Support wellbeing without surveillance, and export verified records the moment audit, legal or leadership asks."
        },
        "start": {
          "eyebrow": "Get started",
          "title": "Sponsor your first talent",
          "body": "Add a talent to your program — every sponsorship comes protected by Tonnie, from day one."
        }
      }
    },
    "goToSlide": "Go to slide {{number}}",
    "next": "Next",
    "skip": "Skip",
    "title": "Introduction to Tonnie"
  },
  "activity": {
    "task": {
      "completed": "Completed: {{label}}",
      "completedForMember": "Completed: {{label}} — {{member}}"
    },
    "housing": {
      "secured": "Housing secured"
    },
    "checkup": {
      "scored": "CheckUp score calculated"
    },
    "checkin": {
      "completed": "Check-in completed"
    },
    "checkpoint": {
      "completed": "Checkpoint: {{label}}"
    },
    "mission": {
      "completed": "Completed mission: {{label}}"
    },
    "world": {
      "completed": "World completed: {{label}}"
    },
    "streak": {
      "milestone_one": "{{count}}-day streak!",
      "milestone_other": "{{count}}-day streak!"
    },
    "stamp": {
      "earned": "Stamp earned: {{label}}"
    },
    "badge": {
      "earned": "Badge earned: {{label}}"
    },
    "onboarding": {
      "completed": "Getting started"
    },
    "journey": {
      "completed": "Journey complete!"
    },
    "event": {
      "addedFromPool": "Added from talent pool",
      "adoptedByInvitation": "Journey linked to a company invitation",
      "arrived": "Arrived at destination",
      "badgeEarned": "Badge earned",
      "checkpointCompleted": "Checkpoint completed",
      "checkupCompleted": "CheckUp completed",
      "checkupStarted": "CheckUp started",
      "companyTaskCompleted": "Company task completed",
      "documentUploaded": "Document uploaded",
      "expiryRenewed": "Journey extended",
      "fundingChanged": "Funding changed",
      "guideCompleted": "Guide completed",
      "guideDiscarded": "Guide discarded",
      "guideRestarted": "Guide restarted",
      "guideRetaken": "Guide retaken",
      "guideStarted": "Guide started",
      "interventionLogged": "Care intervention logged",
      "interventionResolved": "Care intervention resolved",
      "interventionScheduled": "Care intervention scheduled",
      "interventionUpdated": "Care intervention updated",
      "interviewRequested": "Interview requested",
      "invitationAccepted": "Invitation accepted",
      "journeyArchived": "Journey archived",
      "journeyCreated": "Journey created",
      "journeyLifecycle": "Journey status changed",
      "journeyRestored": "Journey restored",
      "missionCompleted": "Mission completed",
      "objectiveFeedbackSubmitted": "Objective feedback submitted",
      "pipelineStageChanged": "Pipeline stage changed",
      "pitchAnalyzed": "Pitch analyzed",
      "protectiveActionLogged": "Protective action logged",
      "setPrimary": "Set as primary journey",
      "sponsorshipAccepted": "Sponsorship accepted",
      "sponsorshipCancelled": "Sponsorship cancelled",
      "sponsorshipDeclined": "Sponsorship declined",
      "sponsorshipRefunded": "Sponsorship refunded",
      "sponsorshipStarted": "Sponsorship started",
      "stampEarned": "Stamp earned",
      "talentArchived": "Talent archived",
      "talentSponsored": "Sponsorship activated",
      "talentUnarchived": "Talent unarchived",
      "teleportalTaskCompleted": "TelePortal task completed",
      "trackCompleted": "Track completed",
      "vettingInviteEmailFailed": "Vetting invitation email could not be sent",
      "visaApproved": "Visa approved",
      "worldCompleted": "World completed",
      "copilotInterviewCompleted": "CoPilot interview completed",
      "testResultsRecorded": "Test results recorded",
      "testitPassed": "TestIt verdict: passed",
      "testitDeclined": "TestIt verdict: declined",
      "profileCompleted": "Profile completed",
      "documentValidated": "Document validated",
      "relocationPlanCreated": "Relocation plan created",
      "relocationPlanUpdated": "Relocation plan updated",
      "milestoneReached": "Milestone reached",
      "interventionDue": "Scheduled care action due",
      "taskReopened": "Relocation task reopened",
      "relationshipMoved": "Moved to a journey of its own",
      "programmeLeft": "Left the programme",
      "shareRequested": "Asked to see more",
      "shareRequestAccepted": "Shared what was asked",
      "shareRequestDeclined": "Declined the request to see more",
      "vettingReminded": "Reminded of what is still to do",
      "testitCompleted": "Completed the tests that were asked for"
    },
    "pipeline": {
      "transition": "Pipeline: {{from}} → {{to}}"
    },
    "business": {
      "intervention": "Intervention: {{label}}",
      "feedbackRoutineCreated": "Feedback routine \"{{name}}\" created",
      "feedbackRoutineStarted": "Feedback routine started",
      "feedbackRoutineCompleted": "Feedback routine completed",
      "feedbackRoutinePaused": "Feedback routine paused",
      "protectiveAction": "Protective action — {{label}}",
      "interventionLogged": "Intervention — {{label}}",
      "documentUploaded": "Document uploaded — {{label}}",
      "taskReminderSent": "Reminder sent — {{label}}",
      "interventionScheduled": "{{label}} scheduled",
      "messageSent": "Sent \"{{name}}\" via {{channel}}",
      "messageSentNoName": "Sent message via {{channel}}",
      "messageNotDelivered": "\"{{name}}\" via {{channel}} was not delivered",
      "messageNotDeliveredNoName": "Message via {{channel}} was not delivered",
      "messageDispatched": "\"{{name}}\" via {{channel}} was handed to delivery — outcome not recorded",
      "messageDispatchedNoName": "Message via {{channel}} was handed to delivery — outcome not recorded",
      "invitationCreated": "Invitation created",
      "invitationSent": "Invitation sent",
      "invitationReminded": "Invitation reminder sent",
      "invitationAccepted": "Invitation accepted",
      "invitationRevoked": "Invitation revoked",
      "invitationRevokedAccountDeleted": "Invitation revoked — the person deleted their account",
      "invitationExpired": "Invitation expired",
      "invitationDeclined": "Invitation declined"
    },
    "generic": "{{text}}",
    "objective": {
      "selfEvaluated": "Completed an objectives self-evaluation"
    },
    "messageTemplate": {
      "account_email_changed": "Sign-in email changed",
      "account_invitation_claim_code": "Invitation claim code",
      "adaptation_nudge_missions": "Adaptation mission suggestion",
      "adaptation_streak_broken": "Adaptation streak nudge",
      "care_checkin_request": "Care check-in request",
      "care_checkpoint_overdue_reminder": "Checkpoint overdue reminder (talent)",
      "care_feedback_requested": "Care feedback request (to talent)",
      "care_intervention_due": "Care intervention due (internal)",
      "care_objective_feedback_cycle_open": "Objective feedback — round open (talent)",
      "care_objective_feedback_due": "Objective feedback — due (provider)",
      "care_objective_feedback_received": "Objective feedback — received (talent)",
      "coaching_message": "Coaching message",
      "cohort_welcome": "Cohort welcome",
      "company_nudge_digest": "Action needed — weekly company digest",
      "evidence_celebrate_badge": "Badge celebration",
      "evidence_request": "Evidence / document request",
      "integration_mission_assigned": "QultureUp mission assigned",
      "interview_first_requested": "Interview-First request",
      "mobility_task_assigned": "Mobility task assigned",
      "mobility_task_pending": "Mobility task reminder",
      "program_enrollment": "Program enrollment welcome",
      "services_request_received": "Tonnie Services request received (internal)",
      "sponsorship_activate": "Sponsorship activation — awaiting talent acceptance",
      "sponsorship_invite": "Sponsorship invitation (journey launch)",
      "sponsorship_offer_reminder": "Sponsorship offer reminder (unanswered)",
      "sponsorship_talent_accepted": "Sponsorship — talent accepted (admin notification)",
      "sponsorship_talent_declined": "Sponsorship — talent declined (admin notification + refund)",
      "sponsorship_welcome": "Sponsorship welcome",
      "talent_invite": "Talent onboarding invitation",
      "team_invite": "Team member invitation",
      "team_invite_reminder": "Team invitation reminder",
      "vetting_complete_checkup": "CheckUp progress nudge",
      "vetting_invite": "Invite candidate to CheckUp",
      "vetting_invite_reminder": "Invitation reminder (unanswered)",
      "vetting_invite_testit": "Invite candidate to specific tests (TestIt)",
      "vetting_reminder": "CheckUp reminder",
      "talent_checkup_link": "CheckUp link for a computer",
      "coaching_encourage": "Coaching — encouragement",
      "coaching_challenge": "Coaching — weekly challenge",
      "coaching_checkin": "Coaching — check-in",
      "coaching_celebrate": "Coaching — celebration",
      "coaching_remind": "Coaching — reminder",
      "talent_programme_left": "Talent left the programme (admin notification)",
      "vetting_share_request": "Request to see the CheckUp (existing relationship)",
      "vetting_share_request_testit": "Request to see test results (existing relationship)",
      "vetting_testit_reminder": "TestIt reminder",
      "talent_share_request_declined": "Talent declined a request (admin notification)",
      "talent_testit_completed": "Talent completed the tests you asked for (admin notification)"
    },
    "guide": {
      "started": "{{flow}} guide started",
      "completed": "{{flow}} guide completed",
      "discarded": "{{flow}} guide discarded",
      "restarted": "{{flow}} guide restarted",
      "retaken": "{{flow}} guide retaken"
    },
    "milestone": {
      "reached": "Milestone reached: {{label}}"
    }
  },
  "catalog": {
    "stamps": {
      "first_step": {
        "name": "First Step",
        "description": "Complete your onboarding and start your journey"
      },
      "first_checkup": {
        "name": "First CheckUp",
        "description": "Complete your first CheckUp assessment"
      },
      "iqulture_pro": {
        "name": "iQulture PRO",
        "description": "Achieve iQulture PRO status (score 70+)"
      },
      "visa_approved": {
        "name": "Visa Approved",
        "description": "Your visa or residence permit has been approved"
      },
      "arrived": {
        "name": "Arrived at Destination",
        "description": "You have arrived at your destination country"
      },
      "housing_secured": {
        "name": "Home Sweet Home",
        "description": "You have secured housing at your destination"
      },
      "first_mission": {
        "name": "First Mission",
        "description": "Complete your first QultureUp learning mission"
      },
      "world_explorer": {
        "name": "World Explorer",
        "description": "Complete your first QultureUp world (all tracks)"
      },
      "streak_7": {
        "name": "7-Day Streak",
        "description": "Complete QultureUp activities 7 days in a row"
      },
      "streak_30": {
        "name": "30-Day Streak",
        "description": "Complete QultureUp activities 30 days in a row"
      },
      "first_checkpoint": {
        "name": "First Checkpoint",
        "description": "Complete your first Care wellbeing checkpoint"
      },
      "care_champion": {
        "name": "Care Champion",
        "description": "Complete all 4 scheduled Care checkpoints"
      },
      "all_heroes": {
        "name": "Full Journey",
        "description": "Activated all 5 heroes in your journey"
      },
      "adaptation_master": {
        "name": "Adaptation Master",
        "description": "Mastered cultural adaptation across multiple worlds"
      },
      "journey_complete": {
        "name": "Journey Complete",
        "description": "Successfully completed your entire integration journey"
      }
    },
    "badges": {
      "legal_expert": {
        "name": "Legal Expert",
        "description": "Mastered the legal track and civic rights"
      },
      "culture_citizen": {
        "name": "Culture Citizen",
        "description": "Completed all cultural worlds at Advanced level"
      },
      "workplace_master": {
        "name": "Workplace Master",
        "description": "Workplace adaptation and language mastery complete"
      },
      "fully_adapted": {
        "name": "Fully Adapted Citizen",
        "description": "Complete integration — all journeys finished"
      },
      "cultural_ambassador": {
        "name": "Cultural Ambassador",
        "description": "Outstanding cultural adaptation — ambassador status"
      }
    }
  },
  "about": {
    "aiModel": "AI model",
    "appName": "Tonnie Citizen",
    "appVersion": "App version",
    "brainService": "Brain service",
    "build": "Build",
    "copyright": "© {{year}} Tonnie. All rights reserved.",
    "description": "Tonnie is a global talent mobility platform that reduces relocation failure and accelerates stable integration. We combine AI-powered guidance with human care to support every step of your journey.",
    "environment": "Environment",
    "expoSdk": "Expo SDK",
    "fetchingVersions": "Fetching version info...",
    "platform": "Platform",
    "platformApi": "Platform API",
    "systemInfo": "System information",
    "title": "About Tonnie",
    "version": "Version {{version}}"
  },
  "accessControl": {
    "accessDenied": "Access denied",
    "accessFeatureInCitizenApp": "Access {{feature}} through the Citizen mobile app.",
    "buildJourney": "Build journey",
    "enableFamilyProgram": "Enable the Family Program in billing to access this feature.",
    "familyMasterOnly": "This feature is only available to Family Masters.",
    "familyProgramRequired": "Family program required",
    "featureInCitizenApp": "This feature is available through the Citizen mobile app.",
    "featureLocked": "Feature locked",
    "goToBilling": "Go to billing",
    "heroNotEnabled": "Hero not enabled",
    "heroNotEnabledDescription": "This hero isn't enabled on your current plan. Upgrade or switch journeys to unlock it.",
    "journeyRequired": "Journey required",
    "locked": "Locked",
    "needJourneyToAccess": "You need to build a journey to access this feature.",
    "noPermission": "You do not have permission to access this feature.",
    "openCitizen": "Open Citizen",
    "switchJourney": "Switch journey",
    "talentOrFamilyMasterOnly": "This feature is only available to Talents and Family Masters.",
    "upgrade": "Upgrade",
    "useCitizenMobileApp": "Use Citizen mobile app"
  },
  "accessScenario": {
    "badges": {
      "companySponsored": "Company sponsored",
      "familyMember": "Family member",
      "free": "Free Mode",
      "governmentSponsored": "Government sponsored"
    },
    "companySponsored": {
      "description": "Talent with company-sponsored journey. Full Pro-level access, no payment required.",
      "label": "Company sponsored"
    },
    "familyMember": {
      "description": "Family member with same access as Free Mode. Journey is unlocked via Family Program.",
      "label": "Family member"
    },
    "free": {
      "description": "Free subscription with limited access. Upgrade via Billing to unlock Pro, Family, or more Journeys.",
      "label": "Free Mode"
    },
    "governmentSponsored": {
      "description": "Talent with government-sponsored journey. Full Pro-level access, no payment required.",
      "label": "Government sponsored"
    },
    "info": {
      "description": "Access scenarios help you test different combinations of subscription modes, journey sponsorship, and user roles. Your selected scenario determines which features you can access in the mockup. In production, your access is determined by your actual subscription and journey instances.",
      "title": "About access scenarios"
    },
    "loading": "Loading...",
    "matrix": {
      "allowed": "Full access",
      "billingDescription": "Plan and billing management",
      "careDescription": "Post-arrival checkpoints and support",
      "careNotAllowed": "No access to Care in Free Mode",
      "careerDescription": "Job opportunities and career tools",
      "checkupDescription": "Pre-immigration readiness assessment",
      "citizenMobile": "Citizen mobile",
      "cvBuilder": "CV builder",
      "cvBuilderDescription": "EU-style CV generator and templates",
      "description": "Compare feature access across all scenarios. Select a scenario to continue.",
      "familyProgramDescription": "Family program management and invitations",
      "familyProgramViaBilling": "Available via billing. Purchase Family add-on (€4.99/month) to enable.",
      "features": "Features",
      "homeDescription": "Dashboard and journey overview",
      "journeyBuilder": "Journey builder",
      "journeyBuilderDescription": "Configure and build your personalized journey",
      "journeyBuilderViaBilling": "Available after purchasing a journey via Billing",
      "legend": {
        "allowed": "Full access",
        "citizenMobile": "Available via Citizen mobile app",
        "limited": "Limited access",
        "notAllowed": "Not available",
        "readOnly": "Read only (Family member)",
        "viaBilling": "Available via billing/Upgrade"
      },
      "limited": "Limited access",
      "notAllowed": "Not available",
      "passportDescription": "Journey timeline and achievements",
      "passportLimited": "View events/log only, no advanced features",
      "profileDescription": "Profile settings and preferences",
      "qultureupDescription": "Cultural integration and learning",
      "qultureupLimited": "Basic missions only, limited content",
      "readOnly": "Read only",
      "selected": "Selected",
      "teleportalDescription": "Relocation and mobility tasks",
      "teleportalLimited": "Checklist only, no document upload, no AI review",
      "title": "Feature access matrix",
      "viaBilling": "Via billing"
    },
    "select": "Select scenario",
    "subtitle": "Choose a scenario to test different access levels. You can upgrade to Pro, add Family, or purchase more Journeys via Billing.",
    "title": "Select access scenario"
  },
  "address": {
    "city": "City",
    "country": "Country",
    "detailsError": "Failed to get address details. Please try again.",
    "search": "Search address",
    "searchDescription": "Start typing to search for an address",
    "searchError": "Failed to search addresses. Please try again.",
    "searchPlaceholder": "Start typing an address...",
    "typeMinChars": "Type at least 3 characters to search",
    "citySearch": {
      "suggestions": "City suggestions",
      "noResults": "No city found — you can keep what you typed.",
      "unavailable": "Suggestions are unavailable right now — you can keep what you typed."
    }
  },
  "admin": {
    "carePillars": {
      "saveSuccess": "Pillars configuration saved!"
    }
  },
  "alt": {
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "copilot": "CoPilot",
    "dialogGraphic": "Dialog graphic",
    "logo": "Logo",
    "passport": "Passport",
    "profile": "Profile",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal",
    "tonnieLogo": "Tonnie logo"
  },
  "assessment": {
    "analyzing": "Analyzing your knowledge level...",
    "answerPlaceholder": "Type your answer here...",
    "duration": "Takes about 5-10 minutes",
    "evaluating": "Evaluating your answers",
    "finish": "Finish",
    "saveFailed": "Your answers could not be saved. Try again.",
    "getRecommendations": "Get your level and recommendations",
    "loadingAssessment": "Loading assessment...",
    "next": "Next",
    "personalizedResults": "Personalized results",
    "previous": "Previous",
    "questionOf": "Question {{current}} of {{total}}",
    "quickAssessment": "Quick assessment",
    "skipAhead": "Skip ahead",
    "skipKnownContent": "Skip content you already know",
    "startAssessment": "Start assessment",
    "startFailed": "We couldn't load the questions. Check your connection and try again.",
    "startFromBeginning": "Start from beginning",
    "subtitle": "Let us evaluate your current cultural knowledge level",
    "title": "Knowledge assessment",
    "viewRecommendedPath": "View recommended path"
  },
  "assessmentChat": {
    "clickToStartRecording": "Click to start recording",
    "clickToUpload": "Click to upload CV",
    "fileFormats": "PDF, DOC, DOCX",
    "notAtAll": "Not at all",
    "recordAgain": "Record again",
    "recordPitch": "Record your pitch",
    "recordPitchDesc": "Record a 60-second pitch about yourself and your goals",
    "recordVideoDesc": "Record a short video introducing yourself (max 30 seconds)",
    "recording": "Recording...",
    "recordingPitch": "Recording... (max 60 seconds)",
    "startRecording": "Start recording",
    "stopRecording": "Stop recording",
    "typeAnswer": "Type your answer...",
    "typeMessage": "Type your message...",
    "veryMuch": "Very much"
  },
  "auth": {
    "alreadySignedIn": {
      "continueToDashboard": "Continue to dashboard",
      "description": "You're signed in as {{email}}. Continue your journey, or sign out to use a different account.",
      "descriptionBusiness": "You're signed in as {{email}}. Continue to the Business dashboard, or sign out to use a different account.",
      "signingOut": "Signing out…",
      "switchAccount": "Sign out and use a different account",
      "title": "You're already signed in"
    },
    "backToLogin": "Back to login",
    "biometricSignIn": "Sign in with biometrics",
    "checkEmail": "Check your email",
    "confirmPassword": "Confirm password",
    "createNewPassword": "Create new password",
    "createStrongPassword": "Create a strong password for your account",
    "email": "Email",
    "enterEmailToReset": "Enter your email to reset your password",
    "enterNewPassword": "Enter your new password below",
    "errors": {
      "invalidCredentials": "Invalid email or password. Please try again.",
      "invalidVerificationCode": "Invalid verification code. Please try again.",
      "resetFailed": "Failed to reset password. Please try again or request a new reset link.",
      "twoFactorRequiredOnReset": "Two-factor authentication is required. Please sign in normally and reset your password from Settings.",
      "unableToCreate": "Unable to create account. Please try again.",
      "unableToProcess": "Unable to process your request. Please try again later.",
      "unableToResend": "Unable to resend code. Please try again."
    },
    "forgotPassword": "Forgot password?",
    "forgotPasswordTitle": "Forgot password?",
    "goToLogin": "Go to login",
    "hidePassword": "Hide password",
    "newPassword": "New password",
    "oauthError": "OAuth authentication could not be completed. Please try again.",
    "oauthFailed": "Sign in failed",
    "oauthRedirecting": "Redirecting you now...",
    "oauthSuccess": "Sign in successful!",
    "oauthVerifying": "Please wait while we verify your account",
    "password": "Password",
    "passwordResetSuccess": "Password reset successfully!",
    "passwordResetSuccessDesc": "Your password has been reset successfully",
    "passwordResetSuccessTitle": "Password reset successful",
    "resendEmail": "Resend email",
    "resetCode": "Reset code",
    "resetLinkInstructions": "Click the link in the email to reset your password. The link will expire in 1 hour.",
    "resetLinkSent": "Password reset link sent to your email!",
    "resetLinkSentTo": "We've sent a password reset link to {{email}}",
    "resetPassword": "Reset password",
    "returnToLogin": "Return to login",
    "sendResetCode": "Send reset code",
    "sendResetLink": "Send reset link",
    "sessionExpiring": "Session expiring",
    "sessionExpiringDesc": "You've been inactive. You'll be signed out in {{seconds}} seconds.",
    "showPassword": "Show password",
    "signIn": "Sign In",
    "signOut": "Sign out",
    "staySignedIn": "Stay signed in",
    "validation": {
      "passwordsMatch": "Passwords match"
    },
    "providerErrors": {
      "emailTaken": "An account with this email already exists. Sign in instead.",
      "accountNotFound": "We couldn't find an account with this email.",
      "passwordIncorrect": "The password is incorrect. Try again, or reset it.",
      "credentialsIncorrect": "The email or password is incorrect.",
      "passwordBreached": "This password has appeared in a data breach. Please choose a different one.",
      "passwordTooShort": "Your password must be at least {{passwordMinLength}} characters long.",
      "passwordTooWeak": "This password is too weak. Please choose a stronger one.",
      "passwordUnchanged": "Your new password must be different from your current one.",
      "codeIncorrect": "That code isn't right. Check the email and try again.",
      "codeExpired": "That code has expired. Ask for a new one.",
      "codeAttemptsExhausted": "Too many wrong codes. Ask for a new one.",
      "emailInvalid": "Enter a valid email address.",
      "emailNotAllowed": "This email address can't be used here.",
      "tooManyAttempts": "Too many attempts. Please wait a few minutes and try again.",
      "accountLocked": "Your account is locked for a while after too many attempts. Please try again later.",
      "alreadySignedIn": "You're already signed in.",
      "botCheckFailed": "We couldn't verify this request. Refresh the page and try again.",
      "passwordNotSet": "This account doesn't use a password. Sign in the way you created it.",
      "accountUnavailable": "This account can't be used. Please contact support.",
      "networkUnreachable": "We couldn't reach the server. Check your connection and try again.",
      "passwordTooLong": "This password is too long. Please choose a shorter one.",
      "reverificationRequired": "For your security, please sign out and back in, then try again.",
      "socialCancelled": "Sign-in was cancelled. You can try again, or use your email instead.",
      "socialAccountInUse": "That account is already connected to a different Tonnie account. Sign in to that account, or choose another way."
    },
    "passwordRule": {
      "length": "At least {{passwordMinLength}} characters",
      "advice": "A few words strung together are strong and easy to remember.",
      "levels": {
        "weak": "Weak",
        "fair": "Fair",
        "good": "Good",
        "strong": "Strong"
      }
    },
    "passwordCard": {
      "signOutOthers": "Sign out of other devices",
      "signOutOthersHint": "Anyone signed in to your account elsewhere will need the new password."
    },
    "social": {
      "continueWith": "Continue with {{provider}}",
      "failed": "We couldn't sign you in with {{provider}}. Please try again, or use your email instead.",
      "failedGeneric": "We couldn't finish signing you in. Please try again, or use your email instead.",
      "signingIn": "Signing you in…",
      "signingInDesc": "One moment while we finish signing you in.",
      "returnFailed": "We couldn't finish signing you in",
      "returnFailedDesc": "The way back from the sign-in page took too long. Please try again."
    },
    "signUpContinue": {
      "unsupported": "We couldn't finish creating your account",
      "unsupportedDesc": "That sign-in needs something we don't ask for. Please start again, or sign up with your email.",
      "startAgain": "Start again"
    },
    "connected": {
      "connect": "Connect {{provider}}",
      "disconnect": "Disconnect",
      "disconnectTitle": "Disconnect {{provider}}?",
      "disconnectDesc": "You won't be able to sign in with {{provider}} any more. You can still sign in with your email.",
      "connected": "{{provider}} is connected. You can now sign in with it.",
      "disconnected": "{{provider}} is disconnected.",
      "failed": "We couldn't connect {{provider}}. Please try again.",
      "disconnectFailed": "We couldn't disconnect {{provider}}. Please try again."
    },
    "brand": {
      "name": "Tonnie",
      "copyright": "© {{year}} Tonnie",
      "citizen": {
        "signInHeadline": "Your move abroad, guided step by step.",
        "signInSubline": "One place for your relocation journey — from the first CheckUp to feeling at home.",
        "signUpHeadline": "Start your move with a plan.",
        "signUpSubline": "Create your account and Tonnie guides every step — before you go, on the day, and once you arrive.",
        "checkup": "See where you stand before you move",
        "teleportal": "Every task of the move, in order",
        "qultureup": "Learn the culture before you land",
        "care": "Support after you arrive",
        "passport": "Every milestone of your journey, stamped"
      },
      "business": {
        "signInHeadline": "Relocate your talent with confidence.",
        "signInSubline": "Invite, sponsor and follow every hire's move — in one place.",
        "signUpHeadline": "Bring your team's relocations into one place.",
        "signUpSubline": "Create your company account, then invite the people you are relocating when you're ready.",
        "vetting": "See who is ready to move",
        "mobility": "Every relocation task, in order",
        "adaptation": "Help new arrivals settle in",
        "care": "Support after arrival"
      }
    },
    "flow": {
      "back": "Back",
      "continue": "Continue",
      "orWithEmail": "or with your email",
      "or": "or",
      "emailLabel": "Email",
      "emailPlaceholder": "name@example.com",
      "change": "Change",
      "signIn": {
        "title": "Welcome back",
        "descriptionCitizen": "Sign in to continue your journey.",
        "descriptionBusiness": "Sign in to your company workspace.",
        "newHere": "New to Tonnie?",
        "createAccount": "Create an account",
        "noAccount": "There's no Tonnie account with this email."
      },
      "password": {
        "title": "Enter your password",
        "label": "Password",
        "forgot": "Forgot password?",
        "submit": "Sign in",
        "codeInstead": "Email me a sign-in code instead"
      },
      "code": {
        "title": "Check your email",
        "description": "We sent a 6-digit code to {{email}}.",
        "newDevice": "This device is new to us. We sent a 6-digit code to {{email}} to confirm it's you.",
        "label": "6-digit code",
        "submit": "Sign in",
        "resend": "Send a new code",
        "resendIn": "You can send a new code in {{seconds}} s."
      },
      "totp": {
        "title": "Enter your authenticator code",
        "description": "Open your authenticator app and enter the 6-digit code for Tonnie.",
        "label": "Authenticator code"
      },
      "signUp": {
        "title": "Create your account",
        "description": "Use an account you already have, or your email.",
        "haveAccount": "Already have an account?",
        "signIn": "Sign in",
        "emailTaken": "There's already an account with this email.",
        "signInInstead": "Sign in instead",
        "legal": "By continuing, you agree to Tonnie's terms.",
        "terms": "Terms of service",
        "privacy": "Privacy policy",
        "step": "Step {{current}} of {{total}}",
        "detailsTitle": "Tell us about you",
        "firstName": "First name",
        "lastName": "Last name",
        "passwordLabel": "Create a password",
        "submit": "Create account",
        "codeNext": "Next, we'll email you a code to confirm the address.",
        "codeTitle": "Confirm your email",
        "codeSubmit": "Confirm"
      },
      "invitation": {
        "signIn": "This invitation was sent to {{email}}. Sign in with that address to accept it.",
        "signUp": "This invitation was sent to {{email}}. Create your account with that address to accept it."
      }
    },
    "security": {
      "methods": {
        "title": "Sign-in methods",
        "description": "Every way into your Tonnie account, in one place."
      },
      "email": {
        "label": "Email",
        "badge": "Sign-in & messages",
        "change": "Change"
      },
      "password": {
        "label": "Password",
        "set": "Set — use it with your email to sign in.",
        "notSetWith": "Not set — you sign in with {{providers}} or a code sent to your email.",
        "notSet": "Not set — you sign in with a code sent to your email.",
        "add": "Add password",
        "change": "Change"
      },
      "connected": {
        "heading": "Connected accounts",
        "connected": "Connected",
        "notConnected": "Not connected",
        "connect": "Connect"
      },
      "sessions": {
        "title": "Where you're signed in",
        "description": "Sign out anywhere you don't recognise.",
        "signOutOthers": "Sign out of other devices",
        "thisDevice": "This device",
        "signOut": "Sign out",
        "none": "No other devices are signed in."
      },
      "passwordDialog": {
        "changeTitle": "Change password",
        "addTitle": "Add a password",
        "description": "You'll use it the next time you sign in with your email.",
        "current": "Current password",
        "new": "New password",
        "confirm": "Confirm new password",
        "submitChange": "Update password",
        "submitAdd": "Add password"
      },
      "emailDialog": {
        "step": "Step {{current}} of {{total}}",
        "title": "Change your email",
        "description": "We'll send a code to the new address. Nothing changes until you enter it.",
        "current": "Current",
        "new": "New email",
        "linkedNote": "{{provider}} keeps signing you in. Its address stays linked to it and isn't affected by this change.",
        "send": "Send code",
        "codeTitle": "Enter the code",
        "codeDescription": "We sent it to {{email}}.",
        "codeLabel": "Code",
        "confirm": "Confirm new email",
        "resend": "Send a new code",
        "doneTitle": "Your email is changed",
        "close": "Done"
      }
    },
    "welcome": {
      "haveAccount": "I already have an account"
    }
  },
  "billing": {
    "availableBalance": "Available balance",
    "availableJourneys": "Available journeys",
    "basicAccess": "Basic access",
    "cancel": "Cancel",
    "cancelFailed": "Failed to cancel subscription. Please try again.",
    "cancelFamilyAddon": "Cancel family add-on",
    "cancelFamilyAddonError": "Failed to cancel the family add-on",
    "cancelFamilyDesc": "Your family members will lose access at the end of the current billing period.",
    "cancelMessage": "Are you sure you want to cancel your Pro subscription? You will keep access until the end of your billing period.",
    "cancelSubscriptionError": "Failed to cancel the subscription",
    "cancelSuccess": "Subscription cancelled. Access continues until period end.",
    "cancelTitle": "Cancel subscription",
    "checkoutError": "Failed to start checkout. Please try again.",
    "checkoutFailed": "Failed to start checkout. Please try again.",
    "comingSoon": "Coming soon",
    "commitmentNote": "No commitment — cancel any time.",
    "confirmCancellation": "Confirm cancellation",
    "contactSupport": "Contact support",
    "createFirstJourney": "Create your first journey",
    "currentPlan": "Current plan",
    "downgradeToFree": "Switch to Free",
    "email": "Email",
    "emailPlaceholder": "member@example.com",
    "expired": "Expired",
    "expires": "Expires",
    "expiringSoon": "Expiring soon",
    "familyAddonError": "Failed to purchase family add-on. Please try again.",
    "familyCancelFailed": "Failed to cancel family add-on. Please try again.",
    "familyCancelSuccess": "Your family add-on has been cancelled.",
    "familyDesc": "Bring your family along — shared access to your relocation journey.",
    "familyMembersWithAccess": "Family members with access",
    "familyProgram": "Family programme",
    "familyProgramAccess": "Family programme access",
    "familyPurchaseFailed": "Failed to purchase family add-on. Please try again.",
    "freeDescription": "Limited access to Tonnie features",
    "freePlan": "Free plan",
    "fullAccess": "Full access",
    "invalidEmail": "Please enter a valid email address",
    "inviteDesc": "Send an invitation so they can join your journey.",
    "inviteFailed": "Failed to send invitation. Please try again.",
    "inviteFamilyMember": "Invite a family member",
    "inviteMember": "Send invitation",
    "inviteSent": "Invitation sent to {{email}}",
    "journeyInstances": "Your journeys",
    "journeyUnlockedPro": "This journey is unlocked with Pro.",
    "keepAddon": "Keep add-on",
    "keepPro": "Keep Pro",
    "locked": "Locked",
    "manageHousehold": "Manage household",
    "members": "Members",
    "monthly": "Monthly",
    "monthlyPrice": "Monthly price",
    "needHelp": "Need help?",
    "nextRenewal": "Next renewal",
    "noFamilyMembers": "No family members yet",
    "noJourneyInstances": "You have no journeys yet",
    "paymentAlreadyProcessed": "Payment already processed. Your journey is active!",
    "paymentCompleted": "Payment completed! Your journey has been unlocked.",
    "paymentStillProcessing": "Payment is still processing. Please wait a moment and refresh.",
    "paymentSuccessUnlocked": "Payment successful! Your journey has been unlocked.",
    "paymentVerificationIssue": "Payment verification issue. Please contact support if your journey is not unlocked.",
    "pending": "Pending",
    "perMonth": "/month",
    "perYear": "/year",
    "pro": "Pro",
    "proDescription": "Unlimited journeys, all features, priority support",
    "proFullAccessDesc": "Full access to every hero, tool and document in your journey.",
    "proPlan": "Pro plan",
    "proUnlockDesc": "Unlock the full journey with Pro.",
    "proceedToPayment": "Continue to payment",
    "processing": "Processing",
    "purchaseFamilyAddon": "Add the family programme",
    "purchased": "Purchased",
    "recentInvoices": "Recent invoices",
    "recommended": "Recommended",
    "renewFailed": "Failed to renew journey. Please try again.",
    "renewJourney": "Renew journey",
    "renewStripeDesc": "You will be taken to Stripe to renew your subscription securely.",
    "revokeAccess": "Revoke access",
    "revokeConfirm": "Are you sure you want to revoke this member's access?",
    "revokeFailed": "Failed to revoke access. Please try again.",
    "revokeSuccess": "Access revoked successfully",
    "sendInvite": "Send invitation",
    "sending": "Sending",
    "statusActive": "Active",
    "stripeRedirectDesc": "You will be taken to Stripe to complete your payment securely.",
    "title": "Billing",
    "tonnieWallet": "Tonnie wallet",
    "topUpWallet": "Top up wallet",
    "unlockFailed": "Failed to unlock journey. Please try again.",
    "unlockJourney": "Unlock journey",
    "unlockNow": "Unlock now",
    "unlocked": "Unlocked",
    "unlockedJourneys": "Unlocked journeys",
    "upgradeToPro": "Upgrade to Pro",
    "verificationFailed": "Could not verify the checkout session.",
    "verificationIssue": "Payment completed but verification had an issue. Your access should be updated shortly.",
    "verifyPaymentError": "Could not verify payment. Please refresh the page or contact support.",
    "yearly": "Yearly",
    "yearlyDiscount": "Save with yearly billing",
    "planChangesUnavailable": "Plan changes aren't available in this app.",
    "invoiceKind": {
      "journey_unlock": "Journey unlock",
      "journey_renewal": "Journey renewal",
      "talent_sponsorship": "Talent sponsorship",
      "pro_subscription": "Pro subscription",
      "enterprise_subscription": "Enterprise subscription",
      "family_addon": "Family add-on",
      "subscription": "Subscription"
    },
    "invoiceStatus": {
      "draft": "Draft",
      "open": "Awaiting payment",
      "paid": "Paid",
      "void": "Voided",
      "uncollectible": "Payment failed"
    },
    "planFeature": {
      "checkup_basic": "Basic CheckUp access",
      "career_basic": "Basic career tools",
      "teleportal_limited": "Limited TelePortal access",
      "qultureup_limited": "Limited QultureUp access",
      "copilot_limited": "Limited CoPilot use",
      "passport_basic": "Basic Passport access",
      "journeys_unlimited": "Unlimited journeys",
      "checkup_full": "Full CheckUp access",
      "teleportal_full": "Full TelePortal access",
      "qultureup_full": "Full QultureUp access",
      "copilot_unlimited": "Unlimited CoPilot use",
      "care_advanced": "Advanced Care features",
      "passport_full": "Full Passport access",
      "career_tools": "Career tools",
      "journey_access_shared": "Shared journey access",
      "family_dashboard": "Family dashboard",
      "seats_unlimited": "Unlimited seats",
      "candidates_unlimited": "Unlimited candidates",
      "programs_unlimited": "Unlimited programmes",
      "cohorts_unlimited": "Unlimited cohorts",
      "copilot_queries_unlimited": "Unlimited CoPilot questions",
      "analytics_basic": "Basic analytics",
      "analytics_advanced_api": "Advanced analytics and API",
      "mobility_adaptation_full": "Full Mobility and Adaptation tracks",
      "yearly_two_months_free": "2 months free compared with monthly",
      "sponsorship_full_access": "Full journey and citizen access for the talent",
      "sponsorship_heroes": "CheckUp, TelePortal, QultureUp and Care",
      "sponsorship_passport": "Passport and achievements",
      "family_access_optional": "Optional family access add-on",
      "discount_vs_free": "{{count}}% off the Free tier",
      "support_email": "Email support",
      "support_priority": "Priority support",
      "family_members_up_to_one": "Up to {{count}} family member",
      "family_members_up_to_other": "Up to {{count}} family members",
      "seats_one": "{{count}} seat (single user)",
      "seats_other": "{{count}} seats",
      "candidates_up_to_one": "Up to {{count}} candidate",
      "candidates_up_to_other": "Up to {{count}} candidates",
      "programs_one": "{{count}} programme",
      "programs_other": "{{count}} programmes",
      "cohorts_one": "{{count}} cohort",
      "cohorts_other": "{{count}} cohorts",
      "copilot_queries_monthly_one": "{{count}} CoPilot question a month",
      "copilot_queries_monthly_other": "{{count}} CoPilot questions a month",
      "access_window_months_one": "{{count}}-month access window",
      "access_window_months_other": "{{count}}-month access window"
    },
    "seeAllInvoices": "See all"
  },
  "biometric": {
    "authenticating": "Authenticating...",
    "benefits": {
      "dataOnDevice": "Your data stays on device",
      "fastLogin": "Fast one-touch login",
      "secure": "Secure and encrypted"
    },
    "enable": "Enable {{name}}",
    "maybeLater": "Maybe later",
    "settingUp": "Setting up...",
    "touchSensorOrLook": "Touch the sensor or look at your device to authenticate",
    "tryAgain": "Try again",
    "use": "Use {{name}}",
    "usePasswordInstead": "Use password instead",
    "type": {
      "iris": "Iris scan",
      "generic": "Biometric"
    },
    "usePasscode": "Use passcode",
    "authenticatePrompt": "Authenticate to continue",
    "verifyToEnablePrompt": "Verify to enable biometric login",
    "error": {
      "initFailed": "Failed to initialize biometric authentication",
      "notSupported": "Biometric authentication not supported",
      "lockout": "Too many failed attempts. Please try again later.",
      "authFailed": "Authentication failed",
      "enableFailed": "Failed to enable biometric authentication",
      "disableFailed": "Failed to disable biometric authentication"
    }
  },
  "sponsorships": {
    "offer": {
      "fallbackCompany": "Your sponsor",
      "headline": "{{company}} would like to sponsor your journey",
      "subheadline": "Accept to unlock the full Pro experience — at no cost to you.",
      "loading": "Loading offer details…",
      "unlocks": {
        "title": "What sponsorship includes",
        "checkup": "Full CheckUp evaluation",
        "teleportal": "TelePortal relocation playbook",
        "qultureup": "QultureUp cultural integration",
        "care": "Care for the immigration journey",
        "passport": "Passport — your portable record"
      },
      "route": "Route: {{from}} → {{to}}",
      "declineNote": "If you decline, the company is automatically refunded. You'll keep your basic-tier access either way.",
      "declineCta": "Decline",
      "acceptCta": "Accept sponsorship",
      "decline": {
        "title": "Decline this sponsorship?",
        "body": "{{company}} will be refunded in full. You can still complete your CheckUp on the basic tier.",
        "reasonLabel": "Tell {{company}} why (optional)",
        "cancel": "Cancel",
        "confirmCta": "Decline anyway",
        "bodyKeepsAccess": "{{company}} will be refunded in full. Your journey stays exactly as it is."
      },
      "accepted": {
        "toast": "Welcome aboard! Your journey is now fully sponsored."
      },
      "declined": {
        "toast": "Sponsorship declined. {{company}} has been refunded."
      },
      "errors": {
        "load": "We couldn't load this sponsorship offer.",
        "accept": "Couldn't accept the sponsorship right now.",
        "decline": "Couldn't decline the sponsorship right now.",
        "notOpen": "This offer is no longer open — it was already answered or withdrawn."
      },
      "dedicatedNote": "{{company}} will sponsor a new journey of your own on this route. Your current journey stays as it is, with the companies already on it.",
      "takeover": {
        "subheadline": "{{company}} will cover this journey from now on — at no cost to you.",
        "pro": {
          "title": "You already have full access with Pro",
          "body": "{{company}} takes this journey over. Your Pro keeps covering your other journeys, and this one returns to your Pro if the sponsorship is cancelled."
        },
        "paid": {
          "title": "You already paid for this journey",
          "refund": "{{company}} takes it over, and we refund {{amount}} — the unused part of your journey unlock — to your original payment method. Refunds usually arrive within 5–10 business days.",
          "noRefund": "{{company}} takes it over. Nothing is left to refund on your journey unlock."
        },
        "declineNote": "If you decline, the company is automatically refunded and your journey stays exactly as it is."
      },
      "card": {
        "eyebrow": "Sponsorship offer",
        "detail": "Your journey to {{country}}",
        "detailDedicated": "A new journey of your own to {{country}}",
        "review": "Review offer",
        "actionFailed": "That didn't go through. Check your connection and try again."
      },
      "notNow": "Not now",
      "deferredUntil": "You put this off for now. It waits here until you decide, and comes back to Home on {{date}}.",
      "list": {
        "title": "{{company}} offers to sponsor you",
        "kind": "Sponsorship",
        "sent": "Sent {{date}}"
      }
    }
  },
  "business": {
    "activity": {
      "title": "Activity",
      "subtitle": "Everything happening across your talents",
      "empty": "No activity yet",
      "untitled": "Activity"
    },
    "pipeline": {
      "stages": {
        "acquisition": "Acquisition",
        "vetting": "Vetting",
        "mobility": "Mobility",
        "integration": "Integration",
        "adaptation": "Adaptation",
        "care": "Care",
        "evidence": "Evidence",
        "sponsored": "Sponsored",
        "pending_invite": "Pending invite",
        "archived": "Archived",
        "cohort_assigned": "Cohort assigned",
        "unknown": "Unknown"
      },
      "talentActions": "Talent actions"
    },
    "about": {
      "aboutUs": "About us",
      "backToDashboard": "Back to dashboard",
      "heroCare": "Care checkpoint management and wellbeing tracking",
      "heroCheckup": "CheckUp results, MESH scores, and iQulture insights for vetting",
      "heroEvidence": "Passport/IRR evidence and program outcomes",
      "heroPrograms": "Program and cohort management",
      "heroQultureup": "QultureUp adaptation progress via Worlds, Tracks, and Missions",
      "heroSponsored": "Sponsored journey allocations and billing",
      "heroTeleportal": "TelePortal progress across Legal, Travel, and Setup tracks",
      "heroes": "Heroes",
      "heroesDesc": "Meet the heroes behind Tonnie — the team dedicated to transforming global talent mobility.",
      "learnMore": "Learn more about Tonnie Business",
      "platformOverview": "Platform overview",
      "platformOverviewDesc": "Our platform helps businesses manage the entire talent mobility lifecycle — from sourcing and vetting to relocation and ongoing care.",
      "termsAndPrivacy": "Terms & privacy",
      "title": "About",
      "tonnieBusiness": "Tonnie Business",
      "tonnieBusinessDesc": "Tonnie Business is a comprehensive platform for managing international talent mobility, hiring, and integration programs.",
      "version": "Version {{version}}"
    },
    "adaptationPage": {
      "active": "Active",
      "activeFilter": "Active",
      "activeTab": "Active",
      "archivedTab": "Archived",
      "activelyLearning": "Actively learning",
      "attentionReason": {
        "inactive": "No activity in 2+ weeks",
        "declining": "Activity declining",
        "not_begun": "Assessment done — no missions yet",
        "streak_at_risk": "Streak about to break"
      },
      "levels": {
        "beginner": "Beginner",
        "intermediate": "Intermediate",
        "advanced": "Advanced"
      },
      "clearFilters": "Clear filters",
      "coach": "Coach",
      "errors": {
        "messageTooShort": "Message must be at least 5 characters",
        "messageTooLong": "Message must be 500 characters or fewer"
      },
      "nudge": "Nudge",
      "nudgeAria": "Send a quick nudge to {{name}}",
      "sendCoachAria": "Send coaching message to {{name}}",
      "sendMessage": "Send message",
      "streakAtRisk": "Streak at risk",
      "talentRowActionsAria": "Actions for {{name}}",
      "tryAdjustFilters": "Try adjusting your search or filters",
      "view": "View",
      "viewTalentAria": "View details for {{name}}",
      "aiCoachDesc": "Suggested coaching for each talent, from their QultureUp progress",
      "aiCoachRecommendations": "AI coach recommendations",
      "alertDescription": "{{inactive}} inactive talents, {{atRisk}} at risk, and {{streaks}} streaks at risk",
      "allCohorts": "All cohorts",
      "allEngagement": "All engagement",
      "allTalents": "All talents",
      "atRiskExcl": "At risk!",
      "atRiskFilter": "At risk",
      "avgMiles": "Avg. Miles",
      "avgQultureUpCompletion": "Avg. QultureUp completion",
      "boostMotivation": "Boost motivation",
      "celebrateTopPerformers": "Celebrate top performers",
      "coachAlert": "Coach alert",
      "coachTip1": "Personalized messages have 3x higher engagement than generic ones",
      "coachTip2": "Talents who receive weekly check-ins are 40% more likely to complete their journey",
      "coachTip3": "Celebrating small wins increases motivation and streak retention",
      "coachingCenter": "Coaching Center",
      "coachingToolkit": "Coaching toolkit",
      "coachingToolkitDesc": "Personalized coaching tools and message templates",
      "description": "Track and manage talent adaptation progress, engagement metrics, and coaching insights",
      "engagement": "Engagement",
      "engagementDistDesc": "View talent engagement across different levels",
      "engagementDistribution": "Engagement distribution",
      "engagementLegendAria": "How engagement bands are calculated",
      "engagementLegendTitle": "How bands are calculated",
      "engagementLegendDesc": "Each talent is classified from how recently they were active, their daily streak, and how many missions they completed this week.",
      "quickActionsAllClear": "All clear",
      "quickActionsAllClearDesc": "No coaching actions are needed right now.",
      "coachingQueueTitle": "Coaching queue",
      "coachingQueueDesc": "Every talent grouped by engagement — most urgent first.",
      "coachAllCount": "Coach all {{count}}",
      "noCoachingTalents": "No talents in Adaptation yet",
      "noCoachingTalentsDesc": "Talents appear here once they begin their QultureUp journey.",
      "engagementTrends": "Learning at a glance",
      "engagementTrendsDesc": "Where your talents stand this week",
      "filterByCohort": "Filter by cohort",
      "gentleNudge": "Gentle nudge",
      "healthDashboard": "Health dashboard",
      "healthScore": "Health score",
      "inactiveFilter": "Inactive",
      "insights": "Insights",
      "messageFailed": "Failed to send message",
      "messageSent": "{{type}} message sent to {{name}}",
      "miles": "Miles",
      "missions": "Missions",
      "missionsThisWeek": "Missions this week",
      "motivateActiveLearners": "Motivate active learners with new challenges",
      "needAttention": "Need attention",
      "needsEncouragement": "Needs encouragement",
      "noTalentsFound": "No talents found",
      "notificationInApp": "The talent will receive a notification in the app",
      "overallProgress": "Overall progress",
      "quickCoachActions": "Quick coach actions",
      "quickCoachActionsDesc": "One-click actions to support your talents",
      "quickNudgeSent": "Quick nudge sent to {{name}}",
      "reachInactiveTalents": "Reach inactive talents",
      "recognizeAchievements": "Recognize achievements",
      "saveStreaks": "Save streaks",
      "score": "Score",
      "searchTalents": "Search talents...",
      "sendPersonalizedMessage": "Choose an action, then add a personal note or send your company’s message.",
      "sendWeeklyChallenge": "Send weekly challenge",
      "setGoals": "Set goals",
      "showYouCare": "Show you care",
      "slowing": "Slowing down",
      "slowingDownFilter": "Slowing down",
      "streak": "Streak",
      "thriving": "Thriving",
      "thrivingFilter": "Thriving",
      "title": "Adaptation",
      "topPerformers": "Top performers",
      "topPerformersDesc": "Talents with the highest engagement and progress",
      "worlds": "Worlds",
      "writeYourMessage": "Write your message",
      "engagementDescriptions": {
        "thriving": "Highly engaged, consistent progress",
        "active": "Regular activity, steady progress",
        "slowing": "Activity decreasing, may need encouragement",
        "at_risk": "Declining engagement, needs attention",
        "inactive": "No recent activity, urgent attention needed"
      },
      "engagementCriteria": {
        "thriving": "A {{thrivingStreak}}+ day streak with strong momentum this week",
        "active": "Active recently with steady weekly momentum",
        "slowing": "Idle more than {{slowingDays}} days, or recent but losing momentum",
        "at_risk": "Idle more than {{atRiskDays}} days, or stalled with no progress this week",
        "inactive": "No activity in {{inactiveDays}}+ days"
      },
      "coachingBandMessage": {
        "thriving": "Celebrate their progress to reinforce the habit.",
        "active": "Keep the momentum going with a fresh challenge.",
        "slowing": "A timely nudge now keeps them from slipping further.",
        "at_risk": "Reach out to remove blockers and rebuild momentum.",
        "inactive": "Re-engage with a personal check-in before they disengage."
      },
      "coachingBandLabel": {
        "thriving": "Celebrate thriving talents",
        "active": "Challenge active talents",
        "slowing": "Coach slowing talents",
        "at_risk": "Coach at-risk talents",
        "inactive": "Coach inactive talents"
      },
      "coachTipsTitle": "Coach tips",
      "coachActions": {
        "encourage": "Encourage",
        "challenge": "Challenge",
        "checkin": "Check In",
        "celebrate": "Celebrate",
        "remind": "Remind"
      },
      "insightsRecommendations": {
        "topWorldRecommend": "Cultural Exploration World has highest engagement — recommend it to struggling talents",
        "sendReminders": "Send reminders",
        "celebrate": "Celebrate",
        "recommend": "Recommend",
        "checkIn": "Check In",
        "streaksAtRisk_one": "{{count}} talent is about to lose their streak — send a reminder now",
        "streaksAtRisk_other": "{{count}} talents are about to lose their streaks — send reminders now",
        "thrivingCelebrate_one": "{{count}} talent is thriving — consider celebrating their achievements",
        "thrivingCelebrate_other": "{{count}} talents are thriving — consider celebrating their achievements",
        "inactiveCheckIn_one": "{{count}} talent hasn't logged in for 2+ weeks — they may need a check-in",
        "inactiveCheckIn_other": "{{count}} talents haven't logged in for 2+ weeks — they may need a check-in"
      },
      "trendMetrics": {
        "activeLearners": "Active learners",
        "weeklyMissions": "Weekly missions",
        "avgMiles": "Avg. Miles"
      },
      "noOneNeedsAttention": "No one needs immediate attention",
      "confirmBulkSend": "Send {{count}}",
      "personalNote": "Personal note (optional)",
      "personalNoteHint": "Leave it empty to send your company’s {{action}} message from Messages.",
      "ofTotal": "{{value}} of {{total}}",
      "viewAllInBand": "View all {{count}}",
      "dayStreak_one": "{{count}} day streak",
      "dayStreak_other": "{{count}} day streak",
      "engagementBandAria_one": "Show {{count}} {{band}} talent",
      "engagementBandAria_other": "Show {{count}} {{band}} talents",
      "needsAttentionCount_one": "{{count}} needs attention",
      "needsAttentionCount_other": "{{count}} need attention",
      "milesCount_one": "{{count}} Mile",
      "milesCount_other": "{{count}} Miles",
      "talentCount_one": "{{count}} talent",
      "talentCount_other": "{{count}} talents",
      "viewAllNeedingAttention_one": "View the {{count}} needing attention",
      "viewAllNeedingAttention_other": "View all {{count}} needing attention",
      "confirmBulkTitle_one": "Send {{count}} coaching message?",
      "confirmBulkTitle_other": "Send {{count}} coaching messages?",
      "confirmBulkDescription_one": "About to send \"{{action}}\" to {{count}} talent. They will receive a notification in their mobile app.",
      "confirmBulkDescription_other": "About to send \"{{action}}\" to {{count}} talents. Each will receive a notification in their mobile app.",
      "searchTalentsLabel": "Search talents"
    },
    "addTalentsWizard": {
      "addCohortToOrganize": "Add a new cohort to organize talents",
      "atsIntegration": "ATS integration",
      "atsMethodDesc": "Connect your ATS system and import candidates directly into your pipeline. Sync in real-time with your existing recruitment tools.",
      "biWeekly": "Bi-weekly (first 8 weeks)",
      "cancel": "Cancel",
      "chooseCohortForCandidates": "Choose which cohort to add these candidates to",
      "chooseCohortForTalents": "Choose which cohort to add these talents to",
      "clear": "Clear",
      "close": "Close",
      "cohortCreated": "Cohort \"{{name}}\" created successfully",
      "cohortNamePlaceholder": "e.g., Q2 2024 — Backend Engineers",
      "cohortNameRequired": "Cohort name *",
      "cohortsCanExistWithoutProgram": "Cohorts can exist without a program. Routes are defined per-talent when sponsoring.",
      "connectAdditionalATS": "You can connect additional ATS systems from your integrations settings.",
      "createCohortButton": "Create cohort",
      "createCohortDesc": "Create a new cohort. You can assign it to a program later, or leave it unassigned.",
      "createNewCohort": "Create new cohort",
      "createNewProgram": "Create new program",
      "createProgramButton": "Create program",
      "createProgramDesc": "Create a new program to organize your international hiring initiatives.",
      "defaultFeedbackCadence": "Default feedback cadence",
      "describeProgramPlaceholder": "Describe the program's goals and scope...",
      "descriptionOptional": "Description (optional)",
      "deselectAll": "Deselect all",
      "downloadTemplateCsv": "Download template CSV",
      "dropFileHere": "Drop your file here or click to browse",
      "email": "Email",
      "enterProgramName": "Please enter a program name",
      "errorReason": "Reason",
      "errorReason_duplicate": "Duplicate",
      "errorReason_invalid": "Invalid",
      "errorReason_system": "System error",
      "errors": {
        "cohortNameRequired": "Cohort name is required",
        "createCohortFailed": "Couldn't create the cohort. Please try again.",
        "createProgramFailed": "Couldn't create the program. Please try again.",
        "emptyFile": "The file is empty or has no data rows",
        "endDateInvalid": "Enter a valid end date",
        "malformedFile": "We couldn't read this file. Try saving it as .csv and re-uploading.",
        "mustMapEmail": "Map at least one column to Email before continuing",
        "mustMapName": "Map at least one column to First name (or Full name) before continuing",
        "noValidRows": "No rows passed validation. Fix the errors above and try again.",
        "programNameRequired": "Program name is required",
        "selectCohort": "Select a cohort before continuing",
        "startDateInvalid": "Enter a valid start date",
        "startDateRequired": "Start date is required",
        "systemFailure": "Something went wrong. Please try again.",
        "tooManyRows": "Files are limited to {{max}} rows. Split your file and try again.",
        "unsupportedFile": "Please upload a .csv, .xlsx, or .xls file",
        "planLimit": "Free plan allows up to 100 candidates. Upgrade to Enterprise to add more.",
        "fileTooLarge": "File is larger than 10 MB. Trim the file and try again.",
        "cohortAtCapacity": "This cohort is full ({{max}} talents). Choose another cohort or raise its limit.",
        "programAtCapacity": "This program is full ({{max}} talents). Choose another program or raise its limit."
      },
      "excelColumn": "Excel column",
      "excelCsvUpload": "Excel/CSV upload",
      "excelMethodDesc": "Import talents from spreadsheet files. Supports Excel and CSV formats with automatic column mapping.",
      "expectedTalentCount": "Expected talent count (optional)",
      "fieldLabels": {
        "email": "Email",
        "firstName": "First name",
        "ignore": "Ignore",
        "lastName": "Last name",
        "location": "Location",
        "name": "Full name (will be split)",
        "role": "Role",
        "skills": "Skills"
      },
      "fileReady": "File ready!",
      "fillRequiredFields": "Please fill in all required fields",
      "firstName": "First name",
      "fixValidationErrors": "Please fix validation errors before continuing",
      "importCandidatesFrom": "Import candidates directly from {{name}}",
      "importMethodLabel": "Import method",
      "importSummary": "Import summary",
      "invalidEmail": "Invalid email",
      "invalidFileType": "Please upload a valid Excel or CSV file",
      "inviteToVetting": "Invite to vetting",
      "inviteToVettingFailed": "Failed to invite talents",
      "lastName": "Last name",
      "location": "Location",
      "mapColumnsInstruction": "Map Excel columns to Tonnie fields. First 5 rows shown:",
      "mapTo": "Map To",
      "match": "match",
      "missingName": "Missing name",
      "monthly": "Monthly (months 3-6)",
      "name": "Name",
      "needDifferentATS": "Need to connect a different ATS?",
      "noDataYet": "No data yet — talents in this stage will populate this view",
      "noProgramUnassigned": "No program (unassigned)",
      "plusMore": "+ More",
      "poolMethodDesc": "Browse and add talents from your Tonnie Talent Pool directly into your pipeline.",
      "programCreated": "Program \"{{name}}\" created successfully",
      "programNamePlaceholder": "e.g., Tech Talent Initiative",
      "programNameRequired": "Program name *",
      "programOptional": "Program (optional)",
      "quarterly": "Quarterly (months 6-12)",
      "readyToImport": "Ready to import talents",
      "readyToMapColumns": "Ready to map columns",
      "requiredFields": "Name and Email are required fields",
      "resultDuplicates": "Duplicates",
      "resultFailed": "Failed",
      "resultImported": "Imported",
      "resultPartial": "Some talents were not imported",
      "role": "Role",
      "samplePreview": "Sample value",
      "searchPlaceholder": "Search by name, role, or location...",
      "select": "Select",
      "selectATSError": "Please select an ATS system",
      "selectAllCount": "Select all ({{count}})",
      "selectCandidateError": "Please select at least one candidate",
      "selectCohortError": "Please select a cohort",
      "selectFile": "Select file",
      "selectProgramOptional": "Select program (optional)",
      "selectedLabel": "Selected",
      "startDateRequired": "Start date *",
      "status": "Status",
      "stepATS": "ATS",
      "stepCohort": "Cohort",
      "stepConfirm": "Confirm",
      "stepMap": "Map",
      "stepMethod": "Method",
      "stepReview": "Review",
      "stepSelect": "Select",
      "stepUpload": "Upload",
      "supportsFileTypes": "Supports Excel (.xlsx, .xls) and CSV files up to 10MB",
      "targetArrivalDate": "Target arrival date",
      "toastImportedHint": "Open the Pipeline > Acquisition column and click Send Invitation to Vetting when you're ready to email each candidate.",
      "toastNothingImported": "No talents imported",
      "totalCandidates": "Total candidates",
      "totalTalents": "Total talents",
      "unassigned": "Unassigned",
      "uploadDifferentFile": "Upload a different file",
      "vettingNotStarted": "Vetting has not started for this talent",
      "whatHappensNext": "What happens next?",
      "whatHappensNextDesc": "After importing, talents will appear in the Acquisition stage. You can then invite them to CheckUp and sponsor those who are ready.",
      "addingToPill": "Adding to: {{name}}",
      "guard": {
        "archivedTitle": "This cohort is archived",
        "pausedTitle": "This cohort is paused",
        "programPausedTitle": "Parent program is paused",
        "archivedBody": "Archived cohorts cannot accept new talents. Restore the cohort first to invite people to it.",
        "pausedBody": "Paused cohorts cannot accept new talents. Resume the cohort first to invite people to it.",
        "programPausedBody": "The parent program is paused. Resume the program to start accepting new talents into this cohort.",
        "cohortPill": "Cohort: {{name}}"
      },
      "issues": {
        "emailInvalid": "Invalid or missing email",
        "emailDuplicate": "Duplicate of row {{row}}",
        "nameMissing": "Missing first name",
        "textTooLong": "{{field}} is longer than {{max}} characters",
        "skillsTooMany": "More than {{max}} skills",
        "skillTooLong": "A skill is longer than {{max}} characters"
      },
      "candidatesAttached_one": "{{count}} candidate attached to the cohort",
      "candidatesAttached_other": "{{count}} candidates attached to the cohort",
      "candidatesSelected_one": "{{count}} candidate selected",
      "candidatesSelected_other": "{{count}} candidates selected",
      "candidatesWillBeAdded_one": "{{count}} candidate will be added to {{cohort}}",
      "candidatesWillBeAdded_other": "{{count}} candidates will be added to {{cohort}}",
      "candidatesWillBeAddedVetting_one": "{{count}} candidate will be added to the selected cohort and can be invited to start vetting.",
      "candidatesWillBeAddedVetting_other": "{{count}} candidates will be added to the selected cohort and can be invited to start vetting.",
      "errorsCount_one": "{{count}} error",
      "errorsCount_other": "{{count}} errors",
      "errorsTitle_one": "{{count}} row needs attention",
      "errorsTitle_other": "{{count}} rows need attention",
      "inviteToVettingSent_one": "Invited {{count}} talent to vetting",
      "inviteToVettingSent_other": "Invited {{count}} talents to vetting",
      "ofShown_one": "(of {{count}} shown)",
      "ofShown_other": "(of {{count}} shown)",
      "readyToAddCandidates_one": "Ready to add {{count}} candidate from your ATS",
      "readyToAddCandidates_other": "Ready to add {{count}} candidates from your ATS",
      "readyToImportTalents_one": "Ready to import {{count}} talent from your spreadsheet",
      "readyToImportTalents_other": "Ready to import {{count}} talents from your spreadsheet",
      "resultAllImported_one": "Imported {{count}} talent",
      "resultAllImported_other": "Imported {{count}} talents",
      "reviewImportedData_one": "Review imported data ({{count}} row)",
      "reviewImportedData_other": "Review imported data ({{count}} rows)",
      "rowsDetected_one": "{{count}} row detected",
      "rowsDetected_other": "{{count}} rows detected",
      "talentsCount_one": "{{count}} talent",
      "talentsCount_other": "{{count}} talents",
      "talentsImported_one": "{{count}} talent imported",
      "talentsImported_other": "{{count}} talents imported",
      "talentsWillBeImported_one": "{{count}} talent will be imported into {{cohort}}",
      "talentsWillBeImported_other": "{{count}} talents will be imported into {{cohort}}",
      "talentsWillBeImportedAcquisition_one": "{{count}} talent will be imported into the selected cohort and will appear in the Acquisition stage.",
      "talentsWillBeImportedAcquisition_other": "{{count}} talents will be imported into the selected cohort and will appear in the Acquisition stage.",
      "toastDuplicates_one": "{{count}} already in your company",
      "toastDuplicates_other": "{{count}} already in your company",
      "toastFailed_one": "{{count}} failed",
      "toastFailed_other": "{{count}} failed",
      "toastImported_one": "{{count}} added to Acquisition",
      "toastImported_other": "{{count}} added to Acquisition",
      "validCount_one": "{{count}} valid",
      "validCount_other": "{{count}} valid",
      "mapColumnTo": "Map column {{column}} to"
    },
    "sponsor": {
      "modal": {
        "title": "Sponsor {{firstName}}'s journey",
        "subtitle": "Activate the full Tonnie experience for this talent.",
        "steps": {
          "recap": "Recap",
          "pricing": "Pricing",
          "message": "Message",
          "review": "Review"
        },
        "step1": {
          "noCheckup": "CheckUp pending — score will appear once {{firstName}} completes the assessment.",
          "craHeading": "Risk profile",
          "verdictHeading": "Why sponsor now",
          "verdict": {
            "pro": "Strong PRO candidate. Sponsorship unlocks the full journey for a high-confidence hire.",
            "potential": "High potential — sponsorship accelerates the path from evaluation to evidence.",
            "emerging": "Emerging signal — sponsorship enables full evaluation across all five heroes."
          },
          "unlocksHeading": "What sponsoring unlocks",
          "unlocksFootnote": "Once {{firstName}} accepts, all five heroes activate.",
          "continueCta": "Continue to pricing"
        },
        "step2": {
          "heading": "Pricing",
          "planNameFree": "Pay-as-you-go",
          "planNameEnterprise": "Enterprise rate",
          "subtitle": "One-time charge — pro-rated refund if you cancel later.",
          "monthlyRate": "Monthly rate",
          "duration": "Duration",
          "total": "Total commitment",
          "billedOnce": "Billed once via Stripe",
          "heroes": {
            "checkup": "CheckUp",
            "teleportal": "TelePortal",
            "qultureup": "QultureUp",
            "care": "Care",
            "passport": "Passport"
          },
          "familyAccess": "Family access",
          "familyAccessHint": "Include household members in the journey",
          "refundHeading": "Refundable on a pro-rated basis",
          "refundScenarios": {
            "decline": {
              "label": "If they decline",
              "body": "full automatic refund, no action needed."
            },
            "cancel": {
              "label": "If you cancel partway",
              "body": "refund equals months remaining × monthly rate."
            },
            "lock": {
              "label": "Heroes lock until acceptance",
              "body": "no risk before talent accepts."
            }
          },
          "refundFootnote": "Refunds are processed automatically through Stripe.",
          "continueCta": "Continue to message",
          "durationMonths_one": "{{count}} month",
          "durationMonths_other": "{{count}} months"
        },
        "step3": {
          "subtitle": "Tonnie sends a curated activation email with the accept/decline link. Add an optional personal note that will appear in the email above the call-to-action.",
          "customMessageLabel": "Your note (optional)",
          "customMessagePlaceholder": "Welcome aboard — we'd love to have you join us in {{destination}}.",
          "charsCounter": "{{count}} / {{max}}",
          "previewHeading": "Email preview",
          "previewSubheading": "What {{firstName}} will actually receive",
          "previewAriaLabel": "Preview of the activation email {{firstName}} will receive",
          "previewDisclaimer": "Auto-sent on payment success. {{firstName}} has unlimited time to accept.",
          "toneHint": {
            "concise": "Concise",
            "warm": "Warm",
            "professional": "Detailed"
          },
          "chips": {
            "label": "Quick inserts",
            "destination": "Add destination",
            "destinationSnippet": "We can't wait to have you with us in {{destination}}.",
            "destinationAria": "Insert a sentence about the destination",
            "teamWelcome": "Add team welcome",
            "teamWelcomeSnippet": "The whole {{company}} team is rooting for you.",
            "teamWelcomeAria": "Insert a welcome sentence from the team",
            "signoff": "Add sign-off",
            "signoffSnippet": "Looking forward to building this journey together.",
            "signoffAria": "Insert a personal sign-off sentence"
          },
          "continueCta": "Review and pay"
        },
        "step4": {
          "talentLabel": "Talent",
          "routeLabel": "Route",
          "pricingLabel": "Pricing",
          "rateTimesMonths": "{{rate}}/mo × {{count}}",
          "messageLabel": "Activation note",
          "messageEmptyPlaceholder": "Tonnie's default activation message will be sent.",
          "routeEmpty": "Set on the talent profile.",
          "routeUnknown": "Not set",
          "vatNote": "Taxes (if any) are calculated in Stripe Checkout.",
          "previewToggle": "Preview the activation email",
          "previewToggleOpen": "Hide email preview",
          "commitmentTitle": "You're about to commit",
          "commitmentBody": "{{total}} today. Pro-rated refund available throughout the {{durationMonths}}-month window. {{firstName}} has unlimited time to accept.",
          "trustAriaLabel": "Payment trust signals",
          "trust": {
            "stripe": "Stripe-secured",
            "refundable": "Pro-rated refund",
            "noExpiry": "No expiry for talent",
            "autoSent": "Email auto-sent"
          },
          "nextTitle": "What happens next",
          "next": {
            "s1": "We open Stripe Checkout in this tab.",
            "s2": "On payment success, {{firstName}} gets your activation email automatically.",
            "s3": "The card moves to Sponsored — Awaiting acceptance."
          },
          "payCta": "Sponsor & pay {{total}}"
        },
        "preview": {
          "fromLabel": "From",
          "subject": "{{company}} would like to sponsor your Tonnie journey",
          "greeting": "Hi {{firstName}},",
          "introTail": "just paid to sponsor your full Tonnie journey — pending your acceptance.",
          "unlocksHeading": "What you unlock if you accept",
          "heroes": {
            "checkup": "full iQulture evaluation",
            "teleportal": "visa, relocation, and housing playbook",
            "qultureup": "cultural integration missions",
            "care": "wellbeing support through the move",
            "passport": "your portable record of progress"
          },
          "noCost": "It costs you nothing. If you decline, {{company}} is automatically refunded and you keep your basic access.",
          "yourNoteHeading": "A note from the team",
          "ctaLabel": "Review and respond to the sponsorship offer",
          "noExpiry": "This offer waits for you — there is no expiration. Take the time you need.",
          "signOff": "Welcome aboard,",
          "signature": "The Tonnie team",
          "fallbackCompany": "Your company"
        },
        "footer": {
          "back": "Back",
          "cancel": "Cancel",
          "peekPreview": "Peek the email"
        },
        "errors": {
          "checkoutFailed": "Couldn't open Stripe Checkout. Try again or contact support.",
          "customMessageTooLong": "Your note must be 2000 characters or fewer.",
          "planNotFound": "The sponsorship plan could not be found. Contact support.",
          "planMisconfigured": "The sponsorship plan is not set up correctly. Contact support.",
          "discountUnavailable": "That discount is no longer available. Review the price and try again.",
          "planLimitExceeded": "You have reached your plan's limit. Upgrade to sponsor more talents.",
          "needsInvitation": "Your company has no relationship with this person yet, so they can't be sponsored directly. Invite them from the Pool first.",
          "inviteFromPool": "Invite from the Pool",
          "alreadySponsored": "This journey already has a sponsorship in progress, so it can't be sponsored again until that one ends.",
          "sharedWithAnotherCompany": "Another company also follows this person on this journey, and a sponsored journey belongs to one company. You can sponsor them on a journey of your own on the same route — they accept it with your offer.",
          "sponsoredByAnotherCompany": "Another company already sponsors this journey.",
          "routeFull": "This person already has the most journeys a route can hold, so a new one can't be created for you. They can archive one first.",
          "sponsorDedicated": "Sponsor on a journey of your own",
          "notSponsorable": "This journey is already funded in a way a company sponsorship can't take over, so nothing was charged."
        }
      },
      "return": {
        "verifyingPayment": "Confirming your payment…",
        "paymentFailed": "Payment couldn't be confirmed",
        "paymentFailedDescription": "Tonnie didn't receive a paid Stripe Checkout session. If you completed payment, refresh in a moment — webhooks can take a few seconds to land. Otherwise, try again from the Vetting drawer.",
        "backToVetting": "Back to Vetting",
        "stepConfirm": {
          "title": "Sponsorship paid — awaiting acceptance",
          "subtitleHint": "The talent stays in Vetting, marked “Sponsorship offered”, until they accept.",
          "headline": "Sponsorship paid — activation email sent",
          "awaitingTitle": "Awaiting talent acceptance",
          "body": "The talent will receive an email and can accept or decline. They move to Sponsored when they accept; if they decline, you're refunded automatically. Until then you'll find them in Vetting, where you can resend the offer or abandon it.",
          "backToVetting": "Back to Vetting",
          "viewTalent": "View talent",
          "resendCta": "Resend activation email",
          "resendSuccess": "Activation email re-sent.",
          "resendAlready": "Activation email was already sent — no duplicate dispatched."
        },
        "errors": {
          "missingSponsorship": "Tonnie is still confirming the payment. Refresh in a few seconds and try again.",
          "resendFailed": "Couldn't resend the activation email."
        }
      }
    },
    "talentDetail": {
      "loading": "Loading…",
      "viewFullVettingReport": "View full vetting report",
      "header": {
        "couple": "Couple",
        "familyWithKids": "Family +{{count}}",
        "singleParent": "Single parent +{{count}}",
        "openLinkedIn": "Open LinkedIn profile",
        "solo": "Solo",
        "sponsorCta": "Sponsor this talent"
      },
      "iqultureBlock": {
        "ariaLabel": "iQulture score {{score}} out of 100, tier {{tier}}",
        "label": "iQulture"
      },
      "kebab": {
        "label": "More actions"
      },
      "insights": {
        "vettingInsights": "Tonnie's verdict at a glance — score, MESH foundations, cultural risks, and pillar evidence in one decision dashboard.",
        "vettingMesh": "Motivation, English, Soft skills, Hard skills — the four signals every confident sponsor decision is built on.",
        "vettingArchetypes": "Cultural archetypes reveal how {{name}} adapts. Low-risk archetypes are your safest sponsor bets.",
        "vettingPillars": "Each pillar is independently scored with green flags, red flags, and evidence — the audit trail behind the iQulture score.",
        "vettingSkills": "What {{name}} brings to the table: soft skills, hard skills, and how they fit culturally.",
        "vettingPitch": "{{name}}'s 60-second pitch — see them in their own words before sponsoring.",
        "vettingProfile": "Identity, background, family context — the complete profile {{name}} built on Tonnie.",
        "vettingActivity": "Every signal Tonnie captured: messages sent, stage transitions, hero milestones.",
        "sponsoredOverview": "Where {{name}} is right now in their relocation journey.",
        "sponsoredVetting": "Why you sponsored {{name}}: their iQulture score and MESH evidence.",
        "sponsoredMobility": "Legal & documents, local setup, travel & logistics — three mobility tracks. A blocker here delays everything else.",
        "sponsoredAdaptation": "QultureUp turns culture shock into measurable adaptation. Consistency beats sprints.",
        "sponsoredCare": "Stability is sponsored success. The cheap check-in today prevents the expensive recovery later.",
        "sponsoredEvidence": "Tangible proof of {{name}}'s journey: badges, miles, milestones.",
        "sponsoredActivity": "Live signal from every hero — the 'what's been happening?' answer admins always need."
      },
      "toneRibbon": {
        "label": "Tonnie recommends",
        "phase": {
          "invited": "Invited",
          "started": "CheckUp in progress",
          "submitted": "CheckUp submitted",
          "scored": "Scored",
          "verdict": "Ready for verdict"
        },
        "tone": {
          "green": "Strong fit — proceed with confidence",
          "amber": "Some caveats — review insights before sponsoring",
          "red": "Significant concerns — read flags carefully",
          "neutralAwaiting": "Awaiting CheckUp signal",
          "neutralScored": "Score available — qualitative signal pending"
        }
      },
      "recommendation": {
        "green": {
          "title": "Tonnie recommends sponsoring"
        },
        "amber": {
          "title": "Sponsor with eyes open"
        },
        "red": {
          "title": "Significant concerns"
        },
        "neutral": {
          "title": "Recommendation pending"
        }
      },
      "radar": {
        "tooltip": {
          "pillar": {
            "scoreAt": "At {{min}}–{{max}}",
            "evaluationQuestion": "Brain asks",
            "band": {
              "excellent": "Excellent",
              "solid": "Solid",
              "mixed": "Mixed",
              "weak": "Weak",
              "tier": "Tier {{tier}}"
            }
          },
          "archetype": {
            "persona": "{{persona}} persona",
            "bucketLow": "Low risk ({{score}})",
            "bucketModerate": "Moderate risk ({{score}})",
            "bucketHigh": "High risk ({{score}})"
          }
        },
        "axis": {
          "ariaLabel": "More about {{label}}"
        }
      },
      "insightsTab": {
        "label": "Insights",
        "emptyTitle": "Insights unlock once the CheckUp is scored",
        "verdict": {
          "scoreSuffix": "/ 100",
          "badgeLabel": "iQulture badge",
          "scoreLabel": "iQulture score",
          "confidenceBand": {
            "high": "High confidence",
            "moderate": "Moderate confidence",
            "low": "Low confidence"
          },
          "confidenceTooltip": "Tonnie's confidence in this assessment: {{percent}}% (average across the 7 evaluation pillars).",
          "scoredToday": "Scored today",
          "scoredAgo_one": "Scored {{count}}d ago",
          "scoredAgo_other": "Scored {{count}}d ago",
          "fallbackRationale": "Tonnie evaluated this profile across MESH foundations and 10 cultural archetypes — the supporting tabs below carry the full breakdown.",
          "rationaleStrong": "Strong {{strongest}} ({{strongestScore}}%) carries this profile.",
          "rationaleWeak": "Weakness in {{weakest}} ({{weakestScore}}%) is the headline concern.",
          "rationaleAlert": "Top alert: {{alert}}",
          "eyebrow": "Tonnie's recommendation"
        },
        "deepLink": {
          "openActivity": "Open activity",
          "openArchetypes": "Open archetypes",
          "openMesh": "Open MESH",
          "openPillars": "Open pillars",
          "openPitch": "Open pitch",
          "openSkills": "Open skills"
        },
        "deepDive": {
          "activity": "Engagement timeline and activity for this profile",
          "pillars": "For the audit trail and pillar-by-pillar evidence",
          "pitch": "To see this candidate in their own words",
          "skills": "For the full capability inventory",
          "title": "Where to look next"
        },
        "badgeAndScore": {
          "title": "iQulture score & badge",
          "scoreLabel": "Score",
          "badgeLabel": "Badge"
        },
        "mesh": {
          "title": "MESH foundations",
          "subtitle": "The four signals every confident sponsorship is built on."
        },
        "conclusion": {
          "title": "Tonnie's conclusion"
        },
        "snapshot": {
          "title": "At-a-glance"
        },
        "cra": {
          "title": "Cultural risk archetypes",
          "severityChip": "{{low}} low · {{moderate}} moderate · {{high}} high",
          "severityTier": {
            "low": "low",
            "moderate": "moderate",
            "high": "high"
          },
          "radarSeries": "Risk score",
          "radarA11yLabel": "Cultural Risk Archetypes radar — {{summary}}",
          "empty": "No archetype data available yet.",
          "description_one": "Where {{name}} sits on the {{count}} archetype — closer to the centre = lower cultural risk.",
          "description_other": "Where {{name}} sits across the {{count}} archetypes — closer to the centre = lower cultural risk."
        },
        "pillars": {
          "title": "Pillar evaluation",
          "description": "All seven evaluation pillars on one radar — closer to the outer edge means a stronger pillar score.",
          "confidenceChip": "{{band}} · avg confidence",
          "radarSeries": "Pillar score",
          "radarA11yLabel": "Pillar evaluation radar — {{summary}}",
          "legendUnknownCodes": "Axis labels are pillar codes. Open the Pillars tab for the full breakdown."
        }
      },
      "tabs": {
        "testit": "TestIt",
        "activity": "Activity",
        "adaptation": "Adaptation",
        "archetypes": "Archetypes",
        "care": "Care",
        "checkup": "CheckUp",
        "evidence": "Evidence",
        "insights": "Insights",
        "mesh": "MESH",
        "mobility": "Mobility",
        "overview": "Overview",
        "pillars": "Pillars",
        "pitch": "Pitch",
        "profile": "Profile",
        "skills": "Skills",
        "vetting": "Vetting",
        "decisionRecords": "Decision records",
        "stripLabel": "Talent sections",
        "scrollPrevious": "Show earlier sections",
        "scrollNext": "Show more sections"
      },
      "communications": {
        "privacyNote": "You see what was sent and what happened to it — never its content, the address it went to, or why a message was not delivered.",
        "empty": "Nothing has been sent to this talent yet.",
        "loadError": "Could not load communications. Try again in a moment.",
        "loadMore": "Load older messages",
        "channelEmail": "Email",
        "channelInApp": "In the app",
        "channelPush": "Push",
        "kindSystem": "Automatic message",
        "kindAdmin": "Message from your team",
        "kindInApp": "In-app notification",
        "statusQueued": "Queued",
        "statusDispatched": "Sent · outcome not recorded",
        "statusSent": "Sent",
        "statusDelivered": "Delivered",
        "statusOpened": "Opened",
        "statusFailed": "Failed",
        "statusBounced": "Bounced",
        "statusNotDelivered": "Not delivered",
        "deliveredAt": "Delivered {{date}}",
        "openedAt": "Opened {{date}}",
        "readInAppAt": "Read in Tonnie {{date}}"
      },
      "activity": {
        "empty": "No activity yet — events will appear here when the talent moves through the pipeline, completes a CheckUp step, or receives a message.",
        "error": "Could not load activity. Try again in a moment.",
        "eventCount_one": "{{count}} event",
        "eventCount_other": "{{count}} events",
        "loadMore": "Load older activity",
        "loadingMore": "Loading older activity…",
        "live": "Live",
        "polling": "Refreshing periodically",
        "withheldBody": "This citizen has not shared their own activity with your company. Any events shown are your company's own: pipeline moves and messages you sent.",
        "eventCountPartial_one": "{{count}} event from your company only",
        "eventCountPartial_other": "{{count}} events from your company only",
        "viewLabel": "Show",
        "view": {
          "all": "All",
          "progress": "Talent progress",
          "pipeline": "Pipeline",
          "messages": "Messages"
        },
        "viewEmpty": "Nothing in this view yet.",
        "hero": {
          "checkup": "CheckUp",
          "mobility": "Mobility",
          "adaptation": "Adaptation",
          "care": "Care",
          "evidence": "Evidence",
          "pipeline": "Pipeline",
          "system": "Tonnie"
        },
        "actorNotRecorded": "Actor not recorded"
      },
      "sponsored": {
        "ribbon": {
          "status": {
            "awaitingAcceptance": "Awaiting talent acceptance",
            "active": "Active sponsorship",
            "cancelling": "Refund processing",
            "talentDeclined": "Talent declined",
            "refunded": "Refunded",
            "cancelled": "Cancelled",
            "pastDue": "Payment past due",
            "failed": "Payment failed",
            "unknown": "No active sponsorship",
            "completed": "Completed"
          },
          "monthsRemaining_one": "{{count}} mo remaining",
          "monthsRemaining_other": "{{count}} mo remaining",
          "refundAtRisk": "{{amount}} refund at risk",
          "acceptedOn": "Accepted {{date}}",
          "awaitingTalent": "Awaiting talent acceptance"
        },
        "health": {
          "totalMonths_one": "{{count}} mo",
          "totalMonths_other": "{{count}} mo",
          "elapsed": "{{elapsed}} of {{total}} months elapsed",
          "awaitingActivationSent": "Activation sent {{ago}}",
          "awaitingBody": "The talent has been emailed an activation link. The sponsorship activates the moment they accept.",
          "cancellingBody": "The refund is processing. Stripe will notify us when the funds settle; the sponsorship will move to refunded automatically.",
          "declinedBody": "The talent declined the sponsorship offer. A full refund has been issued.",
          "closedBody": "The sponsorship is closed and the company no longer funds this journey. The talent keeps their own access to it and can still complete their CheckUp.",
          "closedOn": "Closed {{date}}",
          "paymentFailedBody": "The latest sponsorship payment failed. Update the payment method to keep the talent active.",
          "refundAmount": "Refund amount: {{amount}}",
          "completedBody": "The 12-month sponsorship ran its course. Nothing is refunded; the talent continues on their own plan.",
          "completedOn": "Ended {{date}}"
        },
        "heroes": {
          "mobility": "Mobility",
          "adaptation": "Adaptation",
          "care": "Care",
          "evidence": "Evidence",
          "notStarted": "Not started yet"
        },
        "heroesGrid": {
          "mobilitySubtitle": "Visa, paperwork, travel readiness",
          "adaptationSubtitle": "Cultural prep, missions, streak",
          "careSubtitle": "Wellbeing, stability, interventions",
          "evidenceSubtitle": "Badges, stamps and miles earned",
          "blockers_one": "{{count}} blocker",
          "blockers_other": "{{count}} blockers",
          "worldsLabel": "Worlds",
          "missionsLabel": "Missions",
          "tracksLabel": "Tracks",
          "streakDays_one": "{{count}}d streak",
          "streakDays_other": "{{count}}d streak",
          "wellbeingLabel": "Wellbeing score",
          "lastCheckin": "Last {{ago}}",
          "openInterventions_one": "{{count}} open",
          "openInterventions_other": "{{count}} open",
          "moodLabel": "Mood",
          "settlementLabel": "Settlement",
          "checkpointsValue": "{{done}}/{{total}} checkpoints",
          "docsReady": "Docs ready",
          "assessmentDone": "Assessment done",
          "awaitingData": "Awaiting the first check-in to see the wellbeing score.",
          "miles": "Miles",
          "badges": "Badges",
          "stamps": "Stamps",
          "openTabHint": "Open the tab to nudge"
        },
        "activity": {
          "preview": {
            "title": "Recent activity",
            "viewAll": "View full activity",
            "empty": "No sponsorship events yet"
          }
        },
        "meta": {
          "familyAccess": "Family access",
          "familyAccessOn": "Enabled",
          "familyAccessOff": "Disabled",
          "familyAccessOnToast": "Family access enabled",
          "familyAccessOffToast": "Family access disabled",
          "familyAccessFailed": "Failed to update family access",
          "startedAt": "Started",
          "endsAt": "Ends",
          "amountPaid": "Amount paid",
          "refundIfCancelledToday": "Refund if cancelled today",
          "monthsLeft_one": "{{count}} month left",
          "monthsLeft_other": "{{count}} months left"
        },
        "banner": {
          "headline": "{{name}}'s journey",
          "miles": "Journey Miles",
          "monthsLeft": "Months left",
          "ctaViewVetting": "View assessment",
          "ctaOpenMobility": "Open Mobility",
          "ctaOpenAdaptation": "Open Adaptation",
          "ctaOpenCare": "Open Care",
          "statusNotStarted": "Not started",
          "statusLocked": "Locked",
          "statusDone": "Done",
          "day": "Day {{day}}",
          "dayLabel": "of the journey",
          "nextEyebrow": "Where to look next"
        },
        "footer": {
          "action": {
            "resendActivation": "Resend activation email",
            "abandon": "Abandon sponsorship",
            "cancel": "Cancel sponsorship",
            "close": "Close",
            "reoffer": "Re-offer sponsorship",
            "updatePayment": "Update payment"
          },
          "refundProcessing": "Refund processing — no actions while Stripe finalises"
        },
        "smartNudge": {
          "sending": "Sending…",
          "cta": {
            "mobility": "Send mobility task",
            "adaptation": "Send adaptation reminder",
            "care": "Send Care check-in"
          },
          "sent": {
            "mobility": "Mobility task reminder sent to {{name}}",
            "adaptation": "Adaptation reminder sent to {{name}}",
            "care": "Care check-in request sent to {{name}}"
          },
          "errorMissingEmail": "Cannot send — talent has no email on file.",
          "templateMissing": "Template \"{{code}}\" is not configured for this tenant. Add or restore it in Messages → Templates.",
          "sendFailed": "Failed to send nudge",
          "fallback": {
            "mobilityTask": "your next mobility step",
            "adaptationMission": "your next QultureUp mission"
          }
        },
        "abandon": {
          "confirmTitle": "Abandon this sponsorship?",
          "confirmDescription": "{{name}} will receive a full refund and the journey reverts to invited-only access. This action can't be undone.",
          "confirmCancel": "Keep sponsorship",
          "confirmAction": "Abandon & refund",
          "successToast": "Sponsorship abandoned · refund issued",
          "failedToast": "Failed to abandon sponsorship"
        },
        "resendActivation": {
          "successToast": "Activation email resent",
          "failedToast": "Failed to resend activation email"
        },
        "noSponsorshipTitle": "No active sponsorship for this journey",
        "noSponsorshipBody": "The talent has no active sponsorship row for this journey. Check the Sponsored tab on the pipeline if a different journey is sponsored, or kick off a new one from the Vetting drawer.",
        "relative": {
          "justNow": "just now",
          "minAgo_one": "{{count}}m ago",
          "minAgo_other": "{{count}}m ago",
          "hourAgo_one": "{{count}}h ago",
          "hourAgo_other": "{{count}}h ago",
          "dayAgo_one": "{{count}}d ago",
          "dayAgo_other": "{{count}}d ago"
        },
        "alreadyAnswered": "The talent has already answered this sponsorship offer."
      },
      "nudge": {
        "cta": "Send nudge",
        "description": "Pick a templated message to wake them up. You can override the body before sending.",
        "failed": "Failed to send nudge",
        "noTemplates": "No templates configured for this stage. Add one in Messages → Templates.",
        "overrideHint": "Leave blank to send the template as-is. Anything you type here replaces the template body.",
        "overrideLabel": "Custom message (optional)",
        "overridePlaceholder": "Add a personal note before sending…",
        "recommended": "Recommended",
        "send": "Send nudge",
        "sending": "Sending…",
        "sent": "“{{name}}” sent",
        "templateLabel": "Template",
        "title": "Send a nudge"
      },
      "mobility": {
        "blocked": "Blocked",
        "blockers": {
          "onTrack": "On track — no blockers or overdue tasks.",
          "blockedTracks_one": "{{count}} blocked track",
          "blockedTracks_other": "{{count}} blocked tracks",
          "overdueTasks_one": "{{count}} overdue task",
          "overdueTasks_other": "{{count}} overdue tasks"
        },
        "docStatus": {
          "pending": "Pending",
          "uploaded": "Uploaded",
          "validated": "Validated",
          "rejected": "Rejected",
          "missing": "Missing"
        },
        "documents": {
          "title": "Documents",
          "otherTrack": "Other",
          "certified": "Certified",
          "expiringSoon": "Expiring soon",
          "downloadAll": "Download all",
          "downloadSelected": "Download {{count}}",
          "downloadError": "Could not download the documents.",
          "select": "Select document",
          "withheldBody": "This citizen has not shared their documents with your company. The list below is still accurate — what can no longer be downloaded are the files themselves."
        },
        "error": "Could not load mobility data.",
        "header": {
          "title": "Relocation journey",
          "subtitle": "Tasks, documents & milestones across every track"
        },
        "noTracks": "No mobility tracks have started yet.",
        "nudge": "Send mobility reminder",
        "progress": "{{percent}}% complete",
        "taskStatus": {
          "pending": "To do",
          "in_progress": "In progress",
          "completed": "Completed",
          "blocked": "Blocked",
          "skipped": "Skipped",
          "archived": "Archived"
        },
        "tasks": {
          "title": "Talent tasks",
          "talent": "Talent",
          "otherTrack": "Other",
          "blocking": "Blocking",
          "blockedBy": "Blocked by {{count}}",
          "overdue": "Overdue",
          "certified": "Certified",
          "docCount_one": "{{count}} document",
          "docCount_other": "{{count}} documents",
          "location": {
            "home_country": "Home country",
            "target_country": "Destination",
            "online": "Online",
            "either": "Either"
          },
          "ownership": {
            "company": "Company",
            "government": "Government",
            "dual": "Shared"
          }
        },
        "timeline": {
          "title": "Milestones",
          "summary": "{{reached}} of {{total}} reached",
          "reached": "Reached"
        }
      },
      "adaptation": {
        "error": "Could not load adaptation data.",
        "header": {
          "assessedOn": "Assessed on {{date}}",
          "miles": "Miles",
          "missions": "Missions",
          "notAssessed": "Not assessed",
          "streak": "Streak",
          "streakDays": "{{count}}d",
          "timeLearning": "Time learning",
          "title": "Adaptation"
        },
        "overviewTab": "Overview",
        "tracksTab": "Worlds & tracks",
        "thisWeek": "This week",
        "ariaWeekly": "Weekly engagement chart",
        "missionsProgress": "{{completed}} of {{total}} missions",
        "tracksProgress": "{{completed}}/{{total}} tracks",
        "noWorlds": "No QultureUp worlds started yet.",
        "tracksTitle": "Worlds & tracks",
        "levelAll": "All",
        "noTracksForLevel": "No tracks at this level.",
        "noMissions": "No missions in this track yet.",
        "recommendedNext": "Recommended next",
        "status": {
          "completed": "Completed",
          "in_progress": "In progress",
          "locked": "Locked",
          "not_started": "Not started"
        },
        "suggest": "Suggest",
        "suggestionSent": "Suggested “{{mission}}” — sent by email",
        "worldsTitle": "Worlds",
        "missionsCount_one": "mission",
        "missionsCount_other": "missions"
      },
      "evidence": {
        "error": "Could not load evidence data.",
        "export": {
          "title": "Journey record",
          "description": "Export the talent's complete journey record as a PDF report or a CSV file.",
          "pdf": "Export PDF",
          "csv": "Export CSV"
        },
        "header": {
          "title": "Journey Passport",
          "subtitle": "Stamps, badges & miles earned across the journey",
          "miles": "Total Miles",
          "level": "Citizen level",
          "stamps": "Stamps",
          "badges": "Badges",
          "thisWeek": "This week"
        }
      },
      "care": {
        "checkins": {
          "empty": "No check-ins yet.",
          "last30Days": "Last 30 days",
          "lastCheckin": "Last check-in {{date}}",
          "moodTrend": "Mood trend",
          "privacyNote": "Individual mood entries stay private to the talent — only frequency and trend are shown.",
          "streak": "Day streak",
          "title": "Check-in activity",
          "trend": {
            "down": "Falling",
            "stable": "Steady",
            "up": "Rising"
          }
        },
        "commitment": {
          "component": {
            "careResponsiveness": "Care responsiveness",
            "checkinConsistency": "Check-in consistency",
            "engagementLevel": "Engagement",
            "integrationProgress": "Integration progress",
            "pillarStability": "Pillar stability",
            "tenureStability": "Tenure stability"
          },
          "empty": "Commitment Index will appear once the talent has check-ins or checkpoints.",
          "history": {
            "empty": "Not enough history yet — the trend line appears after a second calculation.",
            "range": "{{min}}–{{max}}",
            "title": "Index history",
            "ariaLabel_one": "Commitment Index history, {{count}} data point from {{min}} to {{max}}",
            "ariaLabel_other": "Commitment Index history, {{count}} data points from {{min}} to {{max}}"
          },
          "level": {
            "at_risk": "At risk",
            "champion": "Champion",
            "committed": "Committed",
            "engaged": "Engaged",
            "flight_risk": "Flight risk"
          },
          "noRisks": "No active risk signals.",
          "risks": "Risk signals",
          "risksRestricted": "Risk signals are restricted in this company. Ask an admin if you need them.",
          "title": "Commitment Index",
          "trend": {
            "declining": "Declining",
            "improving": "Improving",
            "stable": "Stable"
          }
        },
        "checkpoints": {
          "empty": "No checkpoints scheduled yet.",
          "status": {
            "cancelled": "Cancelled",
            "completed": "Completed",
            "due": "Due",
            "in_progress": "In progress",
            "overdue": "Overdue",
            "scheduled": "Scheduled",
            "skipped": "Skipped"
          },
          "title": "Checkpoints"
        },
        "error": "Could not load care data.",
        "header": {
          "title": "Care",
          "stage": "Stage: {{stage}}"
        },
        "pillars": {
          "concerns": "Concerns:",
          "empty": "No wellbeing pillars yet.",
          "title": "Wellbeing pillars"
        },
        "interventions": {
          "empty": "No interventions scheduled yet.",
          "loadError": "Couldn't load interventions.",
          "past": "Past",
          "retry": "Try again",
          "subtitle": "Schedule recurring or one-shot care follow-ups for this talent.",
          "title": "Care interventions",
          "upcoming": "Upcoming"
        },
        "withheldBody": "This citizen has not shared their Care record with your company. The wellbeing score, pillars and checkpoints are withheld. Any interventions shown below are your company's own record of what it sent."
      },
      "consent": {
        "withheld": {
          "srLabel": "Withheld — not shared by this citizen",
          "tooltip": "This citizen has not shared this with your company. It is withheld, not zero.",
          "title": "Withheld by the citizen",
          "body": "This citizen has not shared this information with your company. It is withheld — not zero, and not missing.",
          "householdGroup": "Household member — name withheld"
        }
      },
      "checkup": {
        "withheldBody": "This citizen has not shared their CheckUp with your company. The scores, the MESH breakdown and the pitch analysis are withheld — not missing, and not zero.",
        "completedOn": "CheckUp completed on {{date}}",
        "awaitingConsentBody": "{{name}} has completed the CheckUp and has not shared the result with your company. They choose whether to share it. Until then the scores, the MESH breakdown and the pitch analysis are withheld — not missing, and not zero.",
        "withdrawnBody": "{{name}} stopped sharing the CheckUp result with your company. The scores, the MESH breakdown and the pitch analysis are withheld — not missing, and not zero."
      }
    },
    "askTonnieServices": {
      "budgetLabel": "Budget range (optional)",
      "budgetPlaceholder": "If you have a budget range in mind, please share...",
      "description": "Request Tonnie to handle the entire process turn-key (Tonnie Pack). Tonnie Services will draft a proposal for your approval.",
      "descriptionLabel": "Description of needs",
      "descriptionPlaceholder": "Describe your specific needs and requirements...",
      "scopes": {
        "adaptationDesc": "QultureUp and cultural adaptation",
        "adaptationLabel": "Adaptation",
        "careDesc": "Post-arrival support and Care",
        "careLabel": "Care & stability",
        "hireDesc": "Talent acquisition and sourcing",
        "hireLabel": "Hire",
        "mobilityDesc": "Visa, travel, and relocation",
        "mobilityLabel": "Mobility",
        "sponsorDesc": "Vetting and sponsorship decisions",
        "sponsorLabel": "Sponsor"
      },
      "serviceScopeHint": "Select which parts of the process you'd like Tonnie to handle:",
      "serviceScopeLabel": "Service scope",
      "submitFailed": "Failed to submit request",
      "submitRequest": "Submit request",
      "submitSuccess": "Request submitted — Tonnie Services will reach out shortly",
      "submitting": "Submitting…",
      "timelineLabel": "Timeline expectations",
      "timelinePlaceholder": "When do you need this completed? Any specific deadlines?",
      "title": "Ask Tonnie services",
      "whatHappensNextBody": "Tonnie Services will review your request and draft a proposal (day-rate / fee / package) for your approval. Once approved, Tonnie Pack mode will be activated and progress will be reflected in your pipeline.",
      "whatHappensNextTitle": "What happens next?"
    },
    "auth": {
      "backToSignIn": "Back to sign in",
      "inviteRoleAdmin": "Admin",
      "inviteRoleMember": "Team member",
      "joinCompanySubtitle": "Create your account to join as {{role}}",
      "joinCompanyTitle": "Join {{company}}",
      "noAccess": {
        "acceptInvitation": "Accept an invitation",
        "contactAdmin": "Contact your admin",
        "description": "You're signed in as {{email}}, but this account doesn't have access to Tonnie Business yet.",
        "hint": "Ask a teammate to invite you, accept a pending invitation, or sign out to use a different account.",
        "signingOut": "Signing out…",
        "switchAccount": "Sign out and use a different account",
        "title": "No business access"
      },
      "signUp": "Sign up"
    },
    "billing": {
      "statusLabel": {
        "active": "Active",
        "pending": "Pending",
        "paid": "Paid",
        "cancelling": "Cancelling",
        "cancelled": "Cancelled",
        "past_due": "Past due",
        "overdue": "Overdue",
        "failed": "Failed",
        "completed": "Completed"
      },
      "active": "Active",
      "activeSponsorships": "Active sponsorships",
      "checkoutCancelled": "Checkout cancelled",
      "checkoutSuccessPending": "Payment received — your account will update shortly.",
      "checkoutSuccessVerified": "Payment confirmed — your account has been updated.",
      "checkoutVerifyError": "We received your payment but could not confirm it in real time. Refresh in a moment.",
      "coPilot": "CoPilot",
      "cohorts": "Cohorts",
      "description": "Your plan, sponsorships, invoices and payment method",
      "downgradeDialog": {
        "confirmDowngrade": "Confirm downgrade",
        "description": "Check what changes before you move to a lower plan",
        "discountedRate": "Discounted rate",
        "keepEnterprise": "Keep Enterprise",
        "loseAccess": "You'll lose access to:",
        "sponsorshipNote": "Note: Active sponsorships will continue at their current rate until they expire. New sponsorships will be charged at the Free plan rate.",
        "title": "Downgrade dialog",
        "unlimitedProgramsCohorts": "Unlimited programs cohorts",
        "unlimitedTeam": "Unlimited team"
      },
      "downgradeFailed": "Could not cancel subscription.",
      "downgradeSuccess": "Downgraded to Free plan. Some features are now limited.",
      "enterprisePlanMissing": "Enterprise plan not configured. Contact support.",
      "familyAccessDesc": "Family access includes household members on the same journey.",
      "familyAddonToggled": "Family add-on {{action}} for {{name}}",
      "familyToggleFailed": "Could not toggle family access.",
      "invoices": {
        "description": "Every invoice for your company, ready to download",
        "empty": "No invoices yet",
        "emptyHint": "Invoices will appear after your first payment.",
        "title": "Invoices",
        "view": "View",
        "viewAllInStripe": "View all in Stripe",
        "paymentReference": "Payment ref. {{reference}}",
        "refunded": "Refunded {{amount}}",
        "viewReceipt": "View receipt",
        "documentUnavailable": "We couldn't open this document right now. Please try again."
      },
      "limitedFeaturesDesc": "What your current plan does not include",
      "managePlan": "Manage plan",
      "monthlySpend": "Monthly spend",
      "nextInvoice": "Next invoice",
      "payment": {
        "addressLabel": "Billing address",
        "billingEmail": "Billing email",
        "billingInfoSubtitle": "Your billing information",
        "billingInformation": "Billing information",
        "billingSummary": "Billing summary",
        "companyName": "Company name",
        "currency": "Currency",
        "dueOn": "Due {{date}}",
        "editInStripe": "Edit in Stripe",
        "enterpriseSubscription": "Enterprise subscription",
        "nextInvoiceEstimate": "Next invoice estimate",
        "noAddress": "No address on file",
        "openStripePortal": "Open Stripe portal",
        "paymentsSecuredBy": "Payments secured by",
        "portalSummary": "Open the billing portal to manage your subscription, payment methods, and invoices.",
        "securePaymentVia": "Secure payment via",
        "vatLabel": "VAT number"
      },
      "planLabel": "{{plan}} Plan",
      "planUpdated": "Your plan has been updated. No new payment required.",
      "plans": {
        "anonymizedReporting": "Anonymized reporting",
        "breakEvenPoint": "Break even point",
        "checkupTeleportalQultureupCare": "CheckUp, TelePortal, QultureUp and Care",
        "complianceAuditTools": "Compliance audit tools",
        "contactSales": "Contact sales",
        "currentPlan": "Current plan",
        "custom": "Custom",
        "customIntegrations": "Custom integrations",
        "customJourneyTemplates": "Custom journey templates",
        "dedicatedSupport": "Dedicated support",
        "downgradeToFree": "Downgrade to Free",
        "eachSponsorshipIncludes": "Each sponsorship includes",
        "enterprise": "Enterprise",
        "enterpriseRate": "Enterprise rate",
        "familyAccessOptional": "Family access optional",
        "free": "Free",
        "freePlanRate": "Free plan rate",
        "fullJourneyCitizenAccess": "Full journey Citizen access",
        "fullMobilityAdaptation": "Full Mobility Adaptation",
        "fullMobilityAdaptationTitle": "Full Mobility & Adaptation",
        "getStarted": "Get started",
        "government": "Government",
        "governmentContactDesc": "Contact our sales team to set up a custom contract for public programs.",
        "intelligenceDesc": "Unlock full Mobility and Adaptation support with advanced analytics and API access.",
        "inviteWholeTeamDesc": "Invite your whole team with unlimited seats, programs, and cohorts.",
        "mobilityAdaptationLocked": "Mobility Adaptation locked",
        "multiYearContracts": "Multi year contracts",
        "off67": "67% off",
        "passportAchievements": "Passport achievements",
        "perTalentJourney": "Per talent journey",
        "perTalentPerMonth": "Per talent per month",
        "publicPrograms": "Public programs",
        "quickRoi": "Quick roi",
        "recommended": "Recommended",
        "save67": "Save 67%",
        "savePerYear": "Save on sponsorships",
        "scaleYourMobility": "Scale your Mobility",
        "sponsorship": "Sponsorship",
        "sponsorshipRate": "Sponsorship rate",
        "sponsorshipsDropDesc": "Sponsorship rates drop to the Enterprise tier, so every talent journey costs less.",
        "tailoredToYourNeeds": "Tailored to your needs",
        "unlimitedTeamScale": "Unlimited team scale",
        "whyUpgrade": "Why upgrade",
        "totalSuffix": "total",
        "sponsorshipMonthlyCaption": "{{rate}}/mo · 12-month access",
        "sponsorshipRateError": "Could not load the sponsorship rate. Please refresh."
      },
      "portalUnavailable": "Stripe Customer Portal is not available yet. Complete a checkout first.",
      "programs": "Programs",
      "redirectingToStripe": "Redirecting to Stripe checkout...",
      "renewsOn": "Renews on {{date}}",
      "sponsorships": {
        "access": "Access",
        "activeSponsorships": "Active sponsorships",
        "addFamilyAccess": "Add Family access",
        "description": "The journeys your company sponsors, with their dates and cost",
        "empty": "No sponsorships yet",
        "enterpriseDiscount": "Enterprise discount",
        "family": "Family",
        "removeFamilyAccess": "Remove Family access",
        "title": "Sponsorships",
        "totalSponsored": "Total sponsored",
        "rowActionsAria": "Actions for {{name}}",
        "viewDetails": "View details",
        "yourRate": "Your rate",
        "accessMonths_one": "{{count}} month",
        "accessMonths_other": "{{count}} months",
        "monthsLeft_one": "{{count}} month left",
        "monthsLeft_other": "{{count}} months left",
        "journeyProgress": "Journey progress"
      },
      "subscriptionError": "Could not load subscription. Please refresh.",
      "tabs": {
        "invoices": "Invoices",
        "payment": "Payment",
        "plans": "Plans",
        "sponsorships": "Sponsorships"
      },
      "title": "Billing",
      "totalSponsored": "Total sponsored",
      "unlimitedAccessDesc": "Everything your plan includes, without limits",
      "upgradeDialog": {
        "continueToPayment": "Continue to payment",
        "description": "Unlock unlimited seats, candidates, programs, and full mobility support.",
        "monthlyLabel": "Monthly",
        "save2Months": "Save 2 months",
        "whatYouGet": "What you get",
        "yearlyLabel": "Yearly"
      },
      "upgradeFailed": "Could not start checkout. Please try again.",
      "upgradeToEnterprise": "Upgrade to Enterprise",
      "vetting": "Vetting",
      "stage": {
        "preMobility": "Pre-Mobility",
        "mobility": "Mobility",
        "adaptation": "Adaptation",
        "care": "Care",
        "stable": "Stable"
      },
      "planUnavailable": "This plan can't be purchased right now. Please contact support."
    },
    "businessMessages": {
      "analytics": {
        "attemptedCount_one": "{{count}} attempted",
        "attemptedCount_other": "{{count}} attempted",
        "byEngagement": "By engagement",
        "channelPerformance": "Channel performance",
        "channelPerformanceDesc": "How each channel delivers and gets opened",
        "deliveryRate": "Delivery rate",
        "messagesByCategory": "Messages by category",
        "messagesByCategoryDesc": "Messages sent in each category",
        "noChannelDataYet": "No messages have been sent yet — rates appear here once the first one goes out.",
        "noTemplatesYet": "Create your first template to see engagement here.",
        "openRate": "Open rate",
        "templatesCount_one": "{{count}} template",
        "templatesCount_other": "{{count}} templates",
        "topTemplates": "Top templates"
      },
      "cohortAllSuppressed": "Nobody received this message — everyone in this cohort has these emails turned off.",
      "cohortSentWithSuppressed": "Sent to {{queued}}. {{suppressed}} did not receive it — they turned these emails off.",
      "suppressedByPreferenceGeneric": "The recipient has turned off these emails — nothing was sent",
      "suppressedByPreference": "{{name}} has turned off these emails — nothing was sent",
      "channels": {
        "channelIntegrations": "Channel integrations",
        "channelIntegrationsDesc": "The channels your messages can go out on",
        "comingSoon": "Coming soon",
        "configure": "Configure",
        "connected": "Connected",
        "delivered": "Delivered",
        "email": "Email",
        "getHelp": "Get help",
        "openRate": "Open rate",
        "opened": "Opened",
        "push": "Push",
        "setupRequired": "Setup required",
        "sms": "SMS",
        "test": "Test",
        "viewDocumentation": "View documentation",
        "whatsapp": "WhatsApp",
        "names": {
          "email": "Email",
          "whatsapp": "WhatsApp",
          "sms": "SMS",
          "push": "Citizen push"
        },
        "descriptions": {
          "email": "Send rich HTML emails with attachments and tracking",
          "whatsapp": "Send WhatsApp messages via Business API",
          "sms": "Send SMS messages for urgent notifications",
          "push": "Push notifications to Citizen mobile app"
        },
        "attempts": "Attempts"
      },
      "composer": {
        "bold": "Bold (**text**)",
        "boldHtml": "Bold (<strong>text</strong>)",
        "boldShort": "Bold",
        "channelsLabel": "Delivery channels",
        "formattingToolbar": "Text formatting",
        "italic": "Italic (*text*)",
        "italicHtml": "Italic (<em>text</em>)",
        "italicShort": "Italic",
        "link": "Link ([text](url))",
        "linkHtml": "Link (<a href=\"…\">text</a>)",
        "linkShort": "Link",
        "message": "Message",
        "messageBodyHtml": "Message body (HTML)",
        "messagePlaceholder": "Write your message here…",
        "noSubject": "(no subject)",
        "noTemplate": "Blank message — write your own",
        "previewDesktop": "Desktop",
        "previewEmpty": "Start writing to see the preview.",
        "previewLabel": "Live preview",
        "previewMobile": "Mobile",
        "previewPlain": "Plain text",
        "recipientsCount_one": "{{count}} recipient",
        "recipientsCount_other": "{{count}} recipients",
        "rendering": "Rendering…",
        "startFromTemplate": "Start from a template (optional)",
        "subject": "Subject",
        "subjectPlaceholder": "A friendly nudge — your CheckUp is waiting",
        "tagsLabel": "Insert a tag",
        "tagsUsed": "Used in this message",
        "templatePlaceholder": "Pick a template or leave blank",
        "viaEmail": "Email"
      },
      "description": "Templates, sends and delivery for every message your company sends",
      "editor": {
        "bodyRequired": "Body is required",
        "bodyTooLong": "Body is too long",
        "cancel": "Cancel",
        "category": "Category",
        "channelRequired": "Select at least one channel",
        "createNewTemplate": "Create new template",
        "editTemplate": "Edit template",
        "editorDescription": "Configure your message template with channels, content, and personalization tags.",
        "hintPlain": "Use the toolbar (or **bold**, *italic*, [link](url)) for formatting. Use {{variable}} placeholders to insert dynamic values.",
        "nameRequired": "Name is required",
        "nameTooLong": "Name is too long",
        "saveChanges": "Save changes",
        "saving": "Saving…",
        "sendTest": "Send test",
        "templateName": "Template name",
        "templateNamePlaceholder": "Enter template name...",
        "testSendSaveFirst": "Save your changes before sending a test",
        "testSending": "Sending test…",
        "unsaved": "Unsaved changes",
        "unsavedConfirm": "You have unsaved changes. Discard them and continue?"
      },
      "newTemplate": "New template",
      "stats": {
        "activeTemplates": "Active templates",
        "avgOpenRate": "Avg. Open rate",
        "delivered": "Delivered",
        "sendAttempts": "Send attempts"
      },
      "tabs": {
        "analytics": "Analytics",
        "channels": "Channels",
        "messageTemplates": "Message templates"
      },
      "templates": {
        "activated": "Template activated",
        "allCategories": "All categories",
        "allChannels": "All channels",
        "createFailed": "Could not create template",
        "createFirstTemplate": "Create first template",
        "createTemplate": "Create template",
        "created": "Template created",
        "deactivated": "Template deactivated",
        "delete": "Delete",
        "deleteFailed": "Could not delete template",
        "deleteTitle": "Delete template?",
        "deleteWarning": "This permanently removes \"{{name}}\". This action cannot be undone.",
        "deleted": "Template deleted",
        "deleting": "Deleting…",
        "duplicate": "Duplicate",
        "duplicateFailed": "Could not duplicate template",
        "duplicated": "Template duplicated",
        "edit": "Edit",
        "filterCategory": "Category",
        "filterChannel": "Channel",
        "inactive": "Inactive",
        "loadError": "Could not load templates.",
        "noTemplatesFound": "No templates found",
        "restoreDefault": "Restore default",
        "restoreFailed": "Failed to restore the default template",
        "restored": "Default template restored",
        "saveFailed": "Could not save template",
        "saved": "Template saved",
        "searchPlaceholder": "Enter search...",
        "sendTest": "Send test",
        "testSendFailed": "Failed to send the test message",
        "testSent": "Test message sent",
        "toggleFailed": "Could not update template status",
        "tryAdjustingSearch": "Try adjusting search",
        "talentTagWithoutSubject": "This message goes to your team about no particular talent, so {{tags}} has nobody to name. Use {{readerTag}} to address the reader.",
        "activeToggle": "Active: {{name}}",
        "moreActions": "More actions for {{name}}",
        "alwaysOn": "Always on: the platform sends account and security emails itself.",
        "sourceDuplicate": "Duplicate",
        "sourceCustom": "Custom",
        "sourceCustomized": "Customised",
        "sourceSystem": "System default",
        "deliveredCount_one": "{{count}} delivered",
        "deliveredCount_other": "{{count}} delivered",
        "opened_one": "{{count}} opened",
        "opened_other": "{{count}} opened",
        "sent_one": "{{count}} sent",
        "sent_other": "{{count}} sent",
        "searchLabel": "Search templates"
      },
      "title": "Messages",
      "categories": {
        "names": {
          "vetting": "Vetting",
          "sponsorship": "Sponsorship",
          "mobility": "Mobility",
          "adaptation": "Adaptation",
          "care": "Care",
          "evidence": "Evidence",
          "general": "General",
          "account": "Account & security"
        },
        "descriptions": {
          "vetting": "CheckUp invitations, results, and follow-ups",
          "sponsorship": "Journey invitations and sponsorship communications",
          "mobility": "TelePortal tasks, documents, and status updates",
          "adaptation": "QultureUp missions and learning recommendations",
          "care": "Check-ins, interventions, and wellbeing support",
          "evidence": "Passport updates, badges, and achievements",
          "general": "General announcements and custom messages",
          "account": "Codes and security notices the platform sends itself. They reach people whatever their notification settings."
        }
      },
      "variables": {
        "talentFirstName": "Talent's first name",
        "talentLastName": "Talent's last name",
        "talentFullName": "Talent's full name",
        "talentEmail": "Talent's email address",
        "recipientFirstName": "Recipient's first name",
        "recipientLastName": "Recipient's last name",
        "recipientFullName": "Recipient's full name",
        "recipientEmail": "Recipient's email address",
        "talentRole": "Talent's job role",
        "companyName": "Sponsor company name",
        "companyContact": "Company contact person",
        "programName": "Program name",
        "cohortName": "Cohort name",
        "journeyStage": "Current journey stage",
        "checkupBadge": "iQulture badge level",
        "mobilityArrivalDate": "Estimated arrival date",
        "mobilityNextTask": "Next mobility task",
        "missionName": "QultureUp mission name",
        "actionUrl": "Action uRL/link",
        "actionDeadline": "Action deadline"
      },
      "cohortRecipientCount_one": "{{count}} member",
      "cohortRecipientCount_other": "{{count}} members",
      "cohortSent_one": "Message sent to {{count}} person.",
      "cohortSent_other": "Message sent to {{count}} people."
    },
    "businessNotifications": {
      "allCaughtUp": "All caught up",
      "allNotifications": "All notifications",
      "allTab": "All ({{count}})",
      "delete": "Delete",
      "deleteCount": "Delete ({{count}})",
      "filter": "Filter",
      "markAllRead": "Mark all read",
      "markAsRead": "Mark as read",
      "new": "New",
      "noNotifications": "No notifications",
      "noNotificationsDesc": "New activity from your talents will appear here",
      "noUnreadNotifications": "No unread notifications",
      "selectAll": "Select all",
      "settings": "Settings",
      "summary": {
        "completed": "Completed",
        "unread": "Unread",
        "urgent": "Urgent",
        "warnings": "Warnings"
      },
      "title": "Notifications",
      "unreadTab": "Unread ({{count}})",
      "unreadUrgent": "{{unread}} unread, {{urgent}} urgent",
      "urgentBadge": "Urgent badge",
      "viewDetails": "View details",
      "viewDetailsButton": "View details button",
      "categories": {
        "all": "All",
        "mobility": "Mobility",
        "care": "Care",
        "vetting": "Vetting",
        "evidence": "Evidence",
        "cohorts": "Cohorts"
      },
      "unreadCount_one": "{{count}} unread notification",
      "unreadCount_other": "{{count}} unread notifications",
      "actionsFor": "Actions for “{{title}}”",
      "selectNotification": "Select “{{title}}”"
    },
    "businessOnboarding": {
      "addTalents": {
        "addFromATSOrExcel": "Add candidates from your ATS or upload an Excel/CSV file",
        "addTalentsButton": "Add talents",
        "added": "Added",
        "afterOnboarding": "After completing onboarding, invite these talents to CheckUp from the Acquisition menu",
        "emptyStateDescription": "Import candidates from your ATS or upload an Excel/CSV file. A default cohort will be created automatically.",
        "importDescription": "Import your candidates to get started. Imported talents will appear in the Acquisition menu, where you can invite them for CheckUp (vetting). A default cohort will be created automatically when you add your first talents.",
        "importTalents": "Import talents",
        "startImport": "Start import",
        "step1": "Select a group of talents to invite for CheckUp (vetting and assessment)",
        "step2": "After CheckUp completion, you can sponsor vetted talents and define their migration route",
        "step3": "Sponsored talents will start the journey through: Mobility -> Adaptation -> Care -> Evidence",
        "step4": "Organize your hiring initiatives by creating programs and cohorts at any time",
        "step5": "Use CoPilot for guided operations and support throughout the process",
        "title": "Add talents",
        "whatsNext": "What's next?",
        "whatsNextDescription": "After importing talents, they will appear in the Acquisition menu. From there:",
        "readyForCheckUp_one": "{{count}} talent ready for CheckUp",
        "readyForCheckUp_other": "{{count}} talents ready for CheckUp",
        "talentsAdded_one": "{{count}} talent added",
        "talentsAdded_other": "{{count}} talents added"
      },
      "additionalDetails": {
        "billing": {
          "billingAddressHint": "Used for invoices and billing notifications",
          "billingAddressLabel": "Billing address",
          "billingAddressPlaceholder": "Street address",
          "businessTypeLabel": "Business type",
          "city": "City",
          "complement": "Apartment, suite, etc. (optional)",
          "complementPlaceholder": "e.g. Suite 200",
          "country": "Country",
          "description": "Required before you can upgrade to a paid plan.",
          "legalNameLabel": "Legal entity name",
          "postalCodeLabel": "Postal code",
          "state": "State / Region",
          "street": "Street",
          "taxIdLabel": "Tax ID / VAT",
          "title": "Billing & legal"
        },
        "contact": {
          "description": "Direct phone and company founding year.",
          "foundedLabel": "Founded year",
          "phoneLabel": "Contact phone",
          "title": "Contact & company info"
        },
        "description": "Every field is optional. Expand the sections you want to fill — the rest will stay as reminders on your dashboard.",
        "geographic": {
          "branchesLabel": "Branch offices",
          "cityPlaceholder": "City",
          "countryPlaceholder": "Country",
          "description": "Branches, language requirements, and work arrangement.",
          "languagesLabel": "Language requirements",
          "title": "Geographic details",
          "workArrangement": "Work arrangement",
          "minimumLevel": "Minimum level",
          "languageLabel": "Language"
        },
        "hiring": {
          "challengesLabel": "Top challenges (max 3)",
          "description": "Goals, timeframe, maturity, target roles, and challenges.",
          "goalsLabel": "Primary hiring goals",
          "maturityLabel": "Mobility program maturity",
          "rolesLabel": "Target role types",
          "timeframeLabel": "Hiring timeframe",
          "title": "Hiring details"
        },
        "title": "Fill in the remaining details"
      },
      "companyProfile": {
        "businessDetails": {
          "description": "Help us understand your business model and online presence",
          "title": "Business details"
        },
        "businessType": "Business type",
        "businessTypes": {
          "agency": "Agency",
          "enterprise": "Enterprise",
          "scaleup": "Scale-up",
          "startup": "Startup",
          "startupDesc": "Early-stage, high growth",
          "scaleupDesc": "Proven model, scaling fast",
          "enterpriseDesc": "Established large company",
          "agencyDesc": "Service provider"
        },
        "companyInfo": {
          "description": "Basic details about your organization",
          "title": "Company information"
        },
        "companyName": "Company name",
        "companySize": "Company size",
        "description": "Tell us about your organization. This information helps us personalize your experience and prepare for compliance requirements.",
        "emailPlaceholder": "john@company.com",
        "emailRequired": "Email *",
        "enterCompanyName": "Enter company name",
        "enterPhoneNumber": "Enter your phone number",
        "forContractsAndLegal": "For contracts and legal documents",
        "foundedYear": "Founded year",
        "fullNamePlaceholder": "John Doe",
        "fullNameRequired": "Full name *",
        "industry": "Industry",
        "legalEntityName": "Legal entity name",
        "legalEntityPlaceholder": "e.g., Company Inc., Company Ltd.",
        "legalInfo": {
          "description": "For compliance and contract preparation (optional but recommended for enterprise)",
          "title": "Legal information"
        },
        "linkedinCompanyPage": "LinkedIn company page",
        "phone": "Phone",
        "primaryContact": {
          "description": "The main point of contact for your organization",
          "title": "Primary contact"
        },
        "registeredCountry": "Registered country",
        "registeredCountryDesc": "Where your company is legally registered",
        "registeredCountryRequired": "Registered country *",
        "requiredForEnterprise": "Required for enterprise billing",
        "roleJobTitle": "Role / Job title",
        "selectCountry": "Select country",
        "selectIndustry": "Select industry",
        "selectRole": "Select role",
        "selectSize": "Select size",
        "selectYear": "Select year",
        "taxIdPlaceholder": "e.g., DE123456789",
        "taxIdVat": "Tax ID / VAT number",
        "title": "Company profile",
        "website": "Website",
        "industries": {
          "technology": "Technology",
          "healthcare": "Healthcare",
          "finance": "Finance",
          "manufacturing": "Manufacturing",
          "retail": "Retail",
          "hospitality": "Hospitality",
          "construction": "Construction",
          "education": "Education",
          "consulting": "Consulting",
          "logistics": "Logistics",
          "energy": "Energy",
          "telecommunications": "Telecommunications",
          "mediaEntertainment": "Media & entertainment",
          "realEstate": "Real estate",
          "other": "Other"
        },
        "companySizes": {
          "size1to50": "1-50 employees",
          "size51to200": "51-200 employees",
          "size201to500": "201-500 employees",
          "size501to1000": "501-1000 employees",
          "size1000plus": "1000+ employees"
        },
        "contactRoles": {
          "ceoFounder": "CEO / Founder",
          "hrDirector": "HR director",
          "headOfTalentAcquisition": "Head of talent Acquisition",
          "mobilityManager": "Mobility manager",
          "hrBusinessPartner": "HR Business partner",
          "peopleOperations": "People operations",
          "recruiter": "Recruiter",
          "other": "Other"
        }
      },
      "complete": "Onboarding complete!",
      "confirmCard": {
        "backToConfirm": "Back to auto-filled view",
        "dataFrom": "Data from",
        "description": "We've pulled this from your company's public website. Confirm it looks right.",
        "editDetails": "Edit details",
        "loading": "Looking up your company...",
        "loadingDesc": "This usually takes 2–3 seconds.",
        "manualDesc": "We couldn't auto-detect your company. Please fill in the basics below.",
        "multipleSources": "multiple sources",
        "retry": "Retry auto-detect",
        "thatsUs": "That's us",
        "title": "Is this you?",
        "yourRole": "Your role at {{company}}"
      },
      "errors": {
        "cohortCreation": "Failed to create cohort. Please try again.",
        "completion": "Failed to finalize onboarding. Please try again.",
        "programCreation": "Failed to create program. Please try again."
      },
      "geographicSetup": {
        "addAnotherCountry": "Add another country...",
        "addBranchOffice": "Add branch office",
        "branchOfficesDesc": "Add other locations that can receive relocated talent (optional)",
        "branchOfficesTitle": "Branch offices",
        "canReceiveTalent": "Can receive talent",
        "city": "City",
        "cityName": "City name",
        "cityPlaceholder": "e.g., Lisbon, Berlin, Amsterdam",
        "cityRequired": "City *",
        "country": "Country",
        "countryRequired": "Country *",
        "description": "Configure your company locations and target hiring markets. This helps us pre-configure migration routes and compliance requirements.",
        "headquartersDesc": "Your main office location where relocated talent will primarily work",
        "headquartersTitle": "Headquarters location",
        "languageRequirementsDesc": "What languages should candidates speak? (Optional)",
        "languageRequirementsTitle": "Language requirements",
        "migrationRoutesDesc": "Based on your setup, these migration routes will be pre-configured",
        "migrationRoutesPreview": "Migration routes preview",
        "officeName": "Office name",
        "officeNamePlaceholder": "e.g., Berlin Office",
        "popularSourceMarkets": "Popular source markets",
        "selectCountry": "Select country",
        "selectedMarkets": "Selected markets ({{count}})",
        "targetHiringMarketsDesc": "Where do you plan to hire from? Select your source markets.",
        "targetHiringMarketsTitle": "Target hiring markets",
        "workArrangementDesc": "What work arrangement do you offer for relocated talent?",
        "workArrangementTitle": "Work arrangement",
        "languages": {
          "english": "English",
          "spanish": "Spanish",
          "portuguese": "Portuguese",
          "german": "German",
          "french": "French",
          "dutch": "Dutch",
          "italian": "Italian",
          "polish": "Polish",
          "arabic": "Arabic",
          "chineseMandarin": "Chinese (Mandarin)",
          "japanese": "Japanese",
          "korean": "Korean"
        },
        "languageLevels": {
          "a1": "A1 — Beginner",
          "a2": "A2 — Elementary",
          "b1": "B1 — Intermediate",
          "b2": "B2 — Upper intermediate",
          "c1": "C1 — Advanced",
          "c2": "C2 — Proficient"
        },
        "workArrangements": {
          "onsite": "On-site",
          "onsiteDesc": "Full-time office presence",
          "hybrid": "Hybrid",
          "hybridDesc": "Mix of office and remote",
          "flexible": "Flexible",
          "flexibleDesc": "Employee choice"
        },
        "minimumLevelFor": "Minimum level for {{language}}",
        "otherMarketLabel": "Other hiring market",
        "addMarket": "Add market",
        "addLanguage": "Add {{language}}"
      },
      "hiringContext": {
        "annualHiringVolume": "Annual international hiring volume",
        "description": "Help us understand your hiring goals and strategy. This enables us to personalize your experience and provide relevant recommendations.",
        "hiringGoalsDesc": "What do you want to achieve? Select all that apply.",
        "hiringGoalsTitle": "Hiring goals",
        "mobilityProgramMaturity": "Mobility program maturity",
        "primaryUseCaseDesc": "What's your main reason for using Tonnie? Select the option that best describes your situation.",
        "primaryUseCaseTitle": "Primary use case",
        "scaleTimelineDesc": "Help us understand the scope and urgency of your hiring needs.",
        "scaleTimelineTitle": "Scale & timeline",
        "targetRoleTypesDesc": "What types of roles are you primarily hiring for? Select all that apply.",
        "targetRoleTypesTitle": "Target role types",
        "topChallengesDesc": "What are your biggest challenges with international hiring? Select your top 3.",
        "topChallengesTitle": "Top challenges",
        "useCases": {
          "costOptimization": "Cost optimization",
          "costOptimizationDesc": "Accessing talent from different markets",
          "diversity": "Diversity & inclusion",
          "diversityDesc": "Building diverse international teams",
          "globalExpansion": "Global expansion",
          "globalExpansionDesc": "Expanding operations to new markets with local talent",
          "internationalHiring": "International hiring",
          "internationalHiringDesc": "Hiring international talent to relocate to your offices",
          "remoteToRelocation": "Remote to relocation",
          "remoteToRelocationDesc": "Converting remote workers to relocated employees",
          "talentShortage": "Talent shortage",
          "talentShortageDesc": "Addressing local talent gaps with global sourcing"
        },
        "volumes": {
          "enterprise": "Enterprise scale",
          "established": "Established program",
          "growing": "Growing program",
          "starting": "Getting started"
        },
        "whenPlanToStart": "When do you plan to start?",
        "goals": {
          "reduceTimeToHire": "Reduce time-to-hire for international candidates",
          "improveCandidateExperience": "Improve candidate experience during relocation",
          "increaseRetention": "Increase retention of relocated employees",
          "streamlineCompliance": "Streamline compliance and visa processes",
          "trackMobilityRoi": "Track and measure mobility ROI",
          "reduceRelocationCosts": "Reduce relocation costs",
          "buildTalentPipeline": "Build a sustainable talent pipeline",
          "improveOnboarding": "Improve post-arrival onboarding & adaptation"
        },
        "challenges": {
          "immigrationVisa": "Immigration & visa complexity",
          "findingCandidates": "Finding qualified international candidates",
          "candidateDropoff": "Candidate drop-off during relocation",
          "postArrival": "Post-arrival adaptation & retention",
          "complianceLegal": "Compliance & legal complexity",
          "costManagement": "Cost management",
          "trackingReporting": "Tracking & reporting"
        },
        "timeframes": {
          "immediate": "Immediate",
          "immediateDesc": "Ready to start now",
          "planningDesc": "Planning phase",
          "futureDesc": "Future pipeline",
          "strategicDesc": "Strategic planning"
        },
        "maturity": {
          "firstTime": "First time",
          "firstTimeDesc": "New to international hiring",
          "someExperience": "Some experience",
          "someExperienceDesc": "Done a few relocations",
          "establishedProgram": "Established program",
          "establishedProgramDesc": "Mature mobility function"
        },
        "roleTypes": {
          "engineering": "Engineering",
          "product": "Product",
          "design": "Design",
          "dataScience": "Data science",
          "devops": "DevOps / Infrastructure",
          "marketing": "Marketing",
          "sales": "Sales",
          "customerSuccess": "Customer success",
          "finance": "Finance",
          "hrPeople": "HR / People",
          "operations": "Operations",
          "executive": "Executive / Leadership",
          "other": "Other"
        }
      },
      "hiringSignals": {
        "annualVolume": "Annual hiring volume",
        "annualVolumeDesc": "How many international hires do you expect in the next 12 months?",
        "description": "Two quick questions so we can tailor your workspace.",
        "primaryUseCase": "Primary use case",
        "title": "What brings you to Tonnie?"
      },
      "loadingProgress": "Loading your progress...",
      "markets": {
        "description": "Pick up to 3 markets. You can always add more later.",
        "headquarters": "Headquarters",
        "targetMarkets": "Target hiring markets",
        "title": "Where are you hiring from?"
      },
      "progressRestored": "Your progress has been restored",
      "progressSaved": "Progress saved",
      "validation": {
        "requiredFields": "Please complete the required fields before continuing."
      },
      "review": {
        "editDescription": "Review your details and save when you're ready. You can always come back to this wizard from the Settings page.",
        "editTitle": "Your organization profile",
        "firstTimeDescription": "Here's what we captured to get you started. You can always add more details later from your dashboard.",
        "firstTimeNotice": "Tap Complete Setup to activate your workspace. Missing optional details will appear as reminders on your dashboard.",
        "firstTimeTitle": "You're all set",
        "jumpToAdditional": "Back to additional details",
        "missingFieldsNotice_one": "You still have {{count}} optional detail to capture. Filling it in improves AI matching and unlocks billing.",
        "missingFieldsNotice_other": "You still have {{count}} optional details to capture. Filling them in improves AI matching and unlocks billing."
      },
      "roles": {
        "founderExec": "Founder / Exec",
        "hrPeople": "HR / People",
        "mobilityManager": "Mobility manager",
        "talentAcquisition": "Talent Acquisition"
      },
      "saveFailed": "Failed to save progress",
      "steps": {
        "addTalents": {
          "badge": "Key",
          "description": "Activate your account by adding talents",
          "title": "Add first talents"
        },
        "additionalDetails": {
          "description": "Optional fields to improve matching and unlock billing.",
          "title": "Additional details"
        },
        "companyProfile": {
          "description": "Tell us about your organization",
          "title": "Company profile"
        },
        "geographicSetup": {
          "description": "Locations and migration routes",
          "title": "Geographic setup"
        },
        "hiringContext": {
          "description": "Your goals and hiring strategy",
          "title": "Hiring context"
        },
        "review": {
          "description": "Confirm what we captured and finish setup.",
          "title": "Review & complete"
        }
      },
      "updated": "Profile updated",
      "wizard": {
        "completeSetup": "Complete setup",
        "completing": "Setting up...",
        "progressSaved": "Your progress will be saved automatically",
        "saveChanges": "Save changes",
        "skipInfo": "You can skip and complete later",
        "subtitle": "Company onboarding",
        "title": "Tonnie Business"
      }
    },
    "businessSettings": {
      "branding": {
        "a11yBrandConsistency": "Maintain brand consistency while ensuring accessibility",
        "a11yColorBlind": "Test with color blindness simulators",
        "a11yContrast": "Ensure sufficient contrast between text and background (WCAG AA: 4.5:1)",
        "accessibilityGuidelines": "Accessibility guidelines",
        "activateTheme": "Activate theme",
        "activateThisTheme": "Activate this theme",
        "active": "Active",
        "appIcon": "App icon",
        "appIconDesc": "The square icon shown in browser tabs and on phones",
        "assets": "Assets",
        "colors": "Colors",
        "customDesc": "Your own brand colours",
        "customMode": "Custom mode",
        "dark": "Dark",
        "darkDesc": "Light text on a dark background",
        "dashboard": "Dashboard",
        "description": "Your logo, colours and theme across the portal",
        "draft": "Draft",
        "enterPreviewDesc": "See the portal with your branding before you save it",
        "enterPreviewMode": "Enter preview mode",
        "exitPreview": "Exit preview",
        "favicon": "Favicon",
        "faviconDesc": "The small icon in the browser tab",
        "fileFormatsHint": "{{formats}} (max {{maxSize}})",
        "heroImageN": "Hero image {{number}}",
        "heroImages": "Hero images",
        "heroImagesDesc": "Banner images shown at the top of your pages",
        "light": "Light",
        "lightDesc": "Dark text on a light background",
        "loginPage": "Login page",
        "preview": "Preview",
        "previewModeActive": "Preview mode active",
        "primaryLogo": "Primary logo",
        "primaryLogoDesc": "Shown in the sidebar and on documents you share",
        "replace": "Replace",
        "saveDraft": "Save draft",
        "secondaryLogo": "Secondary logo",
        "secondaryLogoDesc": "A compact version for small spaces",
        "switchToCustomAssets": "Switch to custom assets",
        "switchToCustomColors": "Switch to custom colors",
        "switchToCustomPreview": "Switch to custom preview",
        "themeMode": "Theme mode",
        "themeModeDesc": "Light, dark or your own colours",
        "title": "Branding",
        "upload": "Upload",
        "uploading": "Uploading…",
        "colorNames": {
          "primary": "Primary",
          "secondary": "Secondary",
          "accent": "Accent",
          "success": "Success",
          "warning": "Warning",
          "error": "Error",
          "background": "Background",
          "foreground": "Text"
        },
        "colorPickerLabel": "{{name}} color picker",
        "colorHexLabel": "{{name}} hex code"
      },
      "care": {
        "description": "How Care runs for your talents: pillars, check-ins and objectives",
        "enterpriseDescription": "Custom Care settings are part of the Enterprise plan",
        "features": {
          "checkpointSchedule": "Checkpoint schedule",
          "checkpointScheduleDesc": "When talents are asked for their Care check-ins",
          "customPillars": "Custom pillars",
          "customPillarsDesc": "Which wellbeing pillars your talents rate",
          "feedbackConfig": "Feedback config",
          "feedbackConfigDesc": "Who gives objective feedback, and how often",
          "talentObjectives": "Talent objectives",
          "talentObjectivesDesc": "The objectives your talents work towards",
          "title": "Features"
        },
        "saveFailed": "Could not save care configuration. Please try again.",
        "saved": "Care configuration saved",
        "title": "Care"
      },
      "compliance": {
        "actionLabels": {
          "system_template_dispatched_pre_clerk": "System email sent",
          "talent_bulk_imported": "Talents bulk imported",
          "talent_invitation_created": "Invitation created",
          "talent_invitation_email_failed": "Invitation email not sent",
          "talent_invitation_revoked": "Invitation revoked",
          "talent_invitation_sent": "Invitation sent",
          "talent_invited_to_vetting": "Invited to vetting",
          "account_email_changed": "Account email changed",
          "account_name_changed": "Account name changed",
          "affiliate_payout_cancelled": "Affiliate payout cancelled",
          "affiliate_payout_invoice_attached": "Invoice attached to affiliate payout",
          "affiliate_payout_requested": "Affiliate payout requested",
          "affiliate_platform_overview_viewed": "Affiliate platform overview viewed",
          "communications_relinked_to_account": "Messages linked to the account",
          "evidence_blob_read": "Evidence file opened",
          "evidence_blob_released": "Evidence file released",
          "evidence_capture_expired": "Decision record expired",
          "evidence_capture_read": "Decision record opened",
          "evidence_diff_viewed": "Decision record compared with today",
          "evidence_item_redacted": "Evidence item redacted",
          "feature_flags_write": "Feature flags changed",
          "invitation_claimed": "Invitation claimed",
          "pool_bulk_imported": "Candidates bulk imported",
          "pool_candidate_ingested": "Candidate added to the pool",
          "pool_cv_viewed": "Candidate CV viewed",
          "service_credential_created": "Service credential created",
          "service_credential_revoked": "Service credential revoked",
          "talent_invitation_deleted": "Invitation deleted",
          "talent_invitation_superseded": "Invitation replaced by a new one",
          "account_name_reconciled": "Account name reconciled",
          "ops_vault_orphan_delete": "Orphaned file removed",
          "talent_invitation_declined": "Invitation declined"
        },
        "allActions": "All actions",
        "allUsers": "All users",
        "auditLogs": "Audit logs",
        "auditLogsDesc": "Track who did what, when, and where across your business.",
        "date": "Date",
        "description": "Audit logs, data retention and your company's privacy settings",
        "loadMore": "Load more",
        "loading": "Loading…",
        "noResults": "No audit events match your filters.",
        "resourceLabels": {
          "journey_invitation": "Journey invitation",
          "message_template": "Message template",
          "tenant": "Organization",
          "affiliate_payout": "Affiliate payout",
          "affiliate_platform": "Affiliate platform",
          "engagement_evidence_blob": "Evidence file",
          "engagement_evidence_capture": "Decision record",
          "engagement_evidence_item": "Evidence item",
          "platform_configs": "Platform settings",
          "service_credential": "Service credential",
          "talent": "Talent",
          "user": "User",
          "vault_file": "Vault file"
        },
        "showing": "Showing {{shown}} of {{total}}",
        "systemActor": "System",
        "title": "Compliance",
        "filterByUser": "Filter by user",
        "filterByAction": "Filter by action"
      },
      "description": "Your organization, team, branding and preferences",
      "enterpriseLock": {
        "badge": "Enterprise",
        "description": "This feature is available on the Enterprise plan.",
        "title": "Locked",
        "upgrade": "Upgrade to Enterprise"
      },
      "organization": {
        "annualVolume": "Annual volume",
        "billingAddress": "Billing address",
        "billingCity": "City",
        "billingCountry": "Country",
        "billingLegal": "Legal information",
        "billingLegalDesc": "Used on invoices, contracts, and tax documents.",
        "billingState": "State / Region",
        "branchOffices": "Branch offices",
        "businessType": "Business type",
        "companyName": "Company name",
        "companyProfile": "Company profile",
        "companyProfileDesc": "Your company's name, industry and contact details",
        "companySetup": "Company setup",
        "companySize": "Company size",
        "complement": "Apartment, suite, etc.",
        "contactEmail": "Contact email",
        "contactPhone": "Contact phone",
        "contactRole": "Contact role",
        "description": "Your company profile, locations and hiring context",
        "editInOnboardingWizard": "Edit in onboarding wizard",
        "foundedYear": "Founded",
        "geographicSetup": "Geographic setup",
        "geographicSetupDesc": "Where your company is based and where talents relocate to",
        "headquarters": "Headquarters",
        "hiringContext": "Hiring context",
        "hiringContextDesc": "The roles you hire for and the challenges you face",
        "hiringGoals": "Hiring goals",
        "industry": "Industry",
        "languageRequirements": "Language requirements",
        "legalName": "Legal name",
        "linkedin": "LinkedIn",
        "maturityLevel": "Maturity level",
        "postalCode": "Postal code",
        "primaryContact": "Primary contact",
        "primaryUseCase": "Primary use case",
        "registeredCountry": "Registered country",
        "targetHiringMarkets": "Target hiring markets",
        "targetRoles": "Target roles",
        "taxId": "Tax ID / VAT",
        "timeframe": "Timeframe",
        "title": "Organization",
        "topChallenges": "Top challenges",
        "website": "Website",
        "workArrangement": "Work arrangement"
      },
      "preferences": {
        "dateFormat": "Date format",
        "description": "Language, notifications and how the portal works for you",
        "discardChanges": "Discard",
        "emailNotifications": "Email notifications",
        "emailNotificationsDesc": "Which updates reach you by email",
        "language": "Language",
        "localization": "Localization",
        "localizationDesc": "Your language, time zone and date format",
        "moreComingSoon": "More preferences are on the way — additional languages, timezones, and notification controls will appear here as we roll them out.",
        "pushNotifications": "Push notifications",
        "pushNotificationsDesc": "Which updates appear as browser notifications",
        "saveFailed": "Could not save preferences. Please try again.",
        "savePreferences": "Save preferences",
        "quietHours": "Quiet hours",
        "quietHoursDesc": "Pause push notifications during these hours.",
        "quietHoursEnd": "To",
        "quietHoursStart": "From",
        "saved": "Preferences updated",
        "timezone": "Timezone",
        "title": "Preferences",
        "unsavedChanges": "You have unsaved changes",
        "channelsTitle": "Notification channels",
        "channelsDesc": "How you receive notifications.",
        "categoriesTitle": "What you’re notified about",
        "categoriesDesc": "Choose which kinds of updates reach you.",
        "category": {
          "hero": "Talent journey",
          "heroDesc": "Your talents’ CheckUp, Care and mobility progress.",
          "system": "Account & system",
          "systemDesc": "Security, account and platform housekeeping.",
          "social": "People & pipeline",
          "socialDesc": "Vetting, team and candidate interactions.",
          "alert": "Alerts & billing",
          "alertDesc": "Time- or money-sensitive: billing, payments and deadlines."
        }
      },
      "sections": {
        "branding": "Branding",
        "brandingDesc": "Theme, colors and assets",
        "care": "Care",
        "careDesc": "Care configuration and pillars",
        "compliance": "Compliance",
        "complianceDesc": "Audit logs, data retention and exports",
        "organization": "Organization",
        "organizationDesc": "Company profile and setup",
        "preferences": "Preferences",
        "preferencesDesc": "Notifications, language and locale",
        "profile": "Profile",
        "profileDesc": "Your personal info and avatar",
        "security": "Security",
        "securityDesc": "Authentication, passwords and access",
        "team": "Team",
        "teamDesc": "Members, roles and permissions",
        "serviceCredentials": "Service credentials",
        "serviceCredentialsDesc": "Read-only tokens for scripts and reporting tools"
      },
      "security": {
        "accountDeleteFailed": "Failed to delete account",
        "accountDeleted": "Account deleted",
        "confirmDelete": "Delete forever",
        "confirmDeleteOrg": "Delete organization forever",
        "dangerZone": "Danger zone",
        "dangerZoneDesc": "Irreversible actions. Please be certain.",
        "deleteAccount": "Delete account",
        "deleteAccountConfirmPrompt": "Type DELETE to confirm:",
        "deleteAccountDesc": "Permanently remove your user account and all associated data.",
        "deleteAccountTitle": "Delete account",
        "deleteAccountWarning": "This action is permanent and cannot be undone. All your data will be removed.",
        "deleteOrg": "Delete organization",
        "deleteOrgConfirmPrompt": "Type the organization name to confirm:",
        "deleteOrgFailed": "Failed to delete the organization. Please try again or contact support.",
        "deleteOrgSuccess": "Organization deleted.",
        "deleteOrgTitle": "Delete organization",
        "deleteOrgWarning": "This will permanently delete the organization, all team memberships, programs, cohorts, and talent data.",
        "deleteOrganization": "Delete this organization",
        "deleteOrganizationDesc": "Remove the organization, all team members, programs, and data. This cannot be undone.",
        "deleting": "Deleting…",
        "description": "Sign-in, sessions and deleting your organization",
        "title": "Security",
        "deleteOrgStripeWarning_one": "Organization deleted. {{count}} subscription could not be cancelled automatically — contact support if billing questions arise.",
        "deleteOrgStripeWarning_other": "Organization deleted. {{count}} subscriptions could not be cancelled automatically — contact support if billing questions arise."
      },
      "team": {
        "description": "Manage team members and invitations",
        "enterpriseDescription": "Full team management with role-based access",
        "features": {
          "activityTracking": "Activity tracking",
          "activityTrackingDesc": "See when team members last accessed the platform",
          "roleBasedAccess": "Role-Based access",
          "roleBasedAccessDesc": "Assign roles to control what each member can see and do",
          "stakeholderIdentification": "Stakeholder management",
          "stakeholderIdentificationDesc": "Identify budget owners and program champions",
          "title": "Features",
          "unlimitedMembers": "Unlimited members",
          "unlimitedMembersDesc": "Invite your entire team — no seat limits"
        },
        "invitationResent": "Invitation resent",
        "invitationRevoked": "Invitation revoked",
        "invitations": {
          "description": "Manage pending invitations to your workspace.",
          "expired": "Expired",
          "pending": "Pending",
          "resend": "Resend",
          "revoke": "Revoke",
          "sentOn": "Sent",
          "title": "Pending invitations"
        },
        "inviteDesc": "Send an email invitation to join your organization.",
        "inviteEmailLabel": "Email address",
        "inviteFailed": "Failed to send invitation",
        "inviteRoleLabel": "Role",
        "inviteSent": "Invitation sent",
        "inviteTitle": "Invite team member",
        "memberRemoved": "Team member removed",
        "members": {
          "description": "Active team members with access to your organization",
          "inviteMember": "Invite member",
          "title": "Members"
        },
        "removeConfirm": "Remove {{name}} from the team?",
        "removeFailed": "Failed to remove team member",
        "resendFailed": "Failed to resend invitation",
        "revokeFailed": "Failed to revoke invitation",
        "roleAdmin": "Admin",
        "roleTeamMember": "Team member",
        "roles": {
          "adminDesc": "Full access — manage team, billing, programs, and settings",
          "description": "Available roles and their permissions",
          "teamMemberDesc": "Access to programs, talents, and mobility dashboards",
          "title": "Roles"
        },
        "sendInvite": "Send invite",
        "sending": "Sending…",
        "stats": {
          "pendingInvitations": "Pending invitations",
          "teamMembers": "Total members"
        },
        "title": "Team"
      },
      "title": "Settings",
      "inviteEmailPlaceholder": "colleague@company.com",
      "serviceCredentials": {
        "title": "Service credentials",
        "description": "Read-only tokens that let a script or a reporting tool pull cohort data without a person signing in.",
        "howToTitle": "How to use a credential",
        "howToBody": "Send the token in an Authorization header: Authorization: Bearer <token>. It can read cohort and program snapshots only, it cannot change anything, and it stops working the moment you revoke it or it expires.",
        "empty": "No credentials yet",
        "emptyHint": "Create one when a script or reporting tool needs to read cohort data on its own.",
        "create": "New credential",
        "createTitle": "New service credential",
        "createDescription": "You will see the token once. Store it before closing.",
        "nameLabel": "Name",
        "namePlaceholder": "Quarterly cohort report",
        "nameHint": "So you can tell this credential from the others later.",
        "scopeLabel": "Access",
        "scopeCohortRead": "Read cohort data",
        "scopeHint": "Read-only. A credential can never change data or manage credentials.",
        "cohortModeLabel": "Cohorts",
        "cohortAll": "Every cohort",
        "cohortPick": "Only the cohorts I choose",
        "cohortsLabel": "Which cohorts",
        "cohortsHint": "Pick at least one.",
        "expiryLabel": "Expires after",
        "expiryHint": "Credentials always expire. Ninety days is the maximum.",
        "revealTitle": "Copy your token now",
        "revealWarning": "This token is shown only once. Store it now — it cannot be displayed again.",
        "copy": "Copy",
        "copied": "Copied",
        "storedConfirm": "I have stored this token somewhere safe",
        "done": "Done",
        "statusActive": "Active",
        "statusExpired": "Expired",
        "statusRevoked": "Revoked",
        "allCohorts": "All cohorts",
        "neverUsed": "Never used",
        "revoke": "Revoke",
        "revokeTitle": "Revoke this credential?",
        "revokeDescription": "Anything using it stops working immediately. This cannot be undone.",
        "revokeReasonLabel": "Reason (optional)",
        "revokeConfirm": "Revoke credential",
        "issued": "Credential created",
        "revoked": "Credential revoked",
        "issueFailed": "Could not create the credential",
        "revokeFailed": "Could not revoke the credential",
        "loadFailed": "Could not load credentials",
        "expiryDays_one": "{{count}} day",
        "expiryDays_other": "{{count}} days",
        "cohortCount_one": "{{count}} cohort",
        "cohortCount_other": "{{count}} cohorts",
        "expiringSoon_one": "Expires in {{count}} day",
        "expiringSoon_other": "Expires in {{count}} days"
      }
    },
    "care": {
      "config": {
        "addCustomObjective": "Add custom objective",
        "addToCatalog": "Add to catalog",
        "baselineDescription": "Configure the default Care settings for your organization. These settings will be automatically inherited by all Programs and Cohorts. Individual Programs or Cohorts can customize if needed.",
        "cadences": {
          "monthly": "Monthly",
          "quarterlyRecommended": "Quarterly (recommended)",
          "semiannual": "Semiannual"
        },
        "careModelSummary": "Care model summary",
        "carePillars": "Care pillars",
        "carePillarsDescription": "Select which dimensions of stability talents will self-report during check-ins. Programs and Cohorts can enable/disable these.",
        "pillarCatalog": {
          "housing_stability": {
            "name": "Housing stability",
            "description": "Monitor housing transitions and stability after arrival"
          },
          "schooling_childcare": {
            "name": "Schooling & childcare",
            "description": "Track children's schooling and childcare arrangements"
          },
          "work_fit": {
            "name": "Work fit",
            "description": "Track workplace adaptation, team fit, and productivity"
          },
          "wellbeing_social": {
            "name": "Wellbeing & social",
            "description": "Monitor wellbeing, social connections, and community engagement"
          }
        },
        "carePillarsScheduleDesc": "Care pillars + checkpoint schedule: Talents complete self-check-ins on selected wellbeing dimensions at milestone intervals. Programs/Cohorts can enable/disable pillars and adjust checkpoint timing.",
        "catalogWorkDescription": "Enable objectives here to make them available for Programs and Cohorts. Each Program/Cohort can then choose which objectives to track for their talents.",
        "changesApplyNote": "Changes will apply to all Programs and Cohorts that haven't customized their settings",
        "checkpointSchedule": "Checkpoint schedule",
        "checkpointScheduleDescription": "Default timing for Care Pillar check-ins (post-arrival milestones). Programs and Cohorts can adjust the recurrence.",
        "common": "Common",
        "companyCareBaseline": "Company Care baseline",
        "customObjectiveAdded": "Custom objective added to catalog",
        "detailedFeedbackDescription": "Select roles that can see detailed feedback text (others see summaries only)",
        "detailedFeedbackVisibility": "Detailed feedback visibility",
        "feedbackCadenceDescription": "How often company agents and talent exchange feedback on objectives",
        "feedbackCadenceLabel": "Feedback cadence",
        "feedbackConfigDescription": "How often company agents provide feedback on Talent Objectives and when talents self-evaluate",
        "feedbackConfiguration": "Feedback configuration",
        "feedbackFlowDescription": "At each cadence interval, selected providers submit feedback on talent objectives. Talent receives notification and can view feedback + submit their own self-evaluation.",
        "feedbackFlowTitle": "Feedback flow:",
        "feedbackProviders": "Feedback providers",
        "forObjectives": "For objectives",
        "forPillars": "For pillars",
        "howCatalogWorks": "How the catalog works:",
        "milestones": {
          "monthNine": "Month 9",
          "monthOne": "Month 1",
          "monthSix": "Month 6",
          "monthThree": "Month 3",
          "monthTwelve": "Month 12"
        },
        "objectivePlaceholder": "e.g., Complete security awareness training",
        "objectivesCatalogDescription": "Company library of adaptation objectives. Enable the ones commonly used — Programs and Cohorts can then select which to apply.",
        "primaryConfig": "Primary config",
        "providers": {
          "admin": {
            "description": "Owns the care program — reviews sensitive signals and gives strategic feedback on objectives."
          },
          "teamMember": {
            "description": "Day-to-day contact — provides feedback on adaptation, work fit, and progress against objectives."
          }
        },
        "recommended": "Recommended",
        "riskSignalsDescription": "Select roles that can see sensitive risk indicators and stability alerts",
        "riskSignalsVisibility": "Risk signals visibility",
        "saveConfiguration": "Save configuration",
        "schedules": {
          "intensive": "Intensive",
          "intensiveCadence": "Cadence: every quarter + month-1 settling check (5 checkpoints)",
          "intensiveDescription": "High-touch programs that need close early-stage monitoring and extra quarterly signal.",
          "light": "Light touch",
          "lightCadence": "Cadence: semiannual (2 checkpoints)",
          "lightDescription": "Minimum viable care — just the first-quarter signal and the annual decision point.",
          "standard": "Standard",
          "standardCadence": "Cadence: first month, then quarterly through month 12 (4 checkpoints)",
          "standardDescription": "Balanced checkpoints covering settling, adaptation, and annual retention."
        },
        "talentCheckIns": "Talent check-ins",
        "talentObjectivesCatalog": "Talent objectives catalog",
        "talentObjectivesFeedbackDesc": "Talent objectives + feedback: Enable objectives in your catalog. Programs/Cohorts select which objectives to track. Company agents provide feedback and talents self-evaluate.",
        "visibilityDescription": "Control who can see sensitive Care data based on their role",
        "visibilityPrivacy": "Visibility & privacy",
        "pillarRequired": "Required",
        "pillarMakeRequired": "Make required",
        "objectives": {
          "language_level": "Reach working proficiency in the local language",
          "office_visits": "Attend the office regularly each period",
          "onboarding": "Complete company onboarding program",
          "team_integration": "Establish productive working relationships with team",
          "role_competency": "Demonstrate role competency by review milestone",
          "culture_fit": "Understand and embrace company culture and values",
          "communication": "Effective communication with stakeholders",
          "tools_systems": "Proficiency with company tools and systems",
          "network_building": "Build internal professional network",
          "feedback_giving": "Actively participate in feedback cycles",
          "goal_setting": "Set and track personal development goals",
          "mentorship": "Engage with assigned mentor/buddy"
        },
        "objectiveCategory": {
          "Adaptation": "Adaptation",
          "Onboarding": "Onboarding",
          "Performance": "Performance",
          "Culture": "Culture",
          "Skills": "Skills",
          "Technical": "Technical",
          "Growth": "Growth",
          "Custom": "Custom"
        },
        "enabled_one": "{{count}} enabled",
        "enabled_other": "{{count}} enabled",
        "pillarsEnabledCount_one": "{{count}} pillar enabled. Programs and cohorts inherit it and can choose which pillars are active for their context.",
        "pillarsEnabledCount_other": "{{count}} pillars enabled. Programs and cohorts inherit these and can choose which pillars are active for their context."
      },
      "customizeModal": {
        "cancel": "Cancel",
        "carePillars": "Care pillars",
        "carePillarsDesc": "Dimensions for talent check-ins",
        "checkpointSchedule": "Checkpoint schedule",
        "checkpointScheduleDesc": "When talents complete Care check-ins",
        "cohorts": "Cohorts",
        "configSaved": "Care configuration customized for {{name}}",
        "customized": "Customized",
        "feedbackConfig": "Feedback configuration",
        "feedbackConfigDesc": "How often feedback is provided on objectives",
        "feedbackFrequencyInfo": "HRBP and managers provide feedback on talent objectives at this frequency",
        "feedbackMonthly": "Monthly",
        "feedbackMonthlyDesc": "Once per month",
        "feedbackQuarterly": "Quarterly",
        "feedbackQuarterlyDesc": "Every 3 months",
        "inherited": "Inherited",
        "inheritedInfo": "Settings are inherited from {{from}}. Toggle sections below to customize for this {{level}}.",
        "objectivesAllApply": "No objectives selected — all company objectives apply. Pick a subset to narrow them for this scope.",
        "objectivesNoneEnabled": "No objectives are enabled in the company Care config yet. Enable some in Company Settings to scope them here.",
        "oneMonth": "1 month",
        "overrideDesc": "Override Care settings for {{name}}. {{inheritors}} will inherit these unless they have their own customizations.",
        "pillarHousing": "Housing",
        "pillarHousingDesc": "Living situation stability",
        "pillarWellbeing": "Wellbeing",
        "pillarWellbeingDesc": "Health & mental wellness",
        "pillarWork": "Work",
        "pillarWorkDesc": "Job & career adaptation",
        "resetAllToInherited": "Reset all to inherited",
        "saveChanges": "Save changes",
        "scheduleIntensive": "Intensive",
        "scheduleIntensiveDesc": "Frequent check-ins for new arrivals",
        "scheduleLight": "Light touch",
        "scheduleLightDesc": "Minimal check-ins for settled talents",
        "scheduleStandard": "Standard",
        "scheduleStandardDesc": "Balanced checkpoint schedule",
        "sixMonths": "6 months",
        "talentObjectives": "Talent objectives",
        "talentObjectivesDesc": "Pick which company objectives apply to this scope",
        "talents": "Talents",
        "threeMonths": "3 months",
        "title": "Customize modal",
        "twelveMonths": "12 months",
        "pillarSchooling": "Schooling & childcare",
        "pillarSchoolingDesc": "Track children's schooling and childcare arrangements",
        "nineMonths": "9 months",
        "feedbackSemiannual": "Semi-annual",
        "feedbackSemiannualDesc": "Feedback gathered twice a year",
        "objectivesSelected_one": "{{count}} objective selected. Company agents give feedback on it",
        "objectivesSelected_other": "{{count}} objectives selected. Company agents provide feedback on these",
        "pillarsActive_one": "{{count}} pillar active. Talents rate it during check-ins",
        "pillarsActive_other": "{{count}} pillars active. Talents will rate each pillar during check-ins"
      },
      "effectiveCard": {
        "cadence": "Cadence",
        "careConfiguration": "Care configuration",
        "carePillars": "Care pillars",
        "customized": "Customized",
        "customizedFor": "Customized for {{level}}",
        "inherited": "Inherited",
        "inheritedFrom": "Inherited from {{source}}",
        "providers": "Providers",
        "talentObjectives": "Talent objectives"
      },
      "feedback": {
        "commentWithheld": "Comment hidden by your company’s visibility settings",
        "modal": {
          "description": "Rate each objective against its target, then review the full history.",
          "provideTab": "Provide",
          "historyTab": "History",
          "submit": "Submit feedback",
          "giveFeedback": "Give feedback",
          "cycleDue": "Due {{date}}",
          "awaitingSelfEval": "Awaiting self-eval",
          "noOpenCycle": "No open cycle",
          "historyEmpty": "No feedback has been recorded yet.",
          "archivedObjective": "Archived objective",
          "providerValue": "Company",
          "selfValue": "Self"
        }
      },
      "objective": {
        "measureType": {
          "number": "Count",
          "scale": "Level",
          "percent": "Percent",
          "milestone": "Milestone",
          "rating": "Rating"
        },
        "currentLabel": "Current",
        "targetLabel": "Target",
        "baselineLabel": "Baseline",
        "recordValueLabel": "This period",
        "valuePlaceholder": "Select…",
        "milestoneDone": "Done",
        "milestoneNotYet": "Not yet",
        "editTarget": "Edit target",
        "dashboard": {
          "byObjective": "By objective",
          "onTargetShare": "On target",
          "avgProgress": "Avg progress",
          "empty": "No objectives are being tracked yet. Configure them in the Care strategy and they'll appear as talents are onboarded.",
          "talentsCount_one": "{{count}} talent",
          "talentsCount_other": "{{count}} talents"
        },
        "targetSaved": "Target updated",
        "targetSaveFailed": "Couldn't save the target. Please try again.",
        "nothingToSubmit": "Record a value or comment for at least one objective first.",
        "feedbackSubmitted": "Feedback recorded",
        "feedbackSubmitFailed": "Couldn't record the feedback. Please try again.",
        "errors": {
          "unitTooLong": "Unit must be 24 characters or fewer",
          "targetRequired": "Set a baseline or a target",
          "ratingRange": "Rating must be 1–5",
          "commentTooLong": "Comment must be 2000 characters or fewer",
          "entryEmpty": "Add a value, rating or comment"
        },
        "noOpenCycle": "There is no open feedback cycle for this talent yet, so there is nothing to submit against."
      },
      "intervention": {
        "actAria": "Intervene on {{name}}",
        "actLabel": "Intervene",
        "assigneeLabel": "Owner",
        "assigneeUnassigned": "Unassigned",
        "inbox": {
          "title": "Follow-ups",
          "empty": "You're all caught up — no open follow-ups.",
          "overdue": "Overdue",
          "open": "Open",
          "done": "Done",
          "mine": "Mine",
          "all": "All",
          "due": "Due {{date}}",
          "search": "Search by talent…",
          "groupByTalent": "By talent",
          "flat": "List",
          "noMatch": "No interactions match that talent.",
          "expandAll": "Expand all",
          "collapseAll": "Collapse all",
          "overdueCount_one": "{{count}} overdue",
          "overdueCount_other": "{{count}} overdue"
        },
        "manageLabel": "Schedule & owner",
        "markDoneLabel": "Record outcome + minutes",
        "markDoneHint": "Copy & paste the meeting minutes or recording notes here (if you have them) — internal only, kept for future evaluation.",
        "markDone": "Mark done",
        "ataPlaceholder": "Paste the minutes / what was discussed here (internal only)…",
        "commentsLabel": "Comments",
        "commentsEmpty": "No comments yet.",
        "commentPlaceholder": "Add a comment…",
        "commentSend": "Send",
        "rescheduledToast": "Interaction rescheduled",
        "reassignedToast": "Interaction reassigned",
        "actionFailed": "Action failed. Please try again.",
        "bulkAllFailed": "No actions could be created. Please try again.",
        "bulkPartial": "{{m}} could not be created",
        "bulkSummary": "{{n}} scheduled, {{m}} failed",
        "cancel": "Cancel",
        "cancelFailed": "Failed to cancel.",
        "cancelledToast": "Intervention cancelled",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "Add any context for this action…",
        "dialogDescription": "Log an action or reach out — pick a type and we'll handle the rest. Talent-facing actions are always score-free.",
        "dialogTitle": "Intervene",
        "effect": {
          "logOnly": "Internal record only — never reaches the talent.",
          "talentTouch": "Eligible for an opt-in, score-free warm touch to the talent."
        },
        "errors": {
          "descriptionTooLong": "Description must be 2000 characters or fewer",
          "editClosed": "This interaction is closed and can no longer be edited.",
          "invalidDate": "Enter a valid date",
          "resolutionTooLong": "Resolution must be 2000 characters or fewer",
          "titleRequired": "A title is required",
          "titleTooLong": "Title must be 200 characters or fewer"
        },
        "errorToast": "Couldn't create the action. Please try again.",
        "edit": "Edit",
        "save": "Save changes",
        "saveSuccess": "Interaction updated",
        "saveFailed": "Couldn't save the changes. Please try again.",
        "wizard": {
          "stepType": "Type",
          "stepDetails": "Details",
          "stepReview": "Review",
          "next": "Next",
          "back": "Back",
          "progressLabel": "Interaction setup progress",
          "reviewBulk_one": "This will be created for {{count}} talent.",
          "reviewBulk_other": "This will be created for {{count}} talents."
        },
        "notesLabel": "Notes",
        "notesPlaceholder": "Internal notes (optional)…",
        "outcome": {
          "completed": "Completed",
          "noShow": "No-show",
          "rescheduled": "Rescheduled",
          "declined": "Declined"
        },
        "outcomeLabel": "Outcome",
        "priority": {
          "high": "High",
          "low": "Low",
          "medium": "Medium",
          "urgent": "Urgent"
        },
        "priorityLabel": "Priority",
        "resolutionLabel": "Resolution note",
        "resolutionPlaceholder": "What happened? (optional)",
        "resolve": "Resolve",
        "resolveFailed": "Failed to resolve.",
        "resolvedToast": "Intervention resolved",
        "submit": "Create",
        "submitting": "Saving…",
        "successToast": "Action created",
        "titleLabel": "Title",
        "titlePlaceholder": "e.g. 1:1 wellbeing check-in",
        "scheduledAtLabel": "Date & time",
        "locationOrLinkLabel": "Meeting link / location",
        "locationOrLinkPlaceholder": "e.g. https://meet… or an address",
        "requestCheckinHint": "Adds a one-off check-in to the talent's timeline that feeds their wellbeing index.",
        "type": {
          "call": "Call",
          "video_call": "Video call",
          "in_person_meeting": "In-person meeting",
          "message": "Message",
          "internal_note": "Internal note",
          "request_checkin": "Request a check-in",
          "buddy_connect": "Connect with a buddy",
          "checkpoint_trigger": "Trigger a checkpoint",
          "coaching_note": "Coaching note",
          "manager_alert": "Alert a manager",
          "mission_recommend": "Recommend a mission",
          "personal_check_in": "Personal check-in",
          "reminder": "Set a reminder",
          "support_resource": "Share a support resource"
        },
        "typeLabel": "Interaction type",
        "bulkAppliesTo_one": "This plan applies to {{count}} talent:",
        "bulkAppliesTo_other": "This plan applies to {{count}} talents:",
        "dialogTitleBulk_one": "Intervene on {{count}} talent",
        "dialogTitleBulk_other": "Intervene on {{count}} talents",
        "submitBulk_one": "Create {{count}} action",
        "submitBulk_other": "Create {{count}} actions",
        "bulkAppliesToMatching_one": "This plan reaches the {{count}} talent matching your filters who needs an intervention.",
        "bulkAppliesToMatching_other": "This plan reaches all {{count}} talents matching your filters who need an intervention."
      },
      "effectiveCare": {
        "scheduleLabel": "{{schedule}} schedule",
        "providersList": "Providers: {{providers}}",
        "customize": "Customize",
        "detailsTitle": "Care configuration details",
        "fullConfigFor": "Full configuration for {{name}}",
        "inheritedFromSuffix": "(inherited from {{source}})",
        "activeCarePillars": "Active Care pillars",
        "checkpointSchedule": "Checkpoint schedule",
        "scheduleTitle": "{{schedule}} Schedule",
        "talentObjectivesCount": "Talent objectives ({{count}})",
        "feedbackConfiguration": "Feedback configuration",
        "inheritanceInfoCustomized": "This {{level}} has customized Care settings. Click \"Reset\" to revert to the settings from {{source}}.",
        "inheritanceInfoInherited": "This {{level}} inherits all Care settings from {{source}}. Click \"Customize\" to override specific settings for this {{level}} only.",
        "activeCount_one": "{{count}} active",
        "activeCount_other": "{{count}} active",
        "moreObjectives_one": "+{{count}} more objective",
        "moreObjectives_other": "+{{count}} more objectives"
      }
    },
    "carePage": {
      "act": "Intervene",
      "actAria": "Intervene for {{name}}",
      "activeTab": "Active",
      "activeTracking": "Active tracking",
      "archivedTab": "Archived",
      "commitmentDistribution": "Commitment distribution",
      "startedSummary": "{{started}} of {{total}} started",
      "awaitingCheckin": "Awaiting first check-in",
      "pillarsCardSubtitle": "Per-pillar wellbeing across the cohort",
      "pillarsEmptyHint": "Pillar health appears once talents complete their first Care check-in.",
      "bandChampion": "Champion",
      "bandCommitted": "Committed",
      "bandEngaged": "Engaged",
      "bandAtRisk": "At risk",
      "bandFlightRisk": "Flight risk",
      "bandTracked": "Tracked",
      "clearSelection": "Clear selection",
      "errors": {
        "notesTooLong": "Notes must be 2000 characters or fewer"
      },
      "feedbackPending": "Feedback pending",
      "interveneAria": "Intervene for {{name}}",
      "talentRowActionsAria": "Actions for {{name}}",
      "viewAllRisks": "View all risks",
      "viewDetails": "View details",
      "viewDetailsAria": "View care details for {{name}}",
      "aiCommitmentInsights": "AI commitment insights",
      "allCohorts": "All cohorts",
      "allLevels": "All levels",
      "allPillars": "All pillars",
      "atRiskFilter": "at risk",
      "carePillar": "Care pillar",
      "carePillarsHealth": "Care pillars health",
      "champions": "Champions",
      "championsDesc": "Your most committed talents, highest Commitment Index first",
      "championsFilter": "Champions",
      "commitment": "Commitment",
      "commitmentChampions": "Commitment champions",
      "commitmentLabel": "Commitment",
      "commitmentPercent": "{{value}}%",
      "commitmentRiskAlert": "Commitment risk alert",
      "coldStartDesc": "As soon as an invited talent completes their Care assessment or first check-in, their Commitment Index and pillar health appear here.",
      "coldStartTitle": "No Care activity yet",
      "committedFilter": "Committed",
      "description": "Wellbeing, commitment and interventions for your sponsored talents",
      "engagedFilter": "Engaged",
      "filterByCohort": "Filter by cohort",
      "filterByPillar": "Pillar",
      "flightRiskCount_one": "{{count}} flight risk talent",
      "flightRiskCount_other": "{{count}} flight risk talents",
      "flightRiskFilter": "Flight risk",
      "healthy": "Healthy",
      "inCare": "In Care",
      "insights": "Insights",
      "intervene": "Intervene",
      "interventionQueue": "Intervention queue",
      "interventionQueueDesc": "Talents who need an intervention or owe feedback, most urgent first",
      "needCare": "Need Care",
      "decliningCommitment": "Declining",
      "commitmentIndexLabel": "Commitment Index",
      "awaitingSelfEvalCount_one": "+{{count}} awaiting self-eval",
      "awaitingSelfEvalCount_other": "+{{count}} awaiting self-eval",
      "overdueCheckpoints": "Checkpoints overdue",
      "needIntervention": "Need intervention",
      "noTalentsFound": "No talents found",
      "overallTalentLoyalty": "Overall talent loyalty",
      "overdue": "Overdue",
      "pendingFeedback": "Pending feedback",
      "pillars": "Pillars",
      "searchTalents": "Search talents",
      "selectAllVisible": "Select all on this page",
      "selectTalentAria": "Select {{name}} for bulk intervention",
      "smartRecommendations": "Smart recommendations",
      "talentsLabel": "Talents",
      "title": "Care",
      "tracked": "Tracked",
      "tryAdjustingFilters": "Try adjusting filters",
      "frequency": {
        "weekly": "Weekly",
        "biweekly": "Bi-weekly",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "semiannual": "Semiannual"
      },
      "commitmentIndexHeading": "Commitment Index",
      "gettingStartedBadge": "Getting started",
      "allClearTitle": "All clear",
      "allClearDescription": "No talents need immediate intervention",
      "clearFilters": "Clear filters",
      "routineStatus": {
        "overdue": "Overdue",
        "in_progress": "In progress",
        "scheduled": "Scheduled",
        "completed": "Completed",
        "open": "Open",
        "resolved": "Resolved",
        "cancelled": "Cancelled"
      },
      "commitmentHealth": "Commitment health",
      "viewPillarTalentsAria": "View talents under {{pillar}}",
      "weakOnPillar": "Weak on {{pillar}}",
      "pillarName": {
        "housing_stability": "Housing",
        "schooling_childcare": "Schooling",
        "work_fit": "Work",
        "wellbeing_social": "Wellbeing"
      },
      "pillarStatus": {
        "healthy": "Healthy",
        "moderate": "Moderate",
        "concern": "Concern"
      },
      "insightsRecommendations": {
        "socialPillar": "Social pillar is at {{value}}% — consider team bonding activities",
        "schedule1on1s": "Schedule 1:1s",
        "planActivities": "Plan activities",
        "createProgram": "Create program",
        "flightRisk_one": "{{count}} talent is a flight risk — schedule an immediate 1:1 with the HRBP",
        "flightRisk_other": "{{count}} talents are flight risks — schedule immediate 1:1s with the HRBP",
        "championsProgram_one": "{{count}} champion identified — consider an ambassador programme",
        "championsProgram_other": "{{count}} champions identified — consider an ambassador program"
      },
      "trendMetrics": {
        "avgCommitmentIndex": "Avg. Commitment Index",
        "champions": "Champions",
        "flightRisk": "Flight risk"
      },
      "scored": "Scored",
      "objectivesTitle": "Objectives & feedback",
      "objectivesEmpty": "No objectives have been assigned to this talent yet. Configure them in the Care strategy.",
      "objectivesLoadError": "Could not load objectives.",
      "objectivesRetry": "Retry",
      "objectiveFeedbackCycleStatus": {
        "provider_submitted": "Provider submitted",
        "completed": "Completed",
        "overdue": "Overdue"
      },
      "objectiveFeedbackNoCycle": "No feedback cycle is open right now. Objectives are listed below; a form appears when the next cycle opens.",
      "objectiveFeedbackProviderLabel": "Provider",
      "objectiveFeedbackSelfLabel": "Self-evaluation",
      "objectiveFeedbackCommentLabel": "Comment (optional)",
      "objectiveFeedbackCommentPlaceholder": "Share specific, actionable feedback…",
      "objectiveFeedbackSubmitting": "Submitting…",
      "objectiveFeedbackDueTitle": "Feedback due",
      "objectiveFeedbackDueEmpty": "No open feedback cycles right now. You are all caught up.",
      "objectiveFeedbackDueLoadError": "Could not load the feedback-due list.",
      "objectiveFeedbackDueRow": "Due {{date}}",
      "objectiveFeedbackDueCurrent": "Viewing",
      "feedbackStrategyScope": "Resolved feedback configuration · {{scope}}",
      "feedbackStrategyLoading": "Loading…",
      "feedbackStrategyError": "Could not load the feedback strategy.",
      "feedbackCadenceLabel": "Cadence",
      "feedbackProvidersLabel": "Providers",
      "feedbackProvidersNone": "No providers configured",
      "feedbackProvider": {
        "admin": "Admin",
        "team_member": "Team member"
      },
      "scopeCompanyWide": "Company-wide",
      "scopeCohort": "Selected cohort",
      "tabs": {
        "feedback": "Feedback",
        "interactions": "Interactions"
      },
      "objectivesProgress": {
        "title": "Objectives progress",
        "desc": "On-target share and average progress per objective, across all talents."
      },
      "objectiveFeedback": {
        "title": "Objective feedback",
        "desc": "Structured, objectives-based feedback at the configured cadence. Rate each talent against their objectives; they complete a self-evaluation in return.",
        "dueKpi": "Feedback due",
        "awaitingSelfEvalKpi": "Awaiting self-eval",
        "caughtUp": "All caught up — no feedback owed right now.",
        "rowStatusOpen": "Needs your rating",
        "rowStatusProviderSubmitted": "Waiting on talent self-eval",
        "notProvider": "You're not a configured feedback provider for this scope. Ask an Admin to add your role in Care settings.",
        "loadError": "Could not load the feedback inbox."
      },
      "objectiveFeedbackNotGoverning": "Another company runs this talent's Care, so only it gives feedback and sets targets. You can read the talent's own self-evaluations.",
      "commitmentAtAGlance": "Commitment at a glance",
      "commitmentAtAGlanceDesc": "Where your scored talents stand today",
      "ofScored": "{{value}} of {{total}} scored",
      "bulkInterveneCta_one": "Schedule an intervention for {{count}} talent",
      "bulkInterveneCta_other": "Schedule an intervention for {{count}} talents",
      "pendingCount_one": "{{count}} pending",
      "pendingCount_other": "{{count}} pending",
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected",
      "gettingStartedNote_one": "+ {{count}} getting started (not enough check-in history to score yet)",
      "gettingStartedNote_other": "+ {{count}} getting started (not enough check-in history to score yet)",
      "interveneAllMatching_one": "Intervene on the {{count}} matching",
      "interveneAllMatching_other": "Intervene on all {{count}} matching",
      "interveneAllFlightRisk_one": "Intervene on the {{count}} flight-risk",
      "interveneAllFlightRisk_other": "Intervene on all {{count}} flight-risk"
    },
    "heroOverview": {
      "title": "Journey overview",
      "subtitle": "Track progress",
      "acquisition": {
        "title": "Acquisition",
        "description": "Invited talents who have not yet accepted.",
        "open": "Open acquisition in Pipeline",
        "pendingInvites": "pending invite",
        "statusLabel": "Status",
        "awaitingAcceptance": "Awaiting acceptance",
        "ttl": "14-day invite TTL",
        "viewInPipeline": "View in pipeline",
        "empty": "Everyone invited has accepted. New invitations will land here."
      },
      "vetting": {
        "title": "Vetting",
        "description": "Pre-sponsorship funnel — invited, screening, completed.",
        "open": "Open vetting",
        "inVetting": "In vetting",
        "passRate": "Pass rate",
        "funnel": "Funnel",
        "inProgress": "screening",
        "completed": "completed",
        "done": "done"
      },
      "sponsored": {
        "title": "Sponsored",
        "empty": "No talents sponsored yet. Once a talent is sponsored, their Mobility, Adaptation, and Care engagement will appear here.",
        "headcount_one": "{{count}} talent",
        "headcount_other": "{{count}} talents"
      },
      "mobility": {
        "title": "Mobility",
        "activeOfTotal_one": "{{count}} of {{total}} active",
        "activeOfTotal_other": "{{count}} of {{total}} active"
      },
      "adaptation": {
        "title": "Adaptation",
        "activeOfTotal_one": "{{count}} of {{total}} active",
        "activeOfTotal_other": "{{count}} of {{total}} active"
      },
      "care": {
        "title": "Care",
        "activeOfTotal_one": "{{count}} of {{total}} active",
        "activeOfTotal_other": "{{count}} of {{total}} active"
      },
      "notStartedYet_one": "{{count}} sponsored · not started yet",
      "notStartedYet_other": "{{count}} sponsored · not started yet",
      "notStartedMore_one": "+{{count}} more",
      "notStartedMore_other": "+{{count}} more"
    },
    "cohorts": {
      "activeCohorts": "Running cohorts",
      "addTalents": "Add talents",
      "adjustFilters": "Adjust filters",
      "alerts": "Alerts",
      "all": "All",
      "allPrograms": "All programs",
      "allStatus": "All status",
      "askCoPilot": "Ask CoPilot",
      "atRisk": "at risk",
      "atRiskLabel": "at risk",
      "avgProgress": "Avg. progress",
      "backToCohorts": "Back to cohorts",
      "biWeekly": "Bi weekly",
      "blocked": "Blocked",
      "care": "Care",
      "careRequiresEnterprise": "Care requires Enterprise",
      "careSettingsReset": "Care settings reset",
      "careSettingsSaved": "Care strategy saved",
      "cohortCreated": "Cohort created",
      "cohortDeleted": "Cohort deleted",
      "cohortNameLabel": "Cohort name",
      "cohortNamePlaceholder": "Enter cohort name...",
      "cohortPaused": "Cohort paused",
      "cohortResumed": "Cohort resumed",
      "cohortUpdated": "Cohort updated",
      "createCohort": "Create cohort",
      "createDialogDescription": "A cohort is a batch of talents you're moving through the journey together — same start window, same destination, same program.",
      "createFirstCohort": "Create first cohort",
      "createNewCohort": "Create new cohort",
      "deleteCohort": "Delete cohort",
      "deleteConfirmDescription": "This will permanently delete the cohort. This action cannot be undone.",
      "deleteConfirmTitle": "Delete this cohort?",
      "deleteFailed": "Failed to delete cohort",
      "description": "Group talents by intake to track them together",
      "editCohort": "Edit cohort",
      "editDialogDescription": "Update cohort details below.",
      "exportCsv": "Export CSV",
      "exportCsvFailed": "Couldn't export this cohort. Please try again.",
      "exportCsvTruncated": "This export only includes the first 500 engagements — the cohort has more.",
      "exportingCsv": "Exporting…",
      "warningRosterTruncated": "Showing {{exported}} of {{total}} engagements — this cohort is larger than the list can display.",
      "warningAcceptedWithoutJourney_one": "{{count}} accepted invitation has no journey on record yet.",
      "warningAcceptedWithoutJourney_other": "{{count}} accepted invitations have no journey on record yet.",
      "feedbackCadence": "Feedback cadence",
      "fillRequiredFields": "Fill required fields",
      "filterByProgram": "Filter by program",
      "getMoreInsights": "Get more insights",
      "insights": "Insights",
      "insightsDescription": "How this cohort is progressing",
      "insightCompletionRate": "{{percent}}% of the active talents in this cohort have reached Evidence.",
      "insightSponsoredWithoutCare_one": "{{count}} sponsored talent has no active Care touchpoints — check the check-in cadence.",
      "insightSponsoredWithoutCare_other": "{{count}} sponsored talents have no active Care touchpoints — check the check-in cadence.",
      "insightsEmpty": "No findings for this cohort yet.",
      "inviteToVetting": "Invite To Vetting",
      "iqulture": "iQulture",
      "journeyOverview": "Journey overview",
      "latestUpdates": "Latest updates",
      "messageCohort": "Message cohort",
      "monthly": "Monthly",
      "noCohortsFound": "No cohorts found",
      "noProgramUnassigned": "No program unassigned",
      "notFound": "Cohort not found",
      "notFoundDesc": "This cohort doesn't exist or has been deleted. Try returning to the cohorts list.",
      "onTrack": "On track",
      "overview": "Overview",
      "pauseCohort": "Pause cohort",
      "programOptional": "Program optional",
      "progress": "Progress",
      "quarterly": "Quarterly",
      "recentActivity": "Recent activity",
      "requestUpdate": "Request update",
      "resumeCohort": "Resume cohort",
      "searchCohorts": "Search cohorts",
      "searchTalents": "Search talents",
      "selectProgram": "Select program",
      "sendMessage": "Send message",
      "stability": "Stability",
      "startDateLabel": "Start date",
      "started": "Started",
      "status": "Status",
      "statusChangeFailed": "Failed to change cohort status",
      "targetArrival": "Target arrival",
      "talents": "Talents",
      "title": "Cohorts",
      "totalTalents": "Total talents",
      "trackProgress": "Track progress",
      "unassigned": "Unassigned",
      "updateFailed": "Failed to update cohort",
      "viewDetails": "View details",
      "viewProfile": "View profile",
      "whatHappensNext": "What happens next",
      "whatHappensNextDescription": "You'll land on the cohort detail page where you can invite talents directly, assign them from the Pool, and follow their progress through Vetting and the parallel Sponsored heroes (Mobility, Adaptation, Care).",
      "errors": {
        "nameRequired": "Cohort name is required",
        "nameTooLong": "Cohort name must be 200 characters or fewer",
        "descriptionTooLong": "Description must be 2000 characters or fewer",
        "planLimit": "Free plan allows 1 active cohort. Upgrade to Enterprise for unlimited cohorts."
      },
      "cohortActionsAria": "Actions for {{name}}",
      "emptyTalentsTitle": "No talents in this cohort yet",
      "emptyTalentsDescription": "Invite talents or import a list to start tracking them through Vetting and Sponsorship.",
      "addTalentsAria": "Add talents to {{name}}",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Optional notes about this cohort",
      "targetShort": "Target",
      "startDateUnset": "Start date not set",
      "feedbackCadenceAria": "Feedback cadence: {{cadence}}",
      "targetArrivalAria": "Target arrival: {{date}}",
      "talentRowActionsAria": "Actions for {{name}}",
      "archiveSuccess": "{{name}} moved to archived.",
      "archiveFailed": "Failed to archive cohort",
      "restoreSuccess": "{{name}} restored.",
      "restoreFailed": "Failed to restore cohort",
      "activeTab": "Active",
      "archivedTab": "Archived",
      "manageArchivedOnPipeline": "Manage on the pipeline",
      "archivedReadOnly": "Archived engagements are read-only here. Restore them from the Pipeline.",
      "archivedEmptyTitle": "No archived engagements in this cohort",
      "selectAllAria": "Select all talents",
      "selectAllCount": "Select all ({{selected}}/{{total}})",
      "viewInPipeline": "View talents in Pipeline",
      "disabledPausedCohort": "Resume the cohort to enable this action",
      "disabledPausedProgram": "Resume the parent program to enable this action",
      "archive": "Archive",
      "restore": "Restore",
      "archiveConfirmTitle": "Archive cohort?",
      "archiveConfirmDescription": "{{name}} moves to the Archived tab. Restore any time from there. Existing talents are unaffected.",
      "scope": {
        "active": "Active",
        "archived": "Archived"
      },
      "form": {
        "talentCountPlaceholder": "e.g., 20"
      },
      "atRiskCount_one": "{{count}} at risk",
      "atRiskCount_other": "{{count}} at risk",
      "blockedCount_one": "{{count}} blocked",
      "blockedCount_other": "{{count}} blocked",
      "inviteCountToVetting_one": "Invite {{count}} to Vetting",
      "inviteCountToVetting_other": "Invite {{count}} to Vetting",
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected"
    },
    "common": {
      "add": "Add",
      "back": "Back",
      "cancel": "Cancel",
      "change": "Change",
      "clear": "Clear",
      "close": "Close",
      "confidence": "confidence",
      "confirm": "Confirm",
      "continue": "Continue",
      "founded": "Founded",
      "loading": "Loading...",
      "of": "of",
      "optional": "Optional",
      "other": "Other",
      "save": "Save",
      "select": "Select",
      "tryAgain": "Try again",
      "view": "View",
      "yourCompany": "your company",
      "error": {
        "sectionTitle": "Couldn't load this section",
        "sectionDescription": "Something went wrong fetching the data. Try again — if the problem persists, contact support.",
        "retry": "Retry"
      },
      "relativeTime": {
        "justNow": "just now",
        "today": "Today",
        "yesterday": "Yesterday",
        "weekAgo": "1 week ago",
        "monthAgo": "1 month ago"
      },
      "contactPlaceholder": "contact@tonnie.ai"
    },
    "components": {
      "addTalentsWizard": {
        "assignToCohort": "Assign to cohort",
        "back": "Back",
        "bringFromPool": "Bring from the Tonnie Pool",
        "browsePool": "Browse Pool",
        "cancel": "Cancel",
        "chooseCohortTalentsDesc": "Pick the cohort these talents join",
        "chooseImportMethod": "Choose import method",
        "confirmAndImport": "Confirm & import",
        "confirmImport": "Confirm import",
        "createNewCohort": "Create new cohort",
        "createNewProgram": "Create new program",
        "importing": "Importing...",
        "mapColumns": "Map columns",
        "mapColumnsDesc": "Match your spreadsheet's columns to Tonnie's fields",
        "needHelpChoosing": "Need help choosing",
        "needHelpDescriptionNoATS": "Upload Excel or CSV files, or bring talents from your Tonnie Talent Pool (Enterprise), to add them to your pipeline. ATS integration will be available in a future release.",
        "next": "Next",
        "reviewData": "Review data",
        "reviewDataDesc": "Check each row before it is imported",
        "selectImportDesc": "Import from a spreadsheet or from your ATS",
        "selectTargetCohort": "Select target cohort",
        "uploadExcelCsv": "Upload Excel csv",
        "uploadFile": "Upload file",
        "uploadFileDesc": "An Excel or CSV file with one talent per row"
      },
      "addToCohort": {
        "addToCohortBtn": "Add to cohort",
        "afterAdding": "After adding",
        "cancel": "Cancel",
        "chooseCohort": "Choose cohort",
        "cohortDetails": "Cohort details",
        "currentTalents": "Current talents",
        "pleaseSelectCohort": "Please select a cohort",
        "program": "Program",
        "selectCohort": "Select cohort",
        "title": "Add to cohort",
        "unassigned": "Unassigned",
        "description_one": "Select a cohort to add the {{count}} selected talent to",
        "description_other": "Select a cohort to add the {{count}} selected talents to",
        "talentsAdded_one": "{{count}} talent added to the cohort",
        "talentsAdded_other": "{{count}} talents added to the cohort",
        "talentsSelected_one": "{{count}} talent selected",
        "talentsSelected_other": "{{count}} talents selected",
        "talentCount_one": "{{count}} talent",
        "talentCount_other": "{{count}} talents"
      },
      "confirmDialog": {
        "processing": "Processing"
      },
      "countrySelect": {
        "noResults": "No results",
        "placeholder": "Placeholder",
        "search": "Search"
      },
      "pageHeader": {
        "coPilot": "CoPilot",
        "goBack": "Go back"
      }
    },
    "consent": {
      "objectivesNotShared": "This talent does not share Care with your company, so their objectives are not shown.",
      "withheld": {
        "care_one": "{{count}} talent does not share Care",
        "care_other": "{{count}} talents do not share Care",
        "checkup_one": "{{count}} talent does not share their CheckUp result",
        "checkup_other": "{{count}} talents do not share their CheckUp result",
        "passport_stamps_one": "{{count}} talent does not share their Passport",
        "passport_stamps_other": "{{count}} talents do not share their Passport",
        "qultureup_one": "{{count}} talent does not share QultureUp",
        "qultureup_other": "{{count}} talents do not share QultureUp",
        "teleportal_one": "{{count}} talent does not share TelePortal",
        "teleportal_other": "{{count}} talents do not share TelePortal"
      }
    },
    "copilot": {
      "open": "Open CoPilot"
    },
    "dashboard": {
      "activeJourneys": "Active journeys",
      "addToTalentPool": "Add to talent pool",
      "aiCoPilot": "AI CoPilot",
      "allClear": "All clear",
      "allClearTitle": "All clear",
      "askCoPilot": "Ask CoPilot",
      "attention": "Needs attention",
      "averageScore": "Average score",
      "coPilotDescription": "Ask your AI assistant about talent mobility insights, program recommendations, and data analysis.",
      "conversionRate": "{{rate}}% conversion",
      "createCohort": "Create cohort",
      "critical": "Critical",
      "evidence": "Evidence",
      "exploreHeroes": "Explore heroes",
      "healthy": "Healthy",
      "heroes": {
        "assessReadiness": "Assess talent readiness and cultural fit",
        "checkupAndPool": "CheckUp & Pool",
        "commitment": "Commitment",
        "culturalAdaptation": "Cultural adaptation & iQulture",
        "legalTravelSetup": "Legal, travel & relocation setup",
        "wellbeingLoyalty": "Wellbeing & loyalty monitoring",
        "inTransitCount_one": "{{count}} in transit",
        "inTransitCount_other": "{{count}} in transit",
        "learningCount_one": "{{count}} learning",
        "learningCount_other": "{{count}} learning",
        "talentsCount_one": "{{count}} talent",
        "talentsCount_other": "{{count}} talents",
        "thrivingCount_one": "{{count}} thriving",
        "thrivingCount_other": "{{count}} thriving"
      },
      "importTalents": "Import talents",
      "inCheckUp": "In CheckUp",
      "iqulture": "iQulture",
      "journeyFlow": "Journey flow",
      "launchProgram": "Launch program",
      "milesAndStamps": "{{miles}} miles · {{stamps}} stamps",
      "navigateToDashboards": "Navigate to specialized dashboards",
      "needAttention": "Need attention",
      "needsAttention": "Needs attention",
      "attentionMyTasks": "My tasks",
      "attentionAtRisk": "At risk",
      "noRecentEvents": "No recent events",
      "noUrgentItems": "No urgent items requiring attention",
      "onTrack": "On track",
      "organizeTalents": "Organize talents into groups",
      "pipeline": "Pipeline",
      "portfolioHealth": "Portfolio health",
      "portfolioSummary": "Managing {{programs}} programs and {{cohorts}} cohorts",
      "profileCompletion": {
        "addRemainingDetails": "Add remaining details",
        "complexFieldNotice": "This field is editable from the onboarding wizard. Click 'Finish in the onboarding wizard' to update it.",
        "description": "Add a few more details to unlock better matching and faster billing.",
        "descriptionAlmostThere": "You're almost there — complete a few more details to finish your profile.",
        "dialogDesc": "This takes a few seconds and makes talent matching more accurate.",
        "fields": {
          "annualHiringVolume": "Annual hiring volume",
          "branches": "Branch offices",
          "businessType": "Business type",
          "companyName": "Company name",
          "companySize": "Company size",
          "contactPhone": "Contact phone",
          "contactRole": "Contact role",
          "foundedYear": "Founded year",
          "hiringGoals": "Hiring goals",
          "hiringTimeframe": "Hiring timeframe",
          "hqCountry": "Headquarters country",
          "industry": "Industry",
          "languages": "Language requirements",
          "legalName": "Legal entity name",
          "mobilityMaturity": "Mobility maturity",
          "primaryUseCase": "Primary use case",
          "targetMarkets": "Target markets",
          "targetRoleTypes": "Target role types",
          "taxId": "Tax ID / VAT",
          "topChallenges": "Top challenges",
          "website": "Website",
          "workArrangement": "Work arrangement"
        },
        "finishInWizard": "Finish in the onboarding wizard",
        "seeAll": "See all ({{count}})",
        "title": "Complete your profile",
        "descriptionWithCount_one": "{{count}} detail still to capture — it takes about a minute.",
        "descriptionWithCount_other": "{{count}} details still to capture — it takes about a minute."
      },
      "quickActions": "Quick actions",
      "recentActivity": "Recent activity",
      "sendCheckUp": "Send CheckUp",
      "sponsored": "Sponsored",
      "stages": {
        "adaptation": "Adaptation",
        "care": "Care",
        "mobility": "Mobility",
        "vetting": "Vetting"
      },
      "startNewMobility": "Start new mobility program",
      "startVettingProcess": "Start vetting process",
      "talentDistribution": "Talent distribution across journey stages",
      "topPerformers": "Top performers",
      "urgent": "Urgent",
      "myCareTasks": {
        "title": "My critical tasks",
        "viewAll": "View all in Care"
      },
      "viewAllEvents": "View all events",
      "viewAllIssues": "View all issues",
      "viewAnalytics": "View analytics",
      "welcomeBackBusiness": "Welcome back, {{name}}!",
      "onboarding": {
        "title": "Welcome to Tonnie. Let’s set up your first talents.",
        "body": "Your dashboard fills up as soon as you import talents and group them into a program. Two steps and you’re live across acquisition, vetting, and sponsoring.",
        "importTitle": "Import talents",
        "importBody": "Upload a CSV or XLSX, or add candidates one at a time. Invitations go out as soon as you confirm.",
        "programTitle": "Create your first program",
        "programBody": "Programs group cohorts and surface acquisition / vetting / sponsoring metrics in one place.",
        "helperHint": "Tip: you can do either step first — they wire up to each other automatically once both exist.",
        "skipToPipeline": "Go to pipeline",
        "skipToPool": "Browse the Pool"
      },
      "todayPanel": {
        "blockedSubtitle": "Open the drawer to clear the blocker",
        "atRiskSubtitle": "A nudge today keeps this journey on track",
        "title": "Today’s priorities",
        "blockedItem": "{{name}}: blocked",
        "atRiskItem": "{{name}}: at risk",
        "countLabel_one": "{{count}} action",
        "countLabel_other": "{{count}} actions"
      },
      "weeklySummary": {
        "thisWeek": "This week"
      },
      "blockedFallback": "Process blocked",
      "riskFallback": "At risk",
      "attentionAdaptationRisk": "Low adaptation engagement",
      "attentionCareRisk": "Commitment at risk",
      "atRiskCount_one": "{{count}} at risk",
      "atRiskCount_other": "{{count}} at risk",
      "blockedCount_one": "{{count}} blocked",
      "blockedCount_other": "{{count}} blocked",
      "attentionOverdue_one": "{{count}} overdue",
      "attentionOverdue_other": "{{count}} overdue",
      "welcomeBackBusinessNoName": "Welcome back!"
    },
    "evidence": {},
    "evidencePage": {
      "activeTab": "Active",
      "activity": "Activity",
      "archivedTab": "Archived",
      "adaptation": "Adaptation",
      "allClear": "All clear",
      "allCohorts": "All cohorts",
      "allStages": "All stages",
      "analysis": "Analysis",
      "cohortLabel": "Cohort",
      "irrTrendsEmpty": "Not enough IRR data yet — the evolution chart unlocks after at least two months of activity.",
      "mesh": {
        "motivation": "Motivation",
        "english": "English",
        "softSkills": "Soft skills",
        "hardSkills": "Hard skills"
      },
      "openPassportAria": "Open passport for {{name}}",
      "sponsoredBadge": "Sponsored",
      "stageNotShared": "Not shared",
      "talentRowActionsAria": "Actions for {{name}}",
      "totalBadges": "Total badges",
      "totalStamps": "Total stamps",
      "averageIQultureScore": "Average iQulture Score",
      "avgIQulture": "Avg. iQulture",
      "avgProgress": "Avg. progress",
      "careLabel": "Care",
      "carePillarsHealth": "Care pillars health",
      "carePillarsHealthDesc": "How your talents rate each Care pillar",
      "checkUpProgress": "CheckUp progress",
      "citizenBadges": "Citizen badges",
      "citizenBadgesDesc": "Badges your talents have earned on their journeys",
      "common": "Common",
      "description": "Proof of each talent's journey: passports, stamps and badges",
      "epic": "Epic",
      "estimatedContribution": "Estimated contribution",
      "events": "Events",
      "iqultureBadgeDist": "iQulture badge dist",
      "irrEvolution": "IRR evolution",
      "irrEvolutionDesc": "How your talents' evidence has grown over time",
      "legendary": "Legendary",
      "levelsDistributionDesc": "How many talents have reached each citizen level",
      "meshScoreBreakdown": "MESH breakdown",
      "meshScoreDesc": "Average MESH scores across your scored talents",
      "milesAndStamps": "{{miles}} miles · {{stamps}} stamps",
      "milesFromAchievements": "Miles from achievements",
      "mobility": "Mobility",
      "needsAttention": "Needs attention",
      "overallHealthScore": "Overall health score",
      "overview": "Overview",
      "passports": "Passports",
      "rare": "Rare",
      "uncommon": "Uncommon",
      "noEvents": "No events yet",
      "noPassports": "No passports match your filters.",
      "rarityDistribution": "Rarity distribution",
      "recentEvents": "Recent events",
      "searchTalents": "Search talents",
      "sponsoredTalents": "Sponsored talents",
      "stageLabel": "Stage",
      "stampsBadges": "Achievements",
      "stampsCollection": "Stamps collection",
      "stampsCollectionDesc": "Stamps your talents have collected at each milestone",
      "talentReadinessLevels": "Talent readiness levels",
      "title": "Evidence",
      "topPerformers": "Top performers",
      "totalMiles": "Total Miles",
      "vettingPool": "Vetting Pool",
      "talentStatus": {
        "on-track": "On track",
        "at-risk": "At risk",
        "blocked": "Blocked",
        "completed": "Completed",
        "unknown": "Status pending"
      },
      "pillarScoresPending": "Per-pillar Care scores will appear here once the Care backend projection ships.",
      "stages": {
        "vetting": "Vetting",
        "mobility": "Mobility",
        "adaptation": "Adaptation",
        "care": "Care"
      },
      "blockedCount_one": "{{count}} blocked",
      "blockedCount_other": "{{count}} blocked",
      "earned_one": "{{count}} earned",
      "earned_other": "{{count}} earned",
      "passportCount_one": "{{count}} passport",
      "passportCount_other": "{{count}} passports",
      "talentCount_one": "{{count}} talent",
      "talentCount_other": "{{count}} talents"
    },
    "feedback": {
      "additionalFeedbackHint": "You can provide detailed feedback, attach screenshots, or files to help us understand your experience better.",
      "attachFiles": "Attach files",
      "categoryDescription": "Select the category that best describes your feedback",
      "categoryQuestion": "What type of feedback is this?",
      "characterCount": "{{current}}/{{max}} characters",
      "context": {
        "hero": "Hero",
        "heroPlaceholder": "e.g., CheckUp, TelePortal",
        "notDetected": "No context detected",
        "page": "Page",
        "pagePlaceholder": "e.g., /dashboard, /checkup"
      },
      "contextInfo": "Context information",
      "contextSaved": "Context information saved",
      "detailsDescription": "Please provide details about your feedback",
      "detailsPlaceholder": "Describe your feedback in detail...",
      "detailsQuestion": "Tell us more",
      "editContext": "Edit",
      "fileSizeError": "File size exceeds {{maxSize}} limit",
      "fileUploadDescription": "Add screenshots, PDFs, or other files (up to 20MB each) to help us understand your feedback better.",
      "optional": "Optional",
      "privacyNote": "Your feedback is anonymous and helps us improve Tonnie",
      "ratingDescription": "Rate your overall satisfaction",
      "ratingQuestion": "How was your experience?",
      "selectRatingAndCategory": "Please select both rating and category",
      "submit": "Submit",
      "submitError": "Failed to submit feedback. Please try again.",
      "submitSuccess": "Thank you! Your feedback has been submitted.",
      "submitting": "Submitting...",
      "subtitle": "Help us improve your experience",
      "successMessage": "We appreciate you taking the time to help us improve Tonnie. Your feedback has been received and will be reviewed by our team.",
      "successTitle": "Thank you for your feedback!",
      "title": "Feedback",
      "toggle": "Send feedback",
      "totalFileSize": "{{size}} / {{maxSize}}",
      "uploadFiles": "Upload files",
      "validationError": "Please complete all required fields"
    },
    "affiliate": {
      "availableBalance": "Available balance",
      "codeCopied": "Coupon code copied",
      "colActions": "Actions",
      "colAmount": "Amount",
      "colAmountPaid": "Amount paid",
      "colCommission": "Commission",
      "colDate": "Date",
      "colProgress": "Progress",
      "colRequested": "Requested",
      "colRoute": "Route",
      "colScenario": "Scenario",
      "colStatus": "Status",
      "daysWaiting": "{{count}}d waiting",
      "paidOn": "Paid {{date}}",
      "commission": "Commission",
      "copyCode": "Copy code",
      "discountGiven": "Discount given",
      "exportCsv": "Export CSV",
      "exporting": "Exporting…",
      "exportReady": "Export ready",
      "exportFailed": "Could not export redemptions",
      "filters": {
        "granularityLabel": "Group by",
        "granularity": {
          "day": "Day",
          "month": "Month",
          "year": "Year"
        },
        "rangeLabel": "Period",
        "range": {
          "30d": "30 days",
          "90d": "90 days",
          "12m": "12 months",
          "all": "All time"
        },
        "scenarioLabel": "Scenario",
        "scenarioAll": "All scenarios",
        "statusLabel": "Status",
        "statusAll": "All statuses"
      },
      "scenario": {
        "unlock": "Journey unlock",
        "renewal": "Renewal",
        "pro": "Pro",
        "other": "Other"
      },
      "noRedemptionsForFilters": "No redemptions match these filters.",
      "redemptionsTitle": "Redemptions",
      "rowsPerPage": "Rows per page",
      "showingRange": "{{from}}–{{to}} of {{total}}",
      "goToPage": "Go to page {{page}}",
      "prev": "Previous",
      "next": "Next",
      "checkout": "Tonnie checkout",
      "checkoutSecure": "Secure · Stripe",
      "customerView": "What your customer sees",
      "howTitle": "How the program works",
      "howStep1Title": "Share your code",
      "howStep1Body": "Give {{code}} to people you refer to Tonnie.",
      "howStep2Title": "They save {{percent}}%",
      "howStep2Body": "The code is applied at checkout — the price drops before they pay.",
      "howStep3Title": "You earn {{rate}}%",
      "howStep3Body": "On every paid conversion, {{rate}}% of what they pay is credited to your balance.",
      "howStep4Title": "Withdraw",
      "howStep4Body": "Once your balance reaches {{amount}}, request a payout and upload your invoice to get paid.",
      "refundsNote": "Commission accrues only when a payment succeeds. Refunds within the window reverse the matching commission automatically.",
      "sampleProduct": "Pro journey",
      "sampleProductSub": "Monthly subscription",
      "invoiceOnFile": "Invoice received",
      "invoiceUploaded": "Invoice uploaded",
      "invoiceUploadFailed": "Invoice upload failed",
      "minimumPayout": "Minimum payout: {{amount}}",
      "noPayoutsYet": "No payouts requested yet.",
      "noRedemptionsYet": "No redemptions yet.",
      "notEnrolledBody": "This organization is not enrolled in the Tonnie affiliate program. Contact Tonnie to get started.",
      "notEnrolledTitle": "Not an affiliate yet",
      "awaitingApproval": "Awaiting approval",
      "cancel": "Cancel",
      "payoutCancelled": "Payout cancelled — balance released",
      "payoutCancelFailed": "Could not cancel payout",
      "payoutFailed": "Could not request payout",
      "payoutHistory": "Payout history",
      "payoutRequested": "Payout requested",
      "payoutStep1Title": "Request",
      "payoutStep1Body": "You request a payout of your available balance.",
      "payoutStep2Title": "Approval",
      "payoutStep2Body": "Tonnie reviews and approves your request.",
      "payoutStep3Title": "Invoice",
      "payoutStep3Body": "You upload your invoice for the amount.",
      "payoutStep4Title": "Payment",
      "payoutStep4Body": "Tonnie pays you by bank transfer.",
      "payoutStatus": {
        "approved": "Approved",
        "cancelled": "Cancelled",
        "invoice_received": "Invoice received",
        "paid": "Paid",
        "rejected": "Rejected",
        "requested": "Requested"
      },
      "percentOff": "{{percent}}% off",
      "platform": {
        "colCommission": "Commission",
        "colDiscount": "Discount",
        "colIssuer": "Affiliate",
        "colPaid": "Paid",
        "colRedemptions": "Redemptions",
        "errorHint": "Retry, or check your Tonnie-staff access.",
        "errorTitle": "Couldn't load the platform overview",
        "issuersTitle": "By affiliate",
        "noIssuers": "No paid redemptions yet.",
        "totalCommission": "Total commission",
        "totalDiscount": "Total discount given",
        "totalPaid": "Total paid",
        "totalRedemptions": "Total redemptions"
      },
      "yourCommission": "You earn {{rate}}%",
      "discountHint": "The discount your customers get at checkout.",
      "commissionHint": "Your commission on every amount they pay.",
      "redemptionsOverTime": "Redemptions over time",
      "redemptionStatus": {
        "paid": "Paid",
        "pending": "Pending",
        "refunded": "Refunded"
      },
      "requestPayout": "Request payout",
      "subtitle": "Track redemptions of your coupon and withdraw your commission.",
      "tabHowItWorks": "How it works",
      "tabOverview": "Overview",
      "tabPayouts": "Payouts",
      "tabPlatform": "Platform",
      "title": "Affiliate program",
      "totalCommission": "Total commission",
      "totalRedemptions": "Redemptions",
      "uploadInvoice": "Upload invoice",
      "uploading": "Uploading…",
      "yourCode": "Your coupon code"
    },
    "layout": {
      "adaptation": "Adaptation",
      "affiliates": "Affiliates",
      "billing": "Billing",
      "business": "Business",
      "care": "Care",
      "cohorts": "Cohorts",
      "evidence": "Evidence",
      "home": "Home",
      "logout": "Log out",
      "messages": "Messages",
      "mobility": "Mobility",
      "pipeline": "Pipeline",
      "pool": "Pool",
      "programs": "Programs",
      "settings": "Settings",
      "vetting": "Vetting"
    },
    "legal": {
      "aboutUs": "About us",
      "backToDashboard": "Back to dashboard",
      "dataProtection": "Data protection",
      "dataProtectionBody": "Data protection body",
      "gdprBody": "GDPR body",
      "gdprCompliance": "GDPR compliance",
      "privacyBody": "Privacy body",
      "privacyDescription": "How Tonnie collects, uses and protects personal data",
      "privacyPolicy": "Privacy policy",
      "rightsDescription": "Your rights over the data Tonnie holds, and how to use them",
      "subtitle": "Subtitle",
      "termsBody": "Terms body",
      "termsDescription": "The terms that govern your company's use of Tonnie",
      "termsOfService": "Terms of service",
      "title": "Terms & privacy",
      "viewPrivacy": "View privacy",
      "viewTerms": "View terms",
      "yourRights": "Your rights"
    },
    "mobilityPage": {
      "activeTab": "Active",
      "archivedTab": "Archived",
      "allStatus": "All status",
      "allTracks": "All tracks",
      "analytics": "Analytics",
      "acrossAllTracks": "Across all tracks",
      "avgProgress": "Avg. progress",
      "blocked": "Blocked",
      "blockingDocs": "Blocking docs",
      "complete": "Complete",
      "viewAll": "View all",
      "detailsBtn": "Details",
      "detailsAria": "Open CoPilot details for {{name}}",
      "viewTalentAria": "View details for {{name}}",
      "talentRowActionsAria": "Actions for {{name}}",
      "blockingDocsPending": "Blocking docs pending",
      "coTasks": "Tasks",
      "companyActions": "Company actions",
      "atRiskTalents": "At risk",
      "overdueTasks": "Overdue tasks",
      "companyActionsRequired": "Company actions required",
      "companyDocsPending": "Company docs pending",
      "companyActionsSectionTitle": "Company tasks",
      "companyTasksDesc": "Company-owned obligations across your sponsored talents — grouped by talent.",
      "companyTasksPending": "Company tasks pending",
      "companyTasksPendingCount_one": "{{count}} company task pending",
      "companyTasksPendingCount_other": "{{count}} company tasks pending",
      "companyTasksTitle": "Company tasks",
      "companyTasksOpenTab": "Open ({{count}})",
      "companyTasksCompletedTab": "Completed ({{count}})",
      "companyTasksEmpty": "No tasks here.",
      "attachUpload": "Attach & upload",
      "awaitingUpload": "Awaiting upload",
      "docsAttachedCount": "{{uploaded}}/{{total}} docs",
      "noDocsRequired": "No documents required — mark complete when done.",
      "replaceDocument": "Replace",
      "reopenTaskAria": "Reopen {{title}}",
      "requiredDocuments": "Required documents",
      "docsRequiredToCompleteTitle": "Upload required documents",
      "docsUploadedProgress": "{{uploaded}} of {{total}} documents uploaded",
      "allDocsUploadedReadyToComplete": "All documents uploaded — you can complete this task.",
      "taskReopened": "Reopened \"{{title}}\"",
      "taskReopenFailed": "Failed to reopen \"{{title}}\". Please try again.",
      "completed": "Completed",
      "completionRate": "Completion rate",
      "description": "Visas, travel and setup for your sponsored talents' moves",
      "documentUploadedSuccess": "{{name}} uploaded",
      "done": "Done",
      "dueDate": "Due: {{date}}",
      "filterStatus": "Status",
      "filterTrack": "Track",
      "for": "For",
      "forTalent": "For {{name}}",
      "inMobility": "In Mobility",
      "inMobilitySplit": "{{inProgress}} in progress · {{completed}} completed",
      "statusInProgress": "In progress",
      "engaged": "Engaged",
      "inProgressShort": "in progress",
      "noTalentsInTrack": "No talents in this track yet",
      "viewCompletedTalents": "View completed talents",
      "viewBlockedTalents": "View blocked talents",
      "viewAtRiskTalents": "View at-risk talents",
      "trackCompletion": "Track completion",
      "trackCompletionDescription": "How many talents have finished each track",
      "doneOfEngaged": "{{name}} · {{done}}/{{engaged}}",
      "legal": "Legal",
      "milestones": "Milestones",
      "mobilityTracks": "Mobility tracks",
      "overall": "Overall",
      "noDueDate": "No due date",
      "noPendingTasks": "No pending tasks",
      "noTalentsFound": "No talents found",
      "noTalentsInMobility": "No talents in mobility",
      "onTrack": "On track",
      "pendingTasks": "Pending tasks",
      "reminderSent": "Reminder sent for {{title}}",
      "searchTalents": "Search talents",
      "setup": "Setup",
      "statusAtRisk": "Status at risk",
      "statusBlocked": "Status blocked",
      "statusOnTrack": "Status on track",
      "talentProgress": "Talent progress",
      "talentsBlocked": "Talents blocked",
      "taskMarkedComplete": "{{title}} marked as complete",
      "taskCompleteFailed": "Failed to mark \"{{title}}\" complete. Please try again.",
      "title": "Mobility",
      "trackOverview": "Track overview",
      "travel": "Travel",
      "tryAdjustingFilters": "Try adjusting filters",
      "underReview": "Under review",
      "validated": "Validated",
      "waitingOnCompanyCount": "Waiting on company",
      "actionNeeded": "Action needed",
      "allTasksCompletedTitle": "All tasks completed!",
      "clearFiltersButton": "Clear filters",
      "trackProgressOverview": "Track progress overview",
      "companyActionsSection": "Company actions",
      "completeTaskAria": "Mark {{title}} as complete",
      "waitingOnCompany": "Waiting on company",
      "statusLabels": {
        "completed": "Completed",
        "on-track": "On track",
        "blocked": "Blocked",
        "at-risk": "At risk"
      },
      "trackStatusLegend": {
        "done": "Done",
        "inProgress": "In progress",
        "blocked": "Blocked",
        "notStarted": "Not started"
      },
      "lastActivityUnknown": "No activity yet",
      "tracks": {
        "legal": {
          "name": "Legal",
          "description": "Visa, work permits, documentation"
        },
        "travel": {
          "name": "Travel",
          "description": "Flights, logistics, arrival coordination"
        },
        "setup": {
          "name": "Setup",
          "description": "Housing, banking, local registration"
        }
      },
      "urgentTasksSummary_one": "{{count}} urgent task needs attention",
      "urgentTasksSummary_other": "{{count}} urgent tasks need attention",
      "documentUploadFailed": "Upload failed. Try again.",
      "reminderTooSoonGeneric": "Reminder sent recently.",
      "reminderFailed": "Failed to send reminder. Try again.",
      "uploadTooLarge": "File is larger than 25 MB. Trim or compress and try again.",
      "docsStillOutstanding_one": "{{count}} document needed",
      "docsStillOutstanding_other": "{{count}} documents needed",
      "daysOverdue_one": "{{count}} day overdue",
      "daysOverdue_other": "{{count}} days overdue",
      "dueInDays_one": "Due in {{count}} day",
      "dueInDays_other": "Due in {{count}} days",
      "talentCount_one": "{{count}} talent",
      "talentCount_other": "{{count}} talents",
      "pendingCount_one": "{{count}} pending",
      "pendingCount_other": "{{count}} pending",
      "talentCountCompleted_one": "{{count}} of {{total}} {{label}}",
      "talentCountCompleted_other": "{{count}} of {{total}} {{label}}",
      "reminderTooSoon_one": "Reminder sent recently. Try again in {{count}} hour.",
      "reminderTooSoon_other": "Reminder sent recently. Try again in {{count}} hours."
    },
    "nav": {
      "home": "Home"
    },
    "notFound": {
      "description": "The page you're looking for doesn't exist or has been moved.",
      "goHome": "Go home",
      "title": "Page not found"
    },
    "notifications": {
      "justNow": "Just now",
      "noNotifications": "No notifications",
      "title": "Notifications",
      "tabAll": "All",
      "unread": "Unread",
      "noUnread": "No unread notifications",
      "markAllRead": "Mark all as read",
      "bellLabel_one": "Notifications, {{count}} unread",
      "bellLabel_other": "Notifications, {{count}} unread",
      "clearRead": "Clear read",
      "moreActions": "More actions",
      "markReadAction": "Mark as read",
      "dismiss": "Dismiss",
      "dismissed": "Notification dismissed",
      "undo": "Undo",
      "viewDismissed": "View dismissed",
      "dismissedTitle": "Dismissed",
      "restore": "Restore",
      "noDismissed": "No dismissed notifications",
      "seeAll": "See all notifications",
      "showMore": "Show more",
      "showLess": "Show less",
      "daysAgo_one": "{{count}} day ago",
      "daysAgo_other": "{{count}} days ago",
      "hoursAgo_one": "{{count}} hour ago",
      "hoursAgo_other": "{{count}} hours ago",
      "minutesAgo_one": "{{count}} minute ago",
      "minutesAgo_other": "{{count}} minutes ago"
    },
    "onboarding": {
      "challenges": {
        "candidateDropoff": "Candidate drop-off during relocation",
        "complianceLegal": "Compliance & legal complexity",
        "costManagement": "Cost management",
        "findingCandidates": "Finding qualified international candidates",
        "immigrationVisa": "Immigration & visa complexity",
        "postArrival": "Post-arrival adaptation & retention",
        "trackingReporting": "Tracking & reporting"
      },
      "exitSetup": "Exit setup",
      "geographicSetup": {
        "moreRoutes_one": "+{{count}} more",
        "moreRoutes_other": "+{{count}} more"
      },
      "hiringContext": {
        "selectedChallenges": "Selected: {{count}}/3 challenges"
      },
      "hiringGoals": {
        "buildPipeline": "Build a sustainable talent pipeline",
        "improveExperience": "Improve candidate experience during relocation",
        "improveOnboarding": "Improve post-arrival onboarding & adaptation",
        "increaseRetention": "Increase retention of relocated employees",
        "reduceCosts": "Reduce relocation costs",
        "reduceTime": "Reduce time-to-hire for international candidates",
        "streamlineCompliance": "Streamline compliance and visa processes",
        "trackRoi": "Track and measure mobility ROI"
      },
      "hiringTimeframes": {
        "immediate": "Immediate — ready to start now",
        "long": "Long-term (6–12 months)",
        "medium": "Medium-term (3–6 months)",
        "short": "Short-term (1–3 months)"
      },
      "maturity": {
        "established": "Established program — mature mobility function",
        "firstTime": "First time — new to international hiring",
        "someExperience": "Some experience — done a few relocations"
      },
      "personalInfo": {
        "addressDetailsError": "Failed to get address details. Please try again.",
        "addressHint": "Select your address from the suggestions",
        "addressPlaceholder": "Start typing your address...",
        "addressSearchError": "Failed to search addresses. Please try again.",
        "loadingAddressDetails": "Loading address details...",
        "searchAddress": "Search address",
        "searchAddressDescription": "Type your address and select from Google Places suggestions"
      },
      "saving": "Saving...",
      "step": "Step",
      "workArrangements": {
        "flexible": "Flexible",
        "hybrid": "Hybrid",
        "onsite": "On-site"
      }
    },
    "pipelinePage": {
      "activeTab": "Active",
      "addTalents": "Add talents",
      "allCohorts": "All cohorts",
      "allPrograms": "All programs",
      "archivedSubtitle": "Candidates whose journeys have ended — admin-archived or self-deleted accounts",
      "archivedTab": "Archived",
      "avgIQulture": "Avg. iQulture",
      "bucketAcquisition": "Acquisition",
      "bucketAcquisitionDescription": "Sourced / Imported",
      "bucketSponsored": "Sponsored",
      "bucketSponsoredDescription": "Mobility · Adaptation · Care",
      "bucketVetting": "Vetting",
      "bucketVettingDescription": "CheckUp in progress",
      "clearAll": "Clear all",
      "cohort": "Cohort",
      "description": "Every talent from first contact to sponsored, stage by stage",
      "filters": "Filters",
      "formerCandidate": "Former candidate",
      "inPipeline": "In pipeline",
      "needAttention": "Need attention",
      "noCohortFound": "No cohort found",
      "noProgramFound": "No program found",
      "onTrack": "On track",
      "pipelineView": "Pipeline view",
      "scrollNext": "Next column",
      "scrollPrev": "Previous column",
      "program": "Program",
      "searchCohorts": "Search cohorts",
      "searchPlaceholder": "Enter search...",
      "searchPrograms": "Search programs",
      "status": "Status",
      "statusAtRisk": "At risk",
      "statusBlocked": "Blocked",
      "statusCompleted": "Completed",
      "statusOnTrack": "On track",
      "title": "Pipeline",
      "bulkBarAria": "Bulk actions for selected talents",
      "bulkAddToCohort": "Add to cohort",
      "bulkAddToCohortFailed": "Failed to assign selected talents",
      "bulkAddToCohortPartial": "{{added}} assigned to cohort · {{skipped}} could not be assigned",
      "cardTag": "Card tag",
      "selectWholeColumn": "Select the whole column",
      "talentsInPipeline_one": "{{count}} talent in the pipeline",
      "talentsInPipeline_other": "{{count}} talents in the pipeline",
      "bulkAddToCohortSuccess_one": "{{count}} talent assigned to the cohort",
      "bulkAddToCohortSuccess_other": "{{count}} talents assigned to cohort",
      "searchLabel": "Search talents"
    },
    "vettingCard": {
      "acceptedAgo": "Accepted {{when}}",
      "checkupProgress": "CheckUp {{percent}}% · {{done}} of {{total}} steps",
      "iqultureProgress": "iQulture {{percent}}%",
      "lastSeenAgo": "Last seen {{when}}",
      "missingSteps": "Missing: {{steps}}",
      "notYetActive": "Not yet active",
      "startedAgo": "Started {{when}}",
      "stateAwaitingScore": "Calculating iQulture…",
      "stateNotStarted": "Not started",
      "step": {
        "assistantChat": "Assistant chat",
        "languageTests": "Language tests",
        "motivationalAnswers": "Motivation",
        "pitchVideo": "Pitch video",
        "videosWatched": "Watch videos"
      },
      "submittedAgo": "Submitted {{when}}",
      "testitComplete": "TestIt complete",
      "testitInvited": "TestIt invited",
      "testitProgress": "TestIt · {{done}}/{{total}}",
      "scoredAgo": "Scored {{when}}",
      "completedAgo": "Completed {{when}}",
      "sharingWithdrawnAgo": "Sharing withdrawn {{when}}"
    },
    "pipelineView": {
      "activateAgain": "Activate again",
      "addTalentsCta": "Add talents",
      "archive": "Archive",
      "archiveSponsoredConfirmDescription": "This archives {{name}}'s sponsored journey: the card leaves your pipeline and {{name}} loses access to this opportunity. Their CheckUp results and journey history stay on file for compliance. You can restore it from the Archived tab.",
      "archiveSponsoredConfirmTitle": "Archive sponsored talent",
      "archiving": "Archiving…",
      "askForCheckup": "Invite to full CheckUp",
      "askForTestit": "Invite to specific tests",
      "bulkArchiveCta": "Archive {{count}}",
      "bulkArchiveFailed": "Failed to archive talents",
      "bulkArchivePartial": "{{archived}} archived · {{failed}} failed",
      "bulkClear": "Clear",
      "bulkSendConfirmCta": "Send invitations",
      "bulkSendConfirmTitle": "Send invitations to Vetting",
      "bulkSendPartial": "{{sent}} sent · {{failed}} failed",
      "bulkSending": "Sending…",
      "bulkSendingProgress": "Sending invitations… {{sent}}/{{total}}",
      "bulkSponsorCta": "Sponsor {{count}}",
      "bulkSponsorFailed": "Failed to sponsor talents",
      "bulkSponsorPartial": "{{sponsored}} sponsored · {{failed}} failed",
      "citizenLeft": "Candidate left platform",
      "citizenLeftTooltip": "This candidate deleted their Tonnie account. Their journey is preserved for audit; identifying details are redacted.",
      "clearSearch": "Clear filter",
      "delete": "Delete",
      "deleteConfirmDescription": "This will permanently remove {{name}} and the entire import history (pipeline events, journeys, messages). This action cannot be undone.",
      "deleteConfirmTitle": "Delete talent",
      "deleteInvitationConfirmDescription": "This will permanently remove the invitation for {{name}}. They won't be able to accept the email link. This action cannot be undone.",
      "deleteInvitationConfirmTitle": "Delete invitation",
      "deleteInvitationFailed": "Failed to delete invitation",
      "deleteInvitationSuccess": "Invitation deleted",
      "deleting": "Deleting…",
      "dragNotAllowed": "Cannot move from {{from}} to {{to}} — use the kebab menu for the right action",
      "imported": "Imported {{when}}",
      "invitationDeleteFailed": "Failed to remove invitation",
      "invitationDeleted": "{{name}}’s invitation removed",
      "invitationResendFailed": "Failed to resend",
      "invitationResent": "Invitation resent",
      "invitationRevokeFailed": "Failed to revoke",
      "invitationRevoked": "Invitation revoked",
      "invitationSendFailed": "Failed to send invitation",
      "invitationSent": "Invitation sent",
      "invitationSentHint": "{{name}} will receive the email and the card moves to Vetting.",
      "inviteToVetting": "Invite to Vetting",
      "noMatches": "No matches for \"{{query}}\"",
      "noTalentsInStage": "No talents in this stage",
      "removeFromPipeline": "Remove from pipeline",
      "removeVettingConfirmDescription": "This removes {{name}} from your pipeline, and {{name}} loses access to this opportunity. Their CheckUp data and history stay on file for compliance. You can restore them from the Archived tab.",
      "removeVettingConfirmTitle": "Remove talent from pipeline",
      "invitationEmailNotSent": "The invitation is saved, but its email could not be sent",
      "resendInvitationFailed": "Failed to resend invitation",
      "resendInvitationSuccess": "Invitation resent",
      "revokeInvitationFailed": "Failed to revoke invitation",
      "revokeInvitationSuccess": "Invitation revoked",
      "searchPlaceholder": "Filter name, email, role…",
      "selectAllCount": "Select all ({{selected}}/{{total}})",
      "selectAllMatching": "Select all matching ({{visible}})",
      "statusArchived": "Archived",
      "stageStatus": {
        "onTrack": "On track",
        "blocked": "Blocked",
        "atRisk": "At risk",
        "completed": "Completed"
      },
      "statusAwaitingAcceptance": "Awaiting acceptance",
      "statusDraft": "Draft",
      "subStage": {
        "mobility": "Mobility",
        "adaptation": "Adaptation",
        "care": "Care",
        "evidence": "Evidence"
      },
      "talentArchiveFailed": "Failed to archive talent",
      "talentArchived": "{{name}} archived",
      "talentDeleteFailed": "Failed to delete talent",
      "talentDeleted": "{{name}} has been removed",
      "talentSponsored": "Talent sponsored! Journey instance created with route {{origin}} → {{destination}}",
      "talentSponsoredFailed": "Failed to sponsor talent",
      "unarchiveFailed": "Failed to restore talent",
      "unarchiveSuccess": "Talent restored — journey active again",
      "updated": "Updated {{when}}",
      "selectCandidate": "Select candidate",
      "signedUpNotAccepted": "Signed up, not accepted",
      "signedUpNotAcceptedTooltip": "This person already has a Tonnie account but has not accepted your invitation. Resending is likely to reach them. Their journey and CheckUp stay private until they accept.",
      "tag": {
        "inviteProblem": "Invite problem",
        "onboardingIncomplete": "Finishing profile",
        "waitingForCheckup": "Waiting for CheckUp",
        "checkupInProgress": "CheckUp in progress",
        "awaitingScore": "Calculating score",
        "awaitingReview": "Ready for review",
        "testitPending": "Tests pending",
        "testitComplete": "Tests complete",
        "testitPassed": "Passed",
        "testitDeclined": "Declined",
        "checkupNotRequested": "CheckUp not requested",
        "inviteDeclined": "Declined",
        "inviteExpired": "Invitation expired",
        "sponsorshipOffered": "Sponsorship offered",
        "checkupWithheld": "Awaiting the talent's consent",
        "consentWithdrawn": "Sharing withdrawn"
      },
      "since": {
        "delivered": "Delivered {{when}}",
        "opened": "Opened {{when}}",
        "landed": "Reached the page {{when}}",
        "bounced": "Bounced {{when}}",
        "sent": "Invited {{when}}",
        "signedUp": "Signed up {{when}}",
        "asked": "Asked {{when}}",
        "expired": "Expired {{when}}"
      },
      "alreadyArchived": "This talent was already archived. The board is up to date.",
      "alreadyRestored": "This journey was already restored. The board is up to date.",
      "invitationAlreadyAccepted": "This invitation has already been accepted.",
      "bulkArchiveConfirmTitle_one": "Archive {{count}} talent",
      "bulkArchiveConfirmTitle_other": "Archive {{count}} talents",
      "bulkArchiveConfirmCta_one": "Archive {{count}} talent",
      "bulkArchiveConfirmCta_other": "Archive {{count}} talents",
      "bulkArchiveConfirmDescription_one": "{{count}} talent will leave your active pipeline. Their CheckUp results and journey history stay on file for compliance. You can restore them from the Archived tab.",
      "bulkArchiveConfirmDescription_other": "{{count}} talents will leave your active pipeline. Their CheckUp results and journey history stay on file for compliance. You can restore them from the Archived tab.",
      "bulkArchiveSuccess_one": "{{count}} talent archived",
      "bulkArchiveSuccess_other": "{{count}} talents archived",
      "atRiskCount_one": "{{count}} at risk",
      "atRiskCount_other": "{{count}} at risk",
      "blockedCount_one": "{{count}} blocked",
      "blockedCount_other": "{{count}} blocked",
      "bulkSelectedCount_one": "{{count}} selected",
      "bulkSelectedCount_other": "{{count}} selected",
      "bulkSendCta_one": "Send {{count}} invitation to Vetting",
      "bulkSendCta_other": "Send {{count}} invitations to Vetting",
      "searchLabel": "Filter talents in {{stage}}",
      "declinedWhen": "Declined {{when}}",
      "expiredWhen": "Expired {{when}}",
      "invitationSentAgain": "Invitation sent again",
      "leftProgramme": "Left the programme · {{date}}",
      "leftProgrammeTooltip": "This talent left your programme, which ended the relationship. You can no longer see what they shared. Send them a new invitation to work with them again.",
      "restoreRefusedLeft": "This talent left your programme. Send them a new invitation to work with them again.",
      "resendInvitationMessageMismatch": "This invitation's message was written for a different request. Send it again from the invitation dialog to write its message."
    },
    "pool": {
      "smartSearch": {
        "downloadCv": "Download CV",
        "cvUnavailable": "CV unavailable",
        "selectCandidate": "Select candidate",
        "clearSelection": "Clear",
        "bulkAddTitle": "Add to Acquisition",
        "stepReview": "Review & rank",
        "how1": "Paste one or more job descriptions.",
        "how2": "AI extracts the skills, seniority, and focus.",
        "how3": "We rank your Talent Pool by fit.",
        "extracting": "Reading the job description…",
        "extractError": "We couldn't analyze that job description. Please try again.",
        "skillsTitle": "Skills we found",
        "skillsHint": "Remove any that don't fit, or add your own — the ranking updates live.",
        "ranking": "Ranking…",
        "noSkills": "No skills extracted",
        "noSkillsHint": "Add the key skills for this role below.",
        "addSkillPlaceholder": "Add a skill…",
        "viewResults": "View ranked results",
        "rankedTitle": "Pool ranked by job fit",
        "rankedForTitle": "Ranked for {{title}}",
        "clear": "Clear",
        "nSelected_one": "{{count}} selected",
        "nSelected_other": "{{count}} selected",
        "addNToAcquisition_one": "Add {{count}} to Acquisition",
        "addNToAcquisition_other": "Add {{count}} to Acquisition",
        "bulkAddDesc_one": "Add {{count}} selected candidate to your pipeline's Acquisition stage.",
        "bulkAddDesc_other": "Add {{count}} selected candidates to your pipeline's Acquisition stage.",
        "bulkAdded_one": "{{count}} added to Acquisition",
        "bulkAdded_other": "{{count}} added to Acquisition",
        "bulkFailed_one": "{{count}} couldn't be added",
        "bulkFailed_other": "{{count}} couldn't be added",
        "analyzing_one": "Analyzing {{count}} job description…",
        "analyzing_other": "Analyzing {{count}} job descriptions…",
        "resultsFound_one": "{{count}} candidate matches",
        "resultsFound_other": "{{count}} candidates match",
        "bulkDuplicates_one": "{{count}} already in this cohort",
        "bulkDuplicates_other": "{{count}} already in this cohort",
        "addSkillLabel": "Add a skill"
      },
      "matchReason": {
        "mustHaves": "Must-haves: {{met}}/{{total}}",
        "seniority": "{{level}} seniority",
        "semantic": "{{score}}% profile match",
        "skills": "{{count}}/{{total}} skills: {{skills}}",
        "readiness": "Readiness {{score}}",
        "location": "Based in {{location}}",
        "niceToHaves_one": "+{{count}} nice-to-have",
        "niceToHaves_other": "+{{count}} nice-to-haves"
      },
      "savedSearch": {
        "title": "Saved searches",
        "savedCount": "Saved ({{count}})",
        "save": "Save",
        "saved": "Search saved",
        "saveFailed": "Couldn't save the search",
        "delete": "Delete saved search",
        "deleteFailed": "Couldn't delete the search",
        "noSkills": "No skills",
        "saveTitle": "Save this search",
        "saveDesc": "Give it a name to re-run this Job Description search later.",
        "nameLabel": "Name",
        "namePlaceholder": "e.g. Senior Backend Engineer",
        "errors": {
          "name": "A name is required"
        }
      },
      "detail": {
        "unavailable": "Candidate unavailable",
        "unavailableHint": "This candidate is no longer in the pool.",
        "curriculum": "Curriculum",
        "openCv": "Open in new tab",
        "noCv": "No CV on file",
        "noCvHint": "This candidate hasn't attached a CV yet.",
        "experience": "Experience",
        "seniority": "Seniority",
        "origin": "Origin",
        "inPoolSince": "In pool since",
        "languages": "Languages",
        "linkedin": "LinkedIn profile",
        "availOpen": "Open to offers",
        "availConsideration": "In consideration",
        "availUnavailable": "Unavailable",
        "experienceValue_one": "{{count}} yr",
        "experienceValue_other": "{{count}} yrs"
      },
      "view": {
        "cards": "Cards",
        "list": "List"
      },
      "advancedSearch": {
        "addAtLeastOneJob": "Please add at least one job description",
        "addedSuccessfully": "Added successfully",
        "enterJobDescription": "Please enter a job description or URL",
        "stepInput": "Input",
        "titleAi": "AI-Powered talent search",
        "subtitle": "Extract skills from job descriptions and find matching candidates",
        "jobDescriptionN": "Job description {{count}}",
        "jobPlaceholder": "Paste a job description here...\n\nExample: We are looking for a Senior Software Engineer with 5+ years of experience in React, TypeScript, and Node.js...",
        "addToList": "Add to list",
        "emptyTitle": "No job descriptions yet",
        "emptyHint": "Add job descriptions to extract keywords",
        "jobN": "Job {{count}}",
        "howItWorks": "How it works",
        "extractBtn": "Extract keywords",
        "jobsAdded_one": "{{count}} job description added",
        "jobsAdded_other": "{{count}} job descriptions added",
        "wordCount_one": "{{count}} word",
        "wordCount_other": "{{count}} words",
        "jobDescriptionLabel": "Job description"
      },
      "startAdvancedSearch": "Start advanced search",
      "addToPipeline": "Add to pipeline",
      "searching": "Searching the Talent Pool…",
      "talentCard": {
        "noCheckup": "No CheckUp yet",
        "preVetted": "Tonnie pre-vetted",
        "inPipeline": "In pipeline",
        "whyMatched": "Why matched:",
        "iqultureScore": "iQulture score",
        "skills": "Skills",
        "added": "Added",
        "addToVet": "Add to vet",
        "matchPercent": "{{score}}% match",
        "top": "TOP",
        "moreCount_one": "+{{count}} more",
        "moreCount_other": "+{{count}} more"
      },
      "nSelected_one": "{{count}} selected",
      "nSelected_other": "{{count}} selected",
      "talentsFound_one": "{{count}} talent found",
      "talentsFound_other": "{{count}} talents found"
    },
    "poolImport": {
      "errors": {
        "country": "Country must be a 3-letter code",
        "email": "Invalid email",
        "empty": "No rows to import",
        "tooMany": "Too many rows (max 1000)"
      },
      "failed": "Import failed",
      "placeholder": "Paste CSV or TSV with a header row: email, first name, last name, job title, country, city, skills",
      "subtitle": "Paste screened candidates to add them to the public Talent Pool. Existing profiles are refreshed.",
      "success": "Imported: {{created}} created, {{updated}} updated",
      "title": "Import profiles",
      "import_one": "Import {{count}} profile",
      "import_other": "Import {{count}} profiles",
      "parsedCount_one": "{{count}} valid row ready to import",
      "parsedCount_other": "{{count}} valid rows ready to import"
    },
    "poolPage": {
      "addToVettingDesc": "Add {{name}} to your vetting pipeline",
      "addToVettingPipeline": "Add to Vetting pipeline",
      "advancedSearch": "Advanced search",
      "advancedSearchDesc": "Find talents who match a job description",
      "alphabetical": "Alphabetical",
      "alreadyInPipeline": "Already in pipeline",
      "available": "Available",
      "description": "Search talents who have chosen to be found",
      "failedToAdd": "Failed to add",
      "inPipeline": "In pipeline",
      "iqultureHighToLow": "iQulture high to low",
      "iqultureLowToHigh": "iQulture low to high",
      "iqultureScore": "iQulture score",
      "location": "Location",
      "noCohortsYet": "No cohorts yet — create one to add talents to your pipeline.",
      "noLocationsFound": "No locations found",
      "noRolesFound": "No roles found",
      "noSkillsFound": "No skills found",
      "noTalentsFound": "No talents found",
      "relevance": "Relevance",
      "role": "Role",
      "searchError": "Search failed",
      "searchErrorHint": "Something went wrong loading talents. Please try again.",
      "searchLocations": "Search locations",
      "searchPlaceholder": "Enter search...",
      "searchRoles": "Search roles",
      "searchSkills": "Search skills",
      "selectACohort": "Select a cohort",
      "selectCohort": "Select cohort",
      "selectLocations": "Select locations",
      "selectRoles": "Select roles",
      "selectSkills": "Select skills",
      "skills": "Skills",
      "sortBy": "Sort By",
      "talentAdded": "{{name}} added to pipeline",
      "title": "Pool",
      "tryAdjustingFilters": "Try adjusting filters",
      "upgradeDescription": "Search and add pre-vetted talents from the Tonnie Talent Pool directly into your pipeline.",
      "results": "Results",
      "bestMatch": "Best match",
      "lowestMatch": "Lowest match",
      "searchLabel": "Search talents"
    },
    "profile": {
      "accountDescription": "Details about your account that cannot be changed here.",
      "accountTitle": "Account",
      "avatarDescription": "Shown in the top-right menu and across the platform.",
      "avatarHelper": "PNG, JPG or GIF up to 5 MB. Drag and drop, or click to browse.",
      "avatarRemoveConfirm": "Your profile photo will be replaced with your initials. You can upload a new one any time.",
      "avatarRemoveConfirmAction": "Remove photo",
      "avatarRemoveFailed": "Could not remove photo. Please try again.",
      "avatarRemoveTitle": "Remove profile photo?",
      "avatarRemoved": "Photo removed",
      "avatarTitle": "Profile photo",
      "avatarTooLarge": "Photo is too large. Max 5 MB.",
      "avatarUploadFailed": "Failed to upload photo. Please try again.",
      "avatarUploaded": "Photo updated",
      "avatarWrongType": "Only image files are supported.",
      "changeAvatar": "Change profile photo",
      "description": "Manage your personal information, avatar, and account details.",
      "email": "Email",
      "emailManagedByClerk": "Managed via sign-in",
      "firstName": "First name",
      "lastName": "Last name",
      "memberSince": "Member since",
      "nameDescription": "How your name appears across the platform.",
      "nameTitle": "Your name",
      "remove": "Remove",
      "role": "Role",
      "roleDescription": "Set by your organization admin.",
      "saveChanges": "Save changes",
      "saveFailed": "Could not save changes. Please try again.",
      "saved": "Profile updated",
      "title": "Profile",
      "uploadPhoto": "Upload photo"
    },
    "programs": {
      "activePrograms": "Running programmes",
      "adjustFilters": "Adjust filters",
      "allCohorts": "All cohorts",
      "allStatus": "All status",
      "askCoPilot": "Ask CoPilot",
      "avgProgress": "Avg. progress",
      "backToPrograms": "Back to programs",
      "care": "Care",
      "careRequiresEnterprise": "Care requires Enterprise",
      "careSettingsReset": "Care settings reset",
      "cohorts": "Cohorts",
      "createCohort": "Create cohort",
      "createDialogDescription": "A program is the top-level organizing layer for talents you sponsor or invite. Cohorts and journeys live inside it.",
      "createFirstProgram": "Create first program",
      "createNewProgram": "Create new program",
      "createProgram": "Create program",
      "created": "Created",
      "description": "Your relocation programmes and the cohorts in them",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Enter description...",
      "editDialogDescription": "Update program details below.",
      "editProgram": "Edit program",
      "filterByStatus": "Filter by status",
      "getMoreInsights": "Get more insights",
      "insightPassRate": "Pass rate",
      "insights": "Insights",
      "insightsDescription": "How this programme is progressing",
      "iqulture": "iQulture",
      "latestUpdates": "Latest updates",
      "manageCohorts": "Manage cohorts",
      "noProgramsFound": "No programs found",
      "notFound": "Program not found",
      "notFoundDesc": "This program doesn't exist or has been deleted. Try returning to the programs list.",
      "overview": "Overview",
      "pauseProgram": "Pause program",
      "programCreated": "Program created",
      "programNameLabel": "Program name",
      "programNamePlaceholder": "Enter program name...",
      "programPaused": "Program paused",
      "programResumed": "Program resumed",
      "programUpdated": "Program updated",
      "progress": "Progress",
      "progressLabel": "Progress",
      "recentActivity": "Recent activity",
      "resumeProgram": "Resume program",
      "searchPrograms": "Search programs",
      "stability": "Stability",
      "stabilityValue": "{{value}}% stability",
      "statusChangeFailed": "Failed to change program status",
      "talents": "Talents",
      "title": "Programs",
      "totalCohorts": "Total cohorts",
      "totalTalents": "Total talents",
      "viewDetails": "View details",
      "whatHappensNext": "What happens next",
      "whatHappensNextDescription": "You'll be taken to the program detail page where you can create cohorts, invite talents, and track their journey across Vetting and Sponsored phases.",
      "errors": {
        "nameRequired": "Program name is required",
        "nameTooLong": "Program name must be 200 characters or fewer",
        "descriptionTooLong": "Description must be 2000 characters or fewer",
        "planLimit": "Free plan allows 1 active program. Upgrade to Enterprise for unlimited programs.",
        "createFailed": "Failed to create program"
      },
      "programActionsAria": "Actions for {{name}}",
      "updateFailed": "Failed to update program",
      "archiveSuccess": "{{name}} moved to archived.",
      "archiveFailed": "Failed to archive program",
      "restoreSuccess": "{{name}} restored.",
      "restoreFailed": "Failed to restore program",
      "activeTab": "Active",
      "archivedTab": "Archived",
      "viewInPipeline": "View talents in Pipeline",
      "archive": "Archive",
      "restore": "Restore",
      "archiveConfirmTitle": "Archive program?",
      "archiveConfirmDescription": "{{name}} moves to the Archived tab. Every active cohort under this program is archived too. Restoring the program later does NOT auto-restore cohorts — you re-activate them individually from the Cohorts Archived tab.",
      "insightCareGap": "Sponsored talents but no active Care touchpoints — verify check-in cadence.",
      "cohortScopeAria": "Cohort scope",
      "cohortsEmptyActive": "No active cohorts in this program yet. Create one to start inviting talents.",
      "cohortsEmptyArchived": "No archived cohorts. Cohorts you archive — or that were cascade-archived with the program — will appear here.",
      "cohortCreated": "Cohort created.",
      "talentCount_one": "{{count}} talent",
      "talentCount_other": "{{count}} talents",
      "archiveSuccessWithCascade_one": "{{base}} {{count}} cohort was archived with it.",
      "archiveSuccessWithCascade_other": "{{base}} {{count}} cohorts were archived with it.",
      "restoreSuccessWithCohorts_one": "{{base}} {{count}} cohort is still archived — restore it from the Cohorts tab.",
      "restoreSuccessWithCohorts_other": "{{base}} {{count}} cohorts are still archived — restore them from the Cohorts tab."
    },
    "sendToVetting": {
      "assessmentIntroTalent": "These talents already have a journey with this company, so only the assessment is new — their destination stays as it is.",
      "back": "Back",
      "branchCustom": "Custom destination…",
      "branchLabel": "Branch / office",
      "branchPlaceholder": "Pick a branch or enter custom",
      "bulkSendingProgress": "Sending invitations… {{sent}}/{{total}}",
      "bulkTitle": "Send invitations to Vetting",
      "customizeToggle": "Customize message",
      "description": "We'll create a free CheckUp journey scaffold and email the candidate. You can Sponsor the full journey later if you decide to.",
      "descriptionTestit": "We'll create a free journey scaffold for the specific tests you chose and email the candidate. Their results are reusable.",
      "destinationLabel": "Destination country",
      "destinationPlaceholder": "Where will they be working?",
      "destinationSettingsLink": "Company settings",
      "destinationSource": "From your company settings (HQ and branches).",
      "destinationUnset": "No HQ or branch set in Settings — pick one for this batch, or add it once in Settings.",
      "failed": "Failed to send the invitation. Please try again.",
      "freeCheckUpHint": "No charge until you decide to Sponsor the journey. The candidate gets the CheckUp and you see their MESH + iQulture results in Vetting.",
      "freeCheckUpTitle": "Free CheckUp · Sponsor later if you want",
      "freeTestitHint": "No charge — the candidate completes only the tests you chose, and the results can be reused for future opportunities. You see them in Vetting.",
      "freeTestitTitle": "Free · results are reusable",
      "next": "Next",
      "opportunityIntro": "Choose what the candidate completes, and where the role sits.",
      "outcomeAwaiting": "They stay in Acquisition until they accept.",
      "outcomeMixed": "{{moved}} moved to Vetting · {{awaiting}} awaiting acceptance.",
      "partial": "{{sent}} sent · {{failed}} failed",
      "reviewAssessment": "They will complete",
      "reviewDestination": "Destination",
      "reviewEmailHint": "This is what lands in their inbox.",
      "reviewRecipients": "Recipients",
      "sending": "Sending…",
      "singleCta": "Send invitation",
      "singleSuccess": "Invitation sent to {{name}}",
      "singleTitle": "Send invitation to {{name}}",
      "stepMessage": "Message",
      "stepOf": "Step {{current}} of {{total}}",
      "stepOpportunity": "Assessment",
      "stepReview": "Review & send",
      "workLocationLabel": "Work location",
      "workLocationPlaceholder": "City, office, or remote",
      "bulkCta_one": "Send {{count}} invitation",
      "bulkCta_other": "Send {{count}} invitations",
      "bulkRecipientCount_one": "{{count}} candidate",
      "bulkRecipientCount_other": "{{count}} candidates",
      "bulkSuccess_one": "{{count}} invitation sent",
      "bulkSuccess_other": "{{count}} invitations sent",
      "outcomeRequested_one": "They were asked to share more — nothing changes until they answer.",
      "outcomeRequested_other": "{{count}} were asked to share more — nothing changes until they answer.",
      "outcomeMoved_one": "Moved to Vetting.",
      "outcomeMoved_other": "{{count}} moved to Vetting.",
      "reviewAskNotice_one": "This talent already works with you, so they get the message that fits where they stand: a request to share what they already have, or a reminder of what is still to do.",
      "reviewAskNotice_other": "These {{count}} talents already work with you, so each gets the message that fits where they stand: a request to share what they already have, or a reminder of what is still to do."
    },
    "settings": {
      "customModeActiveDesc": "Custom mode is active. Customize your colors in the Colors tab and upload assets in the Assets tab.",
      "draftSaved": "Draft saved successfully!",
      "fileSizeError": "File size must be less than 2MB",
      "invalidFileFormat": "Invalid file format. Please use PNG, JPG, or SVG",
      "itemRemoved": "{{title}} removed",
      "themeActivated": "Theme activated successfully! Switched to Custom mode.",
      "uploadSuccess": "{{type}} uploaded successfully!"
    },
    "shared": {
      "noPhoneCodeFound": "No phone code found.",
      "searchPhoneCode": "Search phone code..."
    },
    "shell": {
      "viewportGuard": {
        "description": "This application is optimized for desktop screens. Please use a device with a larger screen for the best experience.",
        "hint": "Minimum screen width: 1024px",
        "title": "Desktop required"
      }
    },
    "theme": {
      "configure": "Configure",
      "custom": "Custom",
      "dark": "Dark",
      "light": "Light",
      "system": "System",
      "theme": "Theme"
    },
    "userMenu": {
      "billing": "Billing",
      "logout": "Log out",
      "openMenu": "Open user menu",
      "preferences": "Preferences",
      "profile": "Profile",
      "roleAdmin": "Admin",
      "roleMember": "Team member"
    },
    "vetting": {
      "adjustFilters": "Adjust filters",
      "allBadges": "All badges",
      "allCohorts": "All cohorts",
      "allStatus": "All status",
      "allTalents": "All talents",
      "analytics": "Analytics",
      "avgIQulture": "Avg. iQulture",
      "badgeDistribution": "Badge distribution",
      "badgeDistributionDesc": "How many talents hold each iQulture badge",
      "byCohort": "By cohort",
      "checkUpCompleted": "CheckUp completed",
      "clearFilters": "Clear filters",
      "description": "Assess talents with the CheckUp before you sponsor them",
      "explain": "Explain",
      "explainAria": "Open CoPilot explanation for {{name}}",
      "openTalentAria": "Open talent profile for {{name}}",
      "percentDone": "{{value}}% done",
      "insightBodies": {
        "proInsightBody_one": "{{count}} talent scored 80%+ on iQulture — exceptional readiness for international mobility.",
        "proInsightBody_other": "{{count}} talents scored 80%+ on iQulture, indicating exceptional readiness for international mobility.",
        "potentialInsightBody_one": "{{count}} talent shows strong potential. Consider QultureUp to raise their score.",
        "potentialInsightBody_other": "{{count}} talents show strong potential. Consider QultureUp to boost their scores.",
        "pendingInsightBody_one": "{{count}} talent hasn't completed the CheckUp yet. Send a reminder to speed up vetting.",
        "pendingInsightBody_other": "{{count}} talents haven't completed CheckUp yet. Send reminders to accelerate vetting."
      },
      "sponsorAria": "Sponsor {{name}}",
      "filterByCohort": "Filter by cohort",
      "inVetting": "In Vetting",
      "iqultureAssessed": "iQulture assessed",
      "iqultureBadge": "iQulture badge",
      "loading": "Loading…",
      "loadingDescription": "Loading talent details",
      "mesh": {
        "englishNative": "English",
        "hardOther": "Hard skills",
        "motivation": "Motivation",
        "notScored": "Not scored",
        "softCultural": "Soft & cultural"
      },
      "noTalentsFound": "No talents found",
      "noTalentsInVetting": "No talents in vetting",
      "noobOnly": "Noob only",
      "notFound": "Talent not found",
      "notFoundDesc": "This talent doesn't exist or you don't have access to view their record.",
      "pendingAction": "Pending action",
      "pendingCheckUp": "Pending CheckUp",
      "percentageReadyForMobility": "Percentage ready for Mobility",
      "potential": "Potential",
      "potentialInsight": "Potential insight",
      "potentialOnly": "Potential only",
      "proAndPotentialWithCheckUp": "Pro and potential with CheckUp",
      "proBadges": "Pro badges",
      "proInsight": "Pro insight",
      "proOnly": "Pro only",
      "readyToSponsor": "Ready to sponsor",
      "searchTalents": "Search talents",
      "sponsor": "Sponsor",
      "sponsorshipFunnel": "Sponsorship funnel",
      "sponsorshipFunnelDesc": "From invited to sponsored, stage by stage",
      "sponsorshipReadyRate": "Sponsorship ready rate",
      "statusCompleted": "Status completed",
      "statusInProgress": "Status in progress",
      "statusLabel": "Status",
      "statusPending": "Status pending",
      "talentDetail": {
        "analysis": "Analysis",
        "archivedReadOnly": "This journey is no longer active. The record is preserved for audit; actions aren't available.",
        "exportCsv": "Export CSV",
        "exportFailed": "Couldn't export this report. Please try again.",
        "exportPdf": "Export PDF",
        "vettingCompleteReadOnly": "Vetting is complete — this is a read-only snapshot of the assessment.",
        "askCoPilot": "Ask CoPilot",
        "confidence": "Confidence",
        "copyEmail": "Copy email",
        "copyEmailSuccess": "Email copied to clipboard",
        "culturalRiskAnalysis": "Cultural risk analysis",
        "lowRiskCras": "Low risk CRAs",
        "moderateRiskCras": "Moderate risk CRAs",
        "highRiskCras": "High risk CRAs",
        "archetypesSeverityChip": "{{low}} low · {{moderate}} moderate · {{high}} high",
        "topRisksTitle": "Top cultural risks",
        "topRisksDescription": "The archetypes Tonnie flagged as the highest sponsorship risk for this candidate.",
        "topRisksEmpty": "No high-risk archetypes flagged.",
        "topRisks": {
          "severityShort": {
            "high": "High",
            "moderate": "Mod"
          },
          "a11yLabel": {
            "high": "High risk: {{score}} percent",
            "moderate": "Moderate risk: {{score}} percent"
          }
        },
        "meshTagline": {
          "motivation": "Why this candidate wants to relocate.",
          "english": "Working-language readiness.",
          "softCultural": "Cultural fit and how they collaborate.",
          "hardOther": "Technical and operational capability."
        },
        "pillars": {
          "spreadTitle": "Pillar spread",
          "spreadDescription": "All seven pillars on one radar — the closer each axis reaches the outer edge, the stronger the candidate's evaluation on that pillar.",
          "topGreenFlagsTitle": "Top strengths across pillars",
          "topRedFlagsTitle": "Top concerns across pillars",
          "topFlagsEmpty": "Nothing flagged.",
          "plan90Days": {
            "title": "Suggested 90-day plan",
            "description": "Tonnie's recommended sequence for the first 90 days post-sponsorship.",
            "empty": "No plan generated.",
            "stepDuration": "Day {{day}}"
          },
          "fullName": {
            "ICM": "International Career motivation",
            "MA": "Multicultural adaptability",
            "WMF": "Work model flexibility",
            "CP": "Communication proficiency",
            "CP_ENGLISH": "English communication",
            "CP_NATIVE_TARGET": "Native / Target language",
            "GPE": "Global professional experience",
            "AR": "Academic readiness",
            "PRM": "Psychological resilience for Mobility"
          }
        },
        "pitch": {
          "sentimentLabel": "Sentiment",
          "sentimentValue": {
            "positive": "Positive",
            "neutral": "Neutral",
            "negative": "Negative"
          },
          "deliveryMetric": {
            "communicationClarity": "Communication clarity",
            "confidenceLevel": "Confidence level",
            "energyLevel": "Energy level",
            "pacing": "Pacing",
            "articulation": "Articulation",
            "fillerWords": "Filler words"
          },
          "noPitchTitle": "No pitch recorded yet",
          "noPitchDescription": "{{name}} hasn't recorded their 60-second introduction. Send a reminder to nudge them — the pitch is one of the strongest qualitative signals before sponsoring.",
          "pendingAnalysisTitle": "Pitch recorded — analysis in progress",
          "pendingAnalysisDescription": "{{name}}'s pitch was uploaded but Brain hasn't finished analysing it yet. The transcript and AI insights will appear here within a few minutes.",
          "playbackMissingTitle": "Analysis ready — playback unavailable",
          "playbackMissingDescription": "Tonnie has the pitch transcript and analysis below, but the video file couldn't be loaded right now. Refresh in a moment to retry, or check the citizen's vault.",
          "videoOnlyTitle": "Pitch recorded — analysis pending",
          "videoOnlyDescription": "{{name}}'s pitch is ready to watch above, but Tonnie's transcript, sentiment, and delivery analysis aren't attached to this CheckUp yet. Most often this means the analyzer hasn't run for this run — re-trigger it below to backfill the missing signals.",
          "rerunAnalysis": "Re-run pitch analysis",
          "rerunAnalysisInProgress": "Re-running pitch analysis…",
          "rerunAnalysisError": "Could not re-run pitch analysis",
          "videoFallback": "Your browser can't play this video format.",
          "duration": "Duration: {{value}}",
          "recordedAt": "Recorded {{date}}",
          "statusReady": "Ready to review",
          "statusAnalyzing": "Analyzing",
          "statusPending": "Awaiting upload",
          "statusFailed": "Analysis failed",
          "statusEstimated": "Estimated",
          "failedTitle": "The pitch could not be analysed",
          "failedDescription": "{{name}}'s recording produced no analysis. Nothing on this tab is a score of it.",
          "heuristicTitle": "These signals are estimates, not an AI analysis",
          "heuristicDescription": "The AI analysis was unavailable, so the sentiment and delivery scores below come from a simple word-count heuristic. Don't base a decision on them — re-run the analysis.",
          "failedReason": {
            "noInput": "The analysis ran without a recording. Re-run the analysis.",
            "videoNotFound": "No recording by {{name}} was found in storage.",
            "storageFetchFailed": "The recording could not be read from storage. Re-run the analysis.",
            "serviceComponentMissing": "The analysis service is missing a component it needs. Our team has been alerted — re-run the analysis once it's fixed.",
            "noAudioTrack": "The recording has no sound. Ask {{name}} to record again with the microphone on.",
            "unreadableRecording": "The recording's format could not be decoded. Ask {{name}} to record again.",
            "timedOut": "Processing the recording took too long. Re-run the analysis.",
            "noSpeech": "No speech was detected in the recording. Ask {{name}} to record again.",
            "serviceRejected": "The transcription service refused the recording. Our team has been alerted.",
            "serviceUnavailable": "The transcription service was unavailable. Re-run the analysis.",
            "internalError": "An unexpected error stopped the analysis. Our team has been alerted.",
            "unrecorded": "This result was produced before failure reasons were recorded. Re-run the analysis to find out why."
          },
          "heuristicReason": {
            "modelUnavailable": "Reason: no AI model was configured for the analysis.",
            "invalidResponse": "Reason: the AI's answer could not be used.",
            "serviceRejected": "Reason: the AI service refused the request.",
            "serviceUnavailable": "Reason: the AI service was unavailable.",
            "unrecorded": "Reason: not recorded — this result predates it."
          }
        },
        "skills": {
          "softHardCombinedTitle": "Top soft & hard skills",
          "softHardCombinedDescription": "Each list's shape at a glance, then every skill ranked by its power score with the band Tonnie graded it in. A spoke's number is its row.",
          "additionalSkillsTitle": "Additional skills",
          "additionalSkillsDescription": "Capabilities beyond the top soft/hard list, ranked by power score.",
          "additionalSkillsEmpty": "No additional skills surfaced.",
          "softEmpty": "No soft skills surfaced yet — Tonnie's analysis hasn't returned a top-skills set for this candidate.",
          "hardEmpty": "No hard skills surfaced yet — Tonnie's analysis hasn't returned a top-skills set for this candidate.",
          "softShapeLabel": "Shape of the top soft skills, spokes numbered by rank — {{summary}}",
          "hardShapeLabel": "Shape of the top hard skills, spokes numbered by rank — {{summary}}"
        },
        "deliveryMetrics": "Delivery metrics",
        "drawerDescription": "Vetting review for {{name}} — CheckUp progress, profile data, and admin actions.",
        "evaluationPillars": "Evaluation pillars",
        "evaluationPillarsDesc": "Per-pillar score, confidence, and evidence — the audit trail behind {{name}}'s iQulture verdict.",
        "evidenceLabel": "Evidence",
        "greenFlags": "Green flags",
        "hideDetails": "Hide details",
        "interviewFirst": "Interview first",
        "interviewConfirmTitle": "Send interview invitation?",
        "interviewConfirmDescription": "Tonnie will email {{name}} a pre-sponsorship interview invitation. You can withdraw later, but the email goes out immediately.",
        "interviewConfirmCancel": "Cancel",
        "interviewConfirmAction": "Send invitation",
        "lastSeenAgo_one": "Last seen {{count}} day ago",
        "lastSeenAgo_other": "Last seen {{count}} days ago",
        "lastSeenToday": "Last seen today",
        "menuLabel": "More actions",
        "messageSendError": "We couldn't send the message. Please try again.",
        "messageSent": "Message sent to {{name}}",
        "messageSentDescription": "It's on its way — you'll see it in the message log shortly.",
        "meshAnalysis": "MESH analysis",
        "meshAnalysisDesc": "How {{name}} scores on the four foundations every confident sponsorship is built on.",
        "neverSeen": "Hasn't opened the app yet",
        "calculating": {
          "title": "CheckUp score is being calculated",
          "description": "{{name}}'s new score will appear here as soon as the calculation finishes."
        },
        "noneIdentified": "None identified",
        "pitchVideoAnalysis": "Pitch video analysis",
        "pitchVideoDesc": "{{name}}'s 60-second pitch — transcript, sentiment, and delivery metrics in their own words.",
        "recommendations": "Recommendations",
        "redFlags": "Red flags",
        "reminderSendError": "We couldn't send the reminder. Please try again.",
        "reminderSent": "Reminder sent to {{name}}",
        "reminderSentDescription": "{{name}} will receive an email nudge to complete CheckUp.",
        "reminderTemplateMissing": "The CheckUp reminder template hasn't been set up. Visit Messages to create it.",
        "sendMessage": "Send message",
        "sendMessageDescription": "Customize subject and message before sending — the talent receives it as an email.",
        "sendMessageTitle": "Send a message",
        "sendNow": "Send now",
        "sendReminder": "Send reminder",
        "sending": "Sending…",
        "showDetails": "Show details",
        "sponsoredDrawerDescription": "Sponsored-talent monitoring for {{name}} — hero progress, evidence, and admin actions.",
        "sponsorJourney": "Sponsor journey",
        "sponsorship": {
          "cancelTitle": "Cancel sponsorship?",
          "cancelLoading": "Computing refund amount…",
          "cancelDescription": "Tonnie will refund {{refundAmount}} ({{monthsRemaining}} of {{durationMonths}} months remaining) and {{name}}'s journey will revert to basic-tier access. This action can't be undone.",
          "cancelNoRefundDescription": "This sponsorship has no refundable balance — the full {{durationMonths}}-month window has been consumed. Cancelling will revert {{name}}'s journey to basic-tier access without a refund.",
          "cancelKeep": "Keep sponsorship",
          "cancelAction": "Cancel & refund {{refundAmount}}",
          "cancelNoRefund": "Cancel sponsorship (no refund)",
          "cancelSuccess": "Sponsorship cancelled — {{amount}} refunded to your card.",
          "cancelFailed": "Couldn't cancel the sponsorship right now."
        },
        "tagsHint": "Tip: starting from a template auto-fills the talent's name and other details. Custom messages send as-is.",
        "waitingDays_one": "Waiting {{count}}d",
        "waitingDays_other": "Waiting {{count}}d",
        "waitingOverdue_one": "{{count}}d overdue",
        "waitingOverdue_other": "{{count}}d overdue",
        "phase": {
          "adaptation": {
            "awaiting": {
              "description": "QultureUp is unlocked. {{name}} hasn't started any cultural-prep missions yet.",
              "title": "Awaiting first activity"
            },
            "locked": {
              "description": "QultureUp activates after {{name}} is sponsored. Cultural-prep missions auto-build based on the destination.",
              "title": "Adaptation unlocks after sponsorship"
            }
          },
          "action": {
            "careIntervention": "Care intervention",
            "sendReminder": "Send reminder",
            "viewKit": "View kit"
          },
          "care": {
            "awaiting": {
              "description": "Care is unlocked. {{name}} hasn't logged a check-in yet — gentle reminder may help.",
              "title": "Awaiting first check-in"
            },
            "locked": {
              "description": "Care activates after {{name}} is sponsored. The wellbeing program builds around their settling-in arc.",
              "title": "Care unlocks after sponsorship"
            }
          },
          "checkup": {
            "awaiting": {
              "description": "{{name}} accepted the invitation but hasn't started CheckUp yet. A reminder usually nudges them to begin.",
              "title": "CheckUp not yet started"
            },
            "locked": {
              "description": "CheckUp activates as soon as {{name}} accepts the invitation and a journey is created.",
              "title": "CheckUp not yet activated"
            },
            "inProgress": {
              "title": "CheckUp in progress",
              "description": "{{name}} is working through their CheckUp — {{done}} of {{total}} steps done."
            },
            "awaitingScore": {
              "title": "CheckUp submitted",
              "description": "{{name}} finished their CheckUp. We're calculating their iQulture score."
            }
          },
          "evidence": {
            "awaiting": {
              "description": "No passport stamps yet. Stamps and miles accumulate as {{name}} progresses through the heroes.",
              "title": "Awaiting first milestones"
            },
            "locked": {
              "description": "Passport activates after sponsorship. Milestones from each hero earn stamps automatically.",
              "title": "Evidence unlocks after sponsorship"
            }
          },
          "mobility": {
            "awaiting": {
              "description": "TelePortal kit is ready. {{name}} hasn't started any tasks yet.",
              "title": "Awaiting first activity"
            },
            "locked": {
              "description": "TelePortal will auto-build a personalized relocation kit once {{name}} is sponsored.",
              "title": "Mobility unlocks after sponsorship"
            }
          }
        },
        "phaseStrip": {
          "scrollNext": "Show later phases",
          "scrollPrevious": "Show earlier phases",
          "sponsored": {
            "accepted": "Accepted",
            "ariaLabel": "Sponsorship phase",
            "offered": "Offered",
            "sponsored": "Sponsored",
            "thriving": "Thriving"
          },
          "vetting": {
            "ariaLabel": "Vetting phase",
            "invited": "Invited",
            "scored": "Scored",
            "started": "Started",
            "submitted": "Submitted",
            "verdict": "Verdict"
          }
        },
        "summary": "Summary",
        "topHardSkills": "Top hard skills",
        "topSoftSkills": "Top soft skills",
        "transcript": "Transcript",
        "citizenAccountDeletedTitle": "Citizen account deleted",
        "citizenAccountDeletedBody": "This candidate deleted their Tonnie account. Their profile + activity are preserved in read-only form for your records; no further actions can be taken.",
        "interviewInvitationQueued": "Interview request queued for {{name}}. Email sent; ATS broker integration pending.",
        "interviewInvitationFailed": "Failed to send interview request. Try again.",
        "scoreEstimate": {
          "title": "Parts of this score are estimates, not measurements",
          "pitchFailed": "Pitch: not analysed — the score was calculated without it.",
          "pitchHeuristic": "Pitch delivery (Motivation): estimated from a word count — the AI analysis was unavailable.",
          "pillarsM": "Motivation: some pillars were estimated with a simplified method — the AI evaluation was unavailable.",
          "pillarsE": "English: some pillars were estimated with a simplified method — the AI evaluation was unavailable.",
          "pillarsS": "Soft & cultural: some pillars were estimated with a simplified method — the AI evaluation was unavailable.",
          "pillarsH": "Hard skills: some pillars were estimated with a simplified method — the AI evaluation was unavailable."
        },
        "languages": {
          "title": "Languages",
          "none": "No language result yet."
        },
        "leftProgrammeTitle": "Left your programme on {{date}}",
        "leftProgrammeBody": "The relationship has ended, so this record is read-only and what they shared is no longer visible. Send a new invitation to work with them again — they decide whether to accept."
      },
      "title": "Vetting",
      "topCandidates": "Top candidates",
      "topCandidatesDescription": "The strongest scores ready to sponsor",
      "topPick": "Top pick",
      "totalCandidates": "Total candidates",
      "viewPending": "View pending",
      "viewPotentialTalents": "View potential talents",
      "viewProTalents": "View Pro talents",
      "completed": "Completed",
      "badge": {
        "pro": "PRO",
        "potential": "POTENTIAL",
        "noob": "NOOB",
        "pending": "Pending CheckUp"
      },
      "talentsCount_one": "{{count}} talent",
      "talentsCount_other": "{{count}} talents",
      "readyOfTotal": "{{completed}} of {{total}} ready",
      "talentRowActionsAria": "Actions for {{name}}",
      "testitCandidates": "TestIt candidates",
      "readyCount_one": "{{count}} ready",
      "readyCount_other": "{{count}} ready"
    },
    "invitationDetail": {
      "acceptedAt": "Accepted",
      "accessibleDescription": "Invitation status: {{status}}",
      "accessibleDescriptionLoading": "Loading invitation details",
      "accessibleTitle": "Invitation details",
      "acquisitionEyebrow": "Acquisition",
      "assessment": "Assessment",
      "branch": "Branch",
      "createdAt": "Created",
      "delete": "Delete",
      "destination": "Destination",
      "email": "Email",
      "errorDescription": "The invitation may have been deleted, or the server is unreachable.",
      "errorTitle": "Couldn't load invitation",
      "expiresAt": "Expires",
      "historyTitle": "History",
      "name": "Name",
      "noHistory": "No status changes recorded.",
      "opportunityTitle": "Opportunity",
      "recipientTitle": "Recipient",
      "resend": "Resend",
      "resendHint": "Resending regenerates the token and resets the expiry.",
      "revoke": "Revoke",
      "scenario": "Scenario",
      "scenarioValue": {
        "pre_immigration": "Pre-immigration",
        "already_abroad": "Already abroad",
        "relocation_only": "Relocation only",
        "integration_only": "Integration only"
      },
      "send": "Send invitation",
      "sentAt": "Sent",
      "status": {
        "draft": "Draft",
        "pending": "Pending acceptance",
        "accepted": "Accepted",
        "expired": "Expired",
        "revoked": "Revoked",
        "declined": "Declined",
        "email_queued": "Email queued",
        "email_skipped": "Email skipped",
        "email_failed": "Email not sent",
        "email_sent": "Email sent",
        "email_delivered": "Delivered",
        "email_opened": "Opened",
        "email_clicked": "Link clicked",
        "email_bounced": "Bounced",
        "landed": "Opened the invitation page",
        "email_mismatch": "Sign-in did not match",
        "matched_signup": "Signed up on Tonnie",
        "deferred": "Postponed by the candidate",
        "email_reminded": "Reminder sent",
        "claimed": "Claimed from another account"
      },
      "tokenPreview": "Token preview",
      "tokenTitle": "Token & expiry",
      "workLocation": "Work location",
      "reason": {
        "deleted_sentinel": "Not sent — the recipient deleted their Tonnie account.",
        "email_mismatch": "They were signed in with a different account.",
        "email_unverified": "The address is on their account but not yet verified.",
        "expired": "The invitation had already expired.",
        "expiry_sweep": "Expired without a response.",
        "jit": "Detected on their first sign-in.",
        "lazy_expire_on_open": "Already past its expiry date when the page was opened.",
        "matched_signup_unaccepted": "Expired although this person is already on Tonnie — resending is likely to reach them.",
        "ok": "The invitation was open and ready to accept.",
        "onboarding": "Detected while they completed onboarding.",
        "opted_out": "Not sent — the recipient has opted out of email.",
        "revoked": "The invitation had already been revoked.",
        "webhook": "Detected when their account was created."
      },
      "byActor": "by {{name}}",
      "hasAccountChip": "Signed up, not accepted",
      "resendNudge": "This person already has a Tonnie account — resending is likely to reach someone who can sign in right away.",
      "resendPromoted": "Resend invitation",
      "candidateRole": "Role",
      "candidateLocation": "Location",
      "candidateSkills": "Skills",
      "inviteAgain": "Invite again",
      "closed": {
        "declinedTitle": "Declined the invitation on {{when}}",
        "expiredTitle": "The invitation expired on {{when}}",
        "body": "Invite again to send them a new email with a fresh link, or delete the invitation to clear it from your pipeline."
      }
    },
    "talentRowMenu": {
      "viewDetails": "View details",
      "sendInvitation": "Send invitation",
      "resendInvitation": "Resend invitation",
      "revoke": "Revoke",
      "delete": "Delete",
      "sponsorJourney": "Sponsor the journey",
      "askCoPilot": "Ask CoPilot",
      "askTonnieServices": "Ask Tonnie services",
      "inviteAgain": "Invite again"
    },
    "vettingPage": {
      "activeTab": "Active",
      "archivedTab": "Archived"
    },
    "motivationalForm": {
      "questionCard": {
        "required": "Required",
        "optional": "Optional",
        "maxCharsHint_one": "Max. {{max}} character • Answer in English only",
        "maxCharsHint_other": "Max. {{max}} characters • Answer in English only",
        "answerLabel": "Your answer",
        "answerPlaceholder": "Write your answer here in English…",
        "answerPlaceholderOptional": "Write your answer here in English… (optional)",
        "noComment": "No comment",
        "optionalHint": "Optional question – you can leave it blank.",
        "validationComment": "Validation comment:"
      }
    },
    "quickEdit": {
      "companyPlaceholder": "Acme Corporation, Inc.",
      "taxIdPlaceholder": "EIN, VAT, or national tax ID"
    },
    "additionalDetails": {
      "languagePlaceholder": "English"
    },
    "acceptInvite": {
      "notFound": "Invitation not found",
      "failedToLoad": "Failed to load invitation",
      "failedToAccept": "Failed to accept invitation",
      "roleAdmin": "Admin",
      "roleTeamMember": "Team member",
      "invalidLink": "Invalid invitation link. No token provided.",
      "goToLogin": "Go to login",
      "welcomeTo": "Welcome to {{company}}!",
      "joinedAs": "You have joined as {{role}}. Redirecting to the dashboard...",
      "expiredTitle": "Invitation expired",
      "expiredBody": "This invitation to join {{company}} has expired. Please ask the team admin to send a new invitation.",
      "alreadyTitle": "Already accepted",
      "alreadyBody": "This invitation has already been accepted.",
      "title": "Team invitation",
      "joinCompany": "Join {{company}}",
      "invitedAsRole": "You have been invited to join as {{role}}",
      "signedInAs": "Signed in as {{email}}",
      "accepting": "Accepting...",
      "accept": "Accept invitation",
      "emailMismatch": "This invitation was sent to {{invited}}, but you are signed in as {{current}}. Please sign out and sign in with the correct email address.",
      "invitedToJoin": "You have been invited to join {{company}}",
      "joinAsRole": "Join as {{role}}",
      "invitationSentTo": "Invitation sent to {{email}}",
      "signUpOrLogIn": "Sign up or log in to accept this invitation and join the team.",
      "haveAccount": "Already have an account? Log In",
      "emailUnverified": "Verify {{email}} on your account, then accept the invitation again."
    },
    "weeklySummary": {
      "title": "Weekly summary",
      "insightsFor": "AI-generated insights for {{period}}",
      "keyAchievements": "Key achievements",
      "areasNeedingAttention": "Areas needing attention",
      "trends": "Trends",
      "insights": "Insights",
      "viewFullReport": "View full report"
    },
    "nextBestActions": {
      "title": "Next best actions",
      "empty": "No actions require immediate attention. Great work!",
      "explainCopilot": "AI-powered recommendations for your mobility programs",
      "pipelineCopilot": "AI-powered recommendations aligned to your pipeline",
      "categoryCheckup": "CheckUp pending",
      "categorySponsorship": "Sponsorship decision",
      "categoryMobility": "Mobility blocker",
      "categoryCare": "Care checkpoint",
      "categoryRisk": "Risk signal",
      "urgency": {
        "high": "high",
        "medium": "medium",
        "low": "low"
      },
      "reason": "Reason: {{reason}}",
      "explain": "Explain"
    },
    "iqultureBadge": {
      "pending": "Pending",
      "description": {
        "pro": "Exceptional readiness for international opportunities",
        "potential": "Strong potential with room for growth",
        "noob": "Beginning the readiness journey",
        "noBadge": "CheckUp not yet completed"
      },
      "corporateInsight": {
        "pro": "Top-tier talent ready for immediate mobility",
        "potential": "Strong candidate — consider with preparation plan",
        "noob": "Early stage — monitor progress via QultureUp",
        "noBadge": "Awaiting iQulture assessment"
      }
    },
    "routeFlags": {
      "srLabel": "{{origin}} to {{destination}}"
    },
    "inviteMessage": {
      "bodyHint": "Edit freely. Tags are filled in per recipient — the preview shows the result.",
      "editingSource": "You are editing the message for this send only. The tenant template is unchanged.",
      "linkPresent": "Accept link present",
      "linkRequired": "Keep the accept link — without it the candidate has no way to start."
    },
    "attentionReason": {
      "invitation_never_sent": "Invitation never sent",
      "invitation_bounced": "Email bounced — check the address",
      "invitation_expired": "Invitation expired",
      "signed_up_not_accepted": "Signed up but has not accepted — resend",
      "invite_ignored": "No response in {{days}} days",
      "onboarding_stalled": "Profile unfinished for {{days}} days",
      "checkup_never_requested": "CheckUp never requested",
      "checkup_never_started": "CheckUp not started in {{days}} days",
      "checkup_stalled": "CheckUp stalled for {{days}} days",
      "scoring_stalled": "Scoring delayed {{days}} days",
      "awaiting_company_review": "Awaiting your review for {{days}} days",
      "testit_awaiting_review": "Tests complete — awaiting your verdict",
      "citizen_left": "Candidate left the platform",
      "mobility_track_blocked": "Sponsored but no track started",
      "sponsorship_offer_unanswered": "Sponsorship offer unanswered for {{days}} days",
      "checkup_not_shared": "CheckUp result not shared for {{days}} days",
      "sharing_withdrawn": "Sharing withdrawn {{days}} days ago"
    },
    "companyProfile": {
      "industry": {
        "technology": "Technology",
        "healthcare": "Healthcare",
        "finance": "Finance",
        "manufacturing": "Manufacturing",
        "retail": "Retail",
        "hospitality": "Hospitality",
        "construction": "Construction",
        "education": "Education",
        "consulting": "Consulting",
        "logistics": "Logistics",
        "energy": "Energy",
        "telecommunications": "Telecommunications",
        "mediaEntertainment": "Media and entertainment",
        "realEstate": "Real estate",
        "other": "Other"
      },
      "roleType": {
        "engineering": "Engineering",
        "product": "Product",
        "design": "Design",
        "dataScience": "Data science",
        "devops": "DevOps and infrastructure",
        "marketing": "Marketing",
        "sales": "Sales",
        "customerSuccess": "Customer success",
        "finance": "Finance",
        "hrPeople": "HR and people",
        "operations": "Operations",
        "executive": "Executive and leadership",
        "other": "Other"
      },
      "employeesRange": "{{range}} employees",
      "hiresRange": "{{range}} hires a year",
      "openLinkedIn": "Open profile ↗"
    },
    "lifecycleStatus": {
      "draft": "Draft",
      "active": "Running",
      "paused": "Paused",
      "completed": "Completed",
      "archived": "Archived"
    },
    "taskPriority": {
      "high": "High priority"
    },
    "iqulture": {
      "provisional": {
        "label": "Provisional",
        "tooltip": "Some of this talent's evidence is missing, so the score is the lowest it can be. With the evidence complete it could reach up to {{max}}."
      }
    },
    "shareRequest": {
      "badge": {
        "pendingCheckup": "Asked for CheckUp — waiting for the talent",
        "pendingTests": "Asked for more tests — waiting for the talent",
        "declinedCheckup": "CheckUp request declined · {{date}}",
        "declinedTests": "Test request declined · {{date}}",
        "pendingTooltip": "Asked on {{date}}. Nothing more is shared until the talent answers.",
        "declinedTooltip": "You see what the talent shared before. You can ask again later."
      },
      "notice": {
        "pendingCheckupTitle": "Asked for the CheckUp — waiting for the talent",
        "pendingTestsTitle": "Asked for more tests — waiting for the talent",
        "pendingBody": "Asked on {{date}}. Nothing more is shared until they answer — you keep seeing what they accepted before.",
        "declinedCheckupTitle": "The talent declined your request to see their CheckUp",
        "declinedTestsTitle": "The talent declined your request for more tests",
        "declinedBody": "Declined on {{date}}. Nothing changed: you see what they shared before. You can ask again later."
      }
    }
  },
  "capture": {
    "uploadFailedDefault": "Upload failed. Please try again."
  },
  "care": {
    "additionalComments": "Additional comments (optional)",
    "allStatuses": "All statuses",
    "alreadyCheckedIn": "Already checked in today",
    "appOnlyNotice": {
      "message": "This dashboard is your read-only overview. Open the Tonnie app to log your mood, run quick check-ins, and complete checkpoints.",
      "title": "Daily check-ins happen in the app"
    },
    "askCopilotAboutThis": "Ask CoPilot about this",
    "askCopilotFirst": "Ask CoPilot Brain first",
    "assessedOn": "Assessed on {{date}}",
    "assessment": {
      "completeTitle": "Assessment complete",
      "completed": "Completed",
      "gateTitle": "Care assessment",
      "loading": "Loading assessment…",
      "redirecting": "Redirecting…",
      "retake": "Retake assessment",
      "saving": "Saving…",
      "subtitle": "A short check-in to gauge how well you’re settling in. Takes about 5 minutes.",
      "title": "Care assessment"
    },
    "assessmentEstimatedTime": "About 5 minutes",
    "assessmentInfoDescription": "Your answers help Care personalize check-ins, suggest local resources, and surface support when you need it.",
    "assessmentInfoIntro": "We'll ask a few questions about your wellbeing across health, finance, and community.",
    "baseline": {
      "anxiety": "Current anxiety about relocation",
      "concerns": "Main areas of concern",
      "desc": "Select the option that best describes your current emotional state.",
      "familyConfidence": "Confidence about family adaptation",
      "minimal": "Minimal",
      "notConfident": "Not confident",
      "selectMultiple": "select all that apply",
      "significant": "Significant",
      "supportNeed": "How much support do you think you'll need?",
      "title": "How are you feeling about the move?",
      "veryConfident": "Very confident"
    },
    "carePillars": "Care pillars",
    "challengePlaceholder": "Describe your challenge or question...",
    "checkin": {
      "responseField": {
        "qc_concern": "Concerns",
        "qc_notes": "Notes"
      },
      "responses": "Responses"
    },
    "checkinType": {
      "daily_mood": "Daily mood",
      "evening_checkin": "Evening check-in",
      "morning_checkin": "Morning check-in",
      "quick_checkin": "Quick check-in",
      "weekly_checkin": "Weekly check-in"
    },
    "checkpoint": {
      "complete": {
        "milesEarned": "+{{miles}} Miles earned",
        "nextCheckpoint": "Next checkpoint: {{date}}",
        "recorded": "Responses recorded in your Passport",
        "subtitle": "Thank you for sharing. Your responses help us support you better.",
        "title": "Checkpoint complete!"
      },
      "completed": "Completed",
      "confirmSubmit": {
        "message": "Are you ready to submit your checkpoint responses? You won't be able to change your answers after submitting.",
        "title": "Submit checkpoint?"
      },
      "due": "Due",
      "feedbackLabel": "Any additional feedback? (optional)",
      "feedbackPlaceholder": "Share your thoughts...",
      "loading": "Loading checkpoint...",
      "notFound": "Checkpoint not found",
      "unavailableTitle": "Check-in unavailable",
      "unavailableBody": "We couldn't load the questions for this check-in right now. Please try again later.",
      "overallScore": "Overall score",
      "overdue": "Overdue",
      "previous": "Previous",
      "reviewSubmit": "Review & submit",
      "scaleLabels": [
        "Very dissatisfied",
        "Dissatisfied",
        "Neutral",
        "Satisfied",
        "Very satisfied"
      ],
      "scheduled": "Scheduled",
      "scoresSummary": "Summary of your scores:",
      "skipped": "Skipped",
      "stepOf": "Step {{current}} of {{total}}",
      "submit": "Submit",
      "title": "Checkpoint",
      "typeNames": {
        "ad_hoc": "Check-in",
        "annual": "Annual checkpoint",
        "custom": "Checkpoint",
        "month_1": "1-Month checkpoint",
        "month_12": "12-Month checkpoint",
        "month_3": "3-Month checkpoint",
        "month_6": "6-Month checkpoint",
        "month_9": "9-Month checkpoint",
        "onboarding": "Onboarding checkpoint",
        "pre_move_baseline": "Pre-Move baseline",
        "week_1": "Week 1 checkpoint",
        "week_2": "Week 2 checkpoint"
      },
      "framing": {
        "expectations": "Before your move — your expectations",
        "reality": "Settling in — how things actually are",
        "settling": "Finding your rhythm",
        "established": "Getting established",
        "thriving": "Looking ahead"
      },
      "focusPillar": "Focus",
      "miles_one": "{{count}} Mile",
      "miles_other": "{{count}} Miles",
      "pillarsTime_one": "{{count}} pillar · {{time}} min",
      "pillarsTime_other": "{{count}} pillars · {{time}} min"
    },
    "checkpointCommentsPlaceholder": "Share any thoughts or concerns about your household stability and integration...",
    "checkpointCompleted": "Checkpoint completed successfully!",
    "checkpointDescription": "Self-assessment for wellbeing and integration",
    "checkpointEvolution": "Checkpoint evolution",
    "checkpointFormDescription": "Complete this checkpoint to track your progress. You can also complete it on mobile.",
    "checkpointHistory": "Checkpoint history",
    "checkpointMonth": "{{month}}-month checkpoint",
    "checkpointTitle": "Care checkpoint",
    "checkpoints": {
      "status": {
        "completed": "Completed",
        "due": "Due now",
        "in_progress": "In progress",
        "overdue": "Overdue",
        "pending": "Upcoming",
        "scheduled": "Upcoming",
        "skipped": "Skipped"
      },
      "title": "Checkpoints"
    },
    "checkpointsCompleted": "Checkpoints completed",
    "checkpointsDescription": "View checkpoints and complete them in the mobile app",
    "commitment": {
      "at_risk": "At risk",
      "champion": "Champion",
      "committed": "Committed",
      "engaged": "Engaged",
      "flight_risk": "Needs attention"
    },
    "companyFeedback": "Company feedback",
    "companyRating": "Company rating",
    "completeCheckinMobile": "Complete check-in in mobile",
    "completeCheckpointMobile": "Complete in mobile",
    "completeFirstCycle": "Complete your first feedback cycle to see it here",
    "completedOn": "Completed on",
    "concern": {
      "family": "Family",
      "finances": "Finances",
      "healthcare": "Healthcare",
      "housing": "Housing",
      "language": "Language",
      "loneliness": "Loneliness",
      "schooling": "Schooling",
      "title": "Concerns",
      "work": "Work"
    },
    "continue": {
      "description": "You started your Care assessment. Pick up right where you left off on Citizen Web — your answers so far are saved.",
      "title": "Continue your Care assessment"
    },
    "continueOnWeb": "Continue on Citizen Web",
    "continueOnWebDesc": "Pick up your Care assessment where you left off on the Citizen Web Portal.",
    "copilotSuggestions": "💡 CoPilot Brain suggestions",
    "copilotSuggestionsText": "Before submitting, try asking CoPilot Brain for immediate help. It can suggest lessons, tasks, or resources.",
    "createdOn": "Created on",
    "current": "Current",
    "description": "Track your wellbeing",
    "due": "Due",
    "dueNow": "Due now",
    "error": {
      "description": "Pull to refresh, or tap retry. If it keeps failing, check your connection.",
      "title": "We couldn’t load your Care data"
    },
    "excellent": "5 — Excellent",
    "familyMasterOnly": "Only Family Master can answer Care checkpoints",
    "feedbackComment1": "Great performance in the recent project. Keep it up!",
    "feedbackComment2": "Good progress, continue practicing Portuguese.",
    "feedbackComment3": "Feeling more confident in Portuguese conversations at work.",
    "feedbackComment4": "Still adjusting to the work culture, but making progress.",
    "feedbackPillars": "Feedback pillars",
    "from": "From",
    "getHelpWith": "Get help with {{topic}}",
    "heroBanner": {
      "assessmentComplete": "Assessment complete",
      "awaitingFirstCheckin": "Start your first mood check-in",
      "focusFromAssessment": "Focus areas from your assessment",
      "title": "Your wellbeing",
      "wellbeing": "Wellbeing",
      "gettingStarted": "Getting started"
    },
    "heroMiles": "Care Miles",
    "householdAware": "Household-aware",
    "householdAwareDescription": "This pillar considers your household context (partner, children) in the assessment",
    "improving": "Improving",
    "manager": "Manager",
    "mood": {
      "amazing": "Amazing",
      "checkedIn": "Checked in today!",
      "earnMiles": "Earn miles by checking in daily",
      "good": "Good",
      "great": "Great",
      "howAreYou": "How are you feeling today?",
      "label1": "Struggling",
      "label2": "Okay",
      "label3": "Good",
      "label4": "Great",
      "label5": "Amazing",
      "okay": "Okay",
      "struggling": "Struggling",
      "streakDays_one": "{{count}} day streak",
      "streakDays_other": "{{count}} day streak"
    },
    "mySupportRequests": "My support requests",
    "mySupportRequestsDesc": "Track and review your submitted support requests",
    "needSupport": "Need support?",
    "needsImprovement": "1 — Needs improvement",
    "newRequest": "New request",
    "noCheckins": "No check-ins yet. Start tracking your mood!",
    "noCheckpointsScheduled": "No checkpoints scheduled yet",
    "noDataYet": "No data yet",
    "noHistory": "No feedback history yet",
    "noSupportRequests": "No support requests match this filter",
    "noUpdatesYet": "No updates yet",
    "objectiveChildcareArrangement": "Arrange childcare",
    "objectiveDefinitiveHousing": "Secure definitive housing",
    "objectiveHousingStress": "Reduce housing-related stress",
    "objectiveSchoolEnrollment": "Complete school enrollment",
    "objectiveSocialIntegration": "Build social connections",
    "objectiveTemporaryHousing": "Secure temporary housing",
    "objectiveWellbeingSupport": "Access wellbeing support",
    "objectiveWorkAdaptation": "Adapt to workplace culture",
    "objectiveWorkplaceCulture": "Understand workplace culture",
    "objectives": {
      "title": "Your objectives",
      "subtitle": "What your sponsor team is helping you work toward.",
      "categoryFallback": "Goal",
      "currentLabel": "Now",
      "targetLabel": "Goal",
      "milestoneDone": "Done",
      "milestoneNotYet": "Not yet",
      "feedbackReadyBadge": "Feedback ready",
      "viewFeedbackCta": "View feedback & self-evaluate",
      "sourceCompany": "From your company",
      "sourcePersonal": "Your own goal",
      "currentCycleHeading": "This cycle's feedback",
      "selfEmpty": "You haven't added your self-evaluation for this objective yet.",
      "ratingValue": "{{label}} ({{value}}/5)",
      "cadenceNote": "Feedback is reviewed {{cadence}}.",
      "cadence": {
        "bi-weekly": "every two weeks",
        "monthly": "monthly",
        "quarterly": "quarterly"
      },
      "selfEvalBanner": {
        "title": "Your team shared new feedback",
        "message": "There's an open feedback cycle waiting for your self-evaluation. Add it in the Tonnie app to reflect on each objective.",
        "cta": "Add your self-evaluation in the app"
      }
    },
    "objectiveFeedback": {
      "title": "Objectives & feedback",
      "intro": "Your sponsor team shared feedback on your objectives. Reflect on each one and add your own honest self-evaluation — it stays between you and your team.",
      "providerHeading": "Your team's feedback",
      "providerEmpty": "Your team hasn't added a note for this objective yet.",
      "selfHeading": "Your self-evaluation",
      "ratingPrompt": "How are you doing on this?",
      "valuePlaceholder": "Enter your number",
      "ratingLabel1": "Just starting",
      "ratingLabel2": "Finding my feet",
      "ratingLabel3": "Making progress",
      "ratingLabel4": "Doing well",
      "ratingLabel5": "Thriving",
      "commentLabel": "Anything you'd like to add? (optional)",
      "commentPlaceholder": "What's going well, what's been hard, what you need…",
      "submit": "Submit self-evaluation",
      "submitting": "Submitting…",
      "noRatingHint": "Rate at least one objective to submit.",
      "loadingTitle": "Loading your objectives…",
      "emptyTitle": "No objectives yet",
      "emptyBody": "Once your sponsor team sets objectives for you, they'll show up here.",
      "allCaughtUpTitle": "You're all caught up",
      "allCaughtUpBody": "There's no open feedback cycle right now. We'll let you know when your team shares new feedback.",
      "errorTitle": "We couldn't load your objectives",
      "errorBody": "Pull to refresh, or tap retry. If it keeps failing, check your connection.",
      "successTitle": "Self-evaluation shared",
      "successBody": "Thank you for reflecting. Your team can see your evaluation alongside their feedback.",
      "successDone": "Done",
      "dueOn": "Due {{date}}",
      "cadenceNote": "Your team reviews these {{cadence}}.",
      "cadence": {
        "weekly": "weekly",
        "bi-weekly": "every two weeks",
        "biweekly": "every two weeks",
        "monthly": "monthly",
        "quarterly": "quarterly",
        "semiannual": "twice a year",
        "annual": "yearly"
      },
      "trust": {
        "why": "Your self-evaluation helps your sponsor team understand your objectives from your point of view.",
        "who": "Only you and your Tonnie sponsor team can see your answers. It's never shared with other colleagues.",
        "how": "Reflecting on your objectives keeps your support personal and on track."
      }
    },
    "overdue": "Overdue",
    "phase": {
      "adapting": "Adapting",
      "preMove": "Before the move",
      "settlingIn": "Settling in",
      "thriving": "Thriving"
    },
    "pillar": {
      "housing_stability": {
        "desc": "Temporary & definitive housing, stress & risk",
        "name": "Housing stability"
      },
      "schooling_childcare": {
        "desc": "Education and childcare arrangements",
        "name": "Schooling & childcare"
      },
      "wellbeing_social": {
        "desc": "Mental health, social connections & overall wellbeing",
        "name": "Wellbeing & social"
      },
      "work_fit": {
        "desc": "Job fit and workplace adaptation",
        "name": "Work fit & Adaptation"
      },
      "housing": {
        "name": "Housing stability",
        "description": "Finding, settling into, and feeling secure in your home.",
        "obj1": "Secure stable, suitable housing",
        "obj2": "Reduce housing-related stress",
        "obj3": "Settle into the neighborhood",
        "q1": "How satisfied are you with your current housing situation?",
        "q1_hh": "How satisfied is your family with your current housing situation?",
        "q2": "How secure do you feel about your housing arrangements?",
        "q2_hh": "How secure does your family feel about your housing arrangements?",
        "q3": "How well do you know your local area and amenities?",
        "qPreMove": "How prepared do you feel about your housing arrangements for the move?"
      },
      "schooling": {
        "name": "Schooling & childcare",
        "description": "Your children's schooling and childcare arrangements.",
        "obj1": "Enroll children in suitable schooling",
        "obj2": "Arrange reliable childcare",
        "obj3": "Help children settle in socially",
        "q1": "How satisfied are you with your children's schooling arrangements?",
        "q2": "How well have your children settled into their new school?",
        "q3": "How manageable is your childcare situation?"
      },
      "work": {
        "name": "Work fit",
        "description": "How well you've adapted to your new role and workplace.",
        "obj1": "Adapt to the new role",
        "obj2": "Integrate with the team",
        "obj3": "Understand workplace culture",
        "q1": "How well do you feel you fit into your workplace?",
        "q2": "How clear are your role and responsibilities?",
        "q3": "How supported do you feel by your team?",
        "q4": "How confident are you in your day-to-day work?",
        "qMonth3": "Three months in, how settled do you feel in your role?"
      },
      "wellbeing": {
        "name": "Wellbeing & social",
        "description": "Your overall wellbeing and social connections.",
        "obj1": "Maintain emotional wellbeing",
        "obj2": "Build social connections",
        "obj3": "Support companion integration",
        "q1": "How would you rate your overall wellbeing?",
        "q1_hh": "How would you rate your family's overall wellbeing?",
        "q2": "How connected do you feel to people around you?",
        "q2_hh": "How connected does your family feel to people around them?",
        "q3": "How well are you managing day-to-day life here?",
        "q4": "How optimistic do you feel about settling in?",
        "q4_hh": "How optimistic does your family feel about settling in?",
        "qMonth1": "One month in, how connected do you feel to people here so far?"
      }
    },
    "pillarCommunication": "Communication",
    "pillarHousingStability": "Housing stability",
    "pillarHousingStabilityDesc": "Temporary/definitive housing, stress, risk",
    "pillarIntegration": "Behaviour & Adaptation",
    "pillarSchoolingChildcare": "Schooling/Childcare stability",
    "pillarSchoolingChildcareDesc": "Education and childcare arrangements (if applicable)",
    "pillarSelector": {
      "conditional": "Conditional",
      "desc": "We recommend these pillars based on your profile. You can adjust them.",
      "selected": "selected",
      "title": "Choose your focus areas"
    },
    "pillarTechnical": "Technical skills",
    "pillarWellbeing": "Wellbeing and social Adaptation",
    "pillarWellbeingDesc": "Mental health, social connections, and overall wellbeing",
    "pillarWorkFit": "Work fit and Adaptation",
    "pillarWorkFitDesc": "Job fit and workplace adaptation",
    "pillars": {
      "housingStability": "Housing stability",
      "schoolingChildcare": "Schooling & childcare",
      "title": "Care pillars",
      "wellbeingSocial": "Wellbeing & social",
      "workFit": "Work fit & Adaptation"
    },
    "plan": {
      "active": "Due now",
      "assessmentDone": "Assessment complete",
      "completed": "Completed",
      "encouragement": "Each checkpoint helps us understand how you're settling in and how we can support you better.",
      "focusAreas": "Your focus areas",
      "locked": "Upcoming",
      "milesReward": "+{{miles}} Miles",
      "milestones": "Checkpoint milestones"
    },
    "preferences": {
      "afternoon": "Afternoon",
      "daily": "Daily",
      "desc": "Tell Care when and how often to check in with you. You can change this any time.",
      "evening": "Evening",
      "frequencyLabel": "Frequency",
      "moodReminder": "Mood reminder",
      "moodReminderDesc": "Get a gentle nudge to log how you're feeling.",
      "morning": "Morning",
      "timeLabel": "Preferred time",
      "title": "Care preferences",
      "weekdays": "Weekdays",
      "weekly": "Weekly"
    },
    "proFeature": "Pro feature — Upgrade to access",
    "proFeatureDescription": "Upgrade to Pro to access full Care features, feedback cycles, and support.",
    "proFeatureTitle": "Care & support — Pro feature",
    "progressOverTime": "Your progress over time",
    "quickCheckin": {
      "concern": "Any area you'd like to flag?",
      "continue": "Continue",
      "notes": "Anything else you'd like to share?",
      "overall": "How are you feeling this week overall?",
      "copilotPrompts": {
        "concern": "Any area you'd like to flag?",
        "notes": "Anything else you'd like to share?",
        "overall": "How are you feeling overall this week?"
      },
      "error": {
        "message": "We couldn't save your check-in. Please try again.",
        "title": "Something went wrong"
      },
      "finish": "Finish",
      "intro": {
        "quickEasy": "Quick & easy",
        "quickEasyDesc": "Only 3-5 questions, takes 2 minutes",
        "subtitle": "CoPilot will guide you through a few questions",
        "trackProgress": "Track progress",
        "trackProgressDesc": "Compare with your previous check-ins"
      },
      "processing": {
        "subtitle": "CoPilot is preparing your insights...",
        "title": "Analyzing your responses"
      },
      "questionOf": "Question {{current}} of {{total}}",
      "questions": {
        "notesPlaceholder": "Type your thoughts here...",
        "qcConcern": "Any area you'd like to flag?",
        "qcNotes": "Anything else you'd like to share?",
        "qcOverall": "How are you feeling this week overall?",
        "qcOverallLabels": ["Very bad", "Bad", "Okay", "Good", "Great"]
      },
      "results": {
        "areasOfConcern": "Areas of concern",
        "milesEarned": "+{{miles}} Miles earned",
        "moodScoreOf": "Mood score of {{score}}",
        "nextStep1": "Continue your daily check-ins to track your wellbeing over time",
        "title": "Check-in complete!",
        "today": "Today",
        "trendTitle": "Trend",
        "whatsNext": "What's next",
        "yesterday": "Yesterday",
        "yourNotes": "Your notes",
        "concernHint": "CoPilot will follow up on these areas",
        "nextStep2": "CoPilot will track your trends over time",
        "nextStep3": "You'll get personalized tips for flagged areas"
      },
      "selectAll": "Select all that apply",
      "alreadyDone": {
        "title": "You're all set for today",
        "message": "You've already completed today's check-in. Come back tomorrow!"
      },
      "doneToday": "Completed today",
      "shortDesc": "Quick daily wellbeing check",
      "startButton": "Start check-in",
      "title": "Quick check-in",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles"
    },
    "rateProgress": "How would you rate your progress?",
    "recentCycles": "Your recent checkpoints",
    "requestSupport": "Request support",
    "responses": "responses",
    "retakeAssessment": "Retake assessment",
    "retakeOnWeb": "Retake assessment on web",
    "retakeOnWebDesc": "To retake your Care assessment, use the Citizen Web Portal.",
    "returnToDashboard": "Return to dashboard",
    "risk": {
      "checkinGap": "A long gap since the last check-in",
      "crossHeroStall": "No TelePortal or QultureUp activity in 30+ days",
      "isolation": "Low social/wellbeing scores across recent checkpoints",
      "missedCheckpoint": "A checkpoint is {{overdueDays}} days overdue",
      "moodDecline": "Mood low for {{consecutive}} consecutive check-ins",
      "pillarDrop": "{{pillar}} dropped {{drop}} pts since the last checkpoint"
    },
    "selectPillarOrTheme": "Select pillar or theme",
    "selectPillarOrThemePlaceholder": "Choose a pillar or theme",
    "selectSeverity": "Select severity (optional)",
    "selfFeedback": "Self-Feedback",
    "severity": {
      "high": "High",
      "low": "Low",
      "medium": "Medium",
      "urgent": "Urgent"
    },
    "severityHigh": "High",
    "severityLow": "Low",
    "severityMedium": "Medium",
    "shareThoughts": "Share your thoughts on {{pillar}}...",
    "startCheckpoint": "Start checkpoint",
    "startOnWeb": "Start on Citizen Web",
    "startOnWebDesc": "Set up your Care assessment on the Citizen Web Portal (about 5 minutes). Once done, daily check-ins and checkpoints happen here in the app.",
    "status": {
      "closed": "Closed",
      "in_progress": "In progress",
      "open": "Open",
      "resolved": "Resolved"
    },
    "statusInProgress": "In progress",
    "statusOpen": "Open",
    "statusResolved": "Resolved",
    "streak": {
      "awesome": "Awesome!",
      "bonusMiles": "+{{miles}} bonus Miles",
      "dayStreak": "{{days}}-day streak!"
    },
    "submitCheckpoint": "Submit checkpoint",
    "submitRequest": "Submit request",
    "suggestionMicroLearning": "Micro-learning recommendations",
    "suggestionQultureUp": "Recommended QultureUp lessons",
    "suggestionSelfHelp": "Self-help content",
    "suggestionTelePortal": "TelePortal tasks",
    "support": {
      "footer": "Select a topic to get personalized recommendations from Tonnie CoPilot or request human support from our team.",
      "openRequests": "Open support requests",
      "statusInProgress": "In progress",
      "statusOpen": "Open",
      "subtitle": "Get help with specific challenges",
      "title": "Need support?",
      "topics": {
        "communication": "Communication",
        "culturalFit": "Cultural fit",
        "technical": "Technical",
        "wellbeing": "Wellbeing"
      }
    },
    "supportCommunication": "Communication",
    "supportCultural": "Cultural fit",
    "supportDescription": "Get help with specific challenges",
    "supportHelpText": "Select a topic to get personalized recommendations from Tonnie CoPilot or request human support from our team.",
    "supportHousing": "Housing",
    "supportRequestActions": "Actions",
    "supportRequestDetails": "Support request details",
    "supportRequestDetailsDesc": "View details and updates for your support request",
    "supportRequestSubmitted": "Support request submitted! Our team will get back to you soon.",
    "supportRequestsOpen": "Open requests",
    "supportSchooling": "Schooling",
    "supportTeamWillRespond": "Our support team will respond to your request soon.",
    "supportTechnical": "Technical",
    "supportWellbeing": "Wellbeing",
    "tabs": {
      "checkins": "Check-ins",
      "checkpoints": "Checkpoints",
      "objectives": "Objectives",
      "overview": "Overview",
      "support": "Support"
    },
    "teamLead": "Team lead",
    "thermometer": {
      "mood": "Mood",
      "settlement": "Settlement",
      "wellbeing": "Wellbeing"
    },
    "title": "Care & support",
    "todaysCare": "Today's Care",
    "tonnieSupport": "Tonnie support",
    "topic": "Topic",
    "trust": {
      "checkpoint": {
        "how": "It helps Tonnie provide targeted support and guidance.",
        "who": "Your responses are private. Companies only see aggregated summaries.",
        "why": "Checkpoints help us understand how you're adapting and where support is needed."
      },
      "questions": {
        "how": "It helps us identify support options tailored to you.",
        "who": "Only you and Tonnie support can see your responses. Companies see aggregated trends.",
        "why": "We ask these questions to understand your current adjustment."
      },
      "quickCheckin": {
        "how": "It helps us tailor support and keep your adjustment on track.",
        "who": "Only you and Tonnie support can see your answers. Companies see aggregated trends only.",
        "why": "Quick check-ins help us understand your daily wellbeing and spot support needs early."
      },
      "results": {
        "how": "Insights help CoPilot give better recommendations.",
        "who": "Only you and Tonnie support. Companies see aggregated trends only.",
        "why": "Your check-in data helps us track your wellbeing over time."
      }
    },
    "tryAgainLater": "Please try again later.",
    "unableToLoadData": "Unable to load Care data",
    "upcoming": "Upcoming",
    "updates": "Updates",
    "weekPulse": {
      "title": "Week pulse"
    },
    "welcome": {
      "description": "Care supports you throughout your relocation journey. This one-time setup takes about 5 minutes on Citizen Web — after that, your daily check-ins and wellbeing support live right here in the app.",
      "familyStep": "Family & work",
      "familyStepDesc": "Track family adaptation, schooling, and workplace integration",
      "letsStart": "Let's start",
      "settlingStep": "Settling In",
      "settlingStepDesc": "Track your housing stability and daily life comfort",
      "timeEstimate": "Takes about 5 minutes to complete",
      "title": "Welcome to Care",
      "wellbeingStep": "Wellbeing & social",
      "wellbeingStepDesc": "Check in on your emotional health and social connections"
    },
    "yourChallenge": "your challenge",
    "yourRating": "Your rating",
    "interactions": {
      "title": "With your team",
      "subtitle": "Calls and meetings your sponsor team has set up",
      "upcoming": "Upcoming",
      "past": "Done",
      "type": {
        "call": "Call",
        "video_call": "Video call",
        "in_person_meeting": "In-person meeting",
        "message": "Message",
        "request_checkin": "Check-in"
      }
    },
    "momentum": {
      "event": {
        "checkin": "You checked in",
        "checkpoint": "Checkpoint completed",
        "feedback": "You shared feedback",
        "intervention": "Your team reached out",
        "generic": "Care activity"
      }
    },
    "zone": {
      "youToday": "You today",
      "forYou": "For you",
      "yourProgress": "Your progress"
    },
    "assessmentDimension": {
      "baseline": "Emotional baseline",
      "baselineDesc": "Your current mood, energy, and stress levels",
      "pillars": "Wellbeing pillars",
      "pillarsDesc": "Select focus areas that matter most to you",
      "preferences": "Check-in preferences",
      "preferencesDesc": "How and when you want to be supported"
    },
    "milesAwarded_one": "+{{count}} Mile",
    "milesAwarded_other": "+{{count}} Miles"
  },
  "career": {
    "achievementsSummary": "Career-Relevant achievements",
    "allLocations": "All locations",
    "allOpportunities": "All opportunities",
    "allTypes": "All types",
    "apply": "Apply",
    "avgMatch": "Avg match",
    "careerOverviewDesc": "Overview of your career readiness and profile",
    "careerReadiness": "Career readiness",
    "careerReady": "Career ready",
    "categoryCareer": "Career services",
    "categoryEducation": "Education",
    "categoryNetworking": "Networking",
    "checkBackLater": "Check back later for new matches",
    "contract": "Contract",
    "copilotAnalysis": "CoPilot Brain analysis for {{title}}",
    "createCV": "Create CV",
    "createOrEditCV": "Create or edit CV",
    "createYourFirstCV": "Create your first professional CV to showcase your skills",
    "cv": {
      "downloadError": "Failed to download CV",
      "generateError": "Failed to generate CV"
    },
    "cvDownloaded": "{{format}} CV for {{opportunityTitle}} downloaded successfully",
    "cvView": "CV builder",
    "cvViewDescription": "Create and manage your professional CV for job applications",
    "cvsGenerated": "CVs generated",
    "description": "Discover opportunities and grow your career",
    "disableProactive": "Disable proactive applications",
    "downloadCV": "Download CV",
    "downloadPDF": "Download PDF",
    "downloadWord": "Download word",
    "ecosystemPartners": "Ecosystem partners",
    "editCV": "Edit CV",
    "enableProactive": "Enable proactive applications",
    "experience": "Experience",
    "experienceMatchDesc": "Your experience matches the role",
    "fullTime": "Full-time",
    "gotIt": "Got it",
    "highMatchOpportunities": "High match opportunities",
    "iWantIt": "I want it...",
    "improveMatchText": "Consider improving relevant skills or language levels to increase your match score.",
    "languages": "Languages",
    "lastGenerated": "Last generated",
    "lastUpdated": "Last updated",
    "learnMore": "Learn more",
    "letCompaniesFind": "Let companies find you",
    "levelLabel": "Level",
    "lisbon": "Lisbon",
    "location": "Location",
    "locationMatchDesc": "The job location fits your preferences",
    "mainRole": "Main role",
    "match": "Match",
    "matchQuality": "Match quality",
    "matchScore": "Match score",
    "matchScoreLabel": "Match score",
    "matchingOpportunities": "Matching opportunities",
    "mostRecentCV": "Most recent CV",
    "noCVsYet": "No CVs created yet",
    "noDescription": "No description available",
    "noOpportunities": "No opportunities found",
    "noSavedOpportunities": "No saved opportunities yet",
    "notSpecified": "Not specified",
    "opportunitiesFound": "Opportunities found",
    "opportunitiesSaved": "Opportunities saved",
    "opportunitiesView": "Opportunities",
    "opportunityRemoved": "Opportunity removed from saved",
    "opportunityRequirements": "Opportunity requirements",
    "opportunitySaved": "Opportunity saved",
    "partTime": "Part-time",
    "partnerCVDesc": "CV review & optimization",
    "partnerLinguaDesc": "Professional language courses",
    "partnerNetworkDesc": "Professional networking events",
    "partnersDescription": "Tonnie-Checked partners to accelerate your career journey",
    "porto": "Porto",
    "proactiveApplications": "Proactive applications",
    "proactiveDescription": "Enable your profile to be visible to recruiters and companies looking for talent like you.",
    "proactiveDisabled": "Proactive applications disabled. Your profile is no longer visible to recruiters.",
    "proactiveEnabled": "Proactive applications enabled! Companies can now find you.",
    "professionalCV": "Professional CV",
    "profileComplete": "Profile complete",
    "profileCompleteness": "Profile completeness",
    "profileLabel": "Profile",
    "readinessLabel": "Readiness",
    "readinessMessage": "You're well-prepared for international opportunities. Keep improving your language skills!",
    "readyToApply": "Ready to apply",
    "recentCVs": "Recent CVs",
    "remote": "Remote",
    "removeFromSaved": "Remove from saved",
    "requiredSkills": "Required skills",
    "save": "Save",
    "saveOpportunitiesMessage": "Save opportunities to view them here later",
    "saved": "Saved",
    "savedJobs": "Saved jobs",
    "savedOpportunities": "Saved opportunities ({{count}})",
    "savedOpportunitiesTab": "Saved opportunities",
    "savedOpportunitiesTitle": "Saved opportunities",
    "sharedKeyAchievements": "Key achievements and Passport milestones",
    "sharedProfileSnapshot": "Profile snapshot (role, skills, experience)",
    "sharedReadinessScore": "Readiness score (iQulture) and MESH breakdown",
    "skills": "Skills",
    "skillsMatchDesc": "Your skills align with the job requirements",
    "targetCountries": "Target countries",
    "tipsToImprove": "💡 tips to improve match:",
    "title": "Career, opportunities & CV builder",
    "total": "Total",
    "type": "Type",
    "unsave": "Unsave",
    "untitledCV": "Untitled CV",
    "viewAllCVs": "View all CVs ({{count}})",
    "whatWillBeShared": "What will be shared:",
    "why": "Why?",
    "whyMatch": "Why this match?",
    "years": "years",
    "yourCV": "Your CV",
    "yourReadiness": "Your readiness",
    "highMatchCount_one": "{{count}} high match",
    "highMatchCount_other": "{{count}} high matches",
    "rolesFound_one": "{{count}} role found",
    "rolesFound_other": "{{count}} roles found",
    "savedOpportunitiesDescription_one": "{{count}} opportunity saved for later review",
    "savedOpportunitiesDescription_other": "{{count}} opportunities saved for later review"
  },
  "checkup": {
    "aboutDescription": "This assessment evaluates your readiness across multiple dimensions:",
    "achievement": "Achievement",
    "additionalSkills": "Additional skills",
    "aiTalentSnapshot": "AI talent snapshot",
    "allSet": "You're all set",
    "allSetDesc": "Your CheckUp is complete. We can now build your journey.",
    "analyzingTitle": "Analyzing Your iQulture Profile",
    "areasToWatch": "Areas to watch",
    "assessmentDescription": "Evaluate your international readiness",
    "assessmentHistory": "Assessment history",
    "assessmentResults": "Assessment results",
    "assessmentSubmitted": "Assessment submitted",
    "assessmentTitle": "CheckUp assessment",
    "badge": {
      "explorer": "Explorer",
      "explorerTagline": "Beginning your international journey",
      "globalPro": "Global Pro",
      "globalProTagline": "Ready for international success",
      "risingStar": "Rising star",
      "risingStarTagline": "Building strong foundations"
    },
    "badgeAlt": "{{badge}} badge",
    "band": {
      "noob": "NOOB",
      "potential": "POTENTIAL",
      "pro": "PRO"
    },
    "bandLabels": {
      "emerging": "Emerging",
      "growing": "Growing",
      "power": "Power",
      "strong": "Strong"
    },
    "buildJourneyCta": "Build my journey",
    "buildJourneyTitle": "Ready to build your journey?",
    "calcTimeEstimate": "About 30 seconds",
    "calculateScore": "Calculate my score",
    "calculating": "Calculating…",
    "calculatingAriaLabel": "Calculating your score",
    "calculatingDesc": "Analyzing your responses to generate your personalized MESH assessment...",
    "calculatingScore": "Calculating your score…",
    "calculatingTitle": "Calculating your iQulture score…",
    "calculationComplete": "Calculation complete",
    "calculationError": "Failed to start calculation. Please try again.",
    "calculationFailed": "Calculation failed. Please try again.",
    "calculationTimedOut": "Your CheckUp calculation timed out. Please start it again.",
    "cancelConfirm": {
      "error": "Couldn't cancel your CheckUp. Please try again.",
      "success": "CheckUp cancelled. You can start a new one any time."
    },
    "capture": {
      "acceptedFormats": "Accepts photos, PDFs, Word docs and more",
      "backToTask": "Back to task",
      "backToTelePortal": "Back to TelePortal",
      "cameraPermissionRequired": "Camera access is required to scan documents.",
      "cameraScanHint": "Point your camera at the document for the best quality scan",
      "chooseAnother": "Choose another",
      "docTypeBank": "Bank statement",
      "docTypeBankDesc": "Bank account statement or proof",
      "docTypeCertificate": "Certificate",
      "docTypeCertificateDesc": "Birth, marriage, or other certificate",
      "docTypeContract": "Contract",
      "docTypeContractDesc": "Employment or rental contract",
      "docTypeIdCard": "ID card",
      "docTypeIdCardDesc": "National identity card",
      "docTypeInsurance": "Insurance",
      "docTypeInsuranceDesc": "Health or travel insurance document",
      "docTypeOther": "Other",
      "docTypeOtherDesc": "Any other document",
      "docTypePassport": "Passport",
      "docTypePassportDesc": "Travel passport or ID page",
      "docTypePhoto": "Photo",
      "docTypePhotoDesc": "Passport-style photo",
      "docTypeResidencePermit": "Residence permit",
      "docTypeResidencePermitDesc": "Residence card or permit",
      "docTypeTax": "Tax document",
      "docTypeTaxDesc": "NIF, tax certificate, or tax return",
      "docTypeVisa": "Visa",
      "docTypeVisaDesc": "Entry visa or permit",
      "docTypeWorkPermit": "Work permit",
      "docTypeWorkPermitDesc": "Employment authorization",
      "fieldDocType": "Document type",
      "fieldFile": "File",
      "removeFile": "Remove",
      "retakeCamera": "Retake",
      "selectDocType": "Select document type",
      "selectTypeFirst": "Select a document type above to start uploading",
      "sourceCamera": "Camera scan",
      "sourceFiles": "Browse files",
      "sourceGallery": "Photo library",
      "tapSelectDocType": "Tap to select document type",
      "tryAgain": "Try again",
      "uploadButton": "Upload document",
      "uploadFailed": "Upload failed",
      "uploaded": "Document uploaded",
      "uploadedDesc": "Your {{type}} has been uploaded and attached.",
      "uploading": "Uploading your document…",
      "uploadingNote": "This may take a moment"
    },
    "chat": {
      "clickToUpload": "Click to upload",
      "notAtAll": "Not at all",
      "typeMessage": "Type a message…",
      "typeYourAnswer": "Type your answer…",
      "veryMuch": "Very much"
    },
    "checkAgain": "Check again",
    "checkAgainHelp": "Complete the requirements above and then click 'Check Again'",
    "checkupHistory": "CheckUp history",
    "checkupHistoryDesc": "View your previous CheckUp assessments",
    "companyAverage": "Your company's average",
    "companyCohort": "Company cohort",
    "comparisonsDescription": "Your score compared to others",
    "comparisonsTitle": "How you compare",
    "completeMoreCheckUps": "Complete more CheckUps to see your evolution",
    "completeTitle": "Assessment complete!",
    "conclusionDesc": "Complete analysis of your international readiness",
    "congratulations": "Congratulations on Completing Your iQulture CheckUp!",
    "copilotGuideDescription": "Answer questions about your background and goals",
    "copilotGuideTitle": "CoPilot guide",
    "couldNotLoadResults": "We couldn't load your CheckUp results. Please try again.",
    "description": "Comprehensive 360° international readiness assessment",
    "didYouKnow": "Did you know?",
    "dimensionInternational": "International experience",
    "dimensionLanguage": "Language proficiency",
    "dimensionMotivation": "Motivation & mindset",
    "dimensionProfessional": "Professional background & skills",
    "dontCloseWarning": "Please don't close this page.",
    "downloadReport": "Download full report",
    "elapsed": "elapsed",
    "errorDescription": "Something went wrong loading your CheckUp. Please try again.",
    "errorMessage": "Failed to calculate your CheckUp. Please try again.",
    "errorTitle": "Oops! Something went wrong",
    "estimated": "Estimated",
    "estimatedRemaining": "~{{minutes}}m left",
    "estimatedTime": "Estimated time",
    "evaluationRadar": "Evaluation radar",
    "exportGenerating": "Generating export...",
    "exportPDFDescription": "In production, this would generate a PDF with your CheckUp results.",
    "exportResults": "Export results",
    "exportSuccess": "CheckUp results exported successfully",
    "filePickUnavailable": "File picking is currently unavailable.",
    "finalMessage": "You've completed a comprehensive 360° assessment of your international readiness. Your {{badge}} badge reflects strong foundations in motivation, cultural adaptability, and communication. Focus on the {{plan}} to strengthen your technical skills and you'll be ready for global opportunities.",
    "finalScore": "Final score",
    "goToCheckUp": "Go to CheckUp",
    "goToQultureUp": "Go to QultureUp",
    "goToTelePortal": "Go to TelePortal",
    "greenFlags": "Green flags",
    "heroMiles": "CheckUp Miles",
    "iqultureBand": "iQulture band",
    "journeyStepsSubtitle": "Here's what we need to assess your readiness.",
    "languageTests": {
      "analyzeResult": "Upload & analyze",
      "analyzing": "Analyzing...",
      "attention": "Attention:",
      "attentionText": "Save your result as a screenshot, or download it as a PDF with selectable text ",
      "changeFile": "Change file",
      "completedTest": "Completed test",
      "dropHere": "Click to select your result file",
      "englishTests": "English tests",
      "iUnderstand": "I understand, continue",
      "immediatelyAfter": "immediately after completing the test",
      "importantInstructions": "Important instructions",
      "instructions": "Upload your result as a screenshot (PNG, JPG, WEBP or GIF), a PDF with selectable text, or a Word (.docx) document. We read the level automatically.",
      "languageTests": "Language tests",
      "listening": "Listening",
      "lowConfidenceHint": "We detected a result but couldn't read it confidently. Please review and confirm.",
      "modalDesc": "Add a language test result to strengthen your profile.",
      "openPlatform": "Open test platform",
      "openPlatformHint": "Open the test platform to download your certificate.",
      "pending": "Pending review",
      "portugueseTests": "Portuguese tests",
      "reUpload": "Re-upload",
      "readCarefully": "Please read the certificate carefully before uploading.",
      "reading": "Reading",
      "readyToStart": "Ready to take the test?",
      "referenceHint": "Use a recent certificate (less than 2 years old).",
      "referenceImage": "Reference: Expected results page",
      "resultDetected": "Result detected",
      "resultLowConfidence": "Result detected — please confirm",
      "retakeWarning": "You already have a result for this test. Uploading a new one will replace the previous score.",
      "sampleHint": "Sample certificates: PDF, JPG, PNG.",
      "sampleResults": "Sample results page",
      "screenshotReminder": "Remember to capture your results",
      "screenshotReminderDetail": "Make sure your name and the score are visible in the file you upload.",
      "speaking": "Speaking",
      "stepConfirm": "Confirm",
      "stepInstructions": "Instructions",
      "stepTakeTest": "Take test",
      "stepUpload": "Upload",
      "submitResult": "Submit result",
      "submitted": "Result submitted!",
      "submittedHint": "You've submitted a result. We'll review it and update your score shortly.",
      "supportedFormats": "Supported formats: PNG, JPG, WEBP, GIF, PDF (with selectable text), DOCX. A scanned PDF or a picture inside a Word file cannot be read.",
      "testOpened": "Test platform opened in new tab",
      "uploadFailed": "Failed to upload. Please try again.",
      "uploadFailedError": "Upload failed. Please try again.",
      "uploadSuccess": "Test result submitted to your Vault",
      "uploading": "Uploading...",
      "useThisExtension": "use this extension",
      "alt": {
        "screenshotPreview": "Screenshot preview",
        "reference": "Reference",
        "sampleResults": "Sample results",
        "uploadedResult": "Uploaded result"
      },
      "failed": {
        "title": "We couldn't read a result from this file",
        "languageMismatch": "This certificate appears to certify a different language from this test. Please upload your certificate for this test's language.",
        "unsupportedDocument": "We can't read this file. Upload a PNG, JPG, WEBP or HEIC image, a PDF or a Word (.docx) document.",
        "archiveTooLarge": "This Word document is too large for us to read. Upload your result as an image (PNG, JPG or HEIC) or a PDF instead.",
        "docxEmpty": "This Word document has no text or picture we can read. Upload your result as an image (PNG, JPG or HEIC) or a PDF instead.",
        "tooManyPages": "This document has more than {{max}} pages. Upload only the pages that show your result.",
        "noLevelFound": "We couldn't find a CEFR level (A1–C2) in this file. Make sure your result shows your level and try again.",
        "serviceUnavailable": "Our analysis service couldn't process your file right now. Please try again in a few minutes.",
        "notCompletedHint": "This test isn't marked as done until a level is read from your certificate."
      },
      "cefrLevel": {
        "a1": "Beginner",
        "a2": "Elementary",
        "b1": "Intermediate",
        "b2": "Upper intermediate",
        "c1": "Advanced",
        "c2": "Proficient",
        "native": "Native speaker"
      }
    },
    "lastAssessment": "Last assessment: {{date}}",
    "lastCheckup": "Last CheckUp",
    "legend": {
      "attention": "Attention",
      "critical": "Critical",
      "excellent": "Excellent",
      "good": "Good"
    },
    "loadingAssessment": "Loading assessment…",
    "measureReadiness": "Measure your readiness",
    "mesh": {
      "english": "English / Language reality",
      "englishDesc": "Your language skills are strong, with excellent English proficiency and good progress in Portuguese.",
      "englishRec1": "Continue practicing Portuguese in daily conversations",
      "englishRec2": "Consider advanced language courses",
      "hardSkills": "Hard skills / Professional competence",
      "hardSkillsDesc": "Your technical expertise is excellent and well-aligned with the target market.",
      "hardSkillsRec1": "Stay updated with latest technologies",
      "hardSkillsRec2": "Consider certifications in your field",
      "motivation": "Motivation",
      "motivationDesc": "Your motivation and mindset towards international relocation are strong. You show clear goals and positive attitude.",
      "motivationRec1": "Maintain your positive attitude",
      "motivationRec2": "Set clear goals and milestones",
      "softSkills": "Soft skills & behaviours",
      "softSkillsDesc": "You have a good understanding of cultural differences, but there's room for improvement in workplace adaptation.",
      "softSkillsRec1": "Complete QultureUp lessons on local culture",
      "softSkillsRec2": "Engage with local communities"
    },
    "meshAnalysisDesc": "Motivation • English • soft cultural • hard & other",
    "meshAssessmentIntro": "The MESH assessment measures the four pillars of international career readiness: Motivation, English, Soft skills and Hard skills.",
    "meshBreakdown": "MESH breakdown",
    "meshBreakdownDesc": "Your readiness across Motivation, English, Soft skills, and Hard skills",
    "meshInfo": {
      "E": "English",
      "H": "Hard skills",
      "M": "Motivation",
      "S": "Soft skills"
    },
    "meshReadinessEvaluation": "MESH readiness evaluation",
    "monthsAgo": "months ago",
    "motivational": {
      "questionNumber": "Question {{number}}"
    },
    "nextStepsDesc": "Actions to improve your readiness",
    "noAssessmentYet": "No assessment yet",
    "noCheckUpForJourney": "This journey doesn't have a CheckUp yet.",
    "noHistory": "No previous CheckUps yet",
    "noResultsDesc": "You haven't completed your CheckUp yet. Complete it to see your readiness score.",
    "noResultsForJourneyDesc": "This journey doesn't have CheckUp results yet. Complete the assessment to see your score.",
    "noResultsForJourneyTitle": "No results for this journey",
    "noResultsTitle": "No results yet",
    "notReadyMessage": "Complete these first, then run your CheckUp.",
    "notReadyTitle": "Almost there!",
    "now": "Now",
    "phase": {
      "dataCollection": "Data collection",
      "iqultureScoring": "iQulture scoring",
      "meshAnalysis": "MESH analysis",
      "reportGeneration": "Report generation"
    },
    "photoLibraryUnavailable": "Photo library is currently unavailable.",
    "pillar": {
      "AR": {
        "brief": "Your credentials, certifications, and continuous learning",
        "name": "Academic readiness"
      },
      "CP": {
        "brief": "Your overall language and communication effectiveness",
        "name": "Communication proficiency"
      },
      "CP_ENGLISH": {
        "brief": "Your English language proficiency for professional contexts",
        "name": "English communication"
      },
      "CP_NATIVE_TARGET": {
        "brief": "Your proficiency in native and target-market languages",
        "name": "Native/Target language"
      },
      "GPE": {
        "brief": "Your track record of international/cross-border work",
        "name": "Global professional experience"
      },
      "ICM": {
        "brief": "How clear and committed your international career plan is",
        "name": "International Career motivation"
      },
      "MA": {
        "brief": "Your ability to adapt and thrive across cultures",
        "name": "Multicultural adaptability"
      },
      "PRM": {
        "brief": "Your mental readiness and coping strategies for relocation",
        "name": "Psychological resilience for Mobility"
      },
      "WMF": {
        "brief": "Your openness to different work arrangements (remote/hybrid/on-site)",
        "name": "Work model flexibility"
      }
    },
    "pillarsDesc": "Seven key dimensions of international readiness",
    "pillarsPassed": "Pillars passed",
    "plan90Days": "90-Day action plan",
    "pollingError": "Failed to check calculation status. Please try again.",
    "previousScore": "Your previous score",
    "processingInitializing": "Initializing iQulture calculation...",
    "processingStatus": "Processing status",
    "processingSubtitle": "This may take up to 5 minutes. Please don't close this page.",
    "processingTitle": "Analyzing Your iQulture Profile",
    "progressTitle": "Assessment progress",
    "readinessCheckError": "Failed to check readiness. Please try again.",
    "readinessScore": "You'll get your readiness score",
    "readyForJourney": "You're ready for your journey",
    "recommendation1Description": "Start learning about Portuguese culture and workplace norms",
    "recommendation1Title": "Complete QultureUp assessment",
    "recommendation2Description": "Get your personalized relocation checklist",
    "recommendation2Title": "Start TelePortal assessment",
    "recommendation3Description": "Your communication score is good, but practice makes perfect",
    "recommendation3Title": "Continue language learning",
    "recommendations": "Recommendations",
    "recommendedNextSteps": "Recommended next steps",
    "redirecting": "Redirecting to your results...",
    "requirementMissing": "Requirement missing",
    "requirementsTitle": "Requirements checklist",
    "results": {
      "activateSubtitle": "Your CheckUp is complete. Here's your path forward.",
      "activateTitle": "Activate your journey",
      "activeJourney": "Active",
      "areasRequiringAttention": "Areas requiring attention",
      "areasToWatch": "Areas to watch",
      "assessedOn": "Assessed {{date}}",
      "backToTop": "Back to top",
      "bandAttention": "Attention",
      "bandAttentionDesc": "Developing — targeted improvement recommended",
      "bandAttentionRange": "60-69",
      "bandCritical": "Critical",
      "bandCriticalDesc": "Needs priority focus before moving forward",
      "bandCriticalRange": "Below 60",
      "bandExcellent": "Excellent",
      "bandExcellentDesc": "Strong and consistent — a clear asset",
      "bandExcellentRange": "80-100",
      "bandGood": "Good",
      "bandGoodDesc": "Solid baseline with room to sharpen",
      "bandGoodRange": "70-79",
      "careDesc": "Get post-arrival support and integration assistance",
      "caveat": {
        "lowMotivationSignal": "Your motivational answers were very brief, so this score is less reliable than the others. A fuller answer would sharpen it.",
        "noMotivationData": "You didn't write anything in the motivational assessment, so we couldn't score Motivation. Complete it and recalculate to see this dimension.",
        "noPitch": "You haven't recorded a pitch video yet, so Motivation is based on your written answers alone.",
        "pitchAnalysisFailed": "Your pitch video couldn't be analysed, so Motivation is based on your written answers alone.",
        "pitchHeuristicScoring": "Our full analysis of your pitch video was unavailable, so its part of this score is a simplified estimate.",
        "pillarsEstimated": "Part of this score was estimated with a simplified method because our full analysis was unavailable.",
        "skillsInferenceEmpty": "We couldn't identify your skills from what you've shared yet, so Hard & other skills isn't scored. Add your skills and experience to your profile and recalculate."
      },
      "confidence": "Confidence: {{value}}%",
      "description": "Your international readiness assessment",
      "doctorsRecommendation": "Doctor's recommendation",
      "errorDescription": "There was a problem fetching your CheckUp results. Please try again.",
      "errorTitle": "Could not load results",
      "examCount_one": "{{count}} exam",
      "examCount_other": "{{count}} exams",
      "explore": "Explore",
      "freeAssessmentNote": "Free assessment complete • Upgrade to access all heroes",
      "greenFlags": "Green flags",
      "growthSubtitle": "Where your momentum can accelerate",
      "growthTitle": "Your growth areas",
      "historyTitle": "CheckUp history",
      "journeys": "Journeys",
      "meshDnaSubtitle": "Four pillars that define your international readiness",
      "meshDnaTitle": "Your MESH DNA",
      "meshE": "English & communication",
      "meshELbl": "English",
      "meshH": "Hard & other skills",
      "meshHLbl": "Hard skills",
      "meshM": "Motivation",
      "meshMLbl": "Motivation",
      "meshS": "Soft cultural skills",
      "meshSLbl": "Cultural",
      "moreCheckupsNeeded": "Complete more CheckUps to see your evolution over time",
      "navActivate": "Activate journey",
      "navGrowth": "Your growth areas",
      "navHistory": "CheckUp history",
      "navMeshDna": "MESH DNA",
      "navPillars": "Assessment results",
      "navPrescription": "90-Day prescription",
      "navStrengths": "Your strengths",
      "nextSection": "Next: {{label}}",
      "notScored": "Not scored",
      "overallScore": "Overall readiness score",
      "pillarOverview": "Pillar overview",
      "pillarPerformance": "Your performance across all evaluation dimensions",
      "pillarTapHint": "Tap a pillar to see what it measures",
      "pillarSubtitle": "Like a medical lab report, each pillar measures a specific dimension of your international readiness — how prepared you are for your journey in another country. Each dimension is scored from 0 to 100: the higher the score, the stronger that area.",
      "pillarTitle": "Your assessment results",
      "positiveIndicators": "Positive indicators",
      "prescriptionSubtitle": "A structured plan to convert potential into performance",
      "prescriptionTitle": "Your 90-Day Prescription",
      "progressOverTime": "Your progress over time",
      "qultureupDesc": "Level up your cultural readiness with personalized training",
      "scaleCaption": "Your position on the scale",
      "scaleToNext": "{{points}} pts to {{tier}}",
      "scaleMax": "You've reached the top tier",
      "readingResults": "Reading your results",
      "recommendedNextSteps": "Recommended next steps",
      "scoreOutOf": "/ 100",
      "scrollBackTop": "Scroll back to top",
      "scrollToNext": "Scroll to next section",
      "strengthsSubtitle": "What makes your profile stand out",
      "strengthsTitle": "Your strengths",
      "teleportalDesc": "Start your mobility plan with document verification and visa guidance",
      "title": "CheckUp results",
      "topHardSkills": "Top hard skills",
      "topSoftSkills": "Top soft skills",
      "unlockJourney": "Unlock your full journey",
      "snapshotFallback": "Your iQulture assessment is complete.",
      "badgeReasonFallback": "Based on your overall assessment performance.",
      "provisional": {
        "label": "Provisional",
        "body": "Some of your evidence is missing, so this is the lowest your score can be. With it complete, your score could reach up to {{max}}.",
        "unlock": {
          "M": "Complete your Motivation answers or record your pitch — up to +{{gain}}",
          "E": "Add your language levels, including your native language — up to +{{gain}}",
          "S": "Complete your CheckUp so your soft skills can be measured — up to +{{gain}}",
          "H": "Add your skills and experience to your profile — up to +{{gain}}"
        }
      },
      "skillsNotEnoughEvidence": "Not enough evidence yet to measure these skills."
    },
    "resultsError": "Failed to fetch results. Please try again.",
    "retakeAssessment": "Retake assessment",
    "retakeOnWeb": "Retake assessment on web",
    "retakeOnWebDesc": "To retake your CheckUp assessment, use the Citizen Web Portal on a desktop browser.",
    "score": "Score",
    "scoreEvolution": "Score evolution",
    "scrollForDetails": "Scroll for details",
    "scrollForDetailsHint": "Tap to scroll to your detailed results",
    "selected": "Selected",
    "selectedCheckupDetails": "Selected CheckUp details",
    "shareResults": "Share results",
    "similarProfiles": "Similar profiles",
    "somethingWentWrong": "Something went wrong",
    "startFailed": "Couldn't start CheckUp. Please try again.",
    "startOnWeb": "Start on Citizen Web",
    "startOnWebDesc": "Complete your first CheckUp assessment on the Citizen Web Portal for the full experience.",
    "step": {
      "assistantChat": "Assistant chat",
      "assistantChatMsg": "Chat with our AI assistant to give us more context about your situation.",
      "chatDone": "Chat complete",
      "chatDoneDesc": "You've finished the assistant chat.",
      "journeyInstance": "Journey setup",
      "journeyInstanceMsg": "Tell us where you’re moving to and from.",
      "languageTests": "Language tests",
      "languageTestsDesc": "Add language proficiency results.",
      "languageTestsMsg": "Upload your language certificates to strengthen your readiness score.",
      "motivational": "Motivation",
      "motivationalMsg": "Help us understand what’s driving your move.",
      "onboarding": "Profile basics",
      "onboardingMsg": "Quick details about you to personalize the rest.",
      "pitch": "Pitch video",
      "pitchMsg": "Record a 30-second video introducing yourself.",
      "pitchRecorded": "Pitch recorded",
      "pitchRecordedDesc": "Your pitch video is ready for review.",
      "videos": "Watch videos",
      "videosMsg": "Watch a few short videos about your destination.",
      "profileComplete": "Complete your profile",
      "profileCompleteMsg": "Your score needs a few identity details.",
      "profileCompletePercentMsg": "Your profile is {{percent}}% complete. Your score needs all of it."
    },
    "stuckMessage": "Stuck? Let us know — we can help.",
    "suggestedNextSteps": "Suggested next steps",
    "tabAnalysis": "Analysis",
    "tabComparisons": "Comparisons",
    "tabConclusion": "360° Conclusion",
    "tabHistory": "History",
    "tabInsights": "Insights",
    "tabMESH": "MESH analysis",
    "tabNextSteps": "Next steps",
    "tabOverview": "Overview",
    "tabPillars": "Evaluation pillars",
    "tabSkills": "Skills thermometer",
    "tapToCollapse": "Tap to collapse",
    "tapToReadMore": "Tap to read the full snapshot",
    "tip": {
      "1": "Your MESH score measures Motivation, English, Soft skills, and Hard skills — the 4 pillars of international career readiness.",
      "2": "iQulture badges (Explorer, Rising Star, Global Pro) reflect your overall preparedness for working abroad.",
      "3": "Our AI analyzes your pitch video, language proficiency, and motivational responses to build a 360° profile.",
      "4": "Your personalized 90-day action plan will include specific steps to boost your weakest areas.",
      "5": "The Cultural Risk Assessment identifies potential adaptation challenges and how to overcome them."
    },
    "title": "iQulture CheckUp",
    "tonnieDatabaseAverage": "Tonnie database average",
    "top10Hard": "Top 10 hard skills",
    "top10Soft": "Top 10 soft skills",
    "topHardSkills": "Top hard skills",
    "topSoftSkills": "Top soft skills",
    "triggerFailed": "Failed to start the calculation. Please try again.",
    "tryAgain": "Try again",
    "unableToLoad": "Unable to load CheckUp",
    "unknownDate": "Unknown date",
    "verifiedByTonnieGuard": "Verified by Tonnie guard",
    "vsAverage": "vs average",
    "vsPrevious": "vs previous",
    "welcome": {
      "chatStep": "Guided conversation",
      "chatStepDesc": "Answer a few questions with our AI assistant",
      "description": "Discover your international readiness with our MESH assessment. It evaluates your Motivation, English, Soft Skills, and Hard Skills to generate your personalized iQulture score.",
      "languageStep": "Language check",
      "languageStepDesc": "Quick evaluation of your language skills",
      "letsStart": "Let's start",
      "pitchStep": "Short pitch video",
      "pitchStepDesc": "Record a brief video introducing yourself",
      "timeEstimate": "Takes about 10-15 minutes to complete",
      "title": "Welcome to CheckUp"
    },
    "scoreOutOfSuffix": "/100",
    "missingSteps": {
      "journey_instance": {
        "label": "Journey instance",
        "message": "You need to create a Journey before starting your CheckUp."
      },
      "onboarding_complete": {
        "label": "Onboarding",
        "message": "Complete your profile onboarding to unlock CheckUp."
      },
      "assistant_chat": {
        "label": "Assessment chat",
        "message": "Complete the guided assessment conversation."
      },
      "motivational_answers": {
        "label": "Motivational questions",
        "message": "Answer the motivational questions about your goals."
      },
      "pitch_video": {
        "label": "Pitch video",
        "message": "Record or upload your pitch video."
      },
      "generic": "This step needs to be completed.",
      "videos_watched": {
        "label": "Watch the intro videos",
        "message": "A short introduction before you start."
      },
      "language_tests": {
        "label": "Language tests",
        "message": "Tell us the languages you speak and how well."
      },
      "profile_complete": {
        "label": "Complete your profile",
        "message": "Your score needs a few identity details. Finish them on the web portal."
      }
    },
    "reuse": {
      "title": "Reuse your saved result?",
      "subtitle": "You already completed this test. Reuse it for this assessment, or take a new one.",
      "takenOn": "Taken {{date}}",
      "reuseCta": "Reuse this result",
      "newCta": "Take a new one",
      "daysLeft_one": "{{count}} day left",
      "daysLeft_other": "{{count}} days left"
    },
    "calculatingPct": "Calculating… {{pct}}%",
    "requestedBy": {
      "badge": "Requested by {{company}}",
      "purpose": "Your score shapes the recommendations you get and the support they can offer.",
      "whatTheySee": "They see your score and readiness, never your answers."
    },
    "reusedFrom": {
      "title": "Reused from your {{destination}} CheckUp",
      "body": "Your answers and still-valid tests were carried over from that CheckUp. Your score is calculated again for this destination."
    },
    "profileGate": {
      "progressLabel": "Profile",
      "percent": "{{percent}}%",
      "cta": "Complete profile",
      "field": {
        "name": "Name",
        "dateOfBirth": "Date of birth",
        "nationality": "Citizenship",
        "currentCountry": "Current country",
        "currentCity": "Current city",
        "phone": "Phone"
      },
      "fieldMissing": "Missing"
    },
    "readyToCalculate": {
      "title": "Your assessment is complete",
      "description": "Everything is answered. Your score has not been generated yet.",
      "ctaTitle": "Generate your score",
      "ctaDescription": "One tap. It takes a few minutes, and we send you a notification when your score lands.",
      "cta": "Calculate my score"
    },
    "awaitingProfile": {
      "assessmentDone": "Assessment complete",
      "assessmentDoneDetail": "Every step is done — your answers are saved.",
      "calculateLocked": "Complete your profile to unlock your score."
    }
  },
  "common": {
    "active": "Active",
    "appName": "Tonnie Citizen",
    "appShortName": "Citizen",
    "applicationError": "Application error",
    "availableSoon": "Available soon",
    "back": "Back",
    "backToDashboard": "Back to dashboard",
    "cancel": "Cancel",
    "clear": "Clear",
    "clearFilters": "Clear filters",
    "close": "Close",
    "collapse": "Collapse",
    "comingSoon": "Coming soon",
    "completed": "Completed",
    "confirm": "Confirm",
    "continue": "Continue",
    "continueAssessment": "Continue assessment",
    "continueSetup": "Continue setup",
    "copiedToClipboard": "{{label}} copied to clipboard",
    "copilot": "CoPilot",
    "copyFailed": "Failed to copy {{label}}",
    "countries": {
      "AE": "United Arab Emirates",
      "AU": "Australia",
      "BR": "Brazil",
      "CA": "Canada",
      "CN": "China",
      "DE": "Germany",
      "ES": "Spain",
      "FR": "France",
      "GB": "United Kingdom",
      "IE": "Ireland",
      "IN": "India",
      "IT": "Italy",
      "JP": "Japan",
      "KR": "South Korea",
      "NL": "Netherlands",
      "NZ": "New Zealand",
      "PT": "Portugal",
      "SG": "Singapore",
      "UK": "United Kingdom",
      "US": "United States",
      "AF": "Afghanistan",
      "AL": "Albania",
      "DZ": "Algeria",
      "AD": "Andorra",
      "AO": "Angola",
      "AG": "Antigua and Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AT": "Austria",
      "AZ": "Azerbaijan",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Belarus",
      "BE": "Belgium",
      "BZ": "Belize",
      "BJ": "Benin",
      "BT": "Bhutan",
      "BO": "Bolivia",
      "BA": "Bosnia and Herzegovina",
      "BW": "Botswana",
      "BN": "Brunei",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "CV": "Cabo Verde",
      "KH": "Cambodia",
      "CM": "Cameroon",
      "CF": "Central African Republic",
      "TD": "Chad",
      "CL": "Chile",
      "CO": "Colombia",
      "KM": "Comoros",
      "CG": "Congo",
      "CD": "Congo (DRC)",
      "CR": "Costa Rica",
      "CI": "Côte d'Ivoire",
      "HR": "Croatia",
      "CU": "Cuba",
      "CY": "Cyprus",
      "CZ": "Czech Republic",
      "DK": "Denmark",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "EC": "Ecuador",
      "EG": "Egypt",
      "SV": "El Salvador",
      "GQ": "Equatorial Guinea",
      "ER": "Eritrea",
      "EE": "Estonia",
      "SZ": "Eswatini",
      "ET": "Ethiopia",
      "FJ": "Fiji",
      "FI": "Finland",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "GH": "Ghana",
      "GR": "Greece",
      "GD": "Grenada",
      "GT": "Guatemala",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Hungary",
      "IS": "Iceland",
      "ID": "Indonesia",
      "IR": "Iran",
      "IQ": "Iraq",
      "IL": "Israel",
      "JM": "Jamaica",
      "JO": "Jordan",
      "KZ": "Kazakhstan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "KW": "Kuwait",
      "KG": "Kyrgyzstan",
      "LA": "Laos",
      "LV": "Latvia",
      "LB": "Lebanon",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libya",
      "LI": "Liechtenstein",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "MO": "Macao",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Maldives",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Marshall Islands",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "MX": "Mexico",
      "FM": "Micronesia",
      "MD": "Moldova",
      "MC": "Monaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MA": "Morocco",
      "MZ": "Mozambique",
      "MM": "Myanmar",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "KP": "North Korea",
      "MK": "North Macedonia",
      "NO": "Norway",
      "OM": "Oman",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Palestine",
      "PA": "Panama",
      "PG": "Papua New Guinea",
      "PY": "Paraguay",
      "PE": "Peru",
      "PH": "Philippines",
      "PL": "Poland",
      "QA": "Qatar",
      "RO": "Romania",
      "RU": "Russia",
      "RW": "Rwanda",
      "KN": "Saint Kitts and Nevis",
      "LC": "Saint Lucia",
      "VC": "Saint Vincent and the Grenadines",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "São Tomé and Príncipe",
      "SA": "Saudi Arabia",
      "SN": "Senegal",
      "RS": "Serbia",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SK": "Slovakia",
      "SI": "Slovenia",
      "SB": "Solomon Islands",
      "SO": "Somalia",
      "ZA": "South Africa",
      "SS": "South Sudan",
      "LK": "Sri Lanka",
      "SD": "Sudan",
      "SR": "Suriname",
      "SE": "Sweden",
      "CH": "Switzerland",
      "SY": "Syria",
      "TW": "Taiwan",
      "TJ": "Tajikistan",
      "TZ": "Tanzania",
      "TH": "Thailand",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TO": "Tonga",
      "TT": "Trinidad and Tobago",
      "TN": "Tunisia",
      "TR": "Turkey",
      "TM": "Turkmenistan",
      "TV": "Tuvalu",
      "UG": "Uganda",
      "UA": "Ukraine",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VA": "Vatican City",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "YE": "Yemen",
      "ZM": "Zambia",
      "ZW": "Zimbabwe"
    },
    "delete": "Delete",
    "destination": "Destination",
    "discard": "Discard",
    "discardChanges": "Discard changes?",
    "discardChangesBody": "Your unsaved changes will be lost.",
    "discardProgress": "Discard progress?",
    "discardProgressBody": "Your progress on this screen will be lost.",
    "dismiss": "Dismiss",
    "done": "Done",
    "download": "Download",
    "earned": "Earned",
    "earnedDateMiles": "Earned {{date}} • +{{miles}} Miles",
    "edit": "Edit",
    "email": "Email",
    "error": "Error",
    "errorTitle": "Error",
    "estimatedTime": "Estimated time",
    "expand": "Expand",
    "export": "Export",
    "familyWillLose": "Your family members will lose",
    "filter": "Filter",
    "free": "Free",
    "goBack": "Go back",
    "heroes": {
      "care": "Care",
      "checkup": "CheckUp",
      "qultureup": "QultureUp",
      "teleportal": "TelePortal"
    },
    "inProgress": "In progress",
    "info": "Info",
    "keepEditing": "Keep editing",
    "keepFamily": "Keep Family",
    "keepPro": "Keep Pro",
    "loading": "Loading...",
    "locked": "Locked",
    "logout": "Log out",
    "miles": "Miles",
    "minutes": "minutes",
    "more": "more",
    "next": "Next",
    "no": "No",
    "notAvailable": "Not available",
    "of": "of",
    "openInApp": "Open in app",
    "optional": "Optional",
    "origin": "Origin",
    "other": "Other",
    "page": "Page",
    "pending": "Pending",
    "plan": {
      "basic": "Basic",
      "pro": "Pro"
    },
    "pleaseRetryLater": "Please try again later.",
    "previous": "Previous",
    "progress": "Progress",
    "refresh": "Refresh",
    "remove": "Remove",
    "reset": "Reset",
    "resumeWhereYouLeftOff": "Resume where you left off",
    "retake": "Retake",
    "retry": "Retry",
    "routeSrLabel": "{{origin}} to {{destination}}",
    "review": "Review",
    "save": "Save",
    "selected": "Selected",
    "selectLanguage": "Select language",
    "send": "Send",
    "settings": "Settings",
    "share": "Share",
    "skip": "Skip",
    "soon": "Soon",
    "submit": "Submit",
    "success": "Success",
    "successTitle": "Success",
    "time": {
      "daysAgo": "{{n}}d ago",
      "hoursAgo": "{{n}}h ago",
      "minutesAgo": "{{n}}m ago",
      "monthsAgo": "{{n}}mo ago",
      "now": "just now",
      "weeksAgo": "{{n}}w ago",
      "yesterday": "yesterday"
    },
    "to": "To",
    "toast": {
      "documentUploaded": "Document uploaded",
      "moodFailed": "Couldn't save mood, try again",
      "moodRecorded": "Mood recorded",
      "settingFailed": "Couldn't update setting",
      "settingSaved": "Setting saved",
      "somethingWentWrong": "Something went wrong, please try again",
      "taskCompleted": "Task completed",
      "taskFailed": "Couldn't update task",
      "taskReopened": "Task reopened"
    },
    "today": "Today",
    "tonnieChecked": "Tonnie-Checked",
    "traveler": "Traveler",
    "trust": {
      "howItHelps": "How it helps you",
      "tapToSee": "Tap to see how we protect your data",
      "whoCanSee": "Who can see this",
      "whyAsking": "Why we're asking",
      "yourDataProtected": "Your Data is Protected"
    },
    "tryAgain": "Try again",
    "upload": "Upload",
    "uploading": "Uploading…",
    "view": "View",
    "viewAll": "View all",
    "welcome": "Welcome",
    "working": "Working…",
    "yes": "Yes",
    "yesterday": "Yesterday",
    "youWillLose": "You'll lose access to",
    "beta": {
      "bannerMessage": "Early access — help shape Tonnie 💜",
      "bannerMessageMobile": "Early access — evolve with Tonnie 💜",
      "bannerCta": "Give feedback"
    },
    "openActionTitle": "Open {{action}}",
    "copy": "Copy",
    "network": {
      "a11y": {
        "retry": "Retry failed requests",
        "dismiss": "Dismiss network error banner",
        "showDetails": "Show error details",
        "hideDetails": "Hide error details",
        "copy": "Copy error details to clipboard"
      },
      "hideDetails": "Hide details",
      "detailsCount": "Details · {{count}}",
      "noDetails": "No details captured yet.",
      "copy": {
        "unstable": {
          "title": "Connection is unstable",
          "subtitle": "We paused automatic retries to save battery. Tap Retry to try again.{{countHint}}"
        },
        "network": {
          "title": "Can't reach the server",
          "subtitle": "Check your internet connection.{{countHint}}"
        },
        "timeout": {
          "title": "Slow connection",
          "subtitle": "Requests are taking longer than usual.{{countHint}}"
        },
        "server": {
          "title": "Something went wrong",
          "subtitle": "Our team has been notified. Try again in a moment.{{countHint}}"
        },
        "default": {
          "title": "Connection issue",
          "subtitle": "We're having trouble loading your data.{{countHint}}"
        },
        "countHint_one": " ({{count}} failed request)",
        "countHint_other": " ({{count}} failed requests)"
      }
    },
    "apiError": {
      "network": "We can't reach the server. Check your connection.",
      "timeout": "The request took too long. We'll retry automatically.",
      "unauthorized": "Your session expired. Please sign in again.",
      "forbidden": "You don't have permission for that.",
      "notFound": "Resource not found.",
      "badRequest": "Something in the request was invalid.",
      "serverError": "Something went wrong on our side. We're looking into it.",
      "unknown": "Something went wrong."
    },
    "relativeTime": {
      "justNow": "Just now",
      "minutesAgo_one": "{{count}} minute ago",
      "minutesAgo_other": "{{count}} minutes ago",
      "hoursAgo_one": "{{count}} hour ago",
      "hoursAgo_other": "{{count}} hours ago",
      "daysAgo_one": "{{count}} day ago",
      "daysAgo_other": "{{count}} days ago"
    },
    "device": {
      "unknown": "Unknown device",
      "mobile": "Mobile",
      "desktop": "Desktop"
    },
    "browser": {
      "unknown": "Unknown browser"
    },
    "location": {
      "unknown": "Unknown location"
    },
    "searchCountry": "Search country...",
    "noCountryFound": "No country found.",
    "phoneCode": "Code",
    "searchPhoneCode": "Search phone code...",
    "noPhoneCodeFound": "No phone code found.",
    "untitled": "Untitled",
    "unassigned": "Unassigned",
    "unknown": "Unknown",
    "member": "Member",
    "phoneCountryCodeLabel": "Phone country code",
    "pageOf": "Page {{page}} of {{total}}",
    "pagination": "Pages",
    "daysAgo_one": "{{count}} day ago",
    "daysAgo_other": "{{count}} days ago",
    "rewardMiles_one": "Reward: {{count}} Mile",
    "rewardMiles_other": "Reward: {{count}} Miles",
    "removeItem": "Remove {{name}}",
    "milesGained_one": "+{{miles}} Mile",
    "milesGained_other": "+{{miles}} Miles",
    "aiBadge": "AI",
    "list": {
      "two": "{{first}} and {{second}}"
    }
  },
  "copilot": {
    "beta": {
      "badge": "Beta",
      "tooltipTitle": "Tonnie CoPilot is in beta",
      "tooltipBody": "We're actively improving it — rate replies with 👍 or 👎 to help us make it better.",
      "ariaLabel": "About the Tonnie CoPilot beta"
    },
    "action": {
      "dismiss": "Dismiss",
      "goTo": "Go to",
      "open": "Open"
    },
    "aiDisclaimer": "CoPilot uses AI. Responses may not always be accurate.",
    "answered": "Answered",
    "answersSubmitted": "Your answers have been submitted",
    "askAnything": "Ask anything...",
    "billingPage": "Billing page",
    "brainAssessment": {
      "errorTitle": "Could not load questions",
      "evaluating": {
        "subtitle": "Our AI is checking your response",
        "title": "Evaluating your answer…"
      },
      "feedback": {
        "correct": "Correct!",
        "incorrectEncouragement": "Take a beat — you'll see this concept again.",
        "incorrectHeadline": "Almost — here's the answer",
        "movingOn": "Moving to next question…",
        "next": "Next question",
        "theAnswerIs": "The answer is"
      },
      "level": {
        "advanced": {
          "label": "Advanced",
          "desc_one": "Excellent! {{count}} mission is marked as skippable.",
          "desc_other": "Excellent! {{count}} missions are marked as skippable."
        },
        "beginner": {
          "desc": "You're starting your journey! All lessons are unlocked and ready for you.",
          "label": "Beginner"
        },
        "intermediate": {
          "label": "Intermediate",
          "desc_one": "Great knowledge! {{count}} beginner mission is marked as skippable.",
          "desc_other": "Great knowledge! {{count}} beginner missions are marked as skippable."
        }
      },
      "loading": "Loading assessment questions…",
      "noQuestions": "No questions available for this world.",
      "question": {
        "next": "Next question",
        "openAnswerHint": "Your answer will be evaluated by the AI. Take your time!",
        "openAnswerCounter": "{{count}} / {{max}} characters",
        "openAnswerMinHint": "Minimum {{min}} characters ({{remaining}} to go)",
        "openAnswerPlaceholder": "Type your answer here…",
        "submitFinal": "Submit & see results"
      },
      "results": {
        "continue": "Continue",
        "correct": "Correct",
        "questionDetails": "Question details",
        "retake": "Retake",
        "score": "Score",
        "total": "Total",
        "yourAnswer": "Your answer",
        "skipNote_one": "{{count}} mission will be marked as skippable for your level. You can still complete it to earn Miles.",
        "skipNote_other": "{{count}} missions will be marked as skippable for your level. You can still complete them to earn Miles."
      }
    },
    "brainSubtitle": "Powered by Tonnie Brain",
    "bringFamily": "Are you bringing your family?",
    "bringingFamilyNoProgram": "Bringing Family (no program)",
    "cameraError": "Camera error",
    "cameraErrorTitle": "Camera unavailable",
    "cameraPermissionDenied": "Camera permission denied. Allow camera access in your browser to record a video.",
    "chatLog": "Chat messages",
    "playVideo": "Play video",
    "clickToPlay": "Click to start video",
    "close": "Close CoPilot",
    "confidence": "Confidence",
    "contextualGreeting": "Hello! I'm Tonnie CoPilot, your contextual AI assistant. {{context}}What would you like to know?",
    "couldImprove": "Could improve",
    "createMyJourney": "Create my journey",
    "dailyQuotaReached": "Daily quota reached",
    "destination": "Where are you going?",
    "disclaimer": "Your answers are private and used only to personalize your journey.",
    "errorLoadingQuestions": "Error loading questions",
    "errorTitle": "Something went wrong",
    "familyAddon": "Family Add-on included",
    "familyComingSoonNote": "The Family Program will be available soon. For now, your journey is configured for individual use.",
    "familyConfig": "Family configuration",
    "familyFeature1": "Invite family members (Companion & Family Members)",
    "familyFeature2": "Control access permissions per hero",
    "familyFeature3": "Track household-aware progress",
    "familyFeature4": "Manage family journey together",
    "familyJoinQuestion": "Will family members be joining you on this journey?",
    "familyJoining": "Family members will join your journey",
    "familyProgramAddon": "Family program add-on",
    "familyProgramDesc": "Manage your family's journey together with shared access and progress tracking",
    "familyProgramEnabled": "Family program enabled",
    "findings": {
      "emptyProfile": "Your profile doesn't have any findings yet.",
      "expand": "Expand",
      "looksGood": "Looks good",
      "profile": "Profile",
      "profileIntro": "Here's what we've gathered about your profile from your answers.",
      "profileTitle": "Profile findings"
    },
    "fixErrors": "Fix errors",
    "formSubmittedNote": "Your form has been submitted. Thanks!",
    "goBack": "Go back",
    "greeting": "Hello! I'm Tonnie CoPilot, your AI assistant. {{context}}What would you like to know?",
    "guide": {
      "newMessages": "New messages",
      "typeHere": "Type here...",
      "avatarAlt": "CoPilot AI assistant",
      "aria": {
        "stepOf": "Step {{step}} of {{total}}"
      },
      "taskFallback": "Assessment"
    },
    "guideCompleted": "Guide completed",
    "guideCompletedDesc": "You've completed this guide.",
    "guideTitle": "Tonnie CoPilot guide",
    "household": {
      "addChild": "Add child",
      "addPet": "Add pet",
      "cat": "Cat",
      "child": "Child",
      "childN": "Child {{n}}",
      "children": "Children",
      "childrenDetails": "Tell us about each child who's relocating with you.",
      "description": "Tell us who's relocating with you so we can personalize your journey.",
      "dog": "Dog",
      "hasPassport": "Has passport",
      "name": "Name",
      "namePlaceholder": "Full name",
      "nationality": "Nationality",
      "other": "Other",
      "partner": "Partner",
      "partnerDetails": "Tell us about your partner.",
      "pet": "Pet",
      "petN": "Pet {{n}}",
      "petName": "Pet name",
      "petNamePlaceholder": "What's your pet's name?",
      "petVaccination": "Vaccinations up to date",
      "pets": "Pets",
      "petsDetails": "Tell us about each pet relocating with you.",
      "relocating": "Relocating with me",
      "selectCountry": "Select country",
      "species": "Species",
      "title": "Your household",
      "vaccinationOk": "Vaccinations OK",
      "prefilledFromOnboarding": "Pre-filled from your onboarding answers. Check it and change anything that's different — nothing is saved until you confirm.",
      "you": "You"
    },
    "hybrid": {
      "complete": "All done! Your responses have been recorded.",
      "error": "Something went wrong. Let's try again.",
      "escapeHatch": "I'd rather not answer this",
      "placeholder": "Type your answer...",
      "progress": "Progress",
      "selectOption": "Select an option",
      "stepOf": "Step {{current}} of {{total}}",
      "title": "Guided interview",
      "typeAnswer": "Type your answer",
      "openingFallback": "Let's get started."
    },
    "includedFeatures": "Included features",
    "individualJourney": "Individual journey",
    "inputPlaceholder": "Ask Tonnie anything...",
    "journeyPurpose": "Journey purpose",
    "journeyPurposes": "Journey purposes",
    "journeyReady": "Your journey is ready to unlock!",
    "journeyRoute": "Journey route",
    "journeyRouteDesc": "Select your origin and destination countries",
    "journeySummary": "Your journey summary",
    "justMe": "Just me",
    "lifecycle": {
      "acknowledge": {
        "default": "I understand this action cannot be undone."
      },
      "autosave": {
        "justNow": "just now",
        "offline": "Offline — will retry",
        "saved": "Saved · {{relative}}",
        "saving": "Saving…",
        "unsaved": "Pending save"
      },
      "completion": {
        "errorBody": "Something went wrong saving your answers. You can retry — your work is still here.",
        "errorRetry": "Try again",
        "errorTitle": "Could not save your results",
        "saving": "Saving your results…",
        "successBody": "Your answers are saved. Taking you to your dashboard.",
        "successContinue": "Continue",
        "successRedirect": "Redirecting in {{seconds}}…",
        "successStay": "Stay here",
        "successTitle": "All done!"
      },
      "confirm": {
        "stepLabel": "Step {{currentStep}} of {{totalSteps}} · {{progress}}%"
      },
      "discard": {
        "body": "You're {{progress}}% in. If you cancel now, your work on this attempt will be deleted.",
        "bodyNoProgress": "If you cancel now, your work on this attempt will be deleted.",
        "bodyTeleportalSetup": "Your existing TelePortal tasks stay as they are. Your draft answers from this session will not be saved.",
        "cancel": "Stay",
        "confirm": "Yes, discard",
        "confirmSkip": "Yes, skip",
        "keep": {
          "history": "Any prior completed result",
          "teleportalTasks": "Your existing TelePortal tasks"
        },
        "lose": {
          "answers": "Your current answers ({{progress}}%)",
          "position": "Your spot at step {{currentStep}}",
          "teleportalDraft": "This session's draft answers",
          "teleportalPosition": "You will lose your TelePortal progress on this journey"
        },
        "title": "Discard your {{hero}} progress?",
        "titleTeleportalSetup": "Skip the setup for now?",
        "confirmTeleportalSetup": "Yes, discard this attempt"
      },
      "hero": {
        "care_assessment": "Care assessment",
        "checkup": "CheckUp",
        "journey_builder": "journey",
        "qultureup": "QultureUp level test",
        "teleportal_setup": "TelePortal setup"
      },
      "keep": {
        "empty": "Nothing carries over.",
        "title": "Keeping"
      },
      "leave": {
        "body": "Your progress through step {{currentStep}} is already saved. Pick this back up any time.",
        "bodyNoProgress": "Your progress is saved. Pick this back up any time.",
        "cancel": "Stay",
        "confirm": "Yes, step away",
        "keep": {
          "answers": "Every answer you completed",
          "progress": "Your progress so far ({{progress}}%)"
        },
        "title": "Step away for now?"
      },
      "lose": {
        "empty": "Nothing is deleted.",
        "title": "Losing"
      },
      "restart": {
        "body": "Your current answers will be cleared. You'll begin fresh from step 1.",
        "bodyJourneyBuilder": "You'll start the journey builder over. Your in-progress answers will be cleared.",
        "bodyTeleportalSetup": "Your previous answers will be pre-filled. The conversation starts again from the top, and your task list rebuilds.",
        "cancel": "Stay",
        "confirm": "Yes, restart",
        "keep": {
          "history": "Your previous result (if any)"
        },
        "lose": {
          "answers": "Your current answers ({{progress}}%)",
          "builderAnswers": "Your in-progress builder answers",
          "position": "Your spot at step {{currentStep}}"
        },
        "title": "Restart from step 1?",
        "titleJourneyBuilder": "Restart the journey builder?",
        "titleTeleportalSetup": "Reset your TelePortal setup?"
      },
      "resume": {
        "btnContinue": "Continue from step {{currentStep}}",
        "btnContinueShort": "Continue from where you left off",
        "btnDiscard": "Discard this attempt",
        "btnDiscardSubtitle": "Your answers will be deleted",
        "btnNavigateLastResultCare": "View my Care dashboard",
        "btnNavigateLastResultCheckup": "View my last result",
        "btnNavigateLastResultQultureup": "Go to QultureUp homepage",
        "btnRestart": "Start over",
        "btnSkip": "Skip for now",
        "subtitleLastActive": "Last activity {{relativeTime}}",
        "subtitleProgress": "Step {{currentStep}} of {{totalSteps}} · {{progress}}% complete",
        "subtitleProgressShort": "{{progress}}% complete",
        "title": "Welcome back to your {{hero}}",
        "welcomeBack": "Welcome back — your progress is saved"
      },
      "retake": {
        "body": "Your previous result moves to history and a brand-new attempt starts now.",
        "bodyCare": "Your previous Care assessment is archived. The conversation starts fresh from step 1.",
        "bodyCheckup": "Your previous CheckUp result is archived. The conversation starts fresh from step 1.",
        "bodyQultureup": "Only the starting-level test runs again — your missions and achievements are untouched.",
        "bodyTeleportalSetup": "Your previous setup is archived. The conversation starts again — your existing tasks stay until you complete the new setup.",
        "cancel": "Stay",
        "confirm": "Yes, retake",
        "keep": {
          "archived": "Your previous result (kept in history)",
          "miles": "All your earned Miles",
          "missions": "Your mission progress"
        },
        "lose": {
          "activeScore": "Your active score & badge"
        },
        "reason": {
          "circumstances_changed": "My situation changed",
          "just_curious": "Just curious / exploring",
          "made_a_mistake": "Made a mistake",
          "other": "Other",
          "placeholder": "— Select a reason (optional) —",
          "want_to_update": "Want to update my answers"
        },
        "reasonLabel": "Why are you retaking? (optional)",
        "title": "Take a fresh attempt?",
        "titleHero": "Retake your {{hero}}?"
      },
      "reversible": {
        "no": "Can't be undone",
        "yes": "You can come back to this"
      },
      "stay": "Stay",
      "toolbar": {
        "discard": "Discard",
        "discardHint": "Cancel this attempt and exit. Your answers are deleted.",
        "restart": "Restart",
        "restartHint": "Wipe your answers and start over from step 1."
      },
      "topBar": {
        "exitLabel": "Leave",
        "progressLabel": "{{progress}}% complete",
        "stepLabel": "Step {{currentStep}} of {{totalSteps}}"
      },
      "aria": {
        "whatChanges": "What changes"
      }
    },
    "loadingQuestions": "Loading questions…",
    "maxChars": "Max {{max}} characters",
    "validation": {
      "required": "This question is required.",
      "thin": "A short answer is fine — a few more sentences give us more to work with ({{words}} words so far).",
      "tooLong": "Too long — please keep it under {{max}} characters.",
      "ok": "Looks great — clear and detailed."
    },
    "suggestedWords": "Aim for {{min}}+ words",
    "typeAnswer": "Type your answer",
    "words_one": "{{count}} word",
    "words_other": "{{count}} words",
    "motivationalAssessment": "Motivation assessment",
    "motivationalDesc": "A short reflection to help us understand what drives your move.",
    "needsFix": "Needs fixing",
    "nextVideo": "Next video",
    "noCountriesFound": "No countries found",
    "noQuestionsForPersona": "We don't have questions for this profile yet.",
    "noVideoData": "No video data",
    "noVideos": "No videos available.",
    "notAnsweredYet": "Not answered yet",
    "optional": "Optional",
    "origin": "Where are you from?",
    "pitch": {
      "fileTooLarge": "This video file is too large to upload. Choose a smaller file, or record your pitch here.",
      "tooLong": "This video is longer than {{minutes}} minutes. Choose a shorter video, or record your pitch here.",
      "uploadStalled": "The upload stopped because your connection stopped sending data. Check your connection and try again.",
      "unreadable": "We couldn't read this video, so its length can't be checked. Choose an MP4 or WebM video that plays on this device, or record your pitch here."
    },
    "pitchRecorder": "Pitch recorder",
    "practiceNote": "Tip: practice once before recording.",
    "previousVideo": "Previous video",
    "progressComplete": "{{percent}}% complete",
    "questionN": "Question {{n}}",
    "questionNofM": "Question {{n}} of {{m}}",
    "questions": "Questions",
    "questionsLoadError": "Failed to load questions",
    "questionsUnavailable": "Questions unavailable",
    "quota": {
      "exceeded": "Daily limit reached. Upgrade your plan for more messages.",
      "remaining": "Messages remaining",
      "upgrade": "Upgrade for more"
    },
    "quotaReached": "Quota reached! Upgrade to Pro for unlimited access.",
    "ready": "Ready",
    "readyQ": "Ready to start?",
    "recordAnswer": "Record answer",
    "recordYourPitch": "Record your pitch",
    "required": "Required",
    "responseCare": "Your Care feedback shows improvement in Communication and Technical Skills. Keep up the great work! For Behaviour & Adaptation, consider joining local communities and networking events.",
    "responseCareer": "Based on your profile, you're well-positioned for opportunities in Portugal. Your technical skills are strong, and your English level is excellent. I'd suggest focusing on Portuguese language practice to increase your match rate.",
    "responseCheckup": "Based on your CheckUp results, I can see you're doing well! Your readiness score of 85 shows strong preparation. I'd recommend focusing on cultural adaptation, which is at 75. Consider completing QultureUp lessons to improve this area.",
    "responseDefault": "I understand your question. Let me help you with that. ",
    "responseHelp": "I'm here to help! I can assist you with understanding your CheckUp results, navigating TelePortal tasks, learning about culture in QultureUp, tracking your progress in Care, and finding career opportunities. What specific area would you like help with?",
    "responseQultureup": "Great that you're interested in QultureUp! I recommend starting with the 'Local Culture' world to get familiar with Portuguese customs and traditions. This will help you adapt faster when you arrive.",
    "responseScore": "Your current readiness score is 85/100, which is excellent! You're in the 'Almost Ready' category. The main areas to focus on are Cultural Adaptation (75) and International Experience (70). Would you like specific recommendations?",
    "responseTeleportal": "For your TelePortal journey, I see you're in the Visa Preparation phase. Make sure to gather all required documents and schedule your interview. Would you like me to help you with a specific task?",
    "responseVisa": "For your relocation, I recommend starting with the TelePortal Assessment to get a personalized checklist. Make sure you have all required documents ready. The visa process typically takes 2-3 months, so plan accordingly.",
    "restartFlow": "Restart",
    "reviewAnswers": "Review answers",
    "reviewDesc": "Take a moment to review your answers before submitting.",
    "reviewJourney": "Review your journey configuration before we prepare it for you",
    "reviewYourAnswers": "Review your answers",
    "safety": {
      "critical": "CoPilot cannot provide advice on this topic. Please consult a qualified professional.",
      "elevated": "This topic requires careful consideration. CoPilot provides general guidance only — consult a professional for specific advice.",
      "standard": "CoPilot uses AI. Responses may not always be accurate. Always verify important information.",
      "getHelp": "Get help",
      "rephrase": "I noticed your message contains some content I can't process. Could you rephrase it?"
    },
    "sameCountryWarning": "Origin and destination cannot be the same country.",
    "saved": "Saved",
    "saving": "Saving…",
    "searchCountry": "Search country...",
    "selectCountry": "Select...",
    "selectedAsDest": "Selected as destination",
    "selectedAsOrigin": "Selected as origin",
    "send": "Send",
    "situation": {
      "answered": "Answered",
      "companyProvides": "My company provides this",
      "companySponsored": "Company sponsored",
      "companySponsoredDesc": "My employer is sponsoring my relocation.",
      "description": "Pick the option that best describes your situation.",
      "digitalNomad": "Digital nomad",
      "digitalNomadDesc": "I'll work remotely from my new country.",
      "employedSelf": "I'm employed and moving on my own",
      "employedSponsored": "I'm employed and my company sponsors the move",
      "entrepreneur": "Entrepreneur",
      "euCitizen": "EU citizen",
      "euCitizenDesc": "I'm an EU citizen and don't need a visa.",
      "familyReunion": "Family reunion",
      "familyReunionDesc": "I'm joining family already abroad.",
      "haveHousing": "I have housing arranged",
      "haveVisa": "I already have a visa",
      "haveVisaDesc": "I've secured my visa for this move.",
      "housingTitle": "Housing situation",
      "jobSeeking": "Seeking a job",
      "legalTitle": "Legal situation",
      "needFind": "I need to find housing",
      "needTemp": "I need temporary housing",
      "needVisa": "I need to get a visa",
      "needVisaDesc": "I haven't applied for a visa yet.",
      "pathwayTitle": "Visa pathway",
      "pathwaysUnavailable": "We couldn't load the visa pathways. You can continue without choosing one.",
      "credentialTitle": "Regulated profession",
      "credentialQuestion": "Do you work in a regulated profession (for example medicine, nursing, engineering or law) in the country you're moving to? If so, your qualification must be recognised there before you can practise.",
      "credentialYes": "Yes, my profession is regulated",
      "credentialNo": "No",
      "pathway": {
        "workPermit": "Work permit (sponsored)",
        "workPermitDesc": "Employer-sponsored residence",
        "techVisa": "Tech visa",
        "techVisaDesc": "Certified-company tech hire",
        "d7": "D7 — Passive income / remote",
        "d7Desc": "Income- or remote-work-based",
        "euFamily": "EU / family reunification",
        "euFamilyDesc": "EU national or joining family",
        "d1": "D1 — Work visa",
        "d1Desc": "Salaried job with an employer",
        "d2": "D2 — Entrepreneur / independent worker",
        "d2Desc": "Your own business or independent activity",
        "d8": "D8 — Digital nomad",
        "d8Desc": "Remote work for employers or clients abroad",
        "startup": "Startup visa",
        "startupDesc": "Founding an innovative startup",
        "notSure": "Not sure yet",
        "notSureDesc": "Tonnie will help determine it"
      },
      "professionalTitle": "Professional situation",
      "retired": "Retired",
      "selfEmployed": "Self-employed",
      "student": "Student",
      "studentVisa": "Student visa",
      "studentVisaDesc": "I'm moving on a student visa.",
      "title": "Your situation"
    },
    "submitFailed": "Failed to submit",
    "subtitle": "Your AI assistant is here to help",
    "suggestedQuestions": "Suggested questions:",
    "thinking": "Thinking...",
    "timeEstimate": "About {{value}} min",
    "title": "Tonnie CoPilot",
    "launcher": {
      "label": "Ask Tonnie"
    },
    "toggle": "Toggle CoPilot",
    "trace": {
      "artifactUpdate": "Artifact updated",
      "cancel": "Cancel",
      "completeness": "Completeness",
      "confirm": "Confirm",
      "error": "Error",
      "retry": "Retry",
      "widget": "Widget"
    },
    "tryAgain": "Try again",
    "unavailable": "CoPilot is temporarily unavailable. Please try again in a moment.",
    "unlimited": "Pro plan: Unlimited queries",
    "unlimitedQuestions": "Unlimited questions",
    "unlockNote": "Your personalized journey has been created. Unlock it from the",
    "upgrade": "Upgrade",
    "upgradeToPro": "Upgrade to Pro",
    "uploadNote": "We'll keep your video private — only you and our AI will see it.",
    "uploadingVideo": "Uploading video…",
    "verifiedByTonnieGuard": "Verified by Tonnie guard",
    "videoCompleted": "Completed",
    "videoPlayerDesc": "Video player for {{title}}. Click play to start the video.",
    "videoResume": "Resume",
    "videoSent": "Video sent",
    "videoStateInProgress": "In progress",
    "videoStatePending": "Not started",
    "videoStateWatched": "Watched",
    "videoSubmitted": "Video submitted",
    "videoToWatch": "To watch",
    "videoUploadFailed": "Video upload failed",
    "videoWatchedLabel": "Watched",
    "videosWatched": "videos watched",
    "voice": {
      "error": "Sorry, I couldn't catch that. Please try again.",
      "status": {
        "listening": "I'm listening...",
        "transcribing": "Transcribing…"
      },
      "a11y": {
        "pause": "Pause listening",
        "start": "Start voice input"
      }
    },
    "whyWeAsk": "Why we ask",
    "widgetError": "This widget failed to load.",
    "widgetNotFound": "Widget \"{{name}}\" not found",
    "yesBringingFamily": "Yes, bringing family",
    "aria": {
      "conversation": "Conversation",
      "messageInput": "Message",
      "resultActions": "Result actions",
      "sendMessage": "Send message",
      "answerInput": "Your answer"
    },
    "tools": {
      "checkingCohorts": "Checking your programs…",
      "checkingJourney": "Checking your journey…",
      "checkingTasks": "Checking your tasks…",
      "checkingCheckup": "Checking your CheckUp…",
      "checkingCare": "Checking your wellbeing…",
      "checkingObjectives": "Checking your Care objectives…",
      "checkingPassport": "Checking your Passport…",
      "checkingMiles": "Checking your miles…",
      "checkingNotifications": "Checking your notifications…",
      "checkingHousehold": "Checking your household…",
      "checkingBilling": "Checking your billing…",
      "checkingCareer": "Checking career opportunities…",
      "submittingCheckpoint": "Submitting your checkpoint…",
      "creatingSupport": "Raising a support request…",
      "schedulingCheckpoints": "Scheduling your checkpoints…",
      "submittingSelfEval": "Submitting your self-evaluation…",
      "completingMission": "Completing your mission…",
      "submittingQuiz": "Submitting your quiz…",
      "markingRead": "Updating your notifications…",
      "addingMember": "Adding a household member…",
      "updatingMember": "Updating a household member…",
      "savingOpportunity": "Saving the opportunity…",
      "expressingInterest": "Sending your interest…",
      "checkingDocuments": "Checking your documents…",
      "checkingProfile": "Checking your profile…",
      "checkingMesh": "Checking your MESH…",
      "checkingQultureup": "Checking your QultureUp…",
      "checkingWorlds": "Checking your worlds…",
      "savingToVault": "Saving to your Vault…",
      "attachingFile": "Attaching the file…",
      "updatingTask": "Updating the task…",
      "startingMission": "Starting the mission…",
      "checkingProgramSetup": "Checking your program setup…",
      "reopeningTask": "Reopening the task…",
      "completingTask": "Completing the task…",
      "submittingCheckin": "Logging your check-in…",
      "startingRetake": "Starting your CheckUp…",
      "recallingMemories": "Checking what I remember…",
      "rememberingFact": "Making a note…",
      "forgettingFact": "Forgetting that…",
      "searchingKnowledge": "Checking the knowledge base…",
      "readingNote": "Reading up on that…",
      "listingPipelineTalents": "Checking your talent pipeline…",
      "checkingTalentOverview": "Checking the talent's overview…",
      "checkingTalentReadiness": "Checking the talent's readiness…",
      "checkingTalentMobility": "Checking the talent's relocation progress…",
      "checkingTalentAdaptation": "Checking the talent's adaptation…",
      "checkingTalentRisk": "Checking the talent's wellbeing & risk…",
      "checkingTalentEvidence": "Checking the talent's evidence…",
      "checkingCohort": "Checking the cohort…",
      "checkingProgram": "Checking the program…",
      "checkingPipeline": "Checking your pipeline…",
      "checkingAffiliate": "Checking your affiliate account…",
      "checkingPoolCounts": "Counting your talent pool…",
      "checkingPoolTalent": "Checking the pool talent…",
      "searchingWeb": "Searching the web…",
      "sponsoringTalent": "Preparing the sponsorship…",
      "addingTalentToCohort": "Adding the talent to the cohort…",
      "addingTalentNote": "Adding an internal note…",
      "savingVettingDocument": "Saving the vetting document…",
      "checkingMyWorkQueue": "Checking what needs you…",
      "messagingTalent": "Preparing your message…",
      "requestingCheckin": "Preparing a check-in request…",
      "schedulingMeeting": "Preparing the invitation…",
      "checkingCompany": "Checking your company profile…",
      "checkingPrograms": "Checking your programs…",
      "checkingDashboard": "Checking your dashboard…",
      "checkingActivity": "Checking recent activity…",
      "checkingAnalytics": "Checking your analytics…",
      "checkingVetting": "Checking your vetting overview…",
      "checkingMobility": "Checking your mobility overview…",
      "checkingAdaptation": "Checking your adaptation overview…",
      "checkingEvidence": "Checking your evidence overview…",
      "checkingCareConfig": "Checking your Care configuration…",
      "checkingInvoices": "Checking your invoices…",
      "checkingSponsorships": "Checking your sponsorships…",
      "checkingTeam": "Checking your team…",
      "checkingMessageTemplates": "Checking your message templates…",
      "checkingMessageAnalytics": "Checking your message analytics…",
      "checkingAuditLog": "Checking your audit log…",
      "creatingProgram": "Preparing the new program…",
      "creatingCohort": "Preparing the new cohort…",
      "invitingTeamMember": "Preparing the team invitation…",
      "removingTeamMember": "Preparing to remove the team member…",
      "resolvingInteraction": "Updating the Care interaction…",
      "reschedulingInteraction": "Rescheduling the Care interaction…",
      "cancellingInteraction": "Cancelling the Care interaction…",
      "commentingInteraction": "Adding your comment…",
      "working": "Working…"
    },
    "errors": {
      "quota_exceeded": "You've reached your daily message limit. It resets at midnight.",
      "budget_degraded": "I'm running in a limited mode right now — I can still help with grounded answers.",
      "provider_unavailable": "I'm having trouble reaching my full capabilities right now. Please try again in a moment.",
      "capability_disabled": "That capability is temporarily unavailable.",
      "stale_proposal": "That changed since I suggested it — ask me again and I'll take a fresh look.",
      "aborted": "Stopped.",
      "internal": "Something went wrong on my side. Please try again.",
      "messageRequired": "Please type a message first.",
      "uploadFailed": "Upload failed. Please try again.",
      "ref": "Reference"
    },
    "source": {
      "from": "From",
      "why": "Why you can trust this",
      "cases": "{{n}} similar relocations",
      "webSources": "Sources"
    },
    "webSearch": {
      "toggle": "Search the web",
      "toggleHint": "Let Tonnie look up current information on the web for this question"
    },
    "feedback": {
      "helpful": "Helpful",
      "notHelpful": "Not helpful",
      "thanks": "Thanks for the feedback"
    },
    "toolResult": {
      "success": "Done",
      "failed": "That didn't work"
    },
    "suggestions": {
      "complete_checkup": {
        "title": "Complete your CheckUp",
        "description": "Take the assessment to get personalized recommendations"
      },
      "explore_qultureup": {
        "title": "Explore QultureUp",
        "description": "Start learning about your destination culture"
      },
      "check_passport": {
        "title": "Check your progress",
        "description": "See how far you've come on your journey"
      },
      "checkup_incomplete": {
        "title": "Want to finish your CheckUp? I can walk you through it."
      },
      "tasks_blocked": {
        "title_one": "You have {{count}} blocked task — want help unblocking it?",
        "title_other": "You have {{count}} blocked tasks — want help unblocking them?"
      },
      "care_pending": {
        "title_one": "You have {{count}} check-in waiting — shall we do it?",
        "title_other": "You have {{count}} check-ins waiting — shall we do them?"
      },
      "docs_expiring": {
        "title_one": "{{count}} document is expiring soon — want to review it?",
        "title_other": "{{count}} documents are expiring soon — want to review them?"
      },
      "checkup_result_published": {
        "title": "Your results are in — want me to walk you through them?"
      },
      "vetting_backlog": {
        "title_one": "{{count}} talent is waiting in Vetting — want to review them?",
        "title_other": "{{count}} talents are waiting in Vetting — want to review them?"
      },
      "care_overdue": {
        "title_one": "{{count}} Care checkpoint is overdue — want to see who needs attention?",
        "title_other": "{{count}} Care checkpoints are overdue — want to see who needs attention?"
      }
    },
    "proposal": {
      "aria": "Action confirmation",
      "confirm": "Confirm",
      "confirming": "Confirming…",
      "dismiss": "Not now",
      "expired": "This offer expired — ask me again.",
      "stale": "This changed since I suggested it — ask me again.",
      "error": "Something went wrong. Please try again.",
      "untrustedWarning": "This came from an uploaded file — review it before confirming.",
      "typeToConfirm": "Type {{token}} to confirm",
      "confirmed": "✓ Done — I’ve completed that for you.",
      "alreadyCheckedIn": "You’ve already logged a check-in today, so nothing new was added.",
      "attachedCompletionPending": "✓ File attached — but the task isn’t complete yet; some required documents are still missing."
    },
    "attachFile": "Attach a file",
    "proactive": {
      "dismiss": "Dismiss"
    },
    "newConversation": "New conversation",
    "choices": {
      "label": "Suggested options",
      "other": "Other…"
    },
    "removeAttachment": "Remove file",
    "depth": {
      "label": "Answer length",
      "brief": "Brief",
      "balanced": "Balanced",
      "detailed": "Detailed",
      "briefHint": "Short, to-the-point answers",
      "balancedHint": "Balanced detail (default)",
      "detailedHint": "Thorough, in-depth answers"
    },
    "rewrite": {
      "shorter": "Shorter",
      "longer": "Longer",
      "shorterCommand": "Make your previous answer shorter and more to the point, in the same language.",
      "longerCommand": "Expand your previous answer with more detail and explanation, in the same language."
    },
    "attach": {
      "takePhoto": "Take a photo",
      "choosePhoto": "Choose a photo",
      "recordVideo": "Record a video",
      "chooseVideo": "Choose a video",
      "videoTooLarge": "That video is too large. Record a shorter clip (up to 25 MB) and try again."
    },
    "permissions": {
      "cameraTitle": "Camera unavailable",
      "cameraDenied": "Allow camera access in your device settings so you can show Tonnie a photo or video.",
      "libraryTitle": "Photo library unavailable",
      "libraryUnavailable": "We couldn't open your photo library. Try again, or allow access in your device settings.",
      "microphoneDenied": "Allow microphone access in your device settings so you can speak to Tonnie instead of typing."
    },
    "history": {
      "title": "Conversations",
      "back": "Back to chat",
      "newChat": "New chat",
      "searchPlaceholder": "Search conversations",
      "empty": "No conversations yet",
      "emptySearch": "No matches",
      "untitled": "Untitled",
      "rename": "Rename",
      "delete": "Delete",
      "actions": "Conversation actions",
      "deleteTitle": "Delete conversation?",
      "deleteBody": "This conversation will be removed from your history. This can't be undone.",
      "cancel": "Cancel"
    },
    "familyFromProfile": "From your profile — change it if it's different now.",
    "originShort": "From",
    "destinationShort": "To",
    "actionsAvailable_one": "{{count}} action available",
    "actionsAvailable_other": "{{count}} actions available",
    "questionsRemaining_one": "{{count}} question remaining today",
    "questionsRemaining_other": "{{count}} questions remaining today"
  },
  "coupon": {
    "applied": "Coupon {{code}} applied successfully!",
    "apply": "Apply",
    "enterCode": "Enter coupon code",
    "error": "Failed to apply coupon. Please try again.",
    "invalid": "Invalid coupon code"
  },
  "cvBuilder": {
    "addExperience": "Add experience",
    "addSkill": "Add skill",
    "aiOptimize": "AI-Optimize for Portugal market",
    "clickEditToExpand": "Click Edit to expand this section",
    "complete": "complete",
    "completeAllSections": "Complete all sections for the best results",
    "copilotSuggestions": "CoPilot suggestions",
    "cvCompleteness": "CV completeness",
    "cvSections": "CV sections",
    "deleteExperience": "Delete experience",
    "description": "Create a professional CV tailored to your target market",
    "editExperience": "Edit experience",
    "editSection": "Edit section",
    "education": "Education",
    "exportDescription": "In production, this would generate your CV file.",
    "exportFileDesc": "CV_{{firstName}}_{{lastName}}.{{format}} would be downloaded.",
    "exportPDF": "Export PDF",
    "exportSuccess": "{{format}} exported successfully!",
    "exportWord": "Export word",
    "fullName": "Full name",
    "generatingExport": "Generating {{format}} export...",
    "importLinkedIn": "Import from LinkedIn PDF",
    "items": "items",
    "languages": "Languages",
    "location": "Location",
    "mockEducation1": {
      "degree": "Bachelor of computer science",
      "institution": "University of technology",
      "period": "2014–2018"
    },
    "mockExperience1": {
      "company": "Tech solutions inc.",
      "description": "Led development of scalable web applications. Collaborated with international teams.",
      "period": "2020 — Present",
      "role": "Senior software engineer"
    },
    "mockExperience2": {
      "company": "StartupXYZ",
      "description": "Built and maintained web applications using React and Node.js.",
      "period": "2018–2020",
      "role": "Full-Stack developer"
    },
    "personalInfo": "Personal information",
    "phone": "Phone",
    "preview": "Preview",
    "professionalSummary": "Professional summary",
    "quickActions": "Quick actions",
    "removeSkill": "Remove skill",
    "skills": "Skills",
    "suggestAddSkills": "Add more skills relevant to your target role (5 more recommended)",
    "suggestExpandSummary": "Expand your professional summary with key achievements",
    "template": "Template",
    "templates": {
      "classic": "Classic",
      "creative": "Creative",
      "minimal": "Minimal",
      "modern": "Modern"
    },
    "title": "CV builder",
    "translateToPortuguese": "Translate to Portuguese",
    "wizard": {
      "applyChanges": "Apply changes",
      "applying": "Applying...",
      "backToEdit": "Back to edit",
      "characters": "characters",
      "clickNextToGenerate": "Click Generate to create your tailored CV",
      "company": "Company",
      "companyPlaceholder": "e.g., TechCorp Solutions",
      "completeAllSteps": "Please complete all steps before saving",
      "createFirstCV": "Create your first CV to get started",
      "cvDeleted": "CV deleted successfully!",
      "cvGeneratedDescription": "Your CV has been generated and saved. You can now review and edit each section, or export it directly.",
      "cvGeneratedSuccess": "CV generated successfully!",
      "cvSaved": "CV saved successfully!",
      "cvUpdated": "CV updated successfully!",
      "defaultJobTitle": "this position",
      "deleteConfirm": "Are you sure you want to delete this CV?",
      "deleteConfirmTitle": "Delete CV",
      "description": "Generate professional CVs adapted to job descriptions using your Journey data",
      "done": "Done",
      "dragDropFile": "Drag and drop a file here, or click to select",
      "edit": "Edit",
      "enterPrompt": "Please enter refinement instructions",
      "fileSelected": "File selected",
      "fileUploaded": "File uploaded: {{fileName}}",
      "generateCV": "Generate CV",
      "generatedEducation": "{{degree}} from {{institution}} ({{period}})",
      "generatedExperience": "{{role}} at {{company}} ({{period}})\n{{description}}",
      "generatedReadiness": "International readiness score: {{iqulture}}/100\nMESH breakdown: Motivation {{motivation}}% • English {{english}}% • Soft skills {{softSkills}}% • Hard skills {{hardSkills}}%",
      "generatedSummary": "Experienced professional with {{iqulture}}/100 international readiness score. {{name}} brings strong technical expertise and proven adaptability to international environments, making them an ideal candidate for {{jobTitle}}.",
      "generating": "Generating...",
      "generatingCV": "Generating your CV...",
      "generatingDescription": "AI is analyzing your profile and the job requirements",
      "invalidFileType": "Invalid file type. Please upload .txt, .doc, .docx, or .pdf files.",
      "jobDescription": "Job description",
      "jobDescriptionPlaceholder": "Paste the complete job description here...",
      "jobTitle": "Job title",
      "jobTitlePlaceholder": "e.g., Senior Software Engineer",
      "newCV": "New CV",
      "next": "Next",
      "noCVs": "No CVs yet",
      "of": "of",
      "optional": "(Optional)",
      "orCreateNew": "or create a new one",
      "orUploadFile": "Or upload job description file",
      "preview": "Preview",
      "previous": "Previous",
      "promptPlaceholder": "E.g., Add more details about cloud infrastructure, focus on AWS services...",
      "readyToGenerate": "Ready to generate",
      "refine": "Refine",
      "refineDescription": "Enter instructions to modify this section:",
      "refineSection": "Refine section",
      "refinedBasedOn": "Refined based on",
      "refinementSuccess": "Section refined successfully!",
      "saveCV": "Save CV",
      "savedCVs": "Saved CVs",
      "sections": {
        "education": "Education",
        "internationalReadiness": "International readiness",
        "professionalSummary": "Professional summary",
        "skills": "Skills",
        "workExperience": "Work experience"
      },
      "selectCVToPreview": "Select a CV to preview",
      "step": "Step",
      "step1": {
        "description": "Enter the job description for the position you're applying to. This will help us tailor your CV.",
        "title": "Job description"
      },
      "step2": {
        "description": "AI will analyze the job description and generate tailored CV sections based on your Journey data.",
        "title": "CV generation"
      },
      "step3": {
        "description": "Review and refine each section. Use prompts to customize content for specific requirements.",
        "title": "Refinement"
      },
      "step4": {
        "description": "Review your final CV and save it or export it in your preferred format.",
        "title": "Review & export"
      },
      "steps": {
        "generation": "Generation",
        "jobDescription": "Job description",
        "refinement": "Refinement",
        "review": "Review"
      },
      "subtitle": "Create job-specific CVs tailored to each opportunity",
      "supportedFormats": "Supports: .txt, .doc, .docx, .pdf",
      "title": "CV generator wizard",
      "unsavedChanges": "You have unsaved changes. Are you sure you want to exit?",
      "unsavedChangesTitle": "Unsaved changes"
    },
    "workExperience": "Work experience"
  },
  "dashboard": {
    "activity": {
      "checkupUpdated": "CheckUp assessment updated",
      "portugueseBasicsCompleted": "Completed Portuguese basics level 1",
      "twoDaysAgo": "2 days ago",
      "twoHoursAgo": "2 hours ago",
      "visaVerificationPending": "Visa document verification pending",
      "yesterday": "Yesterday",
      "title": "Recent activity",
      "showAll": "Show all"
    },
    "allCheckpointsDone": "All checkpoints done",
    "banner": {
      "completed": "Done",
      "notStarted": "Not started",
      "progress": "Progress"
    },
    "care": {
      "allComplete": "All checkpoints done",
      "assessmentDone": "Assessment done",
      "awaitingData": "Awaiting data",
      "mood": "Mood:",
      "moodCta": "How are you feeling today?",
      "notStarted": "Track your wellbeing across 5 life pillars with regular check-ins.",
      "startCta": "Start Care",
      "subtitle": "Wellbeing support & check-ins"
    },
    "checkup": {
      "assessmentDone": "Assessment complete",
      "calculateCta": "Calculate score",
      "calculating": "Calculating...",
      "calculatingDesc": "Analyzing your readiness across Motivation, English, Soft Skills and Hard Skills.",
      "iqulture": "iQulture score",
      "lastAssessment": "Last: {{date}}",
      "notStarted": "Discover your readiness score across Motivation, English, Soft Skills and Hard Skills.",
      "readyToCalculate": "Your MESH readiness score is ready to be calculated.",
      "startCta": "Start assessment",
      "subtitle": "Measure your readiness with MESH",
      "awaitingProfile": "Profile needed",
      "awaitingProfileDesc": "Your assessment is done. Complete your profile to get your score."
    },
    "continueJourney": "Continue journey",
    "cta": {
      "continueQultureUp": "Continue QultureUp",
      "continueTelePortal": "Continue TelePortal",
      "startCare": "Start Care",
      "startCheckUp": "Start CheckUp",
      "startQultureUp": "Start QultureUp",
      "startTelePortal": "Start TelePortal",
      "viewCheckUp": "View CheckUp",
      "viewPassport": "View Passport",
      "completeProfile": "Complete your profile",
      "continueCare": "Continue Care"
    },
    "emptyState": {
      "description": "Create your international career journey to unlock your personalized dashboard with progress tracking across all heroes.",
      "title": "Build your journey"
    },
    "errorState": {
      "description": "Something went wrong while loading your dashboard data. Please try refreshing the page.",
      "title": "Unable to load dashboard"
    },
    "heroInsight": {
      "care": {
        "checkpoints": "{{done}} of {{total}} checkpoints",
        "notStarted": "Track your wellbeing",
        "startCheckin": "Log your first check-in",
        "streak": "{{n}}-day streak",
        "subtitle": "Track your wellbeing"
      },
      "checkup": {
        "notStarted": "Take your assessment",
        "subtitle": "Measure your readiness"
      },
      "qultureup": {
        "allDone": "All missions complete!",
        "missionsLabel": "missions",
        "notStarted": "Discover your culture level",
        "subtitle": "Learn your new culture",
        "todaysMission": "Today's mission"
      },
      "teleportal": {
        "allDone": "No deadlines coming up",
        "next": "Next: {{name}}",
        "notStarted": "Build your relocation plan",
        "overdue_one": "{{count}} overdue",
        "overdue_other": "{{count}} overdue",
        "subtitle": "Plan your relocation",
        "tasksLabel": "tasks"
      }
    },
    "journeyProgress": "Your journey {{route}} is {{percent}}% complete.",
    "journeyProgressDescription": "Track your progress through each step",
    "journeyProgressTitle": "Your journey progress",
    "journeyReady": "Your journey is ready to begin.",
    "miles": "Journey Miles",
    "moodLabel": "Mood:",
    "noActivity": "No recent activity yet. Start exploring your heroes!",
    "noJourney": "No journey",
    "passport": {
      "badges": "Badges",
      "citizenLevelValue": "Lv.{{level}}",
      "level": "Level",
      "noData": "Your score will show here",
      "readiness": "Readiness",
      "recentStamps": "Recent stamps",
      "stamps": "Stamps",
      "subtitle": "Your complete journey record",
      "totalMiles": "Total Miles"
    },
    "qultureup": {
      "missions": "Missions",
      "notStarted": "Explore cultural worlds and complete missions to adapt to your new home.",
      "startCta": "Start assessment",
      "streak": "{{days}}-day streak",
      "subtitle": "Cultural adaptation through learning",
      "tracks": "Tracks",
      "worlds": "Worlds"
    },
    "recentActivity": "Recent activity",
    "recentActivityDescription": "Your latest milestones and updates",
    "teleportal": {
      "docs": "Docs ready:",
      "notStarted": "Set up your relocation plan with Legal, Travel, and Setup tracks.",
      "startCta": "Start setup",
      "subtitle": "Plan and execute your relocation"
    },
    "welcomeBack": "Welcome back, {{name}}! 👋",
    "hero": {
      "scoreIn": "Your score is in",
      "hello": "Hi, {{name}}",
      "helloNoName": "Hi again",
      "strongest": "Strongest: {{dimension}}",
      "toGrow": "To grow: {{dimension}}",
      "resultsLink": "See your full results",
      "day": "Day {{day}}",
      "dayLabel": "of your journey"
    }
  },
  "deepLink": {
    "copyUrl": "Copy URL",
    "downloadApp": "Download app",
    "error": {
      "invalidAction": "Invalid deep link action",
      "noUser": "User not authenticated"
    },
    "fallbackDescription": "If the app doesn't open automatically, install it from the app store.",
    "landing": {
      "continueIn": "Continue in",
      "continueOnWeb": "Continue on web",
      "copied": "Link copied",
      "copyLink": "Copy link",
      "desktopBody": "You're on a desktop browser. Open the Tonnie app on your phone or continue on the web.",
      "goHome": "Go home",
      "installApp": "Install the app",
      "invalidBody": "This link isn't valid or has expired.",
      "invalidTitle": "Invalid link",
      "mobileBody": "Open this link in the Tonnie app for the best experience.",
      "openApp": "Open in app",
      "publicNote": "This page is public. Anyone with the link can view it until it expires.",
      "retryAgain": "Try again"
    },
    "openInMobile": "Open in mobile app",
    "qr": {
      "copied": "Link copied",
      "copyLink": "Copy link",
      "description": "Scan this QR code with your phone to open the Tonnie app and continue.",
      "dontHaveApp": "Don't have the app yet?",
      "note": "The link expires after the time shown above.",
      "title": "Continue on your phone"
    },
    "urlCopied": "Deep link URL copied to clipboard"
  },
  "error": {
    "goHome": "Go home",
    "pageDescription": "We're sorry for the inconvenience. Please try again or return to the home page.",
    "pageTitle": "Something went wrong",
    "retry": "Retry",
    "sectionDescription": "This section encountered an error. Try refreshing or continue with other sections.",
    "sectionTitle": "Section error",
    "tryAgain": "Try again",
    "clerkMissing": {
      "title": "Authentication service not configured",
      "body": "This build is missing EXPO_PUBLIC_CLERK_PUBLISHABLE_KEY. Reinstall a newer build from EAS, or contact support if this persists."
    }
  },
  "errorBoundary": {
    "goHome": "Go home",
    "pageEncounteredError": "This page encountered an error",
    "pageMessage": "We're sorry for the inconvenience. Please try again or return to the home screen.",
    "reloadPage": "Reload page",
    "retry": "Retry",
    "sectionError": "Section error",
    "sectionMessage": "This section encountered an error. Try refreshing or continue with other sections.",
    "somethingWentWrong": "Something went wrong",
    "tryAgain": "Try again",
    "unexpectedError": "An unexpected error occurred.",
    "appErrorTitle": "Application error"
  },
  "evidence": {
    "kind": {
      "adaptationProgress": "Adaptation progress",
      "careCheckins": "Care check-ins",
      "careOverview": "Care overview",
      "checkupProgress": "CheckUp progress",
      "checkupResults": "CheckUp results",
      "cv": "CV",
      "household": "Household",
      "mobilityDocuments": "Mobility documents",
      "mobilityPlan": "Mobility plan",
      "passportEvidence": "Passport evidence",
      "pitchVideo": "Pitch video",
      "testitResults": "TestIt results"
    },
    "redaction": {
      "reason": {
        "controllerMinimisation": "Removed by the company to keep only what it needs",
        "dataSubjectRequest": "Removed at the person’s request",
        "legalObligation": "Removed to meet a legal obligation"
      }
    },
    "retention": {
      "reason": {
        "decisionInForce": "Kept as the company’s record of a decision that is still in effect. It will be deleted on the date shown, or sooner if the relationship reaches an outcome first.",
        "engagementEnded": "Kept as the company’s record of a hiring decision, to defend or answer legal claims, until the retention period after the relationship ended.",
        "notProgressed": "Kept as the company’s record of a decision not to proceed, to defend or answer legal claims, until the retention period ends."
      },
      "until": "Kept until {{date}}",
      "noEndDate": "No end date yet — it is set when the relationship reaches an outcome."
    },
    "trigger": {
      "engagementEnd": "Relationship ended",
      "engagementStart": "Relationship started",
      "onDemand": "Saved on request",
      "sponsorshipActivation": "Sponsorship activated",
      "stageTransition": "Stage changed",
      "verdict": "TestIt decision"
    },
    "withheld": {
      "scopeNotGranted": "Not shared with this company when the decision was made"
    },
    "record": {
      "title": "Decision records",
      "description": "What your company could see about {{name}} each time it decided. A record stays exactly as it was taken — later changes to the profile do not alter it.",
      "captureNow": "Save a record now",
      "capturing": "Saving…",
      "captureSuccess": "Record saved",
      "captureRefusedEnded": "This relationship is archived or has ended, so a new record cannot be saved.",
      "captureFailed": "The record could not be saved.",
      "listLabel": "Decision records, newest first",
      "empty": "No decision records yet. A record is saved each time your company moves, decides on, sponsors or ends its relationship with this candidate.",
      "loadError": "Decision records could not be loaded.",
      "detailLoadError": "This record could not be loaded.",
      "retry": "Try again",
      "itemsTitle": "What the record holds",
      "actorBy": "By {{name}}",
      "actorSystem": "Saved automatically",
      "actorOutsideTeam": "On an action by someone outside your team",
      "decision": {
        "stageMove": "Moved from {{from}} to {{to}}",
        "stageEntered": "Entered {{to}}"
      },
      "origin": {
        "backfill": "Legacy record",
        "backfillNote": "Saved before records were kept on the server. It holds only what the browser sent at the time, and the consent in force then was not recorded."
      },
      "listTitle": "Records · newest first",
      "count_one": "{{count}} record",
      "count_other": "{{count}} records"
    },
    "item": {
      "legacy": "Sent by the browser · not verified",
      "legacyNote": "This is what the browser sent with the decision. It was never checked on the server.",
      "redact": "Remove",
      "redactAria": "Remove {{kind}} from this record",
      "redacted": "Removed from the record",
      "redactedOn": "Removed from the record on {{date}}",
      "viewerRedacted": "Some details are hidden for your role."
    },
    "redact": {
      "title": "Remove {{kind}} from this record",
      "description": "Its content is removed permanently. The record keeps a note that it was removed, when and why. This cannot be undone.",
      "reasonLabel": "Reason",
      "reasonRequired": "Choose a reason.",
      "confirm": "Remove permanently",
      "success": "Removed from the record",
      "notRedactable": "This item has nothing left to remove.",
      "failed": "The item could not be removed."
    },
    "file": {
      "open": "Open",
      "opening": "Opening…",
      "openAria": "Open {{name}}",
      "auditNote": "Each opening is logged.",
      "openFailed": "The file could not be opened.",
      "unavailable": "This file is no longer available: it was removed from the record, or the record’s retention period has ended.",
      "notInStorage": "The file was not in storage when the record was saved, so no copy is kept."
    },
    "compare": {
      "title": "At decision · Current",
      "show": "Compare with current",
      "hide": "Hide comparison",
      "atDecision": "At decision",
      "current": "Current",
      "comparedAt": "Compared {{date}}",
      "same": "Same as at decision",
      "different": "Not the same as at decision",
      "notComparable": "Not comparable",
      "currentDated": "current value dated {{date}}",
      "withheldNow": "Not currently shared with this company",
      "loadError": "The comparison could not be loaded."
    },
    "summary": {
      "nothingAtTheTime": "Nothing to record at the time",
      "none": "None recorded",
      "notScored": "Not scored",
      "percent": "{{value}}%",
      "fraction": "{{done}} of {{total}}",
      "score": "Score",
      "calculatedAt": "Calculated",
      "completedAt": "Completed",
      "progress": "Progress",
      "tasks": "Tasks",
      "documents": "Documents ready",
      "missions": "Missions",
      "wellbeing": "Wellbeing",
      "checkpoints": "Checkpoints",
      "results": "Results",
      "resultsSent": "Results sent",
      "miles": "Miles",
      "stamps": "Stamps",
      "badges": "Badges",
      "fileName": "File",
      "fileSize": "Size",
      "uploadedAt": "Uploaded",
      "members": "Members",
      "checkins": "Check-ins",
      "lastCheckin": "Last check-in",
      "nothingNow": "Nothing to show now",
      "files": "Files"
    },
    "verdict": {
      "title": "Decision history",
      "earlier": "Earlier decisions ({{count}})",
      "replacedValue": "Replaced an earlier decision: {{verdict}}",
      "replacedNotRecorded": "Any earlier decision was not recorded",
      "viewRecord": "View record",
      "loadError": "The decision history could not be loaded."
    },
    "notice": {
      "title": "Some companies keep a record",
      "introFile": "The file has left your vault. These companies made a decision about you that included it, and keep their own record of that decision:",
      "introAccount": "Your account has been deleted. These companies made a decision about you and keep their own record of it:",
      "listLabel": "Companies that keep a record",
      "what": "What",
      "until": "Until",
      "why": "Why",
      "noEndDate": "No end date yet — it is set once their decision reaches an outcome",
      "acknowledge": "Got it"
    }
  },
  "family": {
    "admin": "Admin",
    "children": "Children",
    "complete": "complete",
    "emailPlaceholder": "member@example.com",
    "enableFamilyPlan": "Enable Family plan",
    "familyPlan": "Family plan",
    "hasPartner": "Has partner",
    "hasPets": "Has pets",
    "householdConfig": "Your household configuration",
    "householdContext": "Household context",
    "invalidEmail": "Please enter a valid email address",
    "inviteFamilyMember": "Invite Family member",
    "inviteMember": "Invite member",
    "inviteSent": "Invitation sent to {{email}}",
    "journeys": "Journeys",
    "manageMembers": "Manage members",
    "master": "Master",
    "member": "Member",
    "members": "Members",
    "membersAccess": "Family members with access to shared journeys",
    "noMembers": "No family members added yet",
    "pendingName": "Pending",
    "removeMember": "Remove member",
    "removeMemberConfirm": "Remove this family member?",
    "role": "Role",
    "sendInvitation": "Send an invitation to join your family plan",
    "sendInvite": "Send invite",
    "shareJourney": "Share your journey with family members and track progress together.",
    "sharedJourneys": "Shared journey instances",
    "sharedJourneysSubtitle": "Journeys shared with family members",
    "title": "Family program",
    "invite": {
      "emailPlaceholder": "member@example.com"
    }
  },
  "familyProgram": {
    "accepted": "Accepted",
    "accessRevoked": "Access revoked successfully",
    "accessRules": "Access rules",
    "accessRulesDesc": "Who can access what features",
    "addFamilyMember": "Add Family member",
    "addMember": "Add member",
    "care": "Care",
    "careRule": "Only Family Master can answer Care checkpoints. Companion has no access.",
    "career": "Career & opportunities",
    "careerRule": "Family Master and Companion can access their own Career & Opportunities",
    "checkup": "CheckUp",
    "checkupRule": "Family Master and Companion can complete their own CheckUp assessment",
    "children": "Children",
    "childrenCount": "Children count",
    "complete": "Complete",
    "copilotTip": "CoPilot tip",
    "description": "Manage household access and permissions",
    "disabled": "Disabled",
    "docs": "Docs",
    "docsComplete": "Docs complete",
    "documents": "Documents",
    "documentsIncompleteMessage": "{{name}}'s documents are incomplete. Upload the required documents to proceed with the visa application.",
    "editMember": "Edit member",
    "educationSupport": "Education support",
    "educationSupportDesc": "School placement assistance, language classes, and educational resources.",
    "emailAddress": "Email address",
    "enabled": "Enabled",
    "familyAddonRequired": "Family add-on required",
    "familyAddonRequiredDesc": "Family Program requires Pro Journey, Journey Pack, or sponsored plan. Upgrade to enable Family Program.",
    "familyAdmin": "Family admin",
    "familyAdminDesc": "Can manage family members and settings",
    "familyMaster": "Family master",
    "familyMember": "Family member",
    "familyMemberDesc": "Family member with Citizen access only",
    "familySponsored": "Family sponsored",
    "familySupportBenefits": "Family support benefits",
    "householdContext": "Household context",
    "householdContextDesc": "Your household configuration",
    "householdCouple": "Couple",
    "householdCouplePets": "Couple + pets",
    "householdFamily": "Family",
    "householdFamilyPets": "Family + pets",
    "householdReadinessOverTime": "Household readiness progress over time",
    "householdSingle": "Single",
    "householdSingleParent": "Single parent",
    "householdSinglePets": "Single + pets",
    "householdType": "Household type",
    "incomplete": "Incomplete",
    "invalidEmail": "Please enter a valid email address",
    "inviteError": "Failed to send invite",
    "inviteMember": "Invite member",
    "inviteMemberDesc": "Invite a family member to join your journey",
    "inviteNote": "Family members will receive an email invitation to join your journey. They will have access to QultureUp content and can track their own progress.",
    "inviteSent": "Invitation sent to {{email}}",
    "journeyInstance": "Journey instance",
    "management": "Management",
    "members": "Family members",
    "membersDescription": "Manage access for family members",
    "milesAndLessonsPerMember": "Miles and lessons completed per member",
    "monitoring": "Care",
    "monitoringSection": {
      "achievements": "Achievements",
      "acrossAllMembers": "across all members",
      "active": "active",
      "badgesEarned": "badges earned",
      "careNote": "Care checkpoints are answered by Family Master on behalf of the household",
      "checkup": "CheckUp",
      "dayStreak": "day streak",
      "events": "events",
      "householdStability": "Household stability",
      "householdStabilityDesc": "Current Care pillar scores (household-aware, answered by Family Master)",
      "lessons": "lessons",
      "lessonsCompleted": "lessons completed",
      "memberProgress": "Member progress",
      "memberProgressDesc": "Individual progress tracking for each family member",
      "memberReadiness": "Member readiness",
      "noActivity": "No activity yet",
      "noMembersToMonitor": "No family members to follow yet",
      "noReadinessData": "No readiness data available for Companion",
      "noRecentActivity": "No recent activity",
      "notAvailable": "Not available",
      "progressTrends": "Progress trends",
      "progressTrendsDesc": "Visualize family progress over time",
      "qultureupMiles": "QultureUp Miles",
      "qultureupProgress": "QultureUp progress",
      "readinessEvolution": "Readiness evolution",
      "recentActivity": "Recent activity",
      "teleportalProgress": "TelePortal",
      "totalAchievements": "Total achievements",
      "totalMembers": "Total members",
      "totalMiles": "Total Miles",
      "totalQultureupMiles": "Total QultureUp Miles"
    },
    "noJourneyInstance": "No active journey",
    "noMembers": "No family members invited yet",
    "noSharedJourneys": "No shared journey instances",
    "passport": "Passport",
    "passportRule": "Each member sees their own filtered view. Companion accesses via Tonnie Citizen mobile app.",
    "pending": "Pending",
    "petsPresence": "Pets",
    "pillar": {
      "housingStability": "Housing stability",
      "schoolingChildcare": "Schooling & childcare",
      "wellbeing": "Wellbeing",
      "workFit": "Work fit"
    },
    "purchaseFamilyAddon": "Purchase Family add-on",
    "qultureup": "QultureUp",
    "qultureupPercent": "QultureUp %",
    "qultureupRule": "All family members access via Tonnie Citizen mobile app (Companion cannot access via Citizen Web)",
    "readinessPercent": "Readiness %",
    "removeError": "Failed to remove member",
    "removeMember": "Remove member",
    "revokeAccess": "Revoke access",
    "role": "Role",
    "schoolReady": "School ready",
    "sendInvite": "Send invite",
    "servicesAvailable": "Services available for your family",
    "sharedJourneyInstances": "Shared journey instances",
    "sharedJourneyInstancesDesc": "Journey instances shared with family members",
    "spouseEmployment": "Spouse employment",
    "spouseEmploymentDesc": "Job search support, networking opportunities, and work permit guidance.",
    "status": "Family program status",
    "statusDescription": "Current status of your Family Program",
    "teleportal": "TelePortal",
    "teleportalRule": "Only Family Master can control TelePortal tasks. Companion has no access.",
    "title": "Family program",
    "totalMiles": "Total Miles",
    "tryAgainLater": "Please try again later",
    "unableToLoad": "Unable to load family members",
    "viewDetails": "View details",
    "visa": "Visa",
    "visaApproved": "Approved",
    "visaDenied": "Denied",
    "visaInProgress": "In progress",
    "visaNotStarted": "Not started",
    "visaStatus": "Visa status",
    "visasApproved": "Visas approved",
    "wellbeingCare": "Wellbeing Care",
    "wellbeingCareDesc": "Healthcare enrollment, mental health support, and social integration.",
    "yearsOld": "{{age}} years old",
    "you": "You",
    "sharedJourneyCount_one": "{{count}} shared journey",
    "sharedJourneyCount_other": "{{count}} shared journeys"
  },
  "feedback": {
    "additionalFeedbackHint": "You can provide detailed feedback, attach screenshots, or files to help us understand your experience better.",
    "attachFiles": "Attach files",
    "attachFilesOptional": "Attach files (optional)",
    "category": {
      "bug": {
        "description": "Something isn't working",
        "label": "Bug report"
      },
      "other": {
        "description": "Something else",
        "label": "Other"
      },
      "praise": {
        "description": "I love this feature",
        "label": "Praise"
      },
      "question": {
        "description": "I need help",
        "label": "Question"
      },
      "suggestion": {
        "description": "I have an idea",
        "label": "Suggestion"
      }
    },
    "categoryDescription": "Select the category that best describes your feedback",
    "categoryQuestion": "What type of feedback is this?",
    "characterCount": "{{current}} / {{max}} characters",
    "characters": "{{current}}/{{max}} characters",
    "close": "Close feedback",
    "context": {
      "hero": "Hero",
      "heroPlaceholder": "e.g., CheckUp, TelePortal",
      "notDetected": "No context detected",
      "page": "Page",
      "pagePlaceholder": "e.g., /dashboard, /checkup"
    },
    "contextInfo": "Context information",
    "contextSaved": "Context information saved",
    "detailsDescription": "Please provide details about your feedback",
    "detailsPlaceholder": "Describe your feedback, suggestion, or issue...",
    "detailsQuestion": "Tell us more",
    "editContext": "Edit",
    "fileSizeError": "File size exceeds the maximum limit of {{maxSize}}",
    "fileSizeLimit": "Files must be under 20MB",
    "fileUploadDescription": "Add screenshots, PDFs, or other files (up to 20MB each) to help us understand your feedback better.",
    "optional": "Optional",
    "placeholder": "Share your thoughts...",
    "pleaseDescribe": "Please describe your feedback in detail",
    "privacyNote": "Your feedback is anonymous and helps us improve Tonnie",
    "rating": {
      "1": "Very dissatisfied",
      "2": "Dissatisfied",
      "3": "Neutral",
      "4": "Satisfied",
      "5": "Very satisfied",
      "veryDissatisfied": "Very dissatisfied",
      "dissatisfied": "Dissatisfied",
      "neutral": "Neutral",
      "satisfied": "Satisfied",
      "verySatisfied": "Very satisfied"
    },
    "ratingDescription": "Rate your overall satisfaction",
    "ratingQuestion": "How was your experience?",
    "selectRatingAndCategory": "Please select both rating and category",
    "submit": "Submit feedback",
    "submitError": "Failed to submit feedback. Please try again.",
    "submitFeedback": "Submit feedback",
    "submitSuccess": "Thank you! Your feedback has been submitted.",
    "submitted": "Your feedback has been submitted.",
    "submitting": "Submitting...",
    "subtitle": "Help us improve your experience",
    "successMessage": "We appreciate you taking the time to help us improve Tonnie. Your feedback has been received and will be reviewed by our team.",
    "successTitle": "Thank you for your feedback!",
    "tellUsMore": "Tell us more",
    "thankYou": "Thank you!",
    "thankYouMessage": "Your feedback helps us improve Tonnie.",
    "title": "Share feedback",
    "toggle": "Send feedback",
    "totalFileSize": "Total: {{size}} / {{maxSize}}",
    "totalSize": "Total: {{size}} / 20MB max",
    "uploadFiles": "Upload files",
    "validationError": "Please complete all required fields",
    "attachImages": "Attach screenshots",
    "removeImage": "Remove {{name}}",
    "aria": {
      "description": "Feedback description",
      "uploadFiles": "Upload files",
      "removeFile": "Remove {{name}}",
      "satisfactionRating": "Satisfaction rating",
      "ratingOption": "{{label}} – {{value}} out of 5"
    }
  },
  "form": {
    "addressSearch": {
      "city": "City: ",
      "country": "Country: ",
      "postalCode": "Postal code: "
    },
    "datePicker": {
      "cancel": "Cancel",
      "done": "Done",
      "months": [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "placeholder": "Select date",
      "selectDate": "Select date",
      "day": "Day",
      "month": "Month",
      "year": "Year"
    },
    "phoneCountryCode": {
      "clearSearch": "Clear search",
      "noCountriesFound": "No countries found",
      "placeholder": "+XX",
      "searchPlaceholder": "Search country or code...",
      "selectCountryCode": "Select country code"
    },
    "countrySelect": {
      "searchPlaceholder": "Search countries"
    },
    "countryList": {
      "remove": "Remove {{country}}"
    },
    "timePicker": {
      "hour": "Hour",
      "minute": "Minute"
    }
  },
  "gating": {
    "upgrade": "Upgrade",
    "lockedLabel": "Locked",
    "upgradeToUnlock": "Upgrade to unlock",
    "unlockJourney": {
      "title": "Unlock your Journey",
      "qultureup": "To unlock this QultureUp mission, open the Web Portal and unlock your journey for full access.",
      "teleportal": "To unlock this TelePortal task, open the Web Portal and unlock your journey for full access."
    },
    "upgradeBanner": {
      "passport": "Upgrade to Pro to unlock passport analytics, export, and sharing features.",
      "qultureup": "Upgrade to Pro to access all worlds, lessons, and creator content in QultureUp.",
      "teleportal": "Upgrade to Pro to upload documents, validate with AI review, and unlock all TelePortal phases."
    }
  },
  "heroes": {
    "cards": {
      "actionRequired": "Action required",
      "care": {
        "description": "Wellbeing & support",
        "title": "Care"
      },
      "checkup": {
        "description": "Your readiness assessment",
        "title": "CheckUp"
      },
      "feedbackPillars": "Feedback pillars",
      "improving": "Improving",
      "inProgress": "In progress",
      "level2Basics": "Level 2 basics",
      "page": "Page",
      "progress": "Progress",
      "qultureup": {
        "description": "Cultural learning",
        "title": "QultureUp"
      },
      "readinessScore": "Readiness score",
      "teleportal": {
        "description": "Legal & travel tasks",
        "title": "TelePortal"
      },
      "visaProcess": "Visa process"
    },
    "care": {
      "description": "Post-arrival checkpoints and support",
      "title": "Care"
    },
    "career": {
      "description": "Opportunities & CV builder",
      "title": "Career"
    },
    "checkup": {
      "description": "Pre-immigration readiness assessment",
      "readinessScore": "Readiness score",
      "title": "CheckUp"
    },
    "passport": {
      "badges": "Badges",
      "description": "Your journey timeline",
      "stamps": "Stamps",
      "timeline": "Timeline",
      "title": "Passport"
    },
    "qultureup": {
      "description": "Cultural Adaptation",
      "level2Basics": "Level 2: Basics",
      "title": "QultureUp"
    },
    "teleportal": {
      "actionRequired": "Action required",
      "description": "Relocation & Mobility",
      "title": "TelePortal",
      "visaProcess": "Visa process"
    },
    "vault": {
      "allDocuments": "All documents",
      "category": {
        "care": {
          "subtopics": {
            "feedback": "Feedback",
            "supportRequests": "Support requests",
            "wellbeingReports": "Wellbeing reports"
          }
        },
        "career": {
          "subtopics": {
            "applications": "Applications",
            "certificates": "Certificates",
            "generatedCVs": "Generated CVs"
          }
        },
        "checkup": {
          "subtopics": {
            "certificates": "Certificates",
            "cvResume": "CV / Resume",
            "languageTests": "Language tests",
            "linkedin": "LinkedIn",
            "pitchVideo": "Pitch video",
            "profilePhoto": "Profile photo"
          }
        },
        "other": "Other",
        "passport": {
          "subtopics": {
            "achievements": "Achievements",
            "milestones": "Milestones",
            "stamps": "Stamps"
          }
        },
        "qultureup": {
          "subtopics": {
            "achievements": "Achievements",
            "certificates": "Certificates",
            "courseMaterials": "Course materials"
          }
        },
        "teleportal": {
          "subtopics": {
            "legalTrack": "Legal track",
            "setupTrack": "Setup track",
            "travelTrack": "Travel track"
          }
        }
      },
      "category.care.subtopics.feedback": "Feedback",
      "category.care.subtopics.supportRequests": "Support requests",
      "category.care.subtopics.wellbeingReports": "Wellbeing reports",
      "category.career.subtopics.applications": "Applications",
      "category.career.subtopics.certificates": "Certificates",
      "category.career.subtopics.generatedCVs": "Generated CVs",
      "category.checkup.subtopics.certificates": "Certificates",
      "category.checkup.subtopics.cvResume": "CV & resume",
      "category.checkup.subtopics.languageTests": "Language tests",
      "category.checkup.subtopics.linkedin": "LinkedIn",
      "category.checkup.subtopics.pitchVideo": "Pitch video",
      "category.checkup.subtopics.profilePhoto": "Profile photo",
      "category.passport.subtopics.achievements": "Achievements",
      "category.passport.subtopics.milestones": "Milestones",
      "category.passport.subtopics.stamps": "Stamps",
      "category.qultureup.subtopics.achievements": "Achievements",
      "category.qultureup.subtopics.certificates": "Certificates",
      "category.qultureup.subtopics.courseMaterials": "Course materials",
      "category.teleportal.subtopics.legalTrack": "Legal track",
      "category.teleportal.subtopics.setupTrack": "Setup track",
      "category.teleportal.subtopics.travelTrack": "Travel track",
      "chooseCategoryDesc": "Select the hero this document belongs to.",
      "chooseCategoryTitle": "Choose a category",
      "detail": {
        "by": "By",
        "certification": "Certification",
        "details": "Details",
        "documentIdentity": "Document identity",
        "expires": "Expires",
        "issuingAuthority": "Issuing authority",
        "location": "Location",
        "size": "Size",
        "status": "Status",
        "tags": "Tags",
        "type": "Type",
        "uploaded": "Uploaded",
        "validation": "Validation",
        "validityPeriod": "Validity period"
      },
      "documents": "documents",
      "downloadAll": "Download all",
      "downloadSelected": "Download {{count}}",
      "downloadToView": "Download to view",
      "selectDocument": "Select document",
      "emptyState": "Your documents from all heroes — CheckUp, TelePortal, QultureUp, Care, and Passport — will appear here",
      "fetchError": "Failed to load vault",
      "filter": {
        "allStatus": "All status",
        "certification": {
          "label": "Certification",
          "none": "No certification"
        },
        "clear": "Clear",
        "expired": "Expired",
        "expiringSoon": "Expiring soon",
        "expiry": "Expiry",
        "sort": "Sort",
        "status": "Status",
        "tags": "Tags",
        "valid": "Valid"
      },
      "noDocuments": "No documents yet",
      "noResults": "No documents found",
      "previewError": "Preview could not be loaded",
      "previewUnavailable": "Preview not available for this file type",
      "removeConfirmDesc": "This action cannot be undone. The document will be permanently removed.",
      "removeDocument": "Remove document?",
      "removeLinkedTaskWarning": "This document is linked to a TelePortal task. Removing it may affect task completion.",
      "searchPlaceholder": "Search documents...",
      "sort": {
        "largestFirst": "Largest first",
        "nameAZ": "Name A-Z",
        "nameZA": "Name Z-A",
        "newestFirst": "Newest first",
        "oldestFirst": "Oldest first",
        "smallestFirst": "Smallest first"
      },
      "status": {
        "all": "All status",
        "pending": "Pending",
        "rejected": "Rejected",
        "uploaded": "Uploaded",
        "validated": "Validated"
      },
      "subtitle": "All your journey documents in one secure place",
      "tag": {
        "approved": "Approved",
        "archived": "Archived",
        "expiringSoon": "Expiring soon",
        "important": "Important",
        "pendingReview": "Pending review",
        "urgent": "Urgent"
      },
      "tag.approved": "Approved",
      "tag.archived": "Archived",
      "tag.expiringSoon": "Expiring soon",
      "tag.important": "Important",
      "tag.pendingReview": "Pending review",
      "tag.urgent": "Urgent",
      "title": "Vault",
      "track": {
        "legal": "Legal",
        "setup": "Setup",
        "travel": "Travel"
      },
      "track.legal": "Legal",
      "track.setup": "Setup",
      "track.travel": "Travel",
      "verifiedByTonnie": "Verified by Tonnie",
      "view": {
        "grid": "Grid view",
        "list": "List view",
        "timeline": "Timeline view"
      },
      "viewDetails": "View details",
      "documentTypes": {
        "passport": "Passport",
        "birth_certificate": "Birth certificate",
        "marriage_certificate": "Marriage certificate",
        "criminal_record": "Criminal record",
        "employment_contract": "Employment contract",
        "salary_proof": "Salary proof",
        "proof_of_income": "Proof of income",
        "bank_statements": "Bank statements",
        "school_records": "School records",
        "drivers_license": "Driver's license",
        "travel_insurance": "Travel insurance",
        "health_insurance_policy": "Health insurance",
        "lease_agreement": "Lease agreement",
        "proof_of_address": "Proof of address",
        "pet_passport": "Pet passport",
        "certified_translation": "Certified translation",
        "sponsor_letter": "Sponsor letter"
      },
      "documentActions": "Document actions",
      "searchLabel": "Search documents"
    }
  },
  "invitations": {
    "error": {
      "acceptFailedTitle": "We couldn't accept this invitation",
      "alreadyAcceptedDescription": "This invitation has already been accepted by another account.",
      "alreadyAcceptedTitle": "Already accepted",
      "backHome": "Back to home",
      "declinedDescription": "This invitation was declined. Ask {{company}} to send a new one if that was a mistake.",
      "declinedTitle": "Invitation declined",
      "emailMismatchDescription": "This invitation is for {{email}}. Sign out and sign in with that address to accept.",
      "emailMismatchTitle": "Wrong account",
      "emailUnverifiedDescription": "The address this invitation was sent to is on your account but has not been verified yet.",
      "emailUnverifiedTitle": "Verify this address first",
      "expiredDescription": "Ask the company you've been talking with to send a fresh invitation.",
      "expiredTitle": "This invitation has expired",
      "invalidLinkDescription": "This link is missing the invitation token. Check the email you received and try again.",
      "invalidLinkTitle": "Invalid invitation link",
      "notFoundDescription": "The link may be incomplete. Make sure you've used the most recent email.",
      "notFoundTitle": "We couldn't find that invitation",
      "revokedDescription": "The company has withdrawn this invitation. Reach out to them if you think this is a mistake.",
      "revokedTitle": "This invitation was revoked",
      "tryAgain": "Please try again in a moment.",
      "wrongPortalDescription": "This invitation is for a Tonnie citizen account. Sign in with your citizen account to open it.",
      "wrongPortalTitle": "Use your citizen account",
      "requestNotYoursTitle": "This request is for another account",
      "requestNotYoursDescription": "Sign in with the account this company works with to answer it.",
      "requestClosedTitle": "This request can no longer be answered",
      "requestClosedDescription": "Your relationship with this company is no longer active, so nothing more can be shared with it."
    },
    "preview": {
      "acceptCta": "Accept invitation",
      "accepting": "Accepting…",
      "branch": "Branch",
      "declineCta": "Decline",
      "declining": "Declining…",
      "destination": "Destination",
      "emailHint": "This invitation is for {{email}}",
      "expires": "This invitation expires on {{date}}",
      "headline": "You've been invited",
      "invitingYou": "Invitation from",
      "loading": "Loading your invitation…",
      "location": "Location",
      "opportunity": "Opportunity",
      "signInCta": "Sign in to accept",
      "signUpCta": "Sign up to accept",
      "subheadline": "{{company}} would like you to take a CheckUp to explore an international opportunity. It's free and takes about 20 minutes.",
      "subheadlineNamed": "Hi {{firstName}} — {{company}} would like you to take a CheckUp to explore an international opportunity. It's free and takes about 20 minutes.",
      "subheadlineTestit": "{{company}} would like you to complete a few specific tests to explore an international opportunity. It's free, and your results are reusable.",
      "subheadlineTestitNamed": "Hi {{firstName}} — {{company}} would like you to complete a few specific tests to explore an international opportunity. It's free, and your results are reusable.",
      "testitTestsLabel": "What you'll complete"
    },
    "identity": {
      "addEmailBody": "{{company}} sent this invitation to {{email}}. Add that address to your account and verify it, and you can accept without starting over.",
      "addEmailCta": "Add and verify this address",
      "addEmailError": "We couldn't add that address. Try again in a moment.",
      "addEmailTitle": "This invitation is for a different address",
      "cancelCta": "Cancel",
      "codeInvalid": "That code is not right. Check it and try again.",
      "codeLabel": "6-digit code",
      "codeSentBody": "We sent a 6-digit code to {{email}}. Enter it below to finish verifying.",
      "codeSentHint": "Sent to {{email}}. It expires in a few minutes.",
      "codeSentTitle": "Check your inbox",
      "invitedAddress": "Invitation sent to",
      "sendCodeCta": "Send me a code",
      "sending": "Sending…",
      "signedInAs": "You are signed in as",
      "switchAccountCta": "Sign in with a different account",
      "switchAccountHint": "You will come back to this invitation after signing in.",
      "tryAgainCta": "Try again",
      "unverifiedBody": "{{email}} is already on your account but has not been verified. {{company}} sent this invitation to it, so verifying proves it is yours.",
      "unverifiedTitle": "Verify this address to continue",
      "verifyCta": "Verify and continue",
      "verifyError": "We couldn't verify that address. Try again in a moment.",
      "verifying": "Verifying…"
    },
    "card": {
      "eyebrow": "Invitation",
      "titleCheckup": "{{company}} invited you to a CheckUp",
      "titleTestit": "{{company}} asked you for a few tests",
      "detail": "Sent to {{email}} · relocation to {{country}}",
      "detailNoCountry": "Sent to {{email}}",
      "expires": "Expires {{date}}",
      "review": "Review invitation",
      "notNow": "Not now",
      "decline": "Decline",
      "actionFailed": "That didn't go through. Check your connection and try again.",
      "declineTitle": "Decline {{company}}'s invitation?",
      "declineBody": "{{company}} will see that you declined, and this invitation can't be used again.",
      "declineConfirm": "Decline invitation",
      "declineCancel": "Keep it"
    },
    "review": {
      "title": "Join {{company}}",
      "bodyCheckup": "{{company}} asks you to take a CheckUp for your relocation to {{country}}.",
      "bodyCheckupNoCountry": "{{company}} asks you to take a CheckUp.",
      "accept": "Accept invitation",
      "accepting": "Accepting…",
      "residenceBody": "Your journey with {{company}} starts from here, and opens the moment you accept.",
      "deferredUntil": "You put this off for now. It waits here until you decide, and comes back to Home on {{date}}."
    },
    "claim": {
      "title": "That address has its own Tonnie account",
      "subtitle": "{{email}} belongs to another Tonnie account.",
      "body": "If that account is yours too, you can accept the invitation from {{company}} here. We'll send a code to that address to confirm it's yours.",
      "sendCta": "Send me a code",
      "sending": "Sending…",
      "switchInstead": "Sign in with that account instead",
      "codeSentBody": "We sent a 6-digit code to {{email}}. It expires in {{minutes}} minutes.",
      "resendCta": "Send a new code",
      "resendIn": "Send a new code in {{seconds}} s",
      "codeWrong_one": "That code isn't right. {{count}} try left.",
      "codeWrong_other": "That code isn't right. {{count}} tries left.",
      "codeExpired": "That code has expired or been used up. Send a new one.",
      "tooManyCodes": "We've already sent several codes. Try again later.",
      "noOtherAccount": "No other Tonnie account uses this address now. Add it to this account instead.",
      "failed": "Something went wrong. Please try again.",
      "retireNote": "{{email}} is confirmed as yours. Your other Tonnie account with this address holds nothing, so it will be closed when you accept. You'll have one account.",
      "keptNote": "{{email}} is confirmed as yours. Your other Tonnie account with this address keeps its journey, and you can still sign in to it."
    },
    "choice": {
      "checking": "Checking your journeys…",
      "loadFailed": "We couldn't load your journeys. Try again before accepting.",
      "legend": "Which journey do you share with {{company}}?",
      "route": "{{origin}} → {{destination}}",
      "companyJourney": "{{company}} already follows you on this journey",
      "sharedWith": "Also shared with {{companies}}",
      "checkupShared": "{{company}} will see your CheckUp from {{date}}",
      "newTitle": "A new journey for {{company}}",
      "newBody": "Starts fresh: {{company}} sees only what you do on it from now on.",
      "newCapped_one": "You already have {{count}} journey on this route — the most you can hold. Archive it to start another.",
      "newCapped_other": "You already have {{count}} journeys on this route — the most you can hold. Archive one to start another.",
      "newOnly": "We'll start a new journey to {{country}} for {{company}}.",
      "newOnlyNoCountry": "We'll start a new journey for {{company}}.",
      "blocked_one": "Your journey on this route is another company's, and you already hold {{count}} — the most a route can have. Archive one to accept {{company}}'s invitation.",
      "blocked_other": "Your journeys on this route are other companies', and you already hold {{count}} — the most a route can have. Archive one to accept {{company}}'s invitation."
    },
    "list": {
      "title": "{{company}} invited you",
      "deferredUntil": "Put off until {{date}}",
      "expires": "Open until {{date}}",
      "openHint": "Opens the invitation to accept or decline it"
    },
    "request": {
      "eyebrow": "Request",
      "titleCheckup": "{{company}} asks to see your CheckUp score",
      "titleTests": "{{company}} asks to see your results for {{tests}}",
      "cardBody": "Nothing is shared until you say so. Review what they would see, then decide.",
      "bodyCheckupScored": "Your score is ready. Nothing is shared until you say so.",
      "bodyCheckupPending": "If you share, they see your score once your CheckUp is calculated. Nothing is shared until you say so.",
      "bodyTests": "Results you already have are reused. Nothing is shared until you say so.",
      "willSeeTitle": "If you share, {{company}} sees",
      "wontSeeTitle": "{{company}} still does not see",
      "new": "New",
      "share": "Share",
      "sharing": "Sharing…",
      "declineTitle": "Decline {{company}}’s request?",
      "declineBody": "{{company}} is told. Nothing else changes: they keep seeing only what you shared before.",
      "declineConfirm": "Decline request",
      "sharedToast": "Shared with {{company}}",
      "sharedToastBody": "They can see it now. You can change what they see any time in My journeys.",
      "declinedToast": "You declined {{company}}’s request",
      "listTitle": "{{company}} asks to see more",
      "kindCheckup": "Your CheckUp score",
      "kindTests": "Your test results",
      "signInBody": "Sign in to the account {{company}} works with to see exactly what they ask, and decide.",
      "signIn": "Sign in",
      "notWaitingTitle": "This request is not waiting for you",
      "notWaitingBody": "It was already answered or withdrawn, or it is for another account."
    },
    "testit": {
      "title": "{{company}} asks for your test results",
      "body": "{{company}} asks you for the tests below. You take the ones you have not done yet after you accept.",
      "bodyAllDone": "You have already done every test {{company}} asks for. There is nothing new to take.",
      "listLabel": "What {{company}} asks for",
      "testDone": "Already done — your result from {{date}} will be shared",
      "testPending": "To take after you accept",
      "scopeTestsOnly": "Accepting shares the results of these tests with {{company}}. It does not share your CheckUp.",
      "scopeUnchanged": "Accepting adds the results of these tests. {{company}} keeps seeing what you already share with it.",
      "accept": "Accept and take the tests",
      "acceptShare": "Share my results",
      "confirmTitle": "Your results are shared with {{company}}",
      "confirmBody": "{{company}} can now see your results for these tests. There is nothing left for you to take.",
      "confirmDone": "Done"
    }
  },
  "journey": {
    "arrives": "Arrives {{date}}",
    "buildFirstJourney": "Build your first international journey to get started",
    "buildYourFirstJourney": "Build your first journey",
    "builder": {
      "title": "Journey builder",
      "createErrorFallback": "Failed to create journey",
      "notAuthenticated": "You must be signed in to continue",
      "missingCountries": "We could not tell where your journey starts and ends. Please choose your current country and your destination, then try again.",
      "alsoToDestination": "You also have a journey to {{destination}} from {{origins}}.",
      "advice": {
        "title": "You already have this route",
        "body": "You already have a journey from {{origin}} to {{destination}}. Open it, or build another.",
        "capTitle": "This route is full",
        "capBody_one": "You already have {{count}} journey from {{origin}} to {{destination}} — the most a route can hold. Open it.",
        "capBody_other": "You already have {{count}} journeys from {{origin}} to {{destination}} — the most a route can hold. Open one of them.",
        "listLabel": "Your journeys on this route",
        "open": "Open",
        "buildAnother": "Build another",
        "notNow": "Not now"
      }
    },
    "daysOnJourney": "Days on journey",
    "details": {
      "amount": "Amount",
      "featuresIncluded": "Features included",
      "paymentInfo": "Payment info",
      "scenario": "Scenario",
      "scenario_already_abroad": "Already abroad",
      "scenario_integration_only": "Integration only",
      "scenario_pre_immigration": "Pre-Immigration",
      "scenario_relocation_only": "Relocation only",
      "status": "Status",
      "title": "Journey details",
      "type": "Type"
    },
    "expires": "Expires",
    "family": "Family",
    "govSponsored": "Gov. sponsored",
    "guard": {
      "buildDescription": "Before you can access this feature, you need to create your international career journey. This takes just a few minutes.",
      "buildFirst": "Build your first journey",
      "buildNew": "Build new journey",
      "buildTitle": "Build your journey first",
      "builderHint": "The journey builder will help you set up your origin, destination, and career goals.",
      "expiredDescription": "This journey has reached the end of its plan. Renew or upgrade to continue using your heroes.",
      "expiredTitle": "Your journey has expired",
      "goToDashboard": "Go to dashboard",
      "loadErrorDescription": "Something went wrong while loading your journeys. Your data is safe — please try again.",
      "loadErrorTitle": "We couldn't load your journeys",
      "noActiveDescription": "All your journeys may be paused, expired, or completed. Select one from the header or build a new one.",
      "noActiveTitle": "No active journey",
      "pausedDescription": "Access is temporarily paused — usually because a sponsor's payment didn't go through, or the journey was paused by an admin. Reach out to your sponsor or check billing to resume.",
      "pausedTitle": "Your journey is paused",
      "pendingSetupDescription": "We've reserved this journey for you. Tell us where you are moving from and it opens right away.",
      "pendingSetupTitle": "Finish setting up your journey",
      "renewJourney": "Renew",
      "selectDescription": "You need to select an active journey instance to access this feature. Use the journey selector in the header above to choose one.",
      "selectTitle": "Select a journey",
      "selectorHint": "Tip: Use the journey selector in the top navigation bar to switch between your journeys.",
      "unavailableDescription": "This journey is no longer accessible. Pick another one or build a new journey to continue.",
      "unavailableTitle": "Journey unavailable",
      "viewBilling": "View billing",
      "errorTitle": "Couldn't load your journeys",
      "errorDescription": "We could not reach the server. Check your connection and try again.",
      "openSelector": "Open journey selector",
      "openJourney": "Open my journey"
    },
    "loadingJourneys": "Loading journeys…",
    "milesToGo": "Miles to go",
    "nextMilestone": "Next milestone",
    "pro": "Pro",
    "progress": "Progress",
    "selectJourney": "Select journey",
    "selector": {
      "andMore_one": "and 1 more",
      "andMore_other": "and {{count}} more",
      "basicAccess": "Basic access",
      "buildFirst": "Build your first journey",
      "buildNew": "Build new journey",
      "buildOne": "Build a journey",
      "buildOneShort": "Build journey",
      "companiesHint": "Shows every company on this journey",
      "companiesTitle": "Companies on this journey",
      "company": "Company",
      "expired": "Expired",
      "expiresOn": "Expires",
      "family": "Family",
      "from": "from {{country}}",
      "fromUnknown": "From unknown",
      "fullAccess": "Full access",
      "government": "Government",
      "invitedBy": "Invited by {{company}}",
      "invitedOnly": "Invited only",
      "loadingJourneys": "Loading journeys…",
      "locked": "Locked",
      "noJourneys": "No journeys yet",
      "noJourneysDescription": "You don't have any journeys yet. Start one to begin your relocation.",
      "noJourneysTitle": "No journeys yet",
      "paused": "Paused",
      "setupPending": "Setup pending",
      "sponsored": "Sponsored",
      "unlocked": "Unlocked",
      "sharedWith": "Shared with {{company}}"
    },
    "sponsored": "Sponsored",
    "status": {
      "active": "Active",
      "completed": "Completed",
      "draft": "Draft",
      "expired": "Expired",
      "limited": "Limited",
      "paused": "Paused"
    },
    "statusActive": "Active",
    "statusExpired": "Expired",
    "statusLimited": "Limited",
    "switchBetweenJourneys": "Switch between your active journeys",
    "yourJourneyTo": "Your journey to {{country}}",
    "originPending": "Origin pending",
    "invited": "Invited",
    "yourJourneyToUnknown": "Your journey",
    "relationship": {
      "live": "Active",
      "archivedByCompany": "Archived by the company",
      "ended": "Ended",
      "left": "You left"
    },
    "manage": {
      "accessUntil": "Access until {{date}}",
      "activeDescription": "Each journey keeps its own CheckUp, TelePortal and Care progress. Your current journey is the one your dashboard shows.",
      "activeSection": "Active journeys",
      "archive": "Archive",
      "archiveCanRestore": "You can restore it from this page whenever you want.",
      "archiveConfirm": "Archive journey",
      "archiveDialogDescription": "It leaves your list of journeys. Nothing in it is lost.",
      "archiveDialogTitle": "Archive your journey to {{destination}}?",
      "archiveFailed": "We couldn’t archive this journey. Please try again.",
      "archiveKeepsProgress": "Nothing is deleted — its CheckUp, TelePortal and Care progress stays with it.",
      "archiveSwitchesCurrent": "This is your current journey, so Tonnie switches you to another one if you have one.",
      "archivedDescription": "Archived journeys keep everything. Restore one to pick it up where you left off.",
      "archivedOn": "Archived on {{date}}",
      "archivedSection": "Archived",
      "archivedToastBody": "Your journey to {{destination}} is archived. Nothing was deleted.",
      "archivedToastTitle": "Journey archived",
      "blockedLiveProgramBody": "Leave the programme first — that ends your relationship with the company — and then you can archive this journey.",
      "blockedLiveProgramTitle": "A company is still running this programme",
      "blockedSponsorshipBody": "The sponsorship has to end before this journey can be archived.",
      "blockedSponsorshipTitle": "This journey is sponsored",
      "continueJourney": "Continue journey",
      "current": "Current",
      "emptyWithArchived": "You have no active journey. Start a new one, or restore one you archived.",
      "leaveConfirm": "Leave programme",
      "leaveDialogTitle": "Leave {{company}}’s programme?",
      "leaveFailed": "We couldn’t take you out of the programme. Please try again.",
      "leaveFinerHint": "Only want to hide some things? Choose exactly what they can see instead.",
      "leaveKeepsJourney": "Your journey, its progress and your documents stay yours.",
      "leaveProgramme": "Leave programme",
      "leaveCompanyProgramme": "Leave {{company}}’s programme",
      "leaveWithdrawsAccess": "You withdraw the access {{company}} has to the data you shared on this journey.",
      "leftToastCanArchive": "They can no longer see your data, and the relationship has ended. You can archive this journey now.",
      "leftToastTitle": "You left {{company}}’s programme",
      "manageConsents": "What they see",
      "manageJourneys": "Manage journeys",
      "newJourney": "New journey",
      "openExisting": "Open it",
      "recoverArchived": "Recover an archived journey ({{count}})",
      "restore": "Restore",
      "restoreFailed": "We couldn’t restore this journey. Please try again.",
      "restoredToastTitle": "Journey restored",
      "startedOn": "Started {{date}}",
      "subtitle": "Switch between your journeys, archive the ones you are not using, and decide what companies can see.",
      "switchToJourney": "Switch to this journey",
      "title": "My journeys",
      "undo": "Undo",
      "actionsLabel": "Manage journey",
      "actionsHint": "Long press, or use the actions menu, to archive or leave",
      "restoreCapTitle": "This route is full",
      "restoreCapBody_one": "You already have {{count}} live journey to {{destination}} from this origin. Open it, or archive it before restoring this.",
      "restoreCapBody_other": "You already have {{count}} live journeys to {{destination}} from this origin. Open one, or archive one before restoring this.",
      "labelField": "Journey name",
      "labelPlaceholder": "e.g. Work — Lisbon",
      "nameIt": "Name it",
      "rename": "Rename",
      "renamedToast": "Journey renamed",
      "nameClearedToast": "Journey name removed",
      "renameFailed": "We couldn’t save the name. Please try again.",
      "leaveDialogDescriptionInvited": "{{company}} invited you to your journey to {{destination}}.",
      "leaveDialogDescriptionShared": "You shared your journey to {{destination}} with {{company}}.",
      "leaveEndsRelationship": "Your relationship with {{company}} on this journey ends. They can invite you again, and you decide whether to accept.",
      "leftToastOtherProgramme": "They can no longer see your data, and the relationship has ended. Another company’s programme still runs on this journey, so it stays.",
      "leftToastSponsorshipHolds": "They can no longer see your data, and the relationship has ended. A sponsorship still runs on this journey, so it stays until the sponsorship ends.",
      "archiveAfterSponsorship": "This journey is sponsored until {{date}}. You can archive it once the sponsorship ends.",
      "archiveAfterSponsorshipNoDate": "A sponsorship is running on this journey. You can archive it once the sponsorship ends."
    },
    "consent": {
      "action": {
        "granted": "Shared",
        "narrowed": "Shared less",
        "revoked": "Stopped sharing",
        "widened": "Shared more"
      },
      "allRevoked": "They can no longer see your results on this journey.",
      "archivedByCompany": "Archived by the company",
      "changeFailed": "That change did not go through. Nothing was altered.",
      "changedToastBody": "{{company}} · {{scope}}",
      "empty": "No company holds any of your data on this journey.",
      "grantedOn": "Shared since {{date}}",
      "grantedToast": "Shared again",
      "grantedUnknown": "Shared before we started recording consent dates",
      "groupJourney": "On this journey",
      "groupProfile": "From your profile",
      "revokedToast": "No longer shared",
      "scope": {
        "care": "My Care record",
        "care_checkins": "My daily check-ins",
        "checkup": "My CheckUp results",
        "cv": "My CV",
        "household": "My family details",
        "irr": "My activity history",
        "passport_stamps": "My Passport stamps and miles",
        "pitch_video": "My pitch recording",
        "qultureup": "My QultureUp progress",
        "teleportal": "My relocation plan",
        "testit": "My TestIt results"
      },
      "sharingCount": "{{shared}} of {{total}} shared",
      "subtitle": "Each company below holds part of your journey. Turn anything off and they stop seeing it; turn it back on whenever you want. Nothing you have done is deleted.",
      "title": "Who sees my data",
      "trailTitle": "What has changed",
      "leftOn": "You left on {{date}}",
      "endedOn": "Ended on {{date}}",
      "stoppedOn": "Stopped sharing on {{date}}",
      "leftReadOnly": "This relationship has ended. Nothing is shared with {{company}} again unless you accept a new invitation from them."
    }
  },
  "journeyBuilder": {
    "aboutDescription": "Create your personalized international journey configuration",
    "creatingMessage": "Setting up your journey — this only takes a moment.",
    "creatingTitle": "Creating your journey…",
    "creationErrorTitle": "Couldn't create your journey",
    "description": "Let's configure your international journey",
    "estimatedTime": "Estimated time",
    "infoCountries": "Choose your origin and destination countries",
    "infoDescription": "Tell us a few things about your move so we can personalize your journey.",
    "infoDestination": "Destination",
    "infoDestinationDesc": "Where you're moving to.",
    "infoFeatures": "Select which features to include in your journey",
    "infoHousehold": "Configure your household composition and family setup",
    "infoIntro": "Building a journey takes a few minutes. Once done, you'll see your personalized roadmap.",
    "infoJourney": "Journey",
    "infoJourneyDesc": "The full plan from origin to destination.",
    "infoOrigin": "Origin",
    "infoOriginDesc": "Where you're moving from.",
    "infoProfile": "Profile",
    "infoProfileDesc": "Your personal details — used to tailor recommendations.",
    "infoScenario": "Select your journey purpose and what you're looking for",
    "progress": "Progress",
    "progressTitle": "Progress",
    "purposeCare": "Support and care getting there",
    "purposeCheckup": "Check your International Skills",
    "purposeCulture": "Know the Culture and become a Citizen",
    "purposeJob": "Have a job opportunity and support",
    "purposeRelocation": "Support in the relocation process",
    "redirectingMessage": "Redirecting you to your dashboard...",
    "scenario": "What's your situation?",
    "scenarioAlreadyAbroad": "I'm already living abroad",
    "scenarioAlreadyAbroadDesc": "You have already moved and want to improve your integration",
    "scenarioIntegration": "Integration support only",
    "scenarioIntegrationDesc": "You want to focus on culture, language, and career development",
    "scenarioPreImmigration": "I'm planning to move abroad",
    "scenarioPreImmigrationDesc": "You are still in your home country and planning your international move",
    "scenarioRelocation": "Relocation support only",
    "scenarioRelocationDesc": "You need help with the logistical side of moving: visa, housing, legal",
    "successTitle": "Journey configured! 🎉",
    "successToast": "Journey configured successfully!",
    "title": "Journey builder",
    "mobile": {
      "stepOf": "Build your journey · {{current}} of {{total}}",
      "create": "Create my journey",
      "sameCountry": "Choose the country you are leaving — it can't be your destination.",
      "createFailed": "We couldn't create your journey. Check your connection and try again.",
      "gateBody": "Three questions and your journey is ready — right here on your phone.",
      "adviceFailed": "We couldn't check your journeys on this route. Try again."
    }
  },
  "language": {
    "languages": {
      "de": "Deutsch",
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "it": "Italiano",
      "pt": "Português"
    }
  },
  "legal": {
    "privacy": {
      "changes": {
        "content": "We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.",
        "title": "10. Changes to this policy"
      },
      "children": {
        "content": "Our Service is not intended for children under 16 years of age. We do not knowingly collect personal data from children under 16.",
        "title": "9. Children's privacy"
      },
      "collect": {
        "account": "Account information (name, email, phone number)",
        "assessment": "Assessment responses and progress data",
        "documents": "Documents uploaded to our Vault service",
        "intro": "We collect information you provide directly to us, including:",
        "location": "Location data (current country, destination country)",
        "profile": "Profile information (profession, education, skills)",
        "title": "1. Information we collect"
      },
      "contact": {
        "content": "For questions about this Privacy Policy or to exercise your data rights, contact our Data Protection Officer at",
        "title": "11. Contact Us"
      },
      "cookies": {
        "content": "We use cookies and similar technologies to enhance your experience, analyze usage patterns, and deliver personalized content. You can manage cookie preferences through your browser settings.",
        "title": "7. Cookies and tracking"
      },
      "international": {
        "content": "Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place to protect your data in accordance with this Privacy Policy.",
        "title": "8. International data transfers"
      },
      "lastUpdated": "Last updated: {{date}}",
      "retention": {
        "content": "We retain your personal data for as long as your account is active or as needed to provide you services. You can request deletion of your data at any time by contacting us.",
        "title": "5. Data retention"
      },
      "rights": {
        "access": "Access your personal data",
        "correct": "Correct inaccurate data",
        "delete": "Request deletion of your data",
        "intro": "Under applicable data protection laws, you have the right to:",
        "object": "Object to processing of your data",
        "portability": "Request data portability",
        "title": "6. Your rights"
      },
      "security": {
        "content": "We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. All data is encrypted in transit and at rest.",
        "title": "4. Data security"
      },
      "sharing": {
        "employers": "With employers who sponsor your journey (with your explicit consent)",
        "intro": "We may share your information:",
        "legal": "When required by law or to protect our rights",
        "providers": "With service providers who assist in operating our platform",
        "title": "3. Information sharing"
      },
      "title": "Privacy policy",
      "use": {
        "communicate": "Communicate with you about your journey progress",
        "intro": "We use the information we collect to:",
        "personalize": "Personalize your experience and journey recommendations",
        "process": "Process your iQulture assessments and generate insights",
        "protect": "Protect against fraud and unauthorized access",
        "provide": "Provide, maintain, and improve our Service",
        "title": "2. How we use your information"
      }
    },
    "terms": {
      "acceptance": {
        "content": "By accessing and using the Tonnie Platform (\"Service\"), you agree to be bound by these Terms of Service (\"Terms\"). If you do not agree to these Terms, please do not use the Service.",
        "title": "1. Acceptance of terms"
      },
      "accounts": {
        "content": "To use certain features of the Service, you must create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.",
        "title": "3. User accounts"
      },
      "changes": {
        "content": "We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the new Terms on this page and updating the \"Last updated\" date.",
        "title": "8. Changes to terms"
      },
      "contact": {
        "content": "If you have questions about these Terms, please contact us at",
        "title": "9. Contact"
      },
      "ip": {
        "content": "The Service and its original content, features, and functionality are owned by Tonnie and are protected by international copyright, trademark, and other intellectual property laws.",
        "title": "5. Intellectual property"
      },
      "lastUpdated": "Last updated: {{date}}",
      "liability": {
        "content": "In no event shall Tonnie be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the Service.",
        "title": "7. Limitation of liability"
      },
      "responsibilities": {
        "accurate": "Provide accurate and complete information",
        "compliance": "Use the Service in compliance with applicable laws",
        "intro": "You agree to:",
        "noMisuse": "Not misuse or attempt to circumvent the Service's security features",
        "title": "4. User responsibilities",
        "upToDate": "Keep your account information up to date"
      },
      "serviceDesc": {
        "care": "Care — Wellbeing support",
        "checkup": "CheckUp — Readiness assessments",
        "content": "Tonnie provides a global talent mobility platform that assists individuals (\"Talents\") with international relocation and helps companies (\"Employers\") manage global talent programs. The Service includes:",
        "passport": "Passport — Progress tracking and verification",
        "qultureup": "QultureUp — Cultural learning modules",
        "teleportal": "TelePortal — Relocation task management",
        "title": "2. Description of service"
      },
      "termination": {
        "content": "We may terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.",
        "title": "6. Termination"
      },
      "title": "Terms of service"
    }
  },
  "mission": {
    "almostThere": "Almost there!",
    "answerPlaceholder": "Type your answer here...",
    "complete": "Complete mission",
    "completeToEarn": "Complete to earn",
    "completedBadge": "Completed!",
    "completedSuccess": "Mission complete!",
    "correct": "Correct",
    "correctOf": "{{correct}} of {{total}} correct",
    "exitForNow": "Exit for now",
    "milesEarnedLabel": "Miles earned",
    "milesHint": "Miles track your cultural learning progress in QultureUp",
    "needToPass": "You need 75% to pass. Review the content and try again.",
    "next": "Next",
    "notFound": "Mission not found",
    "notPassed": "Not passed",
    "passed": "Passed",
    "perfectScoreBonus": "Perfect score bonus",
    "previous": "Previous",
    "progressWarning": "You'll lose your progress. Are you sure?",
    "progressWarningTitle": "Leave mission?",
    "questionBreakdown": "Question breakdown",
    "quizResults": "Quiz results",
    "review": "Review",
    "reviewAndTryAgain": "Review & try again",
    "startMission": "Start mission",
    "watchVideo": "Watch video",
    "scrollToContinue": "Scroll to the end to continue",
    "startQuiz": "Start quiz",
    "submit": "Submit",
    "submitAnyway": "Submit anyway",
    "submitError": "Failed to submit quiz. Please try again.",
    "tipReread": "Tip: Re-read the content",
    "tipRereadDetail": "Pay attention to the sections you missed. The quiz questions come directly from the lesson material.",
    "title": "Mission",
    "unansweredTitle": "Unanswered questions",
    "whatYoullLearn": "What you'll learn",
    "wrong": "Wrong",
    "lockedError": "This mission is locked for now. Finish the missions before it first.",
    "milesEarned_one": "+{{count}} Mile",
    "milesEarned_other": "+{{count}} Miles",
    "questionsCount_one": "{{count}} question",
    "questionsCount_other": "{{count}} questions",
    "unansweredMessage_one": "You have {{count}} unanswered question. Submit anyway?",
    "unansweredMessage_other": "You have {{count}} unanswered questions. Submit anyway?"
  },
  "nav": {
    "billing": "Billing",
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "family": "Family",
    "home": "Home",
    "passport": "Passport",
    "profile": "Profile",
    "qultureup": "QultureUp",
    "settings": "Settings",
    "teleportal": "TelePortal",
    "testit": "TestIt",
    "userMenu": {
      "billing": "Billing",
      "loggingOut": "Signing out…",
      "logout": "Log out",
      "openMenu": "Open user menu",
      "preferences": "Preferences",
      "profile": "Profile",
      "howItWorks": "How Tonnie works"
    },
    "vault": "Vault"
  },
  "notFound": {
    "description": "The page you're looking for doesn't exist or has been moved.",
    "goBack": "Go back",
    "goHome": "Go home",
    "message": "The page you are looking for does not exist.",
    "title": "Page not found"
  },
  "inbox": {
    "title": "Inbox",
    "subtitle": "Every message sent to you — by email and in the app — in one place.",
    "tabInbox": "Inbox",
    "tabUnread": "Unread",
    "tabArchived": "Archived",
    "unreadCount_one": "{{count}} unread message",
    "unreadCount_other": "{{count}} unread messages",
    "unreadLabel": "Unread",
    "emptyInbox": "No messages yet.",
    "emptyUnread": "You're all caught up.",
    "emptyArchived": "No archived messages.",
    "loadError": "We couldn't load your messages.",
    "retry": "Try again",
    "loadMore": "Load more",
    "archive": "Archive",
    "restore": "Move to inbox",
    "back": "Back to messages",
    "fromPlatform": "Tonnie",
    "channelEmail": "Email",
    "channelInApp": "In the app",
    "channelPush": "Push notification",
    "notRetainedTitle": "Content not retained",
    "notRetainedBody": "This email was sent before Tonnie kept a copy of the messages it sends, so its text can't be shown here.",
    "openAction": "Open",
    "selectPrompt": "Select a message to read it.",
    "actionError": "That didn't work. Please try again.",
    "sentAt": "Sent {{date}}",
    "openFromBell": "Open inbox",
    "markAllRead": "Mark all as read",
    "markAllReadDone": "All messages marked as read",
    "allCaughtUp": "No unread messages",
    "archived": "Message archived",
    "restored": "Moved to your inbox",
    "undo": "Undo",
    "markUnread": "Mark as unread",
    "markRead": "Mark as read",
    "markedUnread": "Marked as unread",
    "markedRead": "Marked as read",
    "groupToday": "Today",
    "groupYesterday": "Yesterday",
    "groupThisWeek": "Earlier this week",
    "groupEarlier": "Earlier",
    "selectTitle": "No message selected",
    "emptyInboxHint": "Emails and in-app messages from Tonnie and the companies you work with will appear here.",
    "emptyUnreadHint": "New messages will show up here as soon as they arrive.",
    "emptyArchivedHint": "Messages you archive are kept here, and you can move them back at any time.",
    "loadErrorHint": "Check your connection and try again.",
    "loading": "Loading your messages",
    "readerLabel": "Message",
    "messageNotFound": "This message isn’t here",
    "messageNotFoundHint": "It may have been deleted, or it was sent to another account.",
    "notRetainedPreview": "The text of this email was not kept.",
    "opensInNewTab": "(opens in a new tab)",
    "viewArchived": "View archived",
    "invitationsSection": "Invitations · {{count}}",
    "invitationsWaiting_one": "{{count}} invitation waiting for your answer",
    "invitationsWaiting_other": "{{count}} invitations waiting for your answer"
  },
  "notifications": {
    "care": {
      "checkpointOverdueTitle": "Your check-in is waiting",
      "coachingAssignedTitle": {
        "encourage": "Assigned to you: send some encouragement",
        "challenge": "Assigned to you: set a new challenge",
        "checkin": "Assigned to you: check in",
        "celebrate": "Assigned to you: celebrate their progress",
        "remind": "Assigned to you: send a friendly reminder"
      },
      "coachingTouchTitle": {
        "encourage": "Your team sent you some encouragement",
        "challenge": "Your team set you a new challenge",
        "checkin": "Your team is checking in on you",
        "celebrate": "Your team is celebrating your progress",
        "remind": "A friendly reminder from your team"
      },
      "checkpointOverdueBody": "A Care check-in is overdue — it only takes about 3 minutes. Open Care to complete it.",
      "interactionAssignedBody": "A Care interaction was assigned to you.",
      "interventionTouchBody": "Your sponsor team scheduled some support for you. Open Care to see more.",
      "objectiveFeedbackCycleOpenTitle": "New feedback round",
      "objectiveFeedbackCycleOpenBody": "Your team will share their feedback shortly — then you can add your own self-evaluation. Open Care to see your objectives.",
      "objectiveFeedbackDueTitle": "Feedback requested",
      "objectiveFeedbackDueBody": "It's time to share your feedback on this round's objectives. Open Care to give it.",
      "objectiveFeedbackReceivedTitle": "New feedback received",
      "objectiveFeedbackReceivedBody": "Your team shared feedback on your objectives. Open Care to review it and add your self-evaluation."
    },
    "checkup": {
      "scoreReadyBody": "{{score}} — see what it means, pillar by pillar.",
      "scoreReadyTitle": "Your iQulture score is in"
    },
    "billing": {
      "actionRequiredBody": "Your bank needs you to authorize this payment. Open Billing to complete it.",
      "actionRequiredTitle": "Confirm your payment",
      "paymentFailedBody": "We couldn't process your payment. Update your payment method to keep your access.",
      "paymentFailedTitle": "Payment failed"
    },
    "testit": {
      "reminderBody": "Complete your TestIt so the company reviewing you can see your results.",
      "reminderTitle": "Your TestIt is waiting"
    },
    "justNow": "Just now",
    "bellLabel_one": "Notifications, {{count}} unread",
    "bellLabel_other": "Notifications, {{count}} unread",
    "title": "Notifications",
    "moreActions": "More actions",
    "tabAll": "All",
    "markReadAction": "Mark as read",
    "unsubscribe": {
      "confirmBody": "We will stop sending “{{category}}” emails to {{email}}.",
      "confirmCta": "Unsubscribe",
      "confirmTitle": "Unsubscribe from these emails?",
      "confirming": "Unsubscribing…",
      "doneBody": "You will no longer receive “{{category}}” emails.",
      "doneTitle": "You're unsubscribed",
      "failed": "That didn't go through. Please try again.",
      "invalidBody": "It may have already been used, or the account it belonged to was closed. Nothing has changed.",
      "invalidTitle": "This link is no longer valid",
      "loading": "Checking your link…",
      "malformedBody": "The unsubscribe link looks truncated. Some email apps cut long links — try opening the message in a browser, or use the Unsubscribe button your email app shows at the top of the message.",
      "malformedTitle": "This link is incomplete",
      "stillReceive": "Essential account emails — password resets and security notices — will still reach you."
    },
    "showMore": "Show more",
    "showLess": "Show less",
    "journey": {
      "relationshipMovedTitle": "Your journeys were updated",
      "relationshipMovedBody": "{{company}} now follows you on a journey of its own, on the same route. See it in My journeys."
    },
    "bellLabelNeedsYou_one": "Notifications, {{count}} waiting for you, including an invitation",
    "bellLabelNeedsYou_other": "Notifications, {{count}} waiting for you, including invitations",
    "tabInvitations": "Invitations",
    "company": {
      "programmeLeftTitle": "A talent left your programme",
      "programmeLeftBody": "{{name}}'s card moved to the Archived tab of your Pipeline, and you can no longer see what they shared.",
      "programmeLeftSponsoredBody": "{{name}} left and you no longer see what they shared. Your sponsorship continues until {{date}}, the end of its paid term.",
      "programmeLeftSponsoredOpenEndedBody": "{{name}} left and you no longer see what they shared. Your sponsorship continues until the end of its paid term.",
      "shareRequestDeclinedTitle": "Request declined",
      "shareRequestDeclinedBody": "{{name}} declined. Nothing has changed: you see exactly what they shared with you before. You can ask again later from their card.",
      "testitCompletedTitle": "Requested tests completed",
      "testitCompletedBody": "{{name}} completed the tests you asked for. Open their card in your Pipeline to review them and record your decision.",
      "sponsorshipAcceptedTitle": "Sponsorship accepted",
      "sponsorshipAcceptedBody": "{{name}} accepted. Their card is now in the Sponsored column of your Pipeline, where you can follow their progress.",
      "sponsorshipDeclinedTitle": "Sponsorship declined",
      "sponsorshipDeclinedBody": "{{name}} declined. Anything you paid is refunded automatically. You can offer again from their card in your Pipeline.",
      "nudgeDigestTitle": "Waiting on your team",
      "nudgeDigestBody": "Waiting on you: {{count}}. Unsent or bounced invitations and unanswered sponsorship offers — only your team can move them forward."
    }
  },
  "onboarding": {
    "completed": "Complete onboarding",
    "education": {
      "addEducation": "Add education",
      "bachelor": "Bachelor's",
      "degree": "Degree",
      "description": "Add your educational background",
      "emptyDescription": "Add your education history to help us better understand your background and qualifications.",
      "emptyTitle": "No education entries yet",
      "entry": "Education entry",
      "field": "Field of study",
      "fieldPlaceholder": "e.g., Computer Science",
      "graduationYear": "Graduation year",
      "institution": "Institution",
      "institutionPlaceholder": "University name",
      "master": "Master's",
      "phd": "PhD",
      "selectDegree": "Select degree type",
      "title": "Education history"
    },
    "experience": {
      "addExperience": "Add experience",
      "company": "Company",
      "companyPlaceholder": "Company name",
      "current": "Current",
      "currentJob": "Leave empty if current",
      "description": "Description",
      "descriptionPlaceholder": "Describe your role and achievements...",
      "emptyDescription": "Add your work experience to showcase your professional background and skills.",
      "emptyTitle": "No work experience yet",
      "endDate": "End date",
      "endDateHint": "Leave empty if this is your current position",
      "entry": "Experience entry",
      "locationCity": "City",
      "locationCityPlaceholder": "e.g., San Francisco",
      "locationCountry": "Country",
      "locationCountryPlaceholder": "Select country",
      "role": "Role / Title",
      "rolePlaceholder": "Job title",
      "startDate": "Start date",
      "title": "Work experience"
    },
    "family": {
      "childrenCount": "Number of children",
      "description": "Tell us about your household",
      "familyProgramHint": "You can set up Family Program later to invite family members to your journey",
      "hasChildren": "I have children",
      "hasPartner": "I have a partner/spouse",
      "hasPets": "I have pets",
      "householdInfo": "Household information",
      "householdInfoDesc": "This helps us personalize your TelePortal and Care checkpoints",
      "title": "Family configuration"
    },
    "fieldFilledFromImport": "Filled from imported profile",
    "fieldImportHint": "Import profile to pre-fill this field",
    "languages": {
      "addLanguage": "Add Language",
      "advanced": "Advanced",
      "beginner": "Beginner",
      "description": "Tell us about your language skills",
      "elementary": "Elementary",
      "emptyDescription": "Add languages you speak to help us assess your communication readiness.",
      "emptyTitle": "No languages added yet",
      "entry": "Language",
      "intermediate": "Intermediate",
      "language": "Language",
      "level": "Proficiency Level",
      "native": "Native",
      "proficient": "Proficient",
      "selectLanguage": "Select a language",
      "selectLevel": "Select proficiency level",
      "title": "Languages",
      "upperIntermediate": "Upper Intermediate"
    },
    "linkedin": {
      "dropPdfSubtitle": "or click to browse",
      "dropPdfTitle": "Drop your LinkedIn Profile PDF here",
      "fileTooLarge": "File is too large. Maximum size is 10 MB.",
      "invalidFileType": "Unsupported file type. Please upload a PDF, Word document, or text file.",
      "parseFailed": "Failed to extract data from the document. Please try a different file.",
      "pdfInstructions": {
        "step1": "Go to LinkedIn and sign in",
        "step2": "Navigate to Settings & Privacy → Data Privacy → Get a copy of your data",
        "step3": "Select 'Profile' and download as PDF",
        "step4": "Upload the PDF file below",
        "title": "How to get your LinkedIn Profile PDF"
      },
      "pdfUploadError": "Failed to upload PDF. Please try again.",
      "selectPdfFile": "Select PDF file",
      "uploadDifferentFile": "Upload different file",
      "uploading": "Uploading...",
      "wizard": {
        "compliance": {
          "description": "Your data stays private. We only read the document you upload — nothing is stored or shared without your consent.",
          "title": "GDPR & LinkedIn compliant"
        },
        "confirmAndContinue": "Confirm & continue",
        "getStarted": "Get started",
        "guide": {
          "cv": {
            "subtitle": "A few tips to get the best results from your CV",
            "tip1": {
              "description": "Upload your most up-to-date CV for the most accurate profile import.",
              "title": "Use a recent version"
            },
            "tip2": {
              "description": "CVs with clear sections (Experience, Education, Skills) give the best extraction results.",
              "title": "Structured formats work best"
            },
            "tip3": {
              "description": "We accept PDF, DOCX, DOC, and TXT files up to 10 MB.",
              "title": "Supported formats"
            },
            "title": "Tips for your CV upload"
          },
          "linkedin": {
            "openLinkedIn": "Open LinkedIn",
            "step1": {
              "description": "Go to linkedin.com, sign in, and navigate to your profile page.",
              "title": "Open your profile"
            },
            "step2": {
              "description": "On your profile page, click the \"More\" button below your headline, then select \"Save to PDF\".",
              "title": "Click \"More\" then \"Save to PDF\""
            },
            "step3": {
              "description": "LinkedIn will generate a PDF. Save it to your computer — you'll upload it in the next step.",
              "title": "Download the file"
            },
            "subtitle": "Follow these 3 simple steps to download your profile",
            "tip": "The PDF is generated instantly from your profile page. No need to request a data export.",
            "title": "How to get your LinkedIn PDF"
          }
        },
        "processing": {
          "analyzing": "Analyzing with AI",
          "extracting": "Extracting text content",
          "structuring": "Structuring your data",
          "subtitle": "Please wait while we analyze your document...",
          "title": "Extracting your profile",
          "uploading": "Uploading document"
        },
        "progress": "Progress",
        "readyToUpload": "I'm ready to upload",
        "review": {
          "at": "at",
          "editHint": "You can edit all details in the next onboarding steps.",
          "fieldCertifications": "Certifications",
          "fieldEducation": "Education",
          "fieldExperience": "Work experience",
          "fieldHeadline": "Professional headline",
          "fieldLanguages": "Languages",
          "fieldNames": "Name",
          "fieldSkills": "Skills",
          "fieldWebsites": "Websites & links",
          "noDataFound": "No data could be extracted. Please ensure the file is a valid profile document (PDF, DOCX, or TXT).",
          "present": "Present",
          "previewDescription": "The following fields will be pre-filled in your Tonnie profile:",
          "subtitle": "We found the following information in your document. Review it and confirm to continue.",
          "title": "Your extracted profile",
          "entries_one": "{{count}} entry",
          "entries_other": "{{count}} entries",
          "languagesCount_one": "{{count}} language",
          "languagesCount_other": "{{count}} languages",
          "positions_one": "{{count}} position",
          "positions_other": "{{count}} positions",
          "skillsCount_one": "{{count}} skill",
          "skillsCount_other": "{{count}} skills",
          "summaryStats_one": "{{count}} field extracted from your document",
          "summaryStats_other": "{{count}} fields extracted from your document"
        },
        "reviewData": "Review data",
        "source": {
          "cvCard": {
            "description": "Upload your existing CV or resume in PDF, DOCX, or TXT format. Works with any layout.",
            "title": "Personal CV / Resume"
          },
          "linkedinCard": {
            "description": "Download your profile from LinkedIn and upload the PDF. Best for accurate, structured data.",
            "tag": "Recommended",
            "title": "LinkedIn profile PDF"
          },
          "subtitle": "Choose how you'd like to import your professional profile. We'll extract your experience, education, and skills automatically.",
          "title": "Import your profile"
        },
        "steps": {
          "guide": "Guide",
          "processing": "Processing",
          "review": "Review",
          "source": "Source",
          "upload": "Upload"
        },
        "success": {
          "description": "Your data has been imported. You can now generate professional CVs and manage multiple versions.",
          "title": "Profile imported successfully!"
        },
        "upload": {
          "subtitle": "Drag and drop your file or click to browse. We accept PDF, DOCX, and TXT files.",
          "title": "Upload your document"
        },
        "aria": {
          "progress": "Wizard progress"
        }
      }
    },
    "linkedinBound": "Profile imported",
    "linkedinConnectionError": "Failed to import profile. Please try again.",
    "location": {
      "currentCountry": "Current country",
      "description": "Where are you now and where do you want to go?",
      "goal": "Your goal",
      "goalHint": "This helps us personalize your journey",
      "goalPlaceholder": "Tell us about your relocation goals and expectations...",
      "selectCountry": "Select a country",
      "targetCountry": "Target country",
      "title": "Location & goals"
    },
    "mobility": {
      "citizenship": "Countries of citizenship",
      "citizenshipHint": "Select all countries where you hold citizenship",
      "description": "Tell us about your citizenship and relocation interests",
      "selectCitizenship": "Select a country...",
      "removeCitizenship": "Remove {{country}}",
      "title": "Mobility",
      "validPassport": "Do you have a valid passport?",
      "validPassportHint": "Passport details will be managed in TelePortal"
    },
    "personalInfo": {
      "addAddress": "Add address",
      "addWebsiteUrl": "Add website URL",
      "address": "Address",
      "addressDetails": "Address details",
      "addressDetailsError": "Failed to get address details. Please try again.",
      "addressHint": "Select your address from the suggestions",
      "addressInitError": "Failed to initialize address search. Please try again.",
      "addressInvalid": "Invalid address data. Please try selecting another address.",
      "addressLoadError": "Failed to load address search. Please refresh the page.",
      "addressPlaceholder": "Start typing your address...",
      "addressSearchError": "Failed to search addresses. Please try again.",
      "addressSelected": "Selected address",
      "addressSuggestions": "Address suggestions",
      "avatarFileSizeError": "File size must be less than 5MB",
      "avatarFileTypeError": "Please upload a valid image file (JPG, PNG, GIF, or WEBP)",
      "avatarRemoved": "Photo removed successfully!",
      "avatarUploadFailed": "Avatar upload failed",
      "avatarUploaded": "Photo uploaded successfully!",
      "changePhoto": "Change photo",
      "city": "City",
      "clickEditToAdd": "Click Edit to add your address",
      "clickToUpload": "Click to upload",
      "complement": "Complement",
      "complementPlaceholder": "Apartment, suite, unit, etc.",
      "country": "Country",
      "dateOfBirth": "Date of birth",
      "description": "Tell us about yourself",
      "firstName": "First name",
      "firstNamePlaceholder": "Enter your first name",
      "lastName": "Last name",
      "lastNamePlaceholder": "Enter your last name",
      "linkedinConnected": "Profile data imported from LinkedIn",
      "loadingAddressDetails": "Loading address details...",
      "noAddress": "No address added yet",
      "phone": "Phone number",
      "phoneHint": "We'll use this to contact you about your journey",
      "phonePlaceholder": "Enter your phone number",
      "photoFileTypes": "JPG, PNG, GIF or WEBP. Max 5MB.",
      "photoInstructions": "Add a professional photo to personalize your profile. This helps recruiters and companies recognize you.",
      "profilePhoto": "Profile photo",
      "removePhoto": "Remove photo",
      "searchAddress": "Search address",
      "searchAddressDescription": "Type your address and select from Google Places suggestions",
      "state": "State/Province",
      "street": "Street",
      "title": "Personal information",
      "uploadPhoto": "Upload photo",
      "websiteLabelPlaceholder": "Custom label (e.g., My Blog)",
      "websiteType": {
        "blog": "Blog",
        "facebook": "Facebook",
        "github": "GitHub",
        "gitlab": "GitLab",
        "instagram": "Instagram",
        "linkedin": "LinkedIn",
        "other": "Other",
        "personal": "Personal",
        "portfolio": "Portfolio",
        "twitter": "Twitter / X",
        "website": "Website",
        "youtube": "YouTube"
      },
      "websiteUrlPlaceholder": "https://...",
      "websiteUrls": "Website URLs & social links",
      "websiteUrlsHint": "Add your portfolio, personal website, GitHub, LinkedIn, or other professional links",
      "workModel": {
        "flexible": "Flexible",
        "hybrid": "Hybrid",
        "on-site": "On-site",
        "remote": "Remote"
      },
      "workModelPreference": "Work model preference",
      "workModelPreferenceHint": "Select the work models you are open to",
      "zipCode": "Zip code",
      "websiteTypeLabel": "Link type",
      "websiteUrlLabel": "Link URL",
      "websiteCustomLabel": "Custom label",
      "removeWebsiteUrl": "Remove link"
    },
    "professional": {
      "advanced": "Advanced",
      "beginner": "Beginner",
      "description": "Tell us about your career",
      "elementary": "Elementary",
      "englishLevel": "English proficiency",
      "englishLevelHint": "This helps us assess your readiness",
      "intermediate": "Intermediate",
      "junior": "Junior",
      "mid": "Mid-level",
      "proficient": "Proficient",
      "role": "Current role / Job title",
      "rolePlaceholder": "e.g., Software Engineer",
      "selectEnglishLevel": "Select your English level",
      "selectSeniority": "Select your seniority level",
      "senior": "Senior",
      "seniority": "Seniority level",
      "title": "Professional background",
      "upperIntermediate": "Upper intermediate"
    },
    "review": {
      "address": "Address",
      "careerTime": "Career time",
      "certifications": "Certifications",
      "countriesOfInterest": "Countries of interest",
      "currentRole": "Current role",
      "education": "Education",
      "experience": "Experience",
      "familyConfig": "Family configuration",
      "hardSkills": "Hard skills",
      "hasChildren": "Has children",
      "hasPartner": "Has partner",
      "hasPets": "Has pets",
      "mobility": "Mobility",
      "passport": "Valid Passport",
      "personalInfo": "Personal information",
      "profilePhoto": "Profile photo",
      "profilePhotoSet": "Profile photo has been set",
      "skills": "Skills & expertise",
      "softSkills": "Soft skills",
      "spokenLanguages": "Spoken languages",
      "websiteUrls": "Website URLs & social links",
      "workModel": "Work model preference",
      "years": "years"
    },
    "saveError": "Failed to save progress. Please try again.",
    "saved": "Progress saved successfully",
    "skills": {
      "addCertification": "Add certification",
      "addHardSkill": "Add hard skill",
      "addLanguage": "Add language",
      "addSoftSkill": "Add soft skill",
      "careerTime": "Career time",
      "certification": "Certification",
      "certificationAuthority": "Issuing authority",
      "certificationAuthorityPlaceholder": "e.g., Amazon Web Services",
      "certificationExpiryDate": "Expiry date",
      "certificationExpiryDatePlaceholder": "Leave empty if no expiry",
      "certificationIssueDate": "Issue date",
      "certificationLicenseNumber": "License number",
      "certificationLicenseNumberPlaceholder": "License or certificate number (optional)",
      "certificationName": "Certification name",
      "certificationNamePlaceholder": "e.g., AWS Certified Solutions Architect",
      "certificationUrl": "Certificate URL",
      "certificationUrlPlaceholder": "https://...",
      "certifications": "Certifications",
      "certificationsHint": "Add professional certifications and licenses",
      "currentRole": "Current role",
      "description": "Tell us about your professional skills and experience",
      "experienceYears": {
        "0_1": "0-1 years",
        "11_15": "11-15 years",
        "16_plus": "16+ years",
        "2_3": "2-3 years",
        "4_5": "4-5 years",
        "6_10": "6-10 years"
      },
      "hardSkills": "Hard skills",
      "hardSkillsHint": "Add technical skills and your years of experience",
      "hardSkillsInfo": "Provide at least 5 of your most strong hard skills and time of experience.",
      "languageLevels": {
        "A1": "A1 — Beginner",
        "A2": "A2 — Elementary",
        "B1": "B1 — Intermediate",
        "B2": "B2 — Upper intermediate",
        "C1": "C1 — Advanced",
        "C2": "C2 — Proficient",
        "native": "Native"
      },
      "languages": "Spoken languages",
      "languagesHint": "Add languages you know and your proficiency level",
      "languagesInfo": "Important to add your English and Native language skills, at least. As much as you inform as much opportunities will be available.",
      "noHardSkillFound": "No hard skill found.",
      "noLanguageFound": "No language found.",
      "noRoleFound": "No role found.",
      "noSoftSkillFound": "No soft skill found.",
      "searchHardSkill": "Search hard skills...",
      "searchLanguage": "Search languages...",
      "searchRole": "Search roles...",
      "searchSoftSkill": "Search soft skills...",
      "selectExperience": "Select experience",
      "selectLevel": "Select level",
      "selectRole": "Select your role...",
      "skillExperience": {
        "0_1": "0-1 years",
        "11_plus": "11+ years",
        "2_3": "2-3 years",
        "4_5": "4-5 years",
        "6_10": "6-10 years"
      },
      "softSkillLevels": {
        "advanced": "Advanced",
        "beginner": "Beginner",
        "expert": "Expert",
        "intermediate": "Intermediate"
      },
      "softSkills": "Soft skills",
      "softSkillsHint": "Add soft skills and your proficiency level",
      "softSkillsInfo": "Provide your at least 3 most strong soft skills.",
      "title": "Skills self assessment",
      "levelFor": "{{name}} level",
      "experienceFor": "Experience in {{name}}"
    },
    "validation": {
      "address_city_country_required": "Please provide at least your city and country",
      "address_city_required": "City is required",
      "address_country_required": "Country is required",
      "career_experience_required": "Please select your career experience",
      "certification_authority_required": "Issuing authority is required",
      "certification_name_required": "Certification name is required",
      "citizenship_required": "Please select at least one citizenship",
      "company_required": "Company is required",
      "dateOfBirth_invalid": "Please enter a valid date of birth",
      "dateOfBirth_invalid_format": "Invalid date format",
      "dateOfBirth_min_age": "You must be at least {{minAge}} years old",
      "dateOfBirth_required": "Date of birth is required",
      "degree_required": "Degree is required",
      "end_date_after_start": "End date must be after start date",
      "exp_role_required": "Role is required",
      "field_of_study_required": "Field of study is required",
      "firstName_max_length": "First name must be at most 100 characters",
      "firstName_min_length": "First name must be at least 2 characters",
      "firstName_required": "First name is required",
      "fixErrors": "Please fix the highlighted fields before continuing.",
      "graduation_year_invalid": "Please enter a valid graduation year",
      "institution_required": "Institution is required",
      "lastName_max_length": "Last name must be at most 100 characters",
      "lastName_min_length": "Last name must be at least 2 characters",
      "lastName_required": "Last name is required",
      "passport_required": "Please indicate if you have a valid passport",
      "phone_invalid_characters": "Phone number contains invalid characters",
      "phone_max_digits": "Phone number must have at most {{maxDigits}} digits",
      "phone_min_digits": "Phone number must have at least {{minDigits}} digits",
      "phone_required": "Phone number is required",
      "role_select_required": "Please select your current role",
      "start_date_required": "Start date is required",
      "url_invalid": "Please enter a valid URL (e.g. https://...)",
      "work_model_required": "Please select at least one work model preference"
    }
  },
  "passport": {
    "achievementUnlocked": "🎉 Achievement unlocked: {{name}}!",
    "activeJourneys": "Active journeys",
    "adjustFilters": "Adjust your filters or complete activities to see events",
    "allTime": "All time",
    "badgeMilesReward": "+{{miles}} miles",
    "badges": "Badges",
    "badgesCount": "{{earned}} of {{total}} badges earned",
    "badgesEarned": "{{earned}} of {{total}} earned",
    "badgesProgress": "Badges progress",
    "bio": {
      "address": "Address",
      "citizenLevel": "Citizen level",
      "dateOfBirth": "Date of birth",
      "email": "Email",
      "fullName": "Full name",
      "nationality": "Citizenship",
      "phone": "Phone"
    },
    "rarityHeading": "Rarity",
    "citizenBadges": "Citizen badges",
    "citizenBadgesDesc": "Special badges earned by demonstrating cultural adaptation and journey completion",
    "citizenBadgesSection": "Citizen badges",
    "citizenLevel": {
      "starter": "Starter"
    },
    "citizenNumber": "Citizen #{{number}}",
    "companyCohort": "Company cohort",
    "completeForBadges": "Complete activities to earn citizen badges!",
    "coverSubtitle": "Passport",
    "coverTitle": "Citizen",
    "daysOnJourney": "Days on journey",
    "description": "Your journey record",
    "earnBadgesMessage": "Complete assessments and lessons to earn badges!",
    "earned": "Earned",
    "earnedOn": "Earned on",
    "errors": {
      "tryAgain": "Please try again later.",
      "unableToLoad": "Unable to load Passport data"
    },
    "event": {
      "ACHIEVEMENT_EARNED.desc": "Earned an achievement"
    },
    "eventCategory": "Category",
    "eventData": "Event data",
    "eventDetails": "Event details",
    "eventType": "Event type",
    "heroBanner": {
      "levelLabel": "Level {{level}}",
      "milesToNextLevel": "{{miles}} miles to {{nextLevel}}",
      "subtitle": "Track your stamps, badges, and milestones across every hero in your relocation journey.",
      "title": "Your journey Passport"
    },
    "heroes": "Heroes",
    "identification": "Identification",
    "insightCultural": "🌍 Cultural integration is key",
    "insightCulturalDesc": "Focus on QultureUp lessons to boost your integration readiness.",
    "insightProgress": "🎯 You're progressing faster than expected!",
    "insightProgressDesc": "Your readiness score improved by 15 points in the last 2 weeks.",
    "insightStreak": "📚 Keep your learning streak alive",
    "insightStreakDesc": "You're on a 7-day streak. One more day to unlock a new badge!",
    "insights": "Insights",
    "issued": "Issued: {{date}}",
    "journeyMiles": "Miles",
    "journeyStamps": "Journey stamps",
    "journeySummary": "Journey summary",
    "journeyTimeline": "Journey timeline",
    "journeyTimelineDesc": "A record of your journey milestones and achievements",
    "keepGoingMilestones": "Keep going to earn milestones!",
    "kpiSectionDesc": "Overall readiness evolution and M/E/S/H pillar trends",
    "last3Months": "Last 3 months",
    "level": "Level",
    "levelCurrent": "Current",
    "levelMilesThreshold": "{{miles}} Miles",
    "levelMilesToReach": "{{miles}} more Miles to reach this level",
    "levelProgress": "Level progress",
    "levels": {
      "ambassador": "Ambassador",
      "explorer": "Explorer",
      "newcomer": "Newcomer",
      "pioneer": "Pioneer",
      "voyager": "Voyager"
    },
    "levelsCollection": "Journey levels",
    "levelsCount": "{{achieved}} of {{total}} levels reached",
    "limitedJourneys": "Limited journeys",
    "loading": "Loading your passport...",
    "locked": "Locked",
    "maxLevel": "(Max)",
    "meshPillarTrends": "M/E/S/H pillar trends",
    "miles": "Miles",
    "milesAbbr": "mi",
    "milesThisWeek": "Miles this week",
    "milesToNextLevel": "Miles to next level",
    "milesValue": "Miles value",
    "milestonesAchievements": "Milestones & achievements",
    "milestonesSection": "Milestones",
    "mobileApp": {
      "description": "View your full passport, share your achievements, and track your journey progress with the mobile app.",
      "openApp": "Open in app",
      "title": "Passport on mobile"
    },
    "nextMilestone": "Next: {{name}}",
    "noAchievements": "No achievements yet",
    "noBadgesYet": "No citizen badges yet. Complete journey activities to earn badges.",
    "noRecentActivity": "No recent activity. Start your journey to earn miles!",
    "noStampsYet": "No stamps yet",
    "noTimelineYet": "No timeline events yet. Complete journey activities to see your history.",
    "notReady": {
      "badges": "Citizen badges",
      "badgesDesc": "Unlock special badges that recognize your cultural adaptation",
      "miles": "Journey Miles",
      "milesDesc": "Accumulate miles as you progress through your relocation",
      "progress": "Track progress",
      "progressDesc": "View your complete journey timeline and milestones",
      "stamps": "Collect stamps",
      "stampsDesc": "Earn stamps by completing activities across all heroes",
      "startCheckup": "Start CheckUp assessment",
      "subtitle": "Complete your first hero activities to start collecting stamps, earning badges, and building your relocation record.",
      "title": "Your Passport awaits!"
    },
    "openInApp": "Open in app",
    "overallReadinessEvolution": "Overall readiness evolution",
    "pagePrefix": "P.",
    "percentComplete": "{{percent}}% complete",
    "photo": "Photo",
    "progress": "Progress",
    "progressLabel": "Progress",
    "rarity": {
      "common": "Common",
      "epic": "Epic",
      "legendary": "Legendary",
      "rare": "Rare",
      "uncommon": "Uncommon"
    },
    "readinessScore": "Readiness score",
    "recentActivity": "Recent activity",
    "recentActivityDesc": "Your latest journey miles earned",
    "returnToDashboard": "Return to dashboard",
    "reward": "Reward",
    "searchEvents": "Search events...",
    "shareAchievement": "Share achievement",
    "shareMessage": "I earned the {{name}} stamp on Tonnie! +{{miles}} Miles 🏆",
    "since": "Since",
    "stampArrived": "Arrived in destination",
    "stampArrivedDesc": "You've arrived in your destination country",
    "stampCultureStarter": "Culture Starter",
    "stampCultureStarterDesc": "Completed your first QultureUp world",
    "stampCategory": {
      "onboarding": "Getting started",
      "checkup": "CheckUp",
      "teleportal": "TelePortal",
      "qultureup": "QultureUp",
      "care": "Care",
      "cross_hero": "Across heroes"
    },
    "stampDetail": {
      "earned": "Stamp earned!",
      "locked": "Not yet earned",
      "milesReward": "Miles reward",
      "milesValueUnit": "{{value}} Miles",
      "title": "Stamp details",
      "source": "Source: {{category}}"
    },
    "stampFirstCare": "First Care cycle",
    "stampFirstCareDesc": "Completed your first Care feedback cycle",
    "stampFirstCheckup": "First CheckUp",
    "stampFirstCheckupDesc": "Completed your first readiness assessment",
    "stampNotFound": "Stamp not found",
    "stampVisaApproved": "Visa approved",
    "stampVisaApprovedDesc": "Your visa application was approved",
    "stamps": "Stamps",
    "stampsCollection": "Stamps collection",
    "stampsCollectionDesc": "Earn stamps by completing achievements across your journey",
    "stampsCount": "{{earned}} of {{total}} stamps earned",
    "stampsEarned": "Stamps earned",
    "stampsSection": "Stamps",
    "status": "Status",
    "swipeToOpen": "Swipe to open",
    "tabs": {
      "levels": "Levels",
      "overview": "Overview",
      "stamps": "Stamps",
      "timeline": "Timeline"
    },
    "thisWeek": "This week",
    "timelineCheckupCompleted": "CheckUp completed",
    "timelineCheckupCompletedDesc": "Your readiness score: 85/100",
    "timelineCultureBadge": "Culture Starter badge earned",
    "timelineCultureBadgeDesc": "You completed CheckUp + 5 culture lessons",
    "timelineFeedbackChampion": "Feedback champion",
    "timelineFeedbackChampionDesc": "You completed your 3rd feedback cycle",
    "timelineJourneyStarted": "Journey started",
    "timelineJourneyStartedDesc": "Welcome to your international journey!",
    "timelineLessonsCompleted": "10 lessons completed",
    "timelineLessonsCompletedDesc": "You've completed 10 QultureUp lessons",
    "timelineStreak": "7-Day streak",
    "timelineStreakDesc": "You've been learning consistently for 7 days",
    "timelineVisaDocs": "Visa documents uploaded",
    "timelineVisaDocsDesc": "All required documents verified and ready",
    "toNextLevel": "Next level",
    "tonnieAverage": "Tonnie average",
    "title": "Passport",
    "totalJourneys": "Total journeys",
    "totalMiles": "Total Miles",
    "totalStamps": "Total stamps",
    "tryDifferentSearch": "Try a different search term",
    "unlocked": "Unlocked",
    "viewInMobile": "View in mobile",
    "visibility": "Visibility",
    "visibleToCompany": "Company",
    "visibleToTalent": "Talent",
    "visibleToTonnie": "Tonnie",
    "vsCompanyCohort": "vs company cohort",
    "vsSelfHistory": "vs self history",
    "vsTonnieDatabase": "vs Tonnie database",
    "welcome": {
      "badgesStep": "Citizen badges",
      "badgesStepDesc": "Unlock badges that recognize your cultural adaptation",
      "description": "Your Passport is your relocation record. Complete hero activities to start collecting stamps, earning badges, and tracking your journey milestones.",
      "hint": "Complete your first CheckUp to begin collecting stamps",
      "progressStep": "Track your journey",
      "progressStepDesc": "View your complete timeline, milestones, and miles",
      "stampsStep": "Collect stamps",
      "stampsStepDesc": "Earn stamps by completing activities across all heroes",
      "startJourney": "Start your journey",
      "title": "Your Passport awaits"
    },
    "yourScore": "Your score"
  },
  "payment": {
    "addPaymentMethod": "Add payment method",
    "amount": "Amount",
    "basePrice": "Base price",
    "cancelFamilyAddon": "Cancel Family add-on",
    "cancelFamilyAddonDesc": "Are you sure you want to cancel your Family Add-on? You'll keep access until the end of your billing period.",
    "cancelFamilyAddonWarning": "After cancellation, you'll lose access to Family Program features at the end of your billing period.",
    "cardEnding": "Card ending in {{last4}}",
    "cardExpires": "Expires {{month}}/{{year}}",
    "checkoutCancelled": "Checkout cancelled",
    "checkoutError": "Failed to start checkout. Please try again.",
    "checkoutSuccess": "Payment successful! Processing your order...",
    "citizenOnly": "Citizen only",
    "confirmAndPay": "Confirm & pay",
    "coupon": {
      "apply": "Apply",
      "applied": "{{code}} · {{percent}}% off applied",
      "applyOrClear": "Apply the coupon to use it, or clear it to continue without one.",
      "invalid": "This coupon code is not valid.",
      "label": "Have a coupon?",
      "placeholder": "Enter code",
      "remove": "Remove",
      "errors": {
        "notFound": "This coupon code doesn't exist. Check it and try again.",
        "expired": "This coupon has expired or isn't active yet.",
        "disabled": "This coupon is no longer available.",
        "exhausted": "This coupon has reached its limit and can't be used again.",
        "wrongProduct": "This coupon can't be used for this purchase."
      }
    },
    "confirmCancelFamily": "Confirm cancellation",
    "confirmCancelPro": "Confirm cancellation",
    "confirmDowngrade": "Are you sure you want to cancel your Pro subscription? You'll keep access until the end of your billing period.",
    "confirmRenewal": "Confirm renewal",
    "createFirstJourney": "Create your first journey",
    "createJourneyFirst": "Please create a journey instance first",
    "createNewJourney": "Create new journey",
    "creditSourcePromotion": "Welcome bonus",
    "creditSourceReferral": "Invited 2 friends",
    "currentExpiration": "Current expiration",
    "currentPlan": "Current plan",
    "discount": "Discount",
    "downgradeToJourney": "Cancel Pro subscription",
    "downgradeWarning": "After cancellation, you'll keep access to Pro features until the end of your billing period, then you'll be downgraded to Journey Mode.",
    "downgradedToJourney": "Pro subscription cancelled. You'll keep access until the end of your billing period.",
    "editPaymentMethod": "Edit",
    "expiresOn": "Expires on",
    "expiringSoon": "Expiring soon",
    "familyAddon": "Family add-on",
    "familyAddonActive": "Family Program is active",
    "familyAddonCancelled": "Family Add-on cancelled successfully!",
    "familyAddonDesc": "Bring your household together on your journey. Invite family members to share access, manage household tasks together, and support everyone's integration success.",
    "familyAddonFeature1": "Invite family members — all get Citizen access & Citizen Web features",
    "familyAddonFeature2": "Household-aware TelePortal & Care — manage relocation together",
    "familyAddonFeature3": "Shared journey progress — everyone stays connected and supported",
    "familyAddonFeatures": "Manage household members and permissions",
    "familyAddonPurchased": "Family Add-on purchased successfully!",
    "familyAddonRequiresPro": "Family Add-on requires Pro Mode or Journey Mode",
    "familyAddonTitle": "Family program access",
    "featureAdvancedCare": "Full Care features: checkpoints, feedback cycles & support",
    "featureAllHeroes": "All 5 heroes unlocked",
    "featureBasicCareer": "Career opportunities & CV Builder",
    "featureBasicCheckup": "Full CheckUp assessment & results",
    "featureBasicPassport": "Passport event log view (no analytics)",
    "featureCareer": "Career opportunities, matching & proactive applications",
    "featureFullAccess": "Full access to all journey features",
    "featureFullCheckup": "Complete CheckUp with full MESH analysis & iQulture scores",
    "featureFullPassport": "Advanced Passport: analytics, history & achievements",
    "featureFullQultureup": "Complete QultureUp: all worlds, lessons & creator content",
    "featureFullTeleportal": "Full TelePortal: all phases, document validation & AI review",
    "featureLimitedCopilot": "Limited CoPilot queries",
    "featureLimitedQultureup": "Limited QultureUp missions",
    "featureLimitedTeleportal": "TelePortal checklist only (no document upload)",
    "featureNoExtra": "No additional payment required",
    "featurePriority": "Priority support & faster responses",
    "featureProPeriod": "Access for the duration of your Pro subscription",
    "featureUnlimitedCopilot": "Unlimited CoPilot (guide, Brain & agent) — all modes",
    "featureUnlimitedJourneys": "Unlimited journeys — create as many as you need",
    "freePlan": "Free plan",
    "freePlanDesc": "One basic Journey with essential features. Upgrade to unlock full access or create unlimited Journeys.",
    "fullAccessEnabled": "Full access enabled",
    "includedInPro": "Included in your Pro plan",
    "includedInSubscription": "Included in Pro subscription",
    "installmentPeriod": "Installment period",
    "installmentPlan": "Installment plan",
    "installments": "Installments",
    "instantUnlock": "Instant unlock",
    "invoiceHistory": "Invoice history",
    "invoiceHistoryDesc": "View and download your invoices",
    "journeyRenewed": "Journey renewed successfully!",
    "journeyUnlocked": "Journey unlocked successfully!",
    "managePaymentMethods": "Manage your payment methods",
    "month": "month",
    "monthly": "Monthly",
    "monthlyCommitment": "12-month minimum commitment",
    "monthlyPayment": "Monthly payment",
    "newExpiration": "New expiration",
    "noInvoices": "No invoices yet",
    "noInvoicesHint": "Invoices will appear here after your first payment",
    "noJourneyInstances": "No configured journeys yet",
    "oneTimePayment": "One-time payment",
    "paymentMethods": "Payment methods",
    "paymentOption": "Payment option",
    "paymentSecurity": "Your payment is secure and encrypted. We support major credit cards and local payment methods (SIBS for Portugal, Stripe for others).",
    "paymentType": "Payment type",
    "price": "Price",
    "proJourney": "Pro plan",
    "proJourneyDesc": "Unlock unlimited journeys with complete access to all features. Create as many journeys as you need — every journey gets full access to all heroes, advanced features, and premium support.",
    "proUnlockDesc": "Unlock this journey instantly with your Pro subscription",
    "proUnlockError": "Failed to unlock journey. Please try again.",
    "proUnlockSuccess": "Journey unlocked instantly with your Pro subscription!",
    "proceedToPayment": "Proceed to payment",
    "processing": "Processing...",
    "purchaseFamilyAddon": "Purchase Family add-on",
    "purchaseJourneyInstance": "Purchase journey instance",
    "purchaseJourneyInstanceDesc": "Unlock every feature of this journey",
    "purchasedOn": "Purchased on",
    "recommended": "Recommended",
    "removePaymentMethod": "Remove",
    "renewJourneyInstance": "Renew journey instance",
    "renewJourneyInstanceDesc": "Extend your access to this journey",
    "renewNow": "Renew now",
    "renewalPrice": "Renewal price",
    "save10": "Save €10.00 with upfront payment",
    "saveYearly": "Save €19.89 per year!",
    "scenarioAlreadyAbroad": "Already abroad",
    "scenarioIntegrationOnly": "Integration only",
    "scenarioPreImmigration": "Pre-immigration",
    "scenarioRelocationOnly": "Relocation only",
    "secureCheckout": "Secure checkout powered by Stripe",
    "selectInstallmentPeriod": "Select installment period",
    "selectJourneyToPurchase": "Please select a journey instance to purchase",
    "selfPaidJourneys": "Self-Paid journeys",
    "sponsoredJourneys": "Sponsored journeys",
    "total": "Total",
    "totalAmount": "Total amount",
    "unlockInstant": "Unlock instantly",
    "unlockJourney": "Unlock journey",
    "unlockNow": "Unlock now",
    "unlockedJourneys": "Configured journeys",
    "unlockedJourneysDesc": "All your purchased and sponsored journey instances",
    "unlocking": "Unlocking...",
    "upfront": "Upfront",
    "upfrontDiscount": "10% discount — Save €10.00",
    "upfrontPayment": "Upfront payment: €323.89 (10% discount)",
    "upfrontPrice": "Upfront payment",
    "upgradeDescription": "Unlock all features and accelerate your journey",
    "upgradeToPro": "Upgrade to Pro",
    "upgradedToPro": "Upgraded to Pro plan!",
    "viewReceipt": "View receipt",
    "whatYouGet": "What you get",
    "year": "year",
    "yearly": "Yearly",
    "featureMonthsAccess_one": "{{count}} month of unlimited access",
    "featureMonthsAccess_other": "{{count}} months of unlimited access",
    "coveredByPro": "Your Pro subscription already covers this journey — unlock it with Pro at no extra cost.",
    "renewNotRenewable": "This journey can't be renewed while a company sponsors it.",
    "paymentReference": "Payment ref. {{reference}}",
    "refunded": "Refunded {{amount}}",
    "viewInvoice": "View invoice",
    "documentUnavailable": "We couldn't open this document right now. Please try again.",
    "invoicesLoadFailed": "We couldn't load your invoices."
  },
  "persona": {
    "familyMaster": {
      "badge": "Controller",
      "controlsHousehold": "You control TelePortal and Care for your household",
      "description": "Main talent controlling the family journey. Full access to all features plus household management responsibilities.",
      "title": "Family master"
    },
    "info": {
      "description": "Your persona determines your access level and available features. You can change this later in your profile settings if needed.",
      "title": "About personas"
    },
    "loading": "Loading...",
    "matrix": {
      "allowed": "Full access",
      "billingCompanySponsored": "Billing managed by sponsoring company",
      "billingDescription": "Plan and billing management",
      "billingGovernmentSponsored": "Billing managed by government/sponsoring program",
      "careDescription": "Post-arrival checkpoints and support",
      "careerDescription": "Job opportunities and career tools",
      "checkupDescription": "Pre-immigration readiness assessment",
      "citizenMobile": "Citizen mobile",
      "controls": "Controls",
      "cvBuilder": "CV builder",
      "cvBuilderDescription": "EU-style CV generator and templates",
      "description": "Compare feature access across all personas. Select a persona to continue.",
      "familyProgramDescription": "Family program management and invitations",
      "familyProgramViaBilling": "Available via billing. Purchase plan to become Family master and manage it",
      "features": "Features",
      "homeDescription": "Dashboard and journey overview",
      "journeyBuilder": "Journey builder",
      "journeyBuilderDescription": "Configure and build your personalized journey",
      "journeyBuilderViaBilling": "Available after purchasing a plan via Billing",
      "journeyBuilderViaBillingBecomesTalent": "Available via billing. After purchasing credits/pro, becomes talent flow",
      "legend": {
        "allowed": "Full access",
        "citizenMobile": "Available via Citizen mobile app",
        "controls": "Controls feature",
        "limited": "Limited access (own only)",
        "notAllowed": "Not available",
        "viaBilling": "Available via billing/Upgrade"
      },
      "limited": "Limited access",
      "notAllowed": "Not available",
      "passportDescription": "Journey timeline and achievements",
      "profileDescription": "Profile settings and preferences",
      "qultureupDescription": "Cultural integration and learning",
      "selected": "Selected",
      "teleportalDescription": "Relocation and mobility tasks",
      "title": "Feature access matrix",
      "viaBilling": "Via billing"
    },
    "select": "Select this role",
    "subtitle": "Choose the persona that best matches your role in the journey. This will determine which features you can access.",
    "talent": {
      "description": "Main talent planning an international career move. Full access to all Citizen features.",
      "title": "Talent (individual)"
    },
    "talentB2B2C": {
      "badge": "Company sponsored",
      "description": "Talent with journey sponsored by a company. Pro-level features, no payment required.",
      "title": "Talent (company sponsored)"
    },
    "talentB2G": {
      "badge": "Government sponsored",
      "description": "Talent with journey sponsored by government/public program. Pro-level features, no payment required.",
      "title": "Talent (government sponsored)"
    },
    "title": "Select your journey role"
  },
  "preferences": {
    "title": "Preferences"
  },
  "profile": {
    "aboutAndLegal": "About & legal",
    "aboutTonnieJourney": "About Tonnie Citizen",
    "address": "Address",
    "allowCohortComparisons": "Allow company benchmarking",
    "allowCohortComparisonsDesc": "Let partnered companies compare your anonymized profile for talent insights",
    "backupCodesDesc": "Store these codes in a safe place. Each code can only be used once to access your account if you lose your authenticator device.",
    "backupCodesDone": "I've saved my codes",
    "backupCodesTitle": "Save your backup codes",
    "cantScanQr": "Can't scan? Enter this key manually:",
    "changePhoto": "Change photo",
    "photo": {
      "actionSheetTitle": "Profile photo",
      "takePhoto": "Take photo",
      "chooseFromLibrary": "Choose from library",
      "remove": "Remove photo",
      "removeConfirmTitle": "Remove profile photo?",
      "removeConfirmBody": "Your photo will be removed and your initials will be shown instead.",
      "uploadSuccess": "Profile photo updated",
      "uploadError": "Couldn't update your photo. Please try again.",
      "removeSuccess": "Profile photo removed",
      "managedByTitle": "Managed by {{provider}}",
      "genericProvider": "your sign-in provider",
      "cameraPermissionTitle": "Camera access needed",
      "cameraPermissionMessage": "To take a new profile photo, allow camera access for Tonnie in your device Settings.",
      "libraryUnavailableTitle": "Photo library unavailable",
      "libraryUnavailableMessage": "We couldn't open your photo library. Please try again."
    },
    "completeOnWeb": "Complete profile on web",
    "completeOnWebDesc": "Set your mobility goals and edit your career details on the Citizen Web Portal.",
    "completeProfile": "Complete your profile",
    "confirmDeleteAccount": "Yes, delete my account",
    "confirmDisable2FA": "Yes, Disable 2FA",
    "connectLinkedInIdentity": "Connect LinkedIn (for identity)",
    "contactSupport": "Get in touch with our support team",
    "contactSupportButton": "Contact support",
    "copyBackupCodes": "Copy all codes",
    "copyright": "© 2024 Tonnie. All rights reserved.",
    "currentRole": "Current role",
    "currentSession": "Current session",
    "dangerZone": "Danger zone",
    "dataProtection": "Data protection",
    "dataProtectionDesc": "You have the right to access, modify, or delete your personal data at any time. For more information about how we handle your data, please review our Privacy Policy.",
    "dateOfBirth": "Date of birth",
    "deleteAccount": "Delete account",
    "deleteAccountError": "Failed to delete account. Please try again.",
    "deleteAccountTitle": "Delete your account",
    "deleteAccountWarning": "This action is permanent. All your data, journey progress, and uploaded documents will be permanently deleted. This cannot be undone.",
    "description": "Manage your account and preferences",
    "disable2FA": "Disable 2FA",
    "disable2FATitle": "Disable two-factor authentication",
    "disable2FAWarning": "Are you sure you want to disable two-factor authentication? Your account will be less secure without it.",
    "disconnectIdentity": "Disconnect identity",
    "documentation": "Documentation",
    "educationCount": "Education ({{count}})",
    "educationalBackground": "Educational background",
    "email": "Email",
    "emailNotifications": "Email notifications",
    "emailNotificationsDesc": "Receive updates via email",
    "enable2FA": "Enable 2FA",
    "enabled": "Enabled",
    "experienceCount": "Experience ({{count}})",
    "feature": {
      "billingManagement": "Billing and subscription management",
      "careCheckpoints": "Care checkpoint management and wellbeing tracking",
      "careerOpportunities": "Career opportunities and CV Builder",
      "checkupAssessments": "Full CheckUp assessments and readiness tracking",
      "familyProgram": "Family Program management",
      "passportTimeline": "Passport timeline, stamps, and badges",
      "qultureupLearning": "QultureUp learning summaries and progress dashboards",
      "teleportalManagement": "TelePortal plan management and task coordination"
    },
    "firstName": "First name",
    "firstNamePlaceholder": "Enter first name",
    "fullName": "Full name",
    "gdprCompliance": "GDPR compliance",
    "gdprComplianceDesc": "Tonnie complies with the General Data Protection Regulation (GDPR) and other applicable data protection laws. You can exercise your rights by contacting us through the app or website.",
    "keyFeatures": "Key features",
    "languages": "Languages",
    "lastName": "Last name",
    "lastNamePlaceholder": "Enter last name",
    "lastPdfUpload": "Last PDF uploaded: {{date}}",
    "learnMoreAboutTonnie": "Learn more about Tonnie Citizen and our platform",
    "legalInformation": "Legal information and policies",
    "linkedInDisconnected": "LinkedIn disconnected",
    "logOut": "Log out",
    "mobility": "Mobility",
    "mobilityDescription": "Citizenship, passport, and relocation interests",
    "needHelp": "Need help?",
    "notProvided": "—",
    "notificationSettings": "Notification settings",
    "ongoing": "Ongoing",
    "personalInfo": "Profile information",
    "personalInfoDescription": "Update your personal information and profile details",
    "phone": "Phone",
    "phoneInvalidFormat": "Phone number can only contain digits, spaces, dashes, and +",
    "phoneNumber": "Phone number",
    "phonePlaceholder": "912 345 678",
    "phoneTooShort": "Phone number is too short (minimum 6 digits)",
    "photoSet": "Photo set",
    "platformOverview": "Platform overview",
    "platformOverviewDescription": "Tonnie Citizen Web works seamlessly with Tonnie Citizen Mobile to provide a complete relocation experience. The mobile app is your daily companion for quick actions and mobile-first features, while the web portal provides comprehensive planning tools, detailed assessments, and progress tracking.",
    "preferenceSettings": "Preference settings",
    "preferences": "Preferences",
    "preferencesSaveError": "Failed to save preference",
    "privacyImportance": "Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your personal information.",
    "privacyPolicy": "Privacy policy",
    "privacyPolicyDesc": "How we handle and protect your personal data",
    "privacySettingUpdated": "Privacy setting updated",
    "privacySettings": "Privacy settings",
    "professionalWorkExperience": "Professional work experience",
    "profile": "Profile",
    "profilePhoto": "Profile photo",
    "profileUpdateFailed": "Failed to update profile. Please try again.",
    "profileUpdated": "Profile updated successfully!",
    "pushNotifications": "Push notifications",
    "pushNotificationsDesc": "Get notifications on your device",
    "readOnly": "This field is read-only",
    "readyToComplete": "Ready to complete your onboarding!",
    "reviewAndComplete": "Review all information above and click \"Complete\" to finish.",
    "scanQrCode": "Scan this QR code",
    "scanQrCodeDesc": "Use your authenticator app (e.g. Google Authenticator, Authy) to scan the QR code below.",
    "security": "Security",
    "sessionBrowserOnDevice": "{{browser}} on {{device}}",
    "settingDisabled": "{{setting}} disabled",
    "settingEnabled": "{{setting}} enabled",
    "shareAnalytics": "Share analytics",
    "shareAnalyticsDesc": "Help improve our platform with anonymized usage data",
    "showInTalentPool": "Show me in the Talent Pool",
    "showInTalentPoolDesc": "Let hiring companies on Tonnie discover your profile. You can opt out anytime.",
    "skills": "Skills",
    "skillsDescription": "Professional skills and expertise",
    "quietHours": "Quiet hours",
    "quietHoursDesc": "Pause push notifications during these hours.",
    "quietHoursEnd": "To",
    "quietHoursTimezone": "Times are in {{timeZone}}.",
    "quietHoursStart": "From",
    "termsAgreement": "By using Tonnie Citizen, you agree to our Terms of Service. Please review the complete terms to understand your rights and obligations.",
    "termsAndPrivacy": "Terms & privacy",
    "termsOfService": "Terms of service",
    "termsOfServiceDesc": "Our terms and conditions for using Tonnie Citizen",
    "title": "Profile",
    "tonnieJourney": "Tonnie Citizen",
    "tonnieJourneyDescription": "Tonnie Citizen is your comprehensive platform for planning and managing your international relocation journey. Track your progress, access detailed dashboards, and coordinate your move with precision.",
    "twoFactor": {
      "backupCodesLabel": "Backup codes",
      "disableError": "Failed to disable 2FA",
      "disabledToast": "Two-factor authentication disabled",
      "enableError": "Failed to start 2FA setup",
      "enabledToast": "Two-factor authentication enabled",
      "copySecretKey": "Copy secret key",
      "secretKeyLabel": "Secret key",
      "verifyError": "Invalid verification code. Please try again."
    },
    "twoFactorAuth": "Two-Factor authentication",
    "twoFactorAuthDesc": "Add an extra layer of security",
    "verificationCode": "Verification code",
    "verify": "Verify",
    "version": "Version {{version}}",
    "viewPolicy": "View policy",
    "viewTerms": "View terms",
    "yourRights": "Your rights",
    "notifCatHero": "Journey & progress",
    "notifCatHeroDesc": "Updates from CheckUp, Care, QultureUp, TelePortal and Passport.",
    "notifCatSystem": "Account & system",
    "notifCatSystemDesc": "Security, account and platform housekeeping.",
    "notifCatSocial": "People & companies",
    "notifCatSocialDesc": "Invitations, vetting, team and messages.",
    "notifCatAlert": "Alerts & reminders",
    "notifCatAlertDesc": "Time- or money-sensitive: billing, payments and deadlines.",
    "notifMatrixTitle": "How you hear about each update",
    "notifMatrixDesc": "Choose email and push for each kind of update. Your inbox always keeps a copy.",
    "notifMatrixCategory": "Category",
    "notifMatrixInApp": "In the app",
    "notifMatrixEmail": "Email",
    "notifMatrixPush": "Push",
    "notifMatrixInAppAlways": "Always on — your inbox keeps every message",
    "notifMatrixEmailOff": "Email Notifications is off, so no category sends email. Turn it on to choose here.",
    "notifMatrixPushOff": "Push Notifications is off, so no category sends push. Turn it on to choose here.",
    "notifMatrixCell": "{{channel}} for {{category}}",
    "identitySection": "Identity",
    "currentCountry": "Current country",
    "currentCountryPlaceholder": "Select where you live now",
    "currentCity": "Current city",
    "currentCityPlaceholder": "The city you live in now",
    "sections": {
      "add": "Add {{section}}",
      "saved": "Saved.",
      "saveFailed": "We couldn't save that. Please try again.",
      "importSaved": "Imported into your profile.",
      "fixErrors_one": "{{count}} field needs attention",
      "fixErrors_other": "{{count}} fields need attention",
      "status": {
        "complete": "Complete",
        "empty": "Not added yet"
      },
      "identity": {
        "title": "Identity",
        "description": "Your name, date of birth, phone and where you live."
      },
      "mobility": {
        "title": "Mobility & passport",
        "description": "Your citizenship, passport, household and how you like to work."
      },
      "skills": {
        "title": "Skills",
        "description": "Your role, years of experience, languages and skills."
      },
      "education": {
        "title": "Education",
        "description": "Your degrees and courses."
      },
      "experience": {
        "title": "Experience",
        "description": "Where you have worked and what you did."
      },
      "import": {
        "title": "Import from your CV or LinkedIn",
        "description": "Upload a CV or a LinkedIn PDF and we fill in your skills, education and experience. You review everything before it is saved.",
        "cta": "Import CV or LinkedIn"
      }
    },
    "strengthen": {
      "title": "Strengthen your profile",
      "description": "Your score is in. Tell companies more about you: add any of these whenever you like. None of it is required."
    },
    "degreeInField": "{{degree}} in {{field}}",
    "strength": {
      "gaugeCaption": "strength",
      "gaugeLabel": "Profile strength: {{percent}} percent",
      "headline": "Your profile is {{percent}}% complete",
      "headlineComplete": "Your profile is complete",
      "subline_one": "{{count}} thing left. The ones marked below shape your iQulture score.",
      "subline_other": "{{count}} things left. The ones marked below shape your iQulture score.",
      "sublineComplete": "Your CheckUp has everything the profile can give it, and companies see all of it.",
      "level": {
        "getting_started": "Getting started",
        "good": "Good",
        "strong": "Strong",
        "complete": "Complete"
      },
      "next": {
        "label": "Next step",
        "labelFastest": "Next step · fastest",
        "addButton": "Add",
        "documentTitle": "Upload your passport",
        "documentFills": "One upload fills: {{items}}",
        "documentButton": "Upload passport"
      },
      "why": {
        "start": "Needed to start your CheckUp",
        "persona": "Needed to start · sets how iQulture reads you",
        "languages": "Your English level shapes the Communication score",
        "experience": "Shapes your Global Experience score",
        "years": "Shapes your skills and experience scores",
        "skills": "Shapes your skills score",
        "education": "Shapes your Academic Readiness score",
        "workModel": "Shapes your Work Model Flexibility score",
        "passport": "Your relocation needs it — TelePortal uses it"
      },
      "readiness": {
        "startTitle": "Needed to start your CheckUp",
        "startDone": "All set. Your CheckUp can start whenever you are ready.",
        "scoreTitle": "Shapes your iQulture score",
        "scoreHint": "The score runs without these, with less to go on:",
        "scoreDone": "Your score has everything the profile can give it.",
        "more_one": "+{{count}} more",
        "more_other": "+{{count}} more"
      },
      "tag": {
        "start": "Needed to start",
        "score": "Shapes iQulture",
        "journey": "For your journey"
      },
      "item": {
        "name": "Full name",
        "date_of_birth": "Date of birth",
        "phone": "Phone",
        "residence": "Where you live",
        "nationality": "Citizenship",
        "passport": "Valid passport",
        "work_model": "How you like to work",
        "current_role": "Current role",
        "years_experience": "Years of experience",
        "skills": "Skills",
        "languages": "English level",
        "education": "A degree or course",
        "experience": "A role you have held"
      },
      "addItem": "Add {{item}}",
      "sectionBar": "Profile sections",
      "sectionCount": "{{complete}} of {{total}}",
      "segmentLabel": "{{section}}: {{complete}} of {{total}}",
      "fillFaster": {
        "recommended": "Recommended"
      },
      "missing": "Still missing",
      "fromCareerCv": "Your CV in Career already gives your iQulture score this. Add it here too to show it on your profile.",
      "loadFailed": "We couldn't load how complete your profile is."
    },
    "identityDocument": {
      "title": "Fill from your passport or ID",
      "subtitle": "Upload once. We read it, you confirm.",
      "close": "Close",
      "typeGroup": "Document type",
      "passport": "My passport",
      "passportHint": "One page. Fills the most, and every relocation needs it.",
      "idCard": "My ID card",
      "idCardHint": "Front and back. Fills your name, date of birth and nationality.",
      "uploadPassport": "The photo page of your passport",
      "uploadFront": "Front of your ID card",
      "uploadBack": "Back of your ID card",
      "uploadHint": "A photo or scan · JPG, PNG, HEIC or PDF, up to {{size}} MB",
      "chooseFile": "Choose file",
      "source": {
        "camera": "Take a photo",
        "library": "Choose a photo",
        "files": "Choose a file"
      },
      "cameraPermission": "Camera access is needed to photograph your document. You can allow it in Settings.",
      "pickUnavailable": "Choosing a file is not available right now.",
      "replaceFile": "Change",
      "aiNotice": "Your document is read by our AI service to fill in your profile. Nothing is saved to your profile until you confirm. The file is kept in your Vault, and you can delete it any time.",
      "continue": "Continue",
      "back": "Back",
      "cancel": "Cancel",
      "read": "Read document",
      "reading": {
        "saving": "Saving to your Vault",
        "reading": "Reading the document"
      },
      "review": {
        "intro": "Tick what to use. Where your profile already says something different, it is unticked so nothing changes by surprise.",
        "verified": "Checked",
        "unverified": "Read by AI — please check",
        "onFile": "On your profile: {{value}}",
        "passportValid": "Valid until {{date}}",
        "passportExpired": "Expired on {{date}}",
        "profileYes": "Yes",
        "profileNo": "No",
        "documentNumber": "Document ending {{last4}}",
        "expiredWarning": "This passport has expired. Using it records that you do not hold a valid passport.",
        "save": "Save to my profile",
        "discard": "Discard",
        "matches": "Matches your profile"
      },
      "done": {
        "title": "Your document is in",
        "bodyPassport": "Saved to your Vault and filled into your profile. TelePortal will use it for passport tasks, with no second upload.",
        "bodyIdCard": "Saved to your Vault and filled into your profile.",
        "close": "Done"
      },
      "error": {
        "notIdentity": "That does not look like a passport or ID card. Try a clear photo of the photo page.",
        "unreadable": "We could not read that file. Try a sharper photo or a PDF scan.",
        "unsupported": "That file type is not supported. Use JPG, PNG, HEIC or PDF.",
        "tooLarge": "That file is over {{size}} MB. Use a smaller photo or scan.",
        "unavailable": "Reading documents is not available right now. Try again in a moment.",
        "generic": "Something went wrong reading your document. Try again.",
        "upload": "The upload did not finish. Try again.",
        "save": "We could not save that. Try again.",
        "tryAgain": "Try another file"
      },
      "steps": {
        "document": "Document",
        "upload": "Upload",
        "reading": "Reading",
        "review": "Review"
      },
      "stepsAria": "Upload progress",
      "start": "Start",
      "privacyTitle": "Private by design.",
      "upload": {
        "title": "Add a clear photo or scan",
        "tipFrame": "The whole page, flat and in focus",
        "tipGlare": "No glare or fingers over the text",
        "tipMrzPassport": "The two lines of code at the bottom of the page fully visible",
        "tipMrzIdCard": "The lines of code on the back fully visible",
        "dropHint": "Drag a photo or PDF here"
      },
      "readingView": {
        "title": "Reading your document",
        "subtitle": "This takes a few seconds. Nothing reaches your profile until you confirm.",
        "savingCount": "Saving to your Vault · {{saved}} of {{total}}"
      },
      "reviewView": {
        "title": "Check what we read",
        "mrzVerified": "The machine-readable zone checks out",
        "mrzUnverified": "We could not check a machine-readable zone — look over each line",
        "selected_one": "{{count}} line to save",
        "selected_other": "{{count}} lines to save"
      },
      "doneView": {
        "applied": "Now on your profile",
        "nothingApplied": "Your document is in your Vault. Nothing on your profile changed."
      },
      "line": {
        "name": "Legal name, as on the document",
        "account_name": "Use it as your account name",
        "date_of_birth": "Date of birth",
        "nationality": "Nationality",
        "passport": "Valid passport"
      },
      "legalName": {
        "label": "Name on your passport or ID",
        "hint": "Read from your document. It fills the forms where a document must match; your account name above is the one people see."
      },
      "sourceShort": {
        "camera": "Camera",
        "library": "Photos",
        "files": "Files"
      },
      "slot": {
        "empty": "Not added yet",
        "added": "Added"
      }
    },
    "emailChange": {
      "sameAsCurrent": "This is already your sign-in email.",
      "taken": "This address belongs to another Tonnie account. Use a different one.",
      "done": "Your sign-in email is now {{email}}. We sent a notice to your previous address.",
      "oldKept": "You now sign in with {{email}}, but {{old}} is still on your account.",
      "oldLinked": "{{old}} stays on your account: you still sign in with {{provider}} through it.",
      "oldLinkedOther": "{{old}} stays on your account: a sign-in method you use is tied to it.",
      "removeOld": "Remove the old address",
      "sendError": "We couldn't send the code just now. Please try again in a few minutes.",
      "verifyError": "We couldn't check the code just now. Please try again in a few minutes.",
      "switchError": "The new address is confirmed, but we couldn't make it your sign-in email. Try again."
    },
    "review": {
      "company": {
        "children_one": "1 child",
        "children_other": "{{count}} children",
        "partner": "Partner",
        "personalInfoDescription": "What the talent shared about themselves",
        "pets": "Pets",
        "validPassport": "Valid passport"
      },
      "present": "Present",
      "showMore": "Show more",
      "showLess": "Show less"
    },
    "ways": {
      "document": {
        "title": "Your passport or ID card",
        "body": "Fills your date of birth, nationality and passport — from a photo.",
        "cta": "Scan my passport"
      },
      "import": {
        "title": "LinkedIn PDF or CV",
        "body": "Fills your experience, education, skills and languages — from one PDF.",
        "cta": "Import a PDF"
      },
      "fastest": "Fastest"
    },
    "citizenshipsAdd": "Add a citizenship"
  },
  "qultureup": {
    "aboutDescription": "This assessment evaluates your knowledge of:",
    "aboveLevel": "Above level",
    "achievementAdvanced": "Cultural expert",
    "achievementAdvancedDesc": "Reach Advanced level",
    "achievementCultureExplorer": "Culture explorer",
    "achievementCultureExplorerDesc": "Started 2+ worlds",
    "achievementFirstMission": "First mission",
    "achievementFirstMissionDesc": "Completed your first mission",
    "achievementStreak3": "3-Day streak",
    "achievementStreak3Desc": "Learning for 3 days straight",
    "achievementWorldMaster": "World master",
    "achievementWorldMasterDesc": "Complete an entire world",
    "achievements": "Achievements",
    "ariaWeeklyActivityChart": "Weekly activity chart",
    "assessedOn": "Assessed on {{date}}",
    "assessment": {
      "aboutDesc": "A short cultural alignment assessment that takes about 10 minutes.",
      "completeMessage": "Your QultureUp assessment is complete. Explore the worlds to keep learning.",
      "completeTitle": "Assessment complete",
      "description": "Answer a few questions about your cultural orientation so we can tailor your journey.",
      "saving": "Saving…",
      "subtitle": "About 10 minutes",
      "title": "QultureUp assessment"
    },
    "assessmentDescription": "Determine your learning level",
    "assessmentTitle": "QultureUp assessment",
    "coPilot": "CoPilot",
    "complete": "complete",
    "completeDescription": "Your learning path has been personalized.",
    "completePreviousTrack": "Complete the previous track to unlock this one",
    "completePreviousWorld": "Complete previous world",
    "completeTitle": "Assessment complete!",
    "continue": "Continue",
    "continueDescription": "You started your QultureUp assessment. Pick up right where you left off on Citizen Web — your answers so far are saved.",
    "continueInApp": "Continue in app",
    "continueInAppButton": "Continue in app",
    "continueLearning": "Continue learning",
    "continueOnWeb": "Continue on Citizen Web",
    "continueOnWebDesc": "Pick up your QultureUp assessment where you left off on the Citizen Web Portal.",
    "continueTitle": "Continue your QultureUp assessment",
    "copilotGuideDescription": "Answer questions about your cultural knowledge",
    "copilotGuideTitle": "CoPilot guide",
    "dayStreak": "Day streak",
    "description": "Learn your new culture",
    "difficultyAdvanced": "Advanced",
    "difficultyBeginner": "Beginner",
    "difficultyIntermediate": "Intermediate",
    "dimensionCulture": "Local culture & norms",
    "dimensionHistory": "History & everyday life",
    "dimensionLanguage": "Language reality (native + English, and basic target language phrases)",
    "dimensionWorkplace": "Workplace culture & rights/duties basics",
    "error": {
      "description": "We couldn't load your QultureUp data. Please try again.",
      "retry": "Try again",
      "title": "Something went wrong"
    },
    "estimatedTime": "Estimated time",
    "filterAdvanced": "Advanced",
    "filterAll": "All levels",
    "filterBeginner": "Beginner",
    "filterIntermediate": "Intermediate",
    "heroBanner": {
      "subtitle": "Master the cultural side of your move",
      "title": "QultureUp"
    },
    "heroMiles": "QultureUp Miles",
    "hours": "h",
    "learnOnTheGo": "Learn on the go",
    "learnOnTheGoDesc": "Complete missions, earn Miles, and track your cultural learning progress with the mobile app.",
    "loadingAssessment": "Loading assessment…",
    "miles": "Miles",
    "minutes": "min",
    "missionDetailsInApp": "Mission details available in the mobile app",
    "missions": "Missions",
    "missionsCompleted": "{{completed}} of {{total}} missions completed",
    "missionsCount": "{{completed}}/{{total}} missions",
    "missionsLabel": "Missions",
    "nextMission": "Next",
    "noMissionsForLevel": "No missions at this level for this track.",
    "noTracksAvailable": "No tracks available for this world yet.",
    "noUnlockedWorlds": "No unlocked worlds yet.",
    "noWorldsAvailable": "No worlds available yet. Check back soon!",
    "ofTotal": "{{completed}} of {{total}}",
    "ofTotalCompleted": "{{completed}} of {{total}} completed",
    "openInApp": "Open in app",
    "openTonnieCitizen": "Open in app",
    "percentComplete": "{{percent}}% complete",
    "progressTitle": "Assessment progress",
    "qultureupMiles": "QultureUp miles",
    "recentlyCompleted": "Recently completed",
    "retakeAssessment": "Retake assessment",
    "retakeOnWeb": "Retake on Citizen Web",
    "retakeOnWebDesc": "Retake your QultureUp assessment on the Citizen Web Portal to update your personalized learning path.",
    "returnToDashboard": "Return to dashboard",
    "score": "Score: {{score}}%",
    "start": "Start",
    "startInApp": "Start in app",
    "startMission": "Start mission",
    "startOnWeb": "Start on Citizen Web",
    "startOnWebDesc": "Complete your QultureUp assessment on the Citizen Web Portal to unlock your personalized learning path.",
    "tabOverview": "Overview",
    "tabTracksAndMissions": "Tracks & missions",
    "tabWorlds": "Worlds",
    "thisWeek": "This week",
    "timeLearning": "Time learning",
    "title": "QultureUp",
    "todaysMission": "Today's mission",
    "tracks": "Tracks",
    "tracksCompleted": "{{completed}} of {{total}} tracks completed",
    "tryAgainLater": "Please try again later.",
    "unableToLoad": "Unable to load QultureUp data",
    "upNext": "Up next",
    "welcome": {
      "cultureStep": "Culture & history",
      "cultureStepDesc": "Explore local traditions, heritage, and civic life",
      "description": "Discover your cultural readiness and unlock a personalized learning path. Our assessment evaluates your knowledge across key citizenship dimensions to guide your integration journey.",
      "languageStep": "Language & communication",
      "languageStepDesc": "Build confidence in daily and official interactions",
      "letsStart": "Let's start",
      "socialStep": "Social & workplace norms",
      "socialStepDesc": "Understand everyday customs and professional expectations",
      "timeEstimate": "Takes about 5-10 minutes to complete",
      "title": "Welcome to QultureUp"
    },
    "world": {
      "completed": "Completed"
    },
    "worlds": "Worlds",
    "questionTier": {
      "easy": "Easy",
      "medium": "Medium",
      "hard": "Hard"
    },
    "difficultyA11y": "Difficulty: {{level}}",
    "min_one": "{{count}} min",
    "min_other": "{{count}} min",
    "sectionsLabel_one": "{{count}} section",
    "sectionsLabel_other": "{{count}} sections"
  },
  "security": {
    "changePassword": "Change password",
    "changing": "Changing...",
    "confirmNewPassword": "Confirm new password",
    "confirmPasswordPlaceholder": "Confirm new password",
    "currentPassword": "Current password",
    "currentPasswordPlaceholder": "Enter current password",
    "fillAllFields": "Please fill in all fields",
    "newPassword": "New password",
    "newPasswordPlaceholder": "Enter new password",
    "passwordChangeFailed": "Failed to change password. Please try again.",
    "passwordChanged": "Your password has been changed successfully.",
    "passwordMustDiffer": "New password must be different from current password",
    "passwordsNotMatch": "New passwords do not match",
    "sessionNotFound": "User session not found. Please sign in again.",
    "title": "Security",
    "ssoManagedTitle": "Sign-in managed by {{provider}}",
    "ssoManagedDesc": "You signed up with {{provider}}, so your account has no Tonnie password. Manage your credentials in your {{provider}} account.",
    "ssoGenericProvider": "your linked sign-in provider"
  },
  "settings": {
    "about": {
      "title": "About"
    },
    "billing": "Billing",
    "dark": "Dark",
    "deleteAccount": "Delete account",
    "deleteAccountConfirm": "This will permanently delete your account and all data. This cannot be undone.",
    "deleteAccountFailed": "Failed to delete account. Please try again.",
    "freePlan": "Free plan",
    "language": {
      "title": "Language"
    },
    "light": "Light",
    "myCheckups": "My CheckUps",
    "myFamily": "My Family",
    "myJourneys": "My journeys",
    "preferences": "Preferences",
    "profile": "Profile",
    "security": "Security",
    "sendFeedback": "Send feedback",
    "signOut": "Sign out",
    "signOutConfirm": "Are you sure you want to sign out?",
    "termsPrivacy": "Terms & privacy",
    "theme": {
      "title": "Theme"
    },
    "themeSystem": "System ({{mode}})",
    "title": "Settings",
    "sessions": {
      "notFound": "Session not found",
      "signedOut": "Session signed out",
      "signOutFailed": "Failed to sign out session",
      "loadFailed": "Failed to load sessions"
    },
    "preferencesLanguageFallback": "English",
    "membersCount_one": "{{count}} member",
    "membersCount_other": "{{count}} members",
    "groups": {
      "journey": "Your journey",
      "app": "App",
      "help": "Help & legal"
    },
    "profileStrength": "Profile: {{level}} · {{percent}}",
    "pro": "Pro"
  },
  "splash": {
    "authenticateToContinue": "Authenticate to continue",
    "biometricFailed": "Biometric authentication failed",
    "tryAgain": "Try again",
    "unlockPrompt": "Unlock Tonnie Citizen",
    "usePasswordInstead": "Use password instead"
  },
  "sponsorship": {
    "companySponsored": "Company sponsored",
    "familySponsored": "Family sponsored",
    "governmentSponsored": "Government sponsored",
    "selfPaid": "Self-Paid"
  },
  "stepper": {
    "care": "Care",
    "checkup": "CheckUp",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "start": "Start",
    "teleportal": "TelePortal"
  },
  "supportRequest": {
    "categories": {
      "account": "Account",
      "billing": "Billing",
      "general": "General",
      "technical": "Technical"
    },
    "category": "Category",
    "description": "Description",
    "descriptionPlaceholder": "Describe your issue in detail...",
    "fillAllFields": "Please fill in all fields.",
    "requestSubmitted": "Request submitted",
    "subject": "Subject",
    "subjectPlaceholder": "Brief summary of your issue",
    "submitRequest": "Submit request",
    "successMessage": "Our support team will review your request and follow up soon.",
    "teamFollowUp": "Our team will get back to you soon.",
    "trustHow": "Faster resolution and personalised follow-up.",
    "trustWho": "Only our support team — never shared with third parties.",
    "trustWhy": "To route your request to the right support specialist."
  },
  "tabs": {
    "care": "Care",
    "home": "Home",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal"
  },
  "teleportal": {
    "aboutDescription": "This assessment helps us understand your relocation needs:",
    "aboutTitle": "About this assessment",
    "addNote": "Add note",
    "agentDate": "Date",
    "agentHistory": "Agent interaction history",
    "agentHistoryDescription": "View past interactions with the TelePortal Consultant Agent",
    "agentInteraction": "Interaction",
    "agentSummary": "Summary",
    "all": "All",
    "allScope": "All members",
    "allStatus": "All status",
    "allTracks": "All tracks",
    "applicationPackages": "Application packages",
    "applicationPackagesDescription": "View your organized document packages",
    "askCoPilot": "Ask CoPilot about this task",
    "assessment": {
      "destination": "Destination",
      "education": "Education",
      "educationBachelor": "Bachelor's degree",
      "educationHighSchool": "High school",
      "educationMaster": "Master's degree",
      "educationPhd": "PhD / Doctorate",
      "educationVocational": "Vocational / Technical",
      "experience": "Experience",
      "experience0to2": "0-2 years",
      "experience10Plus": "More than 10 years",
      "experience3to5": "3-5 years",
      "experience6to10": "6-10 years",
      "infoDestination": "Destination country preferences",
      "infoPurpose": "Purpose of relocation",
      "infoQualifications": "Qualifications assessment",
      "infoTimeline": "Timeline and urgency",
      "purpose": "Purpose",
      "purposeEntrepreneur": "Start a Business",
      "purposeFamily": "Family reunification",
      "purposeRetire": "Retirement",
      "purposeStudy": "Study / Education",
      "purposeWork": "Employment / Work",
      "questionDestination": "Which country are you targeting for relocation?",
      "questionEducation": "What is your highest level of education?",
      "questionExperience": "How many years of professional experience do you have?",
      "questionPurpose": "What is your primary purpose for relocating?",
      "questionTimeline": "When do you plan to relocate?",
      "timeline": "Timeline",
      "timeline1Year": "Within 1 year",
      "timeline3Months": "Within 3 months",
      "timeline6Months": "Within 6 months",
      "timelineAsap": "As soon as possible",
      "timelineExploring": "Just exploring"
    },
    "assessmentCompleteMessage": "We've analyzed your profile and identified potential visa pathways for your target destination.",
    "assessmentDescription": "Configure your relocation journey",
    "assessmentTitle": "TelePortal assessment",
    "associatedWithTasks": "Associated with tasks",
    "attachExistingDocument": "Attach existing document",
    "backToDashboard": "Back to dashboard",
    "blocked": "Blocked",
    "blockedBy": "Blocked By",
    "blocking": "Blocking",
    "blockingOnly": "Blocking tasks only",
    "brain": {
      "error": "Something went wrong building your kit. Please try again in a moment.",
      "destinationNotSupported": "We can't build a relocation kit for this destination yet. Your journey is saved — TelePortal will open here as soon as this destination is supported.",
      "phase1": "Analyzing your profile",
      "phase2": "Mapping required documents",
      "phase3": "Building task list",
      "phase4": "Personalizing milestones",
      "phase5": "Finalizing your kit",
      "ready": "Your kit is ready",
      "reviewKit": "Review your kit",
      "stat": {
        "docsNeeded": "Documents needed",
        "fromVault": "From your vault",
        "members": "Members",
        "tasks": "Tasks"
      },
      "subtitle": "Building your personalized relocation kit",
      "title": "TelePortal Brain",
      "complexity": {
        "simple": "Simple",
        "standard": "Standard",
        "complex": "Complex"
      }
    },
    "captureMobile": "Capture on mobile",
    "certificationLabel": "Certification",
    "certificationRequired": "{{type}}",
    "clearFilters": "Clear filters",
    "clickToUpload": "Click to upload or drag and drop",
    "collapseDetails": "Collapse details",
    "comingSoon": "Coming soon",
    "companionCareerProgress": "Companion Career progress",
    "companionEmploymentReadiness": "Companion employment readiness assessment",
    "companionIntegrationSupport": "Companion Adaptation support milestones",
    "companionProgram": "Companion program",
    "companionProgramDesc": "Risk reduction for dual-career households — track companion's employment readiness and integration support",
    "complete": "Complete",
    "completeInMobile": "Complete in mobile",
    "completeTasksOnMobile": "Complete tasks on mobile",
    "completeTitle": "Assessment complete!",
    "completed": "Completed",
    "completedDate": "Completed {{date}}",
    "completedSection": "Completed",
    "completionNotesPlaceholder": "Add completion notes (optional)...",
    "complexity": {
      "complex": "Complex",
      "simple": "Simple",
      "standard": "Standard"
    },
    "consultantAgent": "TelePortal consultant agent",
    "consultantAgentDesc": "Get expert guidance from our immigration consultants",
    "consultantAgentDescription": "Get help with your TelePortal documents and tasks",
    "consultantAgentHelp": "The Consultant Agent can help you validate, organize, and attach documents automatically",
    "continue": {
      "description": "You started your TelePortal setup. Pick up right where you left off on Citizen Web — your answers so far are saved.",
      "title": "Continue your TelePortal setup"
    },
    "continueOnWeb": "Continue on Citizen Web",
    "continueOnWebDesc": "Pick up your TelePortal setup where you left off on the Citizen Web Portal.",
    "copilotGuideDescription": "Answer questions about your relocation needs",
    "copilotGuideTitle": "CoPilot guide",
    "couldNotLoad": "We couldn't load your TelePortal data. Please try again.",
    "createApplicationPackage": "Create application package",
    "createApplicationPackageDesc": "Prepare and organize all your application documents",
    "createApplicationPackageDescription": "Package multiple documents for visa applications and other submissions",
    "createInMobile": "Create in mobile",
    "criticalTasks": "Critical tasks",
    "currentProofDocuments": "Current proof documents",
    "currentlyInProgress": "Currently in progress",
    "daysLeft": "{{count}}d left",
    "deleteDocumentDescription": "This action cannot be undone. The document will be permanently removed.",
    "deleteDocumentTitle": "Delete document?",
    "dependencies": {
      "allTracks": "All tracks",
      "blockedBy": "Blocked by",
      "blocking": "Blocking",
      "blocks": "Blocks",
      "connectedTasks": "connected tasks",
      "criticalPath": "Critical path",
      "dependsOn": "Depends on",
      "description": "Visualize how tasks depend on each other across tracks",
      "empty": "No task dependencies to display",
      "emptyHint": "Dependencies will appear when your relocation kit has linked tasks",
      "enterFullscreen": "Enter fullscreen",
      "exitFullscreen": "Exit fullscreen",
      "filterByTrack": "Filter by track",
      "graphLabel": "Task dependency graph",
      "graphView": "Graph view",
      "independentTasks": "independent tasks",
      "insightBanner": "Dependency insight",
      "listView": "List view",
      "members": "Members",
      "resetView": "Reset view",
      "shared": "Shared",
      "tabTitle": "Dependencies",
      "title": "Task dependency graph",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out"
    },
    "dependenciesResolved": "Dependencies (resolved)",
    "description": "Description",
    "dimensionFamily": "Family configuration",
    "dimensionStatus": "Current status",
    "dimensionTimeline": "Timeline and deadlines",
    "dimensionVisa": "Visa type and requirements",
    "docDetail": {
      "actions": "Actions",
      "certification": "Certification",
      "certificationNone": "Not required",
      "certificationRequired": "Required ({{type}})",
      "expired": "Expired",
      "expiryDate": "Expiry date",
      "issuingAuthority": "Issuing authority",
      "location": "Location",
      "locationHomeCountry": "Home country",
      "locationOnline": "Online",
      "locationTargetCountry": "Target country",
      "noExpiry": "No expiry date",
      "status": "Status",
      "title": "Document details",
      "type": "Document type",
      "upload": "Upload document",
      "uploadedAt": "Uploaded",
      "validityPeriod": "Validity period",
      "view": "View document",
      "viewFailed": "Failed to open document",
      "openWith": "Open document with…",
      "expiresIn_one": "Expires in {{count}} day",
      "expiresIn_other": "Expires in {{count}} days",
      "validFor_one": "Valid for {{count}} day",
      "validFor_other": "Valid for {{count}} days"
    },
    "docEmployment": "Employment contract",
    "docIncome": "Proof of income",
    "docInsurance": "Health insurance",
    "docNeedsReview": "Document needs review — format may not be optimal",
    "docNotUploaded": "Document not yet uploaded",
    "docPassport": "Passport",
    "docStatusMissing": "Missing",
    "docStatusPending": "Pending",
    "docStatusRejected": "Rejected",
    "docStatusUploaded": "Uploaded",
    "docStatusVerified": "Verified",
    "docSuggestion1": "Ensure document is clear and readable",
    "docSuggestion2": "Check expiration date",
    "docTypeEducation": "Education",
    "docTypeFinancial": "Financial",
    "docTypeHousing": "Housing",
    "docTypeIdentity": "Identity",
    "docTypeLegal": "Legal",
    "docTypeOther": "Other",
    "docTypeTravel": "Travel",
    "docUploadedPendingValidation": "Document uploaded, pending validation",
    "docValid": "Document verified and valid",
    "document": {
      "apostille": "Apostille required",
      "certification": "Certification",
      "certificationRequired": "Certification required",
      "docExpired": "This document has expired",
      "docExpiring": "This document expires in {{days}} days",
      "expired": "Expired",
      "expiresIn": "Expires in {{days}} days",
      "expiresSoon": "Expires soon",
      "haia": "Hague apostille",
      "validFor": "Valid for {{duration}}"
    },
    "documentDeleted": "Document deleted",
    "documentDownloaded": "Document downloaded",
    "documentName": "Document name",
    "documentNamePlaceholder": "e.g., Passport, Birth Certificate...",
    "documentType": "Document type",
    "documentUploadError": "Failed to upload document. Please try again.",
    "documentUploadRequired": "Document upload required",
    "documentUploadedSuccess": "Document uploaded successfully",
    "documentValidatedSuccess": "Document validated successfully",
    "documentValidationError": "Failed to validate document. Please try again.",
    "documents": "documents",
    "documentsDescription": "Upload and verify documents required for your visa application and relocation.",
    "documentsGathered": "Documents gathered",
    "documentsReady": "Documents ready",
    "documentsStatus": "Documents status",
    "documentsUploaded": "Documents uploaded successfully",
    "done": "Done",
    "dueDate": "Due date",
    "dueToday": "Due today",
    "dueTomorrow": "Due tomorrow",
    "editNote": "Edit note",
    "editTask": "Edit task",
    "employerFull": "Yes, full sponsorship",
    "employerNA": "Not applicable",
    "employerNone": "No, self-sponsored",
    "employerPartial": "Yes, partial support",
    "entireFamily": "Entire Family",
    "estimatedDuration": "Estimated duration",
    "estimatedTime": "Estimated time",
    "eventTargetArrival": "Target arrival",
    "eventVisaDecision": "Visa decision",
    "eventVisaInterview": "Visa interview",
    "expandDetails": "Expand details",
    "expired": "Expired",
    "expiredCount": "Expired",
    "expiresInDays": "Expires in {{count}}d",
    "downloadAllDocuments": "Download all ({{count}})",
    "downloadSelectedDocuments": "Download {{count}}",
    "selectDocument": "Select document",
    "expiresOn": "Expires: {{date}}",
    "expiringSoon": "Expiring soon",
    "explainTask": "Explain task",
    "family": "Family",
    "familyBoth": "With partner and children",
    "familyChildren": "With children",
    "familyConfig": {
      "applicableTracks": "Applicable tracks",
      "childNumber": "Child {{number}}",
      "companion": "Companion",
      "configureTracksDescription": "Select which tracks (Legal, Travel, Setup) apply to each family member",
      "configureTracksTitle": "Configure tracks for each member",
      "dependent": "Dependent",
      "description": "Configure track access for each family member, pet, companion, or dependent",
      "familyMember": "Family member",
      "justMe": "Just me",
      "legal": "Legal",
      "mainQuestion": "Will you be relocating with family members?",
      "partnerSpouse": "Partner/Spouse",
      "pet": "Pet",
      "pets": "Pets",
      "setup": "Setup",
      "travel": "Travel",
      "yesBringingFamily": "Yes, bringing family",
      "membersConfigured_one": "{{count}} member set up",
      "membersConfigured_other": "{{count}} members set up"
    },
    "familyJustMe": "Just me",
    "familyMasterOnly": "Only Family Master can modify TelePortal tasks",
    "familyMasterOnlyDesc": "Only the Family Master can start or control TelePortal assessment and tasks. Contact your Family Master for assistance.",
    "familyPartner": "With partner/spouse",
    "filter": {
      "allExpiry": "All expiry",
      "clearAll": "Clear",
      "expired": "Expired",
      "expiringSoon": "Expiring soon",
      "location": "Location",
      "locationAll": "All locations",
      "locationHome": "Home country",
      "locationOnline": "Online",
      "locationTarget": "Target country",
      "member": "Member",
      "memberAll": "All members",
      "selectMember": "Select member",
      "sort": "Sort",
      "sortDefault": "Default",
      "sortDueDate": "Due date",
      "sortPriority": "Priority",
      "valid": "Valid"
    },
    "ganttView": "Gantt view",
    "generatingChecklist": "Generating your personalized checklist...",
    "goToJourneyBuilder": "Go to journey builder",
    "groupBy": {
      "byTrack": "By track",
      "label": "Group by",
      "location": "Group by location"
    },
    "guideSetupSubtitle": "We'll guide you through setup — answer a few questions and we'll build your kit.",
    "heroBanner": {
      "complete": "Complete",
      "documents": "Documents",
      "household": "Household",
      "milestones": "Milestones",
      "subtitle": "Your relocation command center",
      "tasks": "Tasks",
      "title": "TelePortal"
    },
    "heroMiles": "TelePortal Miles",
    "highPriority": "High priority",
    "household": {
      "everyone": "Everyone",
      "bar": {
        "allMembers": "All members",
        "filterBy": "Filter by member",
        "filterByMember": "Filter by member"
      },
      "petSpecies": {
        "cat": "Cat",
        "dog": "Dog",
        "other": "Other"
      },
      "schoolStages": {
        "higher": "Higher education",
        "pre_school": "Pre-school",
        "primary": "Primary school",
        "secondary": "Secondary school"
      },
      "talent": "You"
    },
    "householdAware": "Household-aware",
    "householdMembers": "Household members",
    "inProgressSection": "In progress",
    "keyDates": "Key dates",
    "kit": {
      "activate": "Activate kit",
      "activateModified": "Activate modified kit",
      "buildFailed": "Couldn't build your kit",
      "buildFailedHint": "Try again or contact support if this persists.",
      "byMember": "By member",
      "byTrack": "By track",
      "complexity": {
        "complex": "Complex",
        "simple": "Simple",
        "standard": "Standard"
      },
      "defaultMember": "You",
      "dependencyWarning": "Some tasks depend on others. Removing one may block downstream work.",
      "docs": "Documents",
      "docsLinked": "From vault",
      "docsNeeded": "Docs needed",
      "editHint": "Click any task to edit, remove, or reorder.",
      "loading": "Loading kit…",
      "members": "Members",
      "miles": "Miles",
      "modified": "Modified",
      "rebuild": "Rebuild",
      "rebuildConfirm": "Rebuild kit",
      "rebuildConfirmDesc": "Rebuilding will create a fresh kit based on your latest profile. Modifications you made will be lost.",
      "rebuildConfirmTitle": "Rebuild your kit?",
      "removeTask": "Remove task",
      "removedTasks": "Removed tasks",
      "required": "Required",
      "requiredTask": "Required task",
      "restore": "Restore",
      "retry": "Retry",
      "tasks": "Tasks",
      "title": "Your TelePortal kit",
      "vaultLinked": "Linked from vault",
      "taskCount_one": "{{count}} task",
      "taskCount_other": "{{count}} tasks",
      "milestoneCount_one": "{{count}} milestone",
      "milestoneCount_other": "{{count}} milestones"
    },
    "location": {
      "all": "All",
      "either": "Either country",
      "filter": "Location",
      "filterLabel": "Location",
      "homeCountry": "Home country",
      "online": "Online",
      "other": "Other",
      "targetCountry": "Target country"
    },
    "locationEither": "Either",
    "locationHome": "Home",
    "locationOnline": "Online",
    "locationTarget": "Target",
    "manageJourney": "Plan your relocation",
    "markAsDone": "Mark as done",
    "markComplete": "Mark complete",
    "milesEarned": "+{{miles}} Journey Miles earned",
    "milestoneArrivalPlanning": "Arrival planning",
    "milestoneDocumentCollection": "Document collection",
    "milestoneEssentialServices": "Essential services",
    "milestoneFinancialSetup": "Financial setup",
    "milestoneHousing": "Housing",
    "milestoneTravelBooking": "Travel booking",
    "milestoneVisaApplication": "Visa application",
    "milestones": {
      "admin_complete": "Admin complete",
      "arrived_in_destination": "Arrived at destination",
      "arrived_in_portugal": "Arrived in Portugal",
      "documents_gathered": "Documents gathered",
      "documents_legalized": "Documents legalized",
      "fully_settled": "Fully settled",
      "housing_secured": "Housing secured",
      "legal_registration_complete": "Legal registration complete",
      "travel_booked": "Travel booked",
      "visa_approved": "Visa approved"
    },
    "milestonesCount": "{{completed}}/{{total}} milestones",
    "milestonesLabel": "Milestones",
    "missing": "Missing",
    "mobileAppDescription": "Use the mobile app to upload documents, complete tasks, and get real-time guidance from the TelePortal Consultant Agent.",
    "needHelp": "Need help?",
    "needsAttention": "Needs attention",
    "noAgentHistory": "No agent interactions yet",
    "noAgentHistoryDescription": "Use the TelePortal Consultant Agent in the mobile app to get help with documents",
    "noDocumentsAttached": "No documents attached yet",
    "noDocumentsInTrack": "No documents in this track yet",
    "noDocumentsUploaded": "No documents uploaded yet",
    "noJourneySelected": "No journey selected",
    "noJourneySelectedDesc": "Select a journey to view your TelePortal tasks and progress",
    "noMilestonesYet": "No milestones yet",
    "noPackages": "No application packages created yet",
    "noPackagesDescription": "Create packages in the mobile app to organize documents for submissions",
    "noProofAttached": "No proof document attached yet",
    "noTasksAnyTrack": "No tasks available in any track yet",
    "noTasksFoundForFilter": "No tasks found for the selected filter",
    "noTasksInProgress": "No tasks currently in progress",
    "noTasksInTrack": "No tasks available in this track yet",
    "noTasksMatchingFilters": "No tasks match your current filters",
    "notePlaceholder": "Add your notes here...",
    "noteSaved": "Note saved",
    "notes": "Notes",
    "openInApp": "Open in app",
    "openInMobile": "Open in mobile",
    "openTonnieCitizen": "Open in app",
    "openingDocument": "Opening document...",
    "orDragAndDrop": "PDF, JPG, PNG up to 10MB",
    "orUploadNewProof": "Or upload new proof document",
    "otherDocuments": "Other documents",
    "overallProgress": "Overall progress",
    "overdue": "Overdue",
    "packageCreated": "Created",
    "packageDocuments": "Documents",
    "packageDownload": "Download package",
    "packageName": "Package name",
    "packagePurpose": "Purpose",
    "pending": "Pending",
    "pendingReview": "Pending review",
    "preparingSetup": "Preparing setup…",
    "priorityBlockedTasks": "Priority & blocked tasks",
    "priorityTasksRequiringAttention": "Priority tasks requiring attention",
    "proOnly": "Pro only",
    "processing": "Processing...",
    "progress": "Progress",
    "progressComplete": "{{percent}}% complete",
    "progressSummary": "You're {{progress}}% through your relocation journey. {{attention}} tasks need your attention.",
    "progressTitle": "Assessment progress",
    "proof": "Proof",
    "proofOfDone": "Proof of done",
    "proofOfDoneDescription": "Attach a document as proof that this task has been completed",
    "proofRequired": "This task requires proof of completion. Please attach a document.",
    "questionCurrentStatus": "What's your current status?",
    "questionEmployerSupport": "Do you have employer support or sponsorship?",
    "questionFamily": "Will you be relocating with family members?",
    "questionTargetDate": "What's your target move date?",
    "questionTargetDateFormatted": "What's your target move date? (MM/YYYY)",
    "questionVisaType": "What type of visa or relocation route are you planning?",
    "readOnly": "Read-only view",
    "readOnlyDescription": "Tasks can be completed in the mobile app",
    "redirectingIn": "Redirecting...",
    "rejected": "Rejected",
    "required": "Required",
    "requiredDocuments": "Required documents",
    "requiredForTask": "Required for",
    "requiresProof": "Requires proof",
    "resolveNow": "Resolve now",
    "retakeOnWeb": "Retake setup on Citizen Web",
    "retakeOnWebDesc": "Redo the TelePortal setup wizard on the Citizen Web Portal to update your personalized relocation plan.",
    "retakeSetup": {
      "label": "Retake setup",
      "acknowledge": "I understand",
      "cleanDocs": "Clear linked documents",
      "cleanTasks": "Clear modified tasks",
      "confirmReset": "Reset & rebuild",
      "preFilled": "Your previous answers are pre-filled. Update what changed.",
      "rebuildTasks": "Rebuild task list"
    },
    "returnToDashboard": "Return to dashboard",
    "saveNote": "Save note",
    "searchTasks": "Search tasks...",
    "selectDocumentType": "Select type...",
    "selected": "Selected",
    "setup": {
      "dimensions": {
        "household": {
          "addMember": "Add household member",
          "memberTypes": {
            "child": "Child",
            "extended_family": "Extended Family",
            "partner": "Partner / Spouse",
            "pet": "Pet",
            "talent": "Main applicant (you)"
          },
          "subtitle": "Who's relocating with you?",
          "title": "Your household"
        },
        "housing": {
          "plans": {
            "buy": "Buy a property",
            "company_provided": "Company-provided housing",
            "rent": "Rent an apartment",
            "temporary": "Temporary accommodation first"
          },
          "subtitle": "Where will you live?",
          "title": "Housing plan"
        },
        "legalStatus": {
          "currentStatus": "Current immigration status",
          "subtitle": "Your current legal situation",
          "title": "Legal & immigration status",
          "visaType": "Visa type"
        },
        "professional": {
          "sponsorshipTypes": {
            "company_sponsored": "Company sponsored",
            "freelancer": "Freelancer / Digital nomad",
            "intra_company": "Intra-company transfer",
            "job_seeker": "Job seeker",
            "other": "Other",
            "retired": "Retired",
            "self_employed": "Self-employed",
            "startup": "Starting a business",
            "student": "Student"
          },
          "subtitle": "Your work situation",
          "title": "Professional context"
        },
        "specialCircumstances": {
          "freeTextPlaceholder": "Tell us anything else...",
          "options": {
            "custody_arrangement": "Custody arrangement",
            "dietary_needs": "Special dietary needs",
            "disability_accommodation": "Disability accommodation",
            "medical_needs": "Medical needs or ongoing treatment",
            "military_service": "Military service obligations",
            "pending_legal": "Pending legal matters",
            "religious_requirements": "Religious requirements"
          },
          "subtitle": "Anything else we should know?",
          "title": "Special circumstances"
        },
        "timeline": {
          "subtitle": "When do you need to relocate?",
          "title": "Timeline",
          "urgencies": {
            "flexible": "Flexible / No rush",
            "immediate": "Immediately (within 1 month)",
            "within_3_months": "Within 3 months",
            "within_6_months": "Within 6 months"
          }
        },
        "travel": {
          "modes": {
            "already_there": "Already at destination",
            "one_way": "One-way trip",
            "round_trip": "Round trip (coming back first)"
          },
          "subtitle": "How and when are you traveling?",
          "title": "Travel logistics"
        },
        "vaultScan": {
          "linked": "Linked from vault",
          "outdated": "Needs update",
          "skip": "Skip for now",
          "subtitle": "Let's check what documents you already have",
          "title": "Document scan"
        }
      },
      "processing": {
        "subtitle": "Tonnie is analyzing your situation and creating a personalized plan...",
        "title": "Building your relocation kit"
      },
      "refresh": {
        "button": "Refresh my relocation kit",
        "cancel": "Cancel",
        "confirm": "Refresh",
        "confirmMessage": "Your completed tasks will be preserved. New tasks may be added and some may be archived.",
        "confirmTitle": "Refresh relocation kit?"
      },
      "subtitle": "Let's personalize your relocation plan",
      "summary": {
        "beginJourney": "Begin my journey",
        "complexityLabel": "Complexity",
        "documentsLabel": "Documents needed",
        "householdLabel": "Household members",
        "tasksLabel": "Total tasks",
        "title": "Your relocation kit",
        "tracksLabel": "Tracks"
      },
      "title": "Build your relocation kit",
      "welcome": {
        "prePopulated": "We've pre-filled some information from your profile",
        "subtitle": "We'll build a personalized Relocation Kit based on your situation",
        "title": "Welcome to TelePortal setup"
      },
      "aria": {
        "collapsePanel": "Collapse panel",
        "pinPanel": "Pin panel",
        "unpinPanel": "Unpin panel"
      }
    },
    "setupActivateError": "Failed to activate kit",
    "setupActivatingMessage": "Activating your kit — this takes just a moment.",
    "setupActivatingTitle": "Activating…",
    "setupComplete": "Setup complete",
    "setupCompletedOn": "Setup completed on {{date}}",
    "setupConfigError": "We couldn't load your setup configuration",
    "setupError": "Setup error",
    "setupEstimatedTime": "About 5 minutes",
    "setupInfoDescription": "We'll ask a few questions to personalize your kit — what to bring, who's coming, and your timeline.",
    "setupInfoIntro": "TelePortal is your relocation command center. Setup helps us tailor the kit to your move.",
    "setupMissingJourney": "We couldn't find a journey to set up.",
    "setupNoJourney": "No journey selected",
    "setupNoJourneyMessage": "Pick a journey first, then we'll build your TelePortal kit.",
    "setupOnWeb": "Set up on Citizen Web",
    "setupOnWebDesc": "Complete the TelePortal setup wizard on the Citizen Web Portal to build your personalized relocation plan.",
    "setupProgress": "Setup progress",
    "setupSubtitle": "Personalize your relocation kit",
    "setupSuccessMessage": "Your kit is ready. Let’s start your relocation.",
    "setupSuccessTitle": "You're all set",
    "setupTitle": "TelePortal setup",
    "somethingWentWrong": "Something went wrong",
    "startAssessment": "Start assessment",
    "startTask": "Start task",
    "status": "Status",
    "statusBlocked": "Blocked",
    "statusCompleted": "Completed",
    "statusHome": "Still in home country",
    "statusInProgress": "In progress",
    "statusMoved": "Already moved to destination",
    "statusOverdue": "Overdue",
    "statusTodo": "To do",
    "statusTransit": "In transit",
    "stepOf": "Step {{current}} of {{total}}",
    "summary": {
      "assessmentDetails": "Assessment details",
      "checklistPreviewTitle": "Your personalized checklist will include:",
      "currentStatus": "Current status",
      "description": "Review your relocation details before we generate your personalized checklist",
      "destination": "Destination",
      "employerSupport": "Employer support",
      "familyConfiguration": "Family configuration",
      "generateChecklist": "Generate checklist",
      "journeyRoute": "Journey route",
      "legalTrackDesc": "Legal track — Legal readiness and documents",
      "makeChanges": "Make changes",
      "notSelected": "Not selected",
      "origin": "Origin",
      "setupTrackDesc": "Setup track — Accommodation, credential recognition, and first weeks",
      "targetMoveDate": "Target move date",
      "title": "TelePortal assessment summary",
      "travelTrackDesc": "Travel track — Logistics and travel planning",
      "viewModeDescription": "Complete information about your relocation assessment",
      "visaType": "Visa type"
    },
    "tabDocuments": "Documents",
    "tabOverview": "Overview",
    "tabTasks": "Tasks",
    "tabTimeline": "Timeline",
    "tabTracks": "Tracks & tasks",
    "targetDate": "Target date",
    "task": {
      "allMembers": "All members",
      "ask": "Ask",
      "askCopilotTask": "Ask CoPilot about this task",
      "blockedBy": "Blocked By",
      "blockedComplete": "Blocked — Complete dependencies first",
      "completeError": "Failed to complete task. Please try again.",
      "completionNotesPlaceholder": "Add completion notes (optional)...",
      "confirmComplete": {
        "message": "Are you sure you want to mark this task as complete? This action cannot be undone.",
        "title": "Mark task as complete?"
      },
      "dependenciesResolved": "Dependencies (resolved)",
      "docStatusMissing": "Missing",
      "docStatusPending": "Pending",
      "docStatusRejected": "Rejected",
      "docStatusUploaded": "Uploaded",
      "docStatusVerified": "Verified",
      "documents": "Documents",
      "documentsRequired": "Documents required",
      "dueToday": "Due today",
      "dueTomorrow": "Due tomorrow",
      "entireFamily": "Entire Family",
      "markComplete": "Mark as complete",
      "needHelp": "Need help?",
      "noAdditionalDocs": "No additional documents",
      "noDocsAttached": "No documents attached yet",
      "notFound": "Task not found",
      "notes": "Notes",
      "otherDocuments": "Other documents",
      "reopenError": "Failed to reopen task. Please try again.",
      "reopenTask": "Reopen task",
      "requiredDocuments": "Required documents",
      "statusBlocked": "Blocked",
      "statusCompleted": "Completed",
      "statusInProgress": "In progress",
      "statusOverdue": "Overdue",
      "statusTodo": "To do",
      "taskBlocked": "Task blocked",
      "taskBlockedMsg": "Complete the blocking tasks first before marking this one as done.",
      "title": "Task",
      "trackLegal": "Legal",
      "trackSetup": "Setup",
      "trackTravel": "Travel",
      "uploadDocument": "Upload document",
      "uploadDocumentHint": "Use camera, photo library, or files",
      "uploadRequired": "Upload required",
      "uploaded": "Uploaded",
      "validated": "Validated",
      "companyOwnedNote": "This task is handled by your company — they'll complete it on their side.",
      "companyProvidesDoc": "Your company provides this",
      "daysOverdue_one": "{{count}} day overdue",
      "daysOverdue_other": "{{count}} days overdue",
      "documentsRequiredMsg_one": "Upload the required documents before completing this task. {{count}} document is still missing.",
      "documentsRequiredMsg_other": "Upload the required documents before completing this task. {{count}} documents are still missing.",
      "dueInDays_one": "Due in {{count}} day",
      "dueInDays_other": "Due in {{count}} days",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles",
      "missingCount_one": "{{count}} missing",
      "missingCount_other": "{{count}} missing",
      "uploadDocsFirst_one": "Upload {{count}} required document first",
      "uploadDocsFirst_other": "Upload {{count}} required documents first"
    },
    "taskArrangePickup": "Arrange airport pickup",
    "taskArrangePickupDesc": "Arrange transportation from the airport",
    "taskBookFlights": "Book flights",
    "taskBookFlightsDesc": "Book your flights to the destination country",
    "taskCompleted": "Task completed",
    "taskCompletedError": "Failed to complete task. Please try again.",
    "taskCompletedSuccess": "Task completed successfully!",
    "taskCredentialRecognition": "Complete credential recognition process",
    "taskCredentialRecognitionDesc": "Complete the credential recognition process for regulated professions",
    "taskDefinitiveHousing": "Find definitive housing",
    "taskDefinitiveHousingDesc": "Find and secure permanent housing",
    "taskFillApplication": "Fill visa application form",
    "taskFillApplicationDesc": "Complete the visa application form with accurate information",
    "taskGatherDocuments": "Gather required documents",
    "taskGatherDocumentsDesc": "Collect all necessary documents for your visa application",
    "taskNotFound": "Task not found",
    "taskNoteDescription": "Add a personal note for this task",
    "taskNoteTitle": "Task note: {{title}}",
    "taskPlanItinerary": "Plan arrival itinerary",
    "taskPlanItineraryDesc": "Plan your arrival itinerary and first days",
    "taskPrepareMaterials": "Prepare interview materials",
    "taskPrepareMaterialsDesc": "Prepare all materials needed for the interview",
    "taskReopened": "Task reopened",
    "taskScheduleInterview": "Schedule visa interview",
    "taskScheduleInterviewDesc": "Schedule your visa interview appointment",
    "taskSchoolingChildcare": "Arrange schooling & childcare",
    "taskSchoolingChildcareDesc": "Arrange schooling and childcare for children",
    "taskStatus": {
      "blocked": "Blocked",
      "completed": "Completed",
      "in_progress": "In progress",
      "not_started": "Not started",
      "overdue": "Overdue",
      "pending": "Pending",
      "todo": "To do"
    },
    "taskTemporaryHousing": "Secure temporary housing",
    "taskTemporaryHousingDesc": "Secure temporary accommodation for your arrival",
    "tasks": {
      "apostille_documents": {
        "description": "Get official apostille stamps on all required documents",
        "title": "Apostille documents"
      },
      "baggage_shipping": {
        "company_title": "Arrange baggage shipping",
        "description": "Arrange shipping of personal belongings to destination",
        "title": "Baggage shipping"
      },
      "child_dependent_visa": {
        "description": "Submit dependent visa application for children",
        "title": "Child dependent visa"
      },
      "collect_birth_certificate": {
        "description": "Obtain certified birth certificates for all relocating family members",
        "title": "Collect birth certificate"
      },
      "collect_marriage_certificate": {
        "description": "Obtain certified marriage certificate for visa applications",
        "title": "Collect marriage certificate"
      },
      "collect_passport": {
        "description": "Gather valid passports for all relocating family members",
        "title": "Collect Passport"
      },
      "credential_recognition": {
        "description": "Apply for professional credential recognition in the destination country",
        "title": "Credential recognition"
      },
      "criminal_record": {
        "description": "Request criminal record certificate from your home country",
        "title": "Obtain criminal record"
      },
      "drivers_license_exchange": {
        "description": "Exchange your foreign driver's license for a local one",
        "title": "Driver's license exchange"
      },
      "employment_contract": {
        "company_title": "Issue employment contract",
        "description": "Secure your signed employment contract from your employer",
        "title": "Employment contract"
      },
      "find_housing": {
        "company_title": "Arrange housing support",
        "description": "Search and find permanent accommodation",
        "title": "Find housing"
      },
      "flight_booking": {
        "company_title": "Arrange flight booking",
        "description": "Book flights for all relocating family members",
        "title": "Book flights"
      },
      "get_codice_fiscale": {
        "description": "Obtain your Italian tax code",
        "title": "Get codice fiscale"
      },
      "get_nie": {
        "description": "Obtain your Spanish foreigner identification number",
        "title": "Get NIE"
      },
      "get_nif": {
        "description": "Apply for your Portuguese tax identification number (NIF)",
        "title": "Get NIF (tax number)"
      },
      "get_niss": {
        "description": "Register for Portuguese social security number (NISS)",
        "title": "Get NISS (social security)"
      },
      "groupBy": {
        "member": "Group by member",
        "shared": "Shared (household)",
        "status": "Group by status"
      },
      "health_insurance_enrollment": {
        "company_title": "Arrange health insurance",
        "description": "Enroll in health insurance coverage",
        "title": "Health insurance"
      },
      "health_registration": {
        "description": "Register with the local health system",
        "title": "Health registration"
      },
      "local_sim": {
        "description": "Purchase a local SIM card or eSIM for your destination country",
        "title": "Get local SIM card"
      },
      "marriage_certificate": {
        "description": "Collect your marriage certificate",
        "title": "Marriage certificate"
      },
      "municipality_registration": {
        "description": "Register with your local municipality (Junta de Freguesia)",
        "title": "Municipality registration"
      },
      "nif_partner": {
        "description": "Apply for your partner's Portuguese tax identification number",
        "title": "Partner NIF (tax number)"
      },
      "open_bank_account": {
        "description": "Open a bank account in your destination country",
        "title": "Open bank account"
      },
      "ownership": {
        "company": "Company task",
        "dual": "Shared responsibility",
        "government": "Government process",
        "talent": "Your task"
      },
      "partner_visa_application": {
        "description": "Submit visa application for your partner/spouse",
        "title": "Partner visa application"
      },
      "pet_microchip_verification": {
        "description": "Verify your pet's microchip is ISO compliant and readable",
        "title": "Pet microchip verification"
      },
      "pet_passport": {
        "description": "Obtain EU pet passport with vaccination records",
        "title": "Pet passport"
      },
      "pet_transport": {
        "description": "Arrange safe transport for your pet to the destination",
        "title": "Pet transport"
      },
      "pet_vaccination": {
        "description": "Ensure all required vaccinations are up to date for your pet",
        "title": "Pet vaccination"
      },
      "portuguese_bank_transfer": {
        "description": "Set up international transfers to your Portuguese bank account",
        "title": "International bank transfer"
      },
      "proof_of_address": {
        "description": "Obtain official proof of your residential address",
        "title": "Proof of address"
      },
      "proof_of_income": {
        "description": "Gather bank statements and proof of financial means",
        "title": "Proof of income"
      },
      "provide_employment_contract": {
        "company_title": "Provide employment contract to talent",
        "description": "Company provides the signed employment contract",
        "title": "Provide employment contract"
      },
      "promise_contract": {
        "company_title": "Provide employment promise contract",
        "description": "Company issues the signed promise of employment contract for the visa application",
        "title": "Employment promise contract"
      },
      "consulate_invitation_letter": {
        "company_title": "Provide invitation letter for the consulate",
        "description": "Company issues the invitation / declaration letter the talent presents at the consulate",
        "title": "Invitation letter to consulate"
      },
      "term_of_responsibility": {
        "company_title": "Provide term of responsibility",
        "description": "Company signs the notarized term of responsibility covering the talent's stay",
        "title": "Term of responsibility"
      },
      "techvisa_endorsement": {
        "company_title": "Provide tech visa company endorsement",
        "description": "Certified company issues the Tech Visa endorsement / term of responsibility for the IAPMEI-recognized hire",
        "title": "Tech visa endorsement"
      },
      "reopen": {
        "button": "Reopen task",
        "confirmMessage": "This will move the task back to pending status.",
        "confirmTitle": "Reopen this task?",
        "reason": "Reason for reopening (optional)"
      },
      "residence_permit_renewal": {
        "description": "Track and plan your residence permit renewal timeline",
        "title": "Residence permit renewal"
      },
      "salary_proof": {
        "description": "Gather salary slips or proof of compensation",
        "title": "Proof of salary"
      },
      "school_enrollment": {
        "description": "Enroll children in local schools",
        "title": "School enrollment"
      },
      "school_records": {
        "description": "Collect school records and transcripts for children",
        "title": "School records"
      },
      "sef_aima_appointment": {
        "description": "Schedule and attend your immigration authority appointment",
        "title": "SEF/AIMA appointment"
      },
      "sign_lease": {
        "description": "Review and sign your rental lease agreement",
        "title": "Sign lease agreement"
      },
      "sns_registration": {
        "description": "Register with the Portuguese National Health Service (SNS)",
        "title": "SNS registration"
      },
      "sponsor_letter": {
        "company_title": "Provide sponsorship letter",
        "description": "Obtain sponsorship letter from your employer",
        "title": "Sponsor letter"
      },
      "temp_accommodation": {
        "company_title": "Arrange temporary accommodation",
        "description": "Arrange temporary housing for your first weeks",
        "title": "Temporary accommodation"
      },
      "translate_documents": {
        "description": "Get certified translations of all required documents",
        "title": "Translate documents"
      },
      "travel_insurance": {
        "description": "Arrange travel insurance coverage for the relocation period",
        "title": "Travel insurance"
      },
      "utilities_setup": {
        "description": "Set up electricity, water, gas, and internet at your new home",
        "title": "Utilities setup"
      },
      "visa_application": {
        "description": "Submit your visa application at the consulate or online portal",
        "title": "Visa application"
      },
      "visa_pickup": {
        "description": "Collect approved visa from the consulate or embassy",
        "title": "Visa pickup"
      }
    },
    "tasksCompleted": "Tasks completed",
    "tasksCount": "{{completed}}/{{total}} tasks",
    "tasksDone": "Tasks done",
    "tasksLabel": "Tasks",
    "tasksOfTotal": "{{completed}}/{{total}} tasks",
    "timelineDescription": "Visual timeline of your relocation phases",
    "timelineTitle": "Timeline & Gantt view",
    "timelineView": "Timeline view",
    "title": "TelePortal",
    "toDo": "To do",
    "tonnieChecked": "Tonnie-Checked",
    "track": {
      "legal": "Legal",
      "setup": "Setup",
      "travel": "Travel"
    },
    "trackJourneyProgress": "Track your relocation journey progress",
    "trackLegal": "Legal track",
    "trackLegalDesc": "Route-based legal readiness, document checklists (household-aware)",
    "trackLegalDescShort": "Visa, permits, and legal documentation",
    "trackProgress": "Track progress",
    "trackSetup": "Setup track",
    "trackSetupDesc": "Stabilization layer (first weeks) including accommodation, credential recognition, schooling/childcare, and Companion Program milestones",
    "trackSetupDescShort": "Housing, banking, and settling in",
    "trackSuffix": "Track",
    "trackTasksProgress": "{{completed}}/{{total}} tasks",
    "trackTravel": "Travel track",
    "trackTravelDesc": "Logistics readiness, household-aware travel planning",
    "trackTravelDescShort": "Flights, accommodation, and logistics",
    "tracks": {
      "legal": "Legal & documents",
      "setup": "Local setup",
      "travel": "Travel & logistics"
    },
    "tracksCompleted": "Tracks completed",
    "tryAgain": "Try again",
    "tryAgainLater": "Please try again later.",
    "unableToLoadData": "Unable to load TelePortal data",
    "unlockPro": "Unlock with Pro",
    "upcomingDeadlines": "Upcoming deadlines",
    "upcomingTasks": "Upcoming tasks",
    "upgradeMessage": "Upgrade to access all TelePortal phases and advanced features.",
    "upload": "Upload",
    "uploadDocument": "Upload document",
    "uploadDocumentDescription": "Add a document to your TelePortal journey",
    "uploadFromMobile": "Upload from mobile",
    "uploadFromMobileDescription": "Use Tonnie Citizen to scan and upload documents instantly",
    "uploadFromMobileTitle": "Upload documents from mobile",
    "uploadInMobile": "Upload in mobile",
    "uploaded": "uploaded",
    "uploading": "Uploading...",
    "validate": "Validate",
    "validated": "Validated",
    "vault": {
      "continue": "Continue",
      "continueWithPending": "Continue (pending review)",
      "documentsFound": "documents found in your Vault",
      "empty": "Vault empty",
      "emptyMessage": "Your vault is empty. We'll add documents here as you complete tasks.",
      "expired": "Expired",
      "expiringSoon": "Expiring soon",
      "hint": "Link documents from your vault to skip uploads.",
      "link": "Link",
      "linked": "Linked",
      "remaining": "remaining",
      "scanning": "Scanning vault…",
      "skip": "Skip",
      "undo": "Undo",
      "validUntil": "Valid until {{date}}",
      "skipped": "Skipped"
    },
    "verifiedByTonnieGuard": "Verified by Tonnie guard",
    "viewDetails": "View details",
    "viewDocumentInMobile": "Upload and manage this document in the mobile app",
    "viewMyOptions": "View my options",
    "viewTaskInMobile": "View and complete this task in the mobile app",
    "visaBlueCard": "EU blue card",
    "visaFamily": "Family reunion",
    "visaNomad": "Digital nomad / Remote worker",
    "visaStudent": "Student visa",
    "visaWork": "Work visa / Employment",
    "welcome": {
      "description": "Build your personalized relocation plan. We'll guide you through a quick setup to create your dashboard with tasks, documents, and deadlines tailored to your journey.",
      "docsStep": "Documents & tasks",
      "docsStepDesc": "Get a personalized checklist of everything you need",
      "householdStep": "Your household & visa",
      "householdStepDesc": "Tell us who is relocating and your immigration situation",
      "letsStart": "Let's start",
      "planStep": "Housing & logistics",
      "planStepDesc": "Set up your housing plan, travel, and timeline",
      "timeEstimate": "Takes about 5-10 minutes to complete",
      "title": "Welcome to TelePortal"
    },
    "welcomeMessage": "Welcome to TelePortal Assessment! I'll help you create a personalized relocation checklist. Let's start by understanding your situation.",
    "you": "You",
    "yourNextStep": "Your next step",
    "setupDimension": {
      "profile": "Profile",
      "profileDesc": "Origin, destination, and relocation context",
      "household": "Household",
      "householdDesc": "Family members joining the move",
      "documents": "Documents",
      "documentsDesc": "Vault document scanning and linking",
      "preferences": "Preferences",
      "preferencesDesc": "Travel, accommodation, and lifestyle preferences"
    },
    "docType": {
      "bank_statements": "Bank statements",
      "birth_certificate": "Birth certificate",
      "certified_translation": "Certified translation",
      "consulate_invitation_letter": "Consulate invitation letter",
      "criminal_record": "Criminal record",
      "drivers_license": "Driver's license",
      "employment_contract": "Employment contract",
      "health_insurance_policy": "Health insurance policy",
      "lease_agreement": "Lease agreement",
      "marriage_certificate": "Marriage certificate",
      "passport": "Passport",
      "pet_passport": "Pet passport",
      "promise_contract": "Promise contract",
      "proof_of_address": "Proof of address",
      "proof_of_income": "Proof of income",
      "salary_proof": "Salary proof",
      "school_records": "School records",
      "sponsor_letter": "Sponsor letter",
      "techvisa_endorsement": "TechVisa endorsement",
      "term_of_responsibility": "Term of responsibility",
      "travel_insurance": "Travel insurance"
    },
    "duration": {
      "1_2_days": "1-2 days",
      "1_2_weeks": "1-2 weeks",
      "1_3_days": "1-3 days",
      "1_day": "1 day",
      "1_week": "1 week",
      "2_3_weeks": "2-3 weeks",
      "2_4_weeks": "2-4 weeks",
      "2_6_weeks": "2-6 weeks",
      "2_8_weeks": "2-8 weeks",
      "3_5_days": "3-5 days",
      "4_12_weeks": "4-12 weeks",
      "4_8_weeks": "4-8 weeks",
      "ongoing": "Ongoing"
    },
    "daysOverdue_one": "{{count}} day overdue",
    "daysOverdue_other": "{{count}} days overdue",
    "documentsAttached_one": "{{count}} document attached",
    "documentsAttached_other": "{{count}} documents attached",
    "documentsCount_one": "{{count}} document",
    "documentsCount_other": "{{count}} documents",
    "dueInDays_one": "Due in {{count}} day",
    "dueInDays_other": "Due in {{count}} days",
    "inProgressCount_one": "{{count}} in progress",
    "inProgressCount_other": "{{count}} in progress",
    "missingDocs_one": "{{count}} missing",
    "missingDocs_other": "{{count}} missing",
    "moreCompleted_one": "+{{count}} more completed",
    "moreCompleted_other": "+{{count}} more completed",
    "needsAttentionCount_one": "{{count}} needs attention",
    "needsAttentionCount_other": "{{count}} need attention",
    "pendingCount_one": "{{count}} pending",
    "pendingCount_other": "{{count}} pending",
    "timeMinutes_one": "~{{count}} minute",
    "timeMinutes_other": "~{{count}} minutes"
  },
  "termsPrivacy": {
    "gdprRights": "Under GDPR and applicable data protection laws, you have the right to access, rectify, erase, and port your personal data. You can exercise these rights at any time through Settings or by contacting our Data Protection Officer.",
    "privacyPolicy": "Privacy policy",
    "termsOfService": "Terms of service",
    "title": "Terms & privacy",
    "yourRights": "Your rights"
  },
  "theme": {
    "autoMatchSystem": "The app will automatically match your device's theme settings.",
    "configure": "Configure",
    "custom": "Custom",
    "dark": "Dark",
    "darkTheme": "Dark theme",
    "followSystem": "Follow system ({{mode}})",
    "light": "Light",
    "lightTheme": "Light theme",
    "system": "System",
    "theme": "Theme",
    "themeSelection": "Theme selection",
    "useFixedTheme": "The app will use the {{mode}} theme regardless of your device settings."
  },
  "validation": {
    "passwordUpdateFailed": "Failed to update password. Please try again.",
    "passwordUpdated": "Password updated successfully",
    "required": "This field is required",
    "email": {
      "invalid": "Invalid email address",
      "required": "Enter your email address."
    },
    "password": {
      "min": "Your password needs at least {{passwordMinLength}} characters.",
      "mismatch": "Passwords do not match",
      "max": "Your password can be at most {{passwordMaxLength}} characters.",
      "required": "Enter your password.",
      "confirmRequired": "Confirm your password."
    },
    "firstName": {
      "required": "First name is required",
      "tooLong": "Your first name can be at most 50 characters."
    },
    "lastName": {
      "required": "Last name is required",
      "tooLong": "Your last name can be at most 50 characters."
    },
    "uuid": {
      "invalid": "Invalid UUID"
    },
    "phone": {
      "invalid": "Invalid phone number"
    },
    "url": {
      "invalid": "Invalid URL"
    },
    "countryCode": {
      "length": "Country code must be 2 characters (ISO 3166-1 alpha-2)"
    },
    "dateRange": {
      "endAfterStart": "End date must be after start date"
    },
    "field": {
      "required": "This field is required"
    },
    "iqulture": {},
    "city": {
      "required": "Enter the city you live in",
      "tooLong": "That city name is too long (100 characters maximum)"
    },
    "originCountry": {
      "required": "Choose the country you're leaving"
    },
    "nationality": {},
    "timeZone": {
      "invalid": "That time zone is not recognised."
    },
    "timeOfDay": {
      "invalid": "Use a time like 22:00."
    },
    "code": {
      "sixDigits": "Enter the 6-digit code."
    },
    "destination": {
      "notOpen": "We don't offer this destination yet. Portugal is the destination open today."
    },
    "journey": {
      "requestIdRequired": "A new journey needs a request id",
      "newIntentOnly": "Only a new journey takes a request id or a name",
      "labelRequired": "Enter a name, or clear it",
      "labelTooLong": "Use 40 characters or fewer"
    }
  },
  "vault": {
    "downloadError": "Failed to download",
    "downloadSuccess": "Downloaded",
    "downloadZipError": "Failed to download documents",
    "loadingPreview": "Loading preview…",
    "removeError": "Failed to remove",
    "removeSuccess": "Removed",
    "uploadError": "Failed to upload",
    "uploadSuccess": "Uploaded",
    "uploadRejected": {
      "mimeNotAllowed": "This type of file isn't accepted in this section. Choose a different file.",
      "unidentifiable": "We couldn't recognise this file. It may be damaged — try exporting it again.",
      "declaredMimeMismatch": "This file's contents don't match its type. Upload the original file.",
      "pitchTooLong": "This video is longer than {{minutes}} minutes. Choose a shorter video.",
      "fileTooLarge": "This file is too large to upload. Choose a smaller file.",
      "uploadStalled": "The upload stopped because your connection stopped sending data. Check your connection and try again."
    },
    "downloadZipSuccess_one": "Downloading {{count}} document",
    "downloadZipSuccess_other": "Downloading {{count}} documents",
    "documentsCount_one": "{{count}} document",
    "documentsCount_other": "{{count}} documents"
  },
  "viewport": {
    "description": "Tonnie Citizen Web is designed for larger screens. For the best mobile experience, please download the mobile app.",
    "downloadAppStore": "Download on app store",
    "downloadPlayStore": "Get it on Google Play",
    "orAccessDesktop": "Or access from a tablet or desktop",
    "switchToMobile": "Switch to Tonnie Citizen"
  },
  "wallet": {
    "additions": "Additions",
    "allTransactions": "All",
    "amount": "Amount",
    "available": "available",
    "confirmTopUp": "Confirm top up",
    "deductions": "Deductions",
    "description": "Your wallet balance and transaction history",
    "maxTopUp": "Maximum top-up amount is {{amount}}",
    "minMaxTopUp": "Minimum: {{min}}, maximum: {{max}}",
    "minTopUp": "Minimum top-up amount is {{amount}}",
    "noTransactions": "No transactions yet",
    "sourceAdmin": "Admin allocation",
    "sourceCoupon": "Coupon",
    "sourceEcosystem": "Ecosystem",
    "sourcePurchase": "Purchase",
    "sourceReferral": "Referral",
    "sourceRenewal": "Renewal",
    "sourceSponsor": "Sponsor",
    "sourceSubscription": "Subscription",
    "sourceTopUp": "Top up",
    "title": "Tonnie wallet",
    "topUp": "Top up",
    "topUpDescription": "Add money to your wallet using your payment method",
    "topUpError": "Failed to top up wallet. Please try again.",
    "topUpSuccess": "Successfully added {{amount}} to your wallet",
    "topUpTitle": "Top up wallet",
    "transactionHistory": "Transaction history",
    "transactionHistoryDesc": "View all your wallet transactions"
  },
  "webPortal": {
    "availableOnWeb": "Available on Citizen Web Portal",
    "copied": "Copied!",
    "copyLink": "Copy link for desktop",
    "hint": "The Citizen Web Portal requires a desktop browser.",
    "shareLink": "Share link"
  },
  "widgets": {
    "continue": "Continue",
    "motivationalForm": {
      "sharePlaceholder": "Share your thoughts..."
    },
    "rating": {
      "notAtAll": "Not at all",
      "veryMuch": "Very much"
    },
    "timeline": {
      "12plusMonths": "12+ months",
      "12plusMonthsDesc": "Future planning",
      "1to3months": "1-3 months",
      "1to3monthsDesc": "Short-term planning",
      "3to6months": "3-6 months",
      "3to6monthsDesc": "Medium-term planning",
      "6to12months": "6-12 months",
      "6to12monthsDesc": "Long-term planning",
      "asap": "As soon as possible",
      "asapDesc": "Within the next month",
      "flexible": "Flexible",
      "flexibleDesc": "No specific timeline"
    }
  },
  "world": {
    "completeToUnlock": "Complete previous missions to unlock",
    "upgradeToUnlock": "Upgrade to unlock",
    "completed": "Completed",
    "notFound": "World not found",
    "backToQultureUp": "Back to QultureUp",
    "ofMissions": "{{completed}} of {{total}} missions",
    "overallProgress": "Overall progress",
    "remaining": "Remaining",
    "title": "World",
    "tracks": "Tracks",
    "milesReward_one": "+{{count}} Mile",
    "milesReward_other": "+{{count}} Miles"
  },
  "pricing": {
    "betaPriceLabel": "Early-access price",
    "percentOffLabel": "−{{percent}}%",
    "betaDisclaimer": "Early-access price — regular price {{listPrice}} after launch."
  },
  "ui": {
    "sidebar": {
      "toggle": "Toggle sidebar"
    },
    "carousel": {
      "prev": "Previous slide",
      "next": "Next slide"
    },
    "command": {
      "title": "Command palette",
      "description": "Search for a command to run..."
    }
  },
  "plan": {
    "upgrade": {
      "teleportal": "Upgrade to Journey Mode or Pro to unlock all TelePortal phases",
      "qultureup": "Upgrade to Journey Mode or Pro to access all QultureUp worlds",
      "care": "Upgrade to Journey Mode or Pro to access Care & Support",
      "passport": "Upgrade to Journey Mode or Pro for advanced Passport analytics",
      "career": "Upgrade to Pro for enhanced career features",
      "copilot": "Upgrade to Pro for unlimited CoPilot queries",
      "journeyBuilder": "Upgrade to Journey Mode or Pro to create new journeys",
      "familyProgram": "Upgrade to Journey Mode or Pro to enable Family Program",
      "default": "Upgrade to unlock this feature"
    }
  },
  "appUpdate": {
    "required": {
      "title": "Update required",
      "body": "This version of Tonnie is no longer supported. Please update to keep going.",
      "cta": "Update now"
    },
    "available": {
      "title": "Update available",
      "body": "A new version of Tonnie is ready.",
      "cta": "Update"
    },
    "dismiss": "Later"
  },
  "setup": {
    "title": "Where are you moving from?",
    "countryLabel": "Country you're leaving",
    "countryPlaceholder": "Select a country",
    "cityLabel": "City you live in",
    "cityPlaceholder": "Start typing your city…",
    "destinationLabel": "Moving to",
    "destinationOpenToday": "{{country}} is the destination open today. More are coming.",
    "submit": "Continue",
    "saving": "Setting up your journey…",
    "saveFailed": "We couldn't save that. Check your connection and try again."
  },
  "profileComplete": {
    "known": "Already in your profile",
    "countryPlaceholder": "Select a country",
    "cityPlaceholder": "Start typing your city…",
    "phonePlaceholder": "Your phone number",
    "optionalNote": "Your passport details, CV and household are optional. They never block your score.",
    "saving": "Saving…",
    "saveFailed": "We couldn't save that. Check your connection and try again.",
    "label": {
      "firstName": "First name",
      "lastName": "Last name",
      "dateOfBirth": "Date of birth",
      "currentCountry": "Country you live in",
      "currentCity": "City you live in",
      "phone": "Phone"
    },
    "loadFailed": "We couldn't load your profile. Check your connection and try again."
  },
  "profileBasics": {
    "title": "Your basics",
    "subtitle": "What your CheckUp needs to start. Let a document do the typing — you check everything before it is saved.",
    "progressLabel": "Essentials for your CheckUp",
    "close": "Close",
    "back": "Back to your basics",
    "faster": {
      "title": "Fill it faster",
      "fastest": "Fastest",
      "document": {
        "title": "Scan passport or ID",
        "fills": "Date of birth · citizenship"
      },
      "import": {
        "title": "LinkedIn PDF or CV",
        "fills": "Experience · education · skills · languages"
      }
    },
    "orType": "or type it",
    "filled": {
      "document_one": "Your document filled {{count}} detail. Check what is left below.",
      "document_other": "Your document filled {{count}} details. Check what is left below.",
      "documentNone": "Nothing was added from your document.",
      "import": "Your LinkedIn PDF or CV is in your profile — it sharpens your score."
    },
    "done": {
      "title": "Your basics are all here",
      "body": "Everything your CheckUp needs to start is on file. A LinkedIn PDF or CV still sharpens your score."
    },
    "doneCta": "Done",
    "privacy": "Nothing is saved until you press Save.",
    "later": "Later",
    "save": "Save my basics",
    "saved": "Your basics are saved."
  },
  "citizenHome": {
    "needsYou": {
      "checkin": {
        "action": "Check in",
        "body": "Your daily check-in takes a minute.",
        "last": "Last check-in: {{date}}",
        "title": "How are you today?"
      },
      "checkpoint": {
        "action": "Start",
        "body": "Tell us how settling in is going.",
        "overdueTitle": "A Care checkpoint is overdue",
        "title": "A Care checkpoint is due"
      },
      "invitation": {
        "action": "Review",
        "body": "Review the invitation to decide whether to join.",
        "title": "{{company}} invited you"
      },
      "later": "Later",
      "laterA11y": "Later: {{title}}",
      "seeAll": "See all",
      "showLess": "Show less",
      "seeAllA11y_one": "See the {{count}} thing that needs you",
      "seeAllA11y_other": "See all {{count}} things that need you",
      "profile": {
        "action": "Complete profile",
        "body": "Your CheckUp score needs a few more details about you.",
        "title": "Complete your profile",
        "secondary": "Upload passport"
      },
      "taskOverdue": {
        "action": "Open task",
        "body": "Some relocation deadlines have passed.",
        "title_one": "{{count}} overdue task",
        "title_other": "{{count}} overdue tasks"
      },
      "title": "Needs you",
      "unread": {
        "action": "Read",
        "body": "Catch up on what's new.",
        "title_one": "{{count}} unread message",
        "title_other": "{{count}} unread messages"
      },
      "dismiss": "Dismiss",
      "dismissA11y": "Dismiss: {{title}}",
      "sponsorship": {
        "title": "{{company}} will sponsor your journey",
        "body": "Every chapter opens — TelePortal, QultureUp, Care and Passport — at no cost to you.",
        "action": "Review offer"
      },
      "testit": {
        "title_one": "{{company}} asks for {{count}} test",
        "title_other": "{{company}} asks for {{count}} tests",
        "body_one": "{{count}} still to take. Your results stay yours to reuse.",
        "body_other": "{{count}} still to take. Your results stay yours to reuse.",
        "action": "Start tests"
      },
      "checkupRequested": {
        "title": "{{company}} is waiting for your CheckUp",
        "bodyStart": "Your iQulture score is what they asked for. It takes about 10–15 minutes.",
        "actionStart": "Start CheckUp",
        "bodyContinue": "Finish your CheckUp — your iQulture score is what they asked for.",
        "actionContinue": "Continue CheckUp",
        "bodyProfile": "Your CheckUp is done. Add a few profile details and your score is ready.",
        "actionProfile": "Complete profile",
        "bodyCalculate": "Every step is done. Calculate your score to answer their request.",
        "actionCalculate": "Calculate score",
        "bodyCalculating": "Your score is being calculated. It won't take long.",
        "actionCalculating": "View CheckUp",
        "bodyConsent": "Your score is ready. They see it only if you choose to share it.",
        "actionConsent": "Choose what they see",
        "titleConsent": "{{company}} asks to see your CheckUp score"
      },
      "checkupShared": {
        "title": "{{company}} can see your CheckUp",
        "body": "They see your score and readiness, never your answers. You can change it at any time.",
        "action": "Manage sharing"
      },
      "countAria_one": "{{count}} thing needs you",
      "countAria_other": "{{count}} things need you",
      "request": {
        "titleTests": "{{company}} asks to see more of your test results",
        "body": "Review what they would see, then decide. Nothing is shared until you do.",
        "action": "Review"
      }
    },
    "handoff": {
      "testit": {
        "title": "Take your tests",
        "description": "TestIt runs on Citizen Web, with the camera and microphone some tests need."
      },
      "sharing": {
        "title": "Choose what companies see",
        "description": "Who sees your data, and what they see, is managed on Citizen Web under My journeys."
      }
    },
    "welcome": {
      "badge": "Welcome to Tonnie",
      "badgeInvited": "Invited by {{company}}",
      "title": "{{name}}, your move abroad starts here.",
      "titleNoName": "Your move abroad starts here.",
      "titleInvited": "Welcome, {{name}}. {{company}} is waiting for you.",
      "titleInvitedNoName": "Welcome. {{company}} is waiting for you.",
      "body": "Build your journey, find out how ready you are with a CheckUp as thorough as a medical check-up, then plan every document and deadline — until you are a Citizen.",
      "bodyInvited": "Accept the invitation and your journey starts: what {{company}} asked for first, then a plan for every document and deadline of your move.",
      "ctaBuild": "Build your journey",
      "ctaReview": "Review invitation",
      "ctaBasics": "Add my basics · 1 min",
      "ctaHow": "How it works",
      "routeAria": "Four chapters: your journey, the CheckUp, plan and move, become a Citizen",
      "route": {
        "build": {
          "title": "Build your journey",
          "sub": "Where you are going"
        },
        "accept": {
          "title": "Accept the invitation",
          "sub": "Your journey is created"
        },
        "checkup": {
          "title": "CheckUp",
          "sub": "How ready you are"
        },
        "plan": {
          "title": "Plan and move",
          "sub": "Documents, deadlines"
        },
        "citizen": {
          "title": "Become a Citizen",
          "sub": "Culture, care, passport"
        }
      }
    },
    "quickStart": {
      "eyebrow": "Quick start",
      "title": "Your basics in about a minute",
      "body": "Let a document do the typing — you check everything before it is saved.",
      "progress": "Essentials for your CheckUp: {{done}} of {{total}}",
      "type": {
        "title": "Type it yourself",
        "body": "Only what is still missing — about two minutes.",
        "cta": "Add by hand"
      }
    },
    "path": {
      "eyebrow": "Getting started",
      "title": "Your first five steps",
      "progress": "{{done}} of {{total}} done",
      "progressAria": "{{done}} of {{total}} steps done",
      "parts": "{{done}} of {{total}}",
      "note": "The CheckUp is free for everyone. Steps 3 and 4 are faster with your passport or CV.",
      "status": {
        "done": "Done",
        "in_progress": "In progress",
        "available": "Available now",
        "locked": "Locked"
      },
      "optional": "Optional · better score",
      "missing": "Still missing: {{items}}",
      "steps": {
        "journey": {
          "title": "Build your journey",
          "titleInvited": "Accept {{company}}'s invitation",
          "text": "Tell us where you are going, and we build the plan around it.",
          "textInvited": "Accepting creates your journey, with {{company}} on it.",
          "textDone": "Your journey is ready.",
          "meta": "About 3 minutes",
          "metaInvited": "1 minute",
          "cta": "Build journey",
          "ctaInvited": "Review invitation"
        },
        "essential": {
          "title": "Add essential data",
          "text": "What the CheckUp needs to start: your name, date of birth, citizenship, where you live and your phone.",
          "textDone": "Everything the CheckUp needs to start.",
          "meta": "2 minutes · or one passport photo",
          "cta": "Add in a minute"
        },
        "assessment": {
          "title": "Do the CheckUp assessment",
          "text": "Five short parts: videos, your pitch, languages, motivation and a chat.",
          "textLocked": "Opens when your journey exists.",
          "textDone": "All five parts are done.",
          "next": "Next: {{part}}.",
          "meta": "About 20 minutes · pause any time",
          "cta": "Start",
          "ctaContinue": "Continue",
          "parts": {
            "videos_watched": "the introduction videos",
            "pitch_video": "your pitch video",
            "language_tests": "your language tests",
            "motivational_answers": "your motivation answers",
            "assistant_chat": "the chat with Tonnie"
          }
        },
        "moreData": {
          "title": "Add more data",
          "text": "Skills, languages, education and experience sharpen your score.",
          "textDone": "Everything the score reads is on file.",
          "meta": "1 minute with a LinkedIn PDF or CV",
          "cta": "Import LinkedIn or CV"
        },
        "score": {
          "title": "Get your iQulture score",
          "titleShared": "Send your score to {{company}}",
          "text": "Your readiness, pillar by pillar — and what to work on next.",
          "textShared": "Calculated with one click, and {{company}} sees it.",
          "meta": "One click, once steps 2 and 3 are done",
          "cta": "Calculate my score",
          "ctaCalculating": "See progress",
          "ctaDone": "View results"
        }
      }
    },
    "chapters": {
      "eyebrow": "How it works",
      "title": "Four chapters to becoming a Citizen",
      "free": "Free for everyone",
      "planOrSponsor": "Plan or sponsor",
      "basics": {
        "title": "It starts with your basics",
        "body": "Your CheckUp needs a few details about you — and a document can type most of them for you.",
        "document": "A photo of your passport or ID card fills your date of birth and citizenship.",
        "import": "A LinkedIn PDF or CV fills your experience, education, skills and languages.",
        "check": "Nothing is saved before you check it. Only where you live and your phone are typed.",
        "cta": "Add my basics"
      },
      "checkup": {
        "title": "A diagnosis, not a quiz",
        "body": "Like a medical check-up for your move: your iQulture score, pillar by pillar — what is strong and what to work on."
      },
      "teleportal": {
        "title": "Your move, planned to the day",
        "body": "Every visa step, document and deadline for your route, with the documents kept in your Vault."
      },
      "qultureup": {
        "title": "Know the country before you land",
        "body": "Missions and worlds about the culture, work and daily life of your destination. Earn miles as you go."
      },
      "care": {
        "label": "Care & Passport",
        "title": "Settle in, and show it",
        "body": "Check-ins that keep you well after arrival, and a Passport that collects every stamp of your journey."
      }
    },
    "unlock": {
      "badge": "Unlock every chapter",
      "title": "The CheckUp is free. The rest of the journey opens two ways.",
      "body": "TelePortal, QultureUp, Care and Passport open with a plan of your own, or when a company sponsors your journey.",
      "plan": {
        "title": "Choose a plan",
        "body": "Every chapter of your journey opens the moment you choose.",
        "cta": "See plans"
      },
      "sponsor": {
        "title": "Get sponsored by a company",
        "body": "Companies hiring abroad can pay for your whole journey. When one does, its offer appears here."
      }
    },
    "error": {
      "title": "Home didn't load",
      "body": "Check your connection and try again."
    },
    "ready": {
      "chipInvited": "Invited by {{company}}",
      "chipSponsored": "Sponsored by {{company}}",
      "chipRoute": "Your journey · {{origin}} → {{destination}}",
      "title": "Hi {{name}} — your move to {{country}} starts here.",
      "titleNoName": "Your move to {{country}} starts here.",
      "titleNoCountry": "Hi {{name}} — your move starts here.",
      "titleBare": "Your move starts here.",
      "body": "Five steps to your iQulture score — your readiness, pillar by pillar, and what to work on next. Every chapter of your move is tailored by it.",
      "bodyWaiting": "Five steps to your iQulture score. {{company}} is waiting for it — and every chapter of your journey is tailored by it.",
      "bodyYours": "Five steps to your iQulture score — yours to keep. You decide whether {{company}} sees it.",
      "stepsAria": "Five steps to your iQulture score",
      "ofTotal": "of {{total}} done",
      "now": "Now",
      "privacyShared": "{{company}} sees your score and readiness — never your answers.",
      "privacyOwn": "Your answers stay yours. Nobody sees your score unless you share it.",
      "next": {
        "eyebrow": "Your next step",
        "whatIs": "What is the CheckUp?",
        "parts": {
          "videos_watched": "Videos",
          "pitch_video": "Your pitch",
          "language_tests": "Languages",
          "motivational_answers": "Motivation",
          "assistant_chat": "A short chat"
        },
        "assessment": {
          "title": "Do the CheckUp assessment",
          "body": "Five short parts — about 15 minutes. You can stop and pick up where you left off.",
          "cta": "Start CheckUp"
        },
        "assessmentContinue": {
          "title": "Finish the CheckUp assessment",
          "body": "{{done}} of {{total}} parts done. Next: {{part}}.",
          "cta": "Continue CheckUp"
        },
        "essential": {
          "title_one": "Add {{count}} detail to get your score",
          "title_other": "Add {{count}} details to get your score",
          "body": "{{items}} — under a minute. Your answers are safe; nothing is lost.",
          "cta": "Add the details"
        },
        "moreData": {
          "title": "Sharpen your score",
          "body": "Skills, languages and experience — optional, and every one counts.",
          "cta": "Import LinkedIn or CV"
        },
        "score": {
          "title": "Get your iQulture score",
          "titleShared": "Calculate your score and send it to {{company}}",
          "body": "One click. Your readiness, pillar by pillar — and what to work on next. It stays yours unless you share it.",
          "bodyShared": "One click. {{company}} sees your score and readiness — never your answers.",
          "cta": "Get my score",
          "ctaShared": "Calculate my score"
        },
        "retry": {
          "title": "Try the calculation again",
          "body": "Something went wrong on our side. Your answers are safe — nothing to redo.",
          "cta": "Calculate again"
        },
        "calculating": {
          "title": "Your score is being calculated",
          "body": "We are weighing your answers, your pitch and your languages. You can leave — it will be here when you come back.",
          "status": "Calculating…",
          "cta": "View CheckUp"
        },
        "failed": {
          "title": "Your score couldn't be calculated",
          "body": "Something went wrong on our side. Open your CheckUp to pick up where it stopped.",
          "cta": "Open CheckUp"
        }
      },
      "chapters": {
        "title": "What opens after your score",
        "body": "Your iQulture score tailors every chapter of the move to you.",
        "bodyPlan": "Everything opens with a plan, or when a company sponsors your journey.",
        "seePlans": "See plans",
        "bodySponsored": "Sponsored by {{company}} — every chapter is open.",
        "teleportal": "Every task of the move — legal, travel, setting up — in order.",
        "qultureup": "Learn the culture before you land, one world at a time.",
        "care": "Support after you arrive — wellbeing check-ins and checkpoints.",
        "passport": "Every milestone of your journey, stamped.",
        "open": "Open",
        "basic": "Basic · open now",
        "locked": "Opens with a plan or a sponsor",
        "passportStatus_one": "{{count}} stamp · {{miles}} miles",
        "passportStatus_other": "{{count}} stamps · {{miles}} miles",
        "passportStamps_one": "{{count}} stamp",
        "passportStamps_other": "{{count}} stamps",
        "explore": "Explore",
        "view": "View"
      },
      "latest": {
        "eyebrow": "Latest",
        "empty": "Your first stamps and miles will show here."
      },
      "ask": {
        "title": "Questions about the CheckUp?",
        "cta": "Ask Tonnie"
      }
    },
    "phone": {
      "surface": {
        "phone": "On your phone",
        "computer": "On a computer",
        "either": "Phone or computer"
      },
      "emailLink": "Email me the link",
      "shareLink": "Share the link",
      "emailSent": "We emailed you the link — open it on your computer.",
      "emailHeld": "We can't email you right now. Use “Share the link” to send it to yourself.",
      "emailFailed": "The email didn't go out. Try again, or share the link.",
      "next": {
        "assessment": {
          "title": "Do the CheckUp assessment on a computer",
          "body": "Five short parts — about 15 minutes, with video and your pitch, so it is built for a bigger screen. You can stop and pick up where you left off."
        },
        "assessmentContinue": {
          "title": "Finish the CheckUp assessment on a computer"
        },
        "calculating": {
          "body": "We are weighing your answers, your pitch and your languages. We will send you a notification when it lands."
        },
        "score": {
          "body": "One tap. Your readiness, pillar by pillar — and what to work on next. It stays yours unless you share it.",
          "bodyShared": "One tap. {{company}} sees your score and readiness — never your answers."
        }
      },
      "header": {
        "route": "{{origin}} → {{destination}}",
        "switchJourney": "Switch journey. Current: {{route}}"
      },
      "welcome": {
        "meta": "3 questions · on your phone"
      },
      "quickStart": {
        "eyebrow": "While you are here",
        "title": "Add your basics · 1 min",
        "body": "A photo of your passport fills your date of birth and citizenship."
      },
      "meanwhile": {
        "title": "Meanwhile, on your phone",
        "essential": {
          "title_one": "Add {{count}} detail your score needs",
          "title_other": "Add {{count}} details your score needs",
          "body": "{{items}} · a passport photo fills most of them"
        }
      },
      "stepsTitle": "Your five steps",
      "steps": {
        "assessment": {
          "text": "Five short parts, about 20 minutes — on a computer. We email you the link."
        },
        "score": {
          "text": "One tap, once steps 2 and 3 are done.",
          "textShared": "One tap, once steps 2 and 3 are done — and {{company}} sees it."
        }
      },
      "stepper": {
        "notStarted": "Not started"
      }
    },
    "how": {
      "intro": {
        "eyebrow": "Your companion",
        "title": "Tonnie, every day of your move",
        "body": "From first plans to settling in, Tonnie walks with you — on your phone and on the web."
      },
      "chapters": {
        "checkup": {
          "title": "Know where you stand",
          "body": "Your relocation-readiness score and what to work on next. The assessment is done on a computer; your score goes everywhere with you."
        },
        "teleportal": {
          "title": "Your move, step by step",
          "body": "Follow your relocation tasks and milestones, and check them off as you go."
        },
        "qultureup": {
          "title": "Feel at home, faster",
          "body": "Bite-size missions to learn your destination's culture, language, and everyday life."
        },
        "care": {
          "title": "Support when you need it",
          "body": "Reach your relocation team — messages, check-ins, and meetings, all in one place."
        },
        "passport": {
          "title": "Your progress, stamped",
          "body": "Earn stamps and see how far you've come on your relocation journey."
        }
      },
      "title": "How Tonnie works",
      "start": {
        "title": "It starts with your journey",
        "body": "Three questions — where you are going, your situation, your family — and your journey is ready, on your phone or the web. It powers everything that follows."
      }
    }
  },
  "profileImport": {
    "phone": {
      "source": {
        "subtitle": "We read your experience, education, skills and languages — you check them before anything is saved.",
        "linkedin": "Your LinkedIn profile, saved as a PDF.",
        "cv": "Your CV — PDF, Word or text, up to 10 MB."
      },
      "guide": {
        "title": "Get your LinkedIn PDF",
        "choose": "Choose the PDF",
        "steps": {
          "computer": "On a computer, open your profile on linkedin.com",
          "save": "Choose More, then Save to PDF",
          "send": "Send the PDF to this phone — by email, Files or iCloud",
          "choose": "Come back here and choose it"
        }
      },
      "review": {
        "privacy": "Nothing is saved until you press Save. Your name stays as it is.",
        "save": "Save to my profile",
        "showAll": "Show all {{count}}",
        "showLess": "Show less",
        "present": "Present",
        "languageNoLevel_one": "{{names}}: the document gives no level, so it is not saved — add it on your profile.",
        "languageNoLevel_other": "{{names}}: the document gives no level, so they are not saved — add them on your profile."
      },
      "saved": {
        "title": "Your profile is updated",
        "body": "Your experience, skills and languages now sharpen your score."
      },
      "saveFailed": "We couldn't save it. Check your connection and try again."
    }
  },
  "profileQuality": {
    "calculate": {
      "anyway": "Calculate with what I have",
      "footnote": "You can add details and recalculate any time."
    },
    "backTo": "Back to {{hero}}",
    "returnHint": "Every detail you add here makes {{hero}} more precise."
  },
  "checkupCard": {
    "status": {
      "answersDone": "Answers complete"
    },
    "title": {
      "welcome": "Your iQulture score, in two parts",
      "ready": "Your answers are in"
    },
    "subtitle": {
      "welcome": "Your score reads your answers and your profile together — the more complete both are, the more precise it is.",
      "ready": "Your score reads them together with your profile. Add what's missing for a sharper score, or calculate now.",
      "readyComplete": "Your profile is complete too — your score reads every detail."
    },
    "ring": {
      "caption": "your score",
      "label": "Your iQulture score appears here once it is calculated"
    },
    "next": {},
    "part": {
      "answers": "Your answers",
      "done": "Done",
      "profileRead": "Your score reads {{complete}} of {{total}} details",
      "profileOptional": "Optional — it sharpens your score, and you can start now.",
      "profileComplete": "Complete — your score reads every detail."
    },
    "calculate": {
      "improveFirst": "Improve my profile first"
    },
    "basics": {
      "title": "One step from your score",
      "subtitle": "Your answers are saved. Add your basics to unlock the calculation — and complete your profile for the most accurate score.",
      "lockedHint": "Unlocks once your basics are in.",
      "lockedLabel": "Calculate my score — locked until your basics are in"
    },
    "path": {
      "label": "Your path to the score",
      "answers": "Your answers",
      "answersState": "Done",
      "basics": "Your basics",
      "basicsState": "Required · {{complete}} of {{total}}",
      "profile": "Full profile",
      "profileState": "Recommended · {{percent}}",
      "calculate": "Your score",
      "calculateState": "Locked"
    },
    "required": {
      "eyebrow": "Required to calculate",
      "title_one": "Add {{count}} detail to unlock your score",
      "title_other": "Add {{count}} details to unlock your score",
      "addField": "Add {{field}}",
      "fastest": "Fastest: scan your passport — it fills {{items}} in one go."
    },
    "recommended": {
      "eyebrow": "Recommended",
      "title": "For the most accurate score",
      "body": "Your score reads {{complete}} of {{total}} details from your profile. Each one you add makes your pillars and recommendations more precise."
    }
  },
  "heroStart": {
    "status": {
      "notStarted": "Not started",
      "inProgress": "In progress"
    },
    "next": {
      "eyebrow": "Your next step"
    },
    "part": {
      "profile": "Your profile",
      "addBasics": "Add your basics",
      "improve": "Improve my profile"
    },
    "profileRead": "{{complete}} of {{total}} profile details added",
    "profileComplete": "Complete — every detail is in.",
    "teleportal": {
      "title": "Your relocation plan, in two parts",
      "subtitle": "TelePortal builds your plan from your setup and your profile — the more complete both are, the more precise every task and deadline.",
      "ringCaption": "your plan",
      "steps": "Your setup",
      "why": "Your nationality, residence and household set your visa path.",
      "optional": "Optional — it makes your plan more precise, and you can start now."
    },
    "qultureup": {
      "title": "Your learning path, in two parts",
      "subtitle": "QultureUp tailors your path from your assessment and your profile — the more complete both are, the closer it fits you.",
      "ringCaption": "your path",
      "steps": "Your assessment",
      "why": "Where you're from and where you live set your starting point.",
      "optional": "Optional — it brings your path closer to you, and you can start now."
    },
    "care": {
      "title": "Care, alongside your journey",
      "subtitle": "Care starts with a short assessment of how you're settling in. Your profile is the base your whole journey reads.",
      "ringCaption": "your care",
      "steps": "Your assessment",
      "why": "Your score, your relocation plan and your learning path all read it.",
      "optional": "Optional — it keeps your whole journey accurate, and you can start now."
    }
  }
}
